webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = React.PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = Draft;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(1031);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = Immutable;

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighestRank = exports.getCategoryBySlug = exports.getCategory = exports.getCategoryCount = exports.getCategories = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getCategories = exports.getCategories = function getCategories(state) {
  return state.categories;
};

var getCategoryCount = exports.getCategoryCount = function getCategoryCount(state) {
  return getCategories(state).length;
};

var getCategoryId = function getCategoryId(state, categoryId) {
  return categoryId;
};

var getCategorySlug = function getCategorySlug(state, categorySlug) {
  return categorySlug;
};

var getCategory = exports.getCategory = (0, _reselect.createSelector)([getCategories, getCategoryId], function (categories, categoryId) {
  return _lodash2.default.find(categories, function (category) {
    return category._id === categoryId;
  });
});

var getCategoryBySlug = exports.getCategoryBySlug = (0, _reselect.createSelector)([getCategories, getCategorySlug], function (categories, categorySlug) {
  return _lodash2.default.find(categories, function (category) {
    return category.slug === categorySlug;
  });
});

var getHighestRank = exports.getHighestRank = (0, _reselect.createSelector)([getCategories], function (categories) {
  return Math.max.apply(Math, [-1].concat(_toConsumableArray(_lodash2.default.map(categories, function (category) {
    return category.rank;
  }))));
});

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEMO_MODE_PREVIEW = exports.DEMO_MODE_EDITOR = exports.DEMO_MODE_SITE = exports.USER_UNSUBSCRIBED = exports.USER_SUBSCRIBED = exports.PROFILE_UPDATE_FAILED = exports.PROFILE_UPDATE = exports.REQUIRE_PROFILE_FIELDS = exports.CATEGORY_UNSUBSCRIBED = exports.CATEGORY_SUBSCRIBED = exports.CATEGORY_UPDATE = exports.CATEGORY_DELETE = exports.MEMBER_UNBLOCK = exports.MEMBER_BLOCK = exports.MEMBER_DEMOTE_MODERATOR = exports.MEMBER_PROMOTE_MODERATOR = exports.REQUIRE_CATEGORY_FIELDS = exports.REQUIRE_POST_FIELDS = exports.COMMENT_DELETE = exports.COMMENT_UPDATE = exports.POST_REMOVE_TOP_COMMENT = exports.POST_ADD_TOP_COMMENT = exports.POST_CHANGE_CATEGORY = exports.POST_MOVE = exports.POST_UPDATE = exports.POST_DISABLE_COMMENTING = exports.POST_ENABLE_COMMENTING = exports.POST_UNSUBSCRIBED = exports.POST_SUBSCRIBED = exports.POST_UNPIN = exports.POST_PIN = exports.POST_DELETE = undefined;

var _POST_DELETE$POST_UPD;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(34);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var POST_DELETE = exports.POST_DELETE = 'post-delete';
var POST_PIN = exports.POST_PIN = 'post-pin';
var POST_UNPIN = exports.POST_UNPIN = 'post-unpin';
var POST_SUBSCRIBED = exports.POST_SUBSCRIBED = 'post-subscribe';
var POST_UNSUBSCRIBED = exports.POST_UNSUBSCRIBED = 'post-unsubscribe';
var POST_ENABLE_COMMENTING = exports.POST_ENABLE_COMMENTING = 'post-enable-commenting';
var POST_DISABLE_COMMENTING = exports.POST_DISABLE_COMMENTING = 'post-disable-commenting';
var POST_UPDATE = exports.POST_UPDATE = 'post-update';
var POST_MOVE = exports.POST_MOVE = 'post-move';
var POST_CHANGE_CATEGORY = exports.POST_CHANGE_CATEGORY = 'post-category-change';
var POST_ADD_TOP_COMMENT = exports.POST_ADD_TOP_COMMENT = 'post-add-top-comment';
var POST_REMOVE_TOP_COMMENT = exports.POST_REMOVE_TOP_COMMENT = 'post-remove-top-comment';

var COMMENT_UPDATE = exports.COMMENT_UPDATE = 'comment-update';
var COMMENT_DELETE = exports.COMMENT_DELETE = 'comment-delete';

var REQUIRE_POST_FIELDS = exports.REQUIRE_POST_FIELDS = 'require-post-fields';

var REQUIRE_CATEGORY_FIELDS = exports.REQUIRE_CATEGORY_FIELDS = 'require-category-fields';

var MEMBER_PROMOTE_MODERATOR = exports.MEMBER_PROMOTE_MODERATOR = 'member-promote-moderator';
var MEMBER_DEMOTE_MODERATOR = exports.MEMBER_DEMOTE_MODERATOR = 'member-demote-moderator';

var MEMBER_BLOCK = exports.MEMBER_BLOCK = 'member-block';
var MEMBER_UNBLOCK = exports.MEMBER_UNBLOCK = 'member-unblock';

var CATEGORY_DELETE = exports.CATEGORY_DELETE = 'category-delete';
var CATEGORY_UPDATE = exports.CATEGORY_UPDATE = 'category-update';
var CATEGORY_SUBSCRIBED = exports.CATEGORY_SUBSCRIBED = 'category-subscribed';
var CATEGORY_UNSUBSCRIBED = exports.CATEGORY_UNSUBSCRIBED = 'category-unsubscribed';

var REQUIRE_PROFILE_FIELDS = exports.REQUIRE_PROFILE_FIELDS = 'require-profile-fields';
var PROFILE_UPDATE = exports.PROFILE_UPDATE = 'profile-update';
var PROFILE_UPDATE_FAILED = exports.PROFILE_UPDATE_FAILED = 'profile-update-failed';

var USER_SUBSCRIBED = exports.USER_SUBSCRIBED = 'user-subscribe';
var USER_UNSUBSCRIBED = exports.USER_UNSUBSCRIBED = 'user-unsubscribe';

var DEMO_MODE_SITE = exports.DEMO_MODE_SITE = 'demo-mode-site';
var DEMO_MODE_EDITOR = exports.DEMO_MODE_EDITOR = 'demo-mode-editor';
var DEMO_MODE_PREVIEW = exports.DEMO_MODE_PREVIEW = 'demo-mode-preview';

exports.default = (_POST_DELETE$POST_UPD = {}, _defineProperty(_POST_DELETE$POST_UPD, POST_DELETE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-deleted',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_UPDATE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-updated',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_ENABLE_COMMENTING, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.commenting-enabled',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_DISABLE_COMMENTING, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.commenting-disabled',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_PIN, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-pinned',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_UNPIN, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-unpinned',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_ADD_TOP_COMMENT, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-top-comment-added',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_REMOVE_TOP_COMMENT, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-top-comment-removed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, USER_SUBSCRIBED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.user-subscribed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, USER_UNSUBSCRIBED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.user-unsubscribed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_SUBSCRIBED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-subscribed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_UNSUBSCRIBED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-unsubscribed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_MOVE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-moved',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, POST_CHANGE_CATEGORY, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.post-category-changed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, COMMENT_UPDATE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.comment-updated',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, COMMENT_DELETE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.comment-deleted',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, REQUIRE_POST_FIELDS, {
  content: function content(data) {
    var key = data && data.sort().join('-');
    switch (key) {
      case 'title':
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'messages.post-title-required',
          useDangerouslySetInnerHTML: true
        });
      case 'content':
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'messages.post-content-required',
          useDangerouslySetInnerHTML: true
        });
      default:
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'messages.post-fields-required',
          useDangerouslySetInnerHTML: true
        });
    }
  },
  type: 'error'
}), _defineProperty(_POST_DELETE$POST_UPD, REQUIRE_CATEGORY_FIELDS, {
  content: function content(data) {
    var key = data && data.sort().join('-');
    switch (key) {
      case 'label':
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'messages.category-title-required',
          useDangerouslySetInnerHTML: true
        });
      default:
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'messages.category-fields-required',
          useDangerouslySetInnerHTML: true
        });
    }
  },
  type: 'error'
}), _defineProperty(_POST_DELETE$POST_UPD, MEMBER_PROMOTE_MODERATOR, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.user-promoted-moderator',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, MEMBER_DEMOTE_MODERATOR, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.user-demoted-moderator',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, MEMBER_BLOCK, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.user-blocked',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, MEMBER_UNBLOCK, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.user-unblocked',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, CATEGORY_DELETE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.category-deleted',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, CATEGORY_UPDATE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.category-updated',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, CATEGORY_SUBSCRIBED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.category-subscribed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, CATEGORY_UNSUBSCRIBED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.category-unsubscribed',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, REQUIRE_PROFILE_FIELDS, {
  content: function content(data) {
    var name = data.name,
        image = data.image,
        cover = data.cover;

    if (name) {
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'messages.profile-name-required',
        useDangerouslySetInnerHTML: true
      });
    }
    if (image) {
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'messages.profile-image-uploading',
        useDangerouslySetInnerHTML: true
      });
    }
    if (cover) {
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'messages.profile-cover-uploading',
        useDangerouslySetInnerHTML: true
      });
    }
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.profile-unknown-error',
      useDangerouslySetInnerHTML: true
    });
  },
  type: 'error'
}), _defineProperty(_POST_DELETE$POST_UPD, PROFILE_UPDATE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.profile-updated',
      useDangerouslySetInnerHTML: true
    });
  }
}), _defineProperty(_POST_DELETE$POST_UPD, PROFILE_UPDATE_FAILED, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.profile-update-failed',
      useDangerouslySetInnerHTML: true
    });
  },
  type: 'error'
}), _defineProperty(_POST_DELETE$POST_UPD, DEMO_MODE_SITE, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.demo-mode-site',
      useDangerouslySetInnerHTML: true
    });
  },
  type: 'info'
}), _defineProperty(_POST_DELETE$POST_UPD, DEMO_MODE_EDITOR, {
  content: function content() {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.demo-mode-editor',
      useDangerouslySetInnerHTML: true
    });
  },
  type: 'info'
}), _defineProperty(_POST_DELETE$POST_UPD, DEMO_MODE_PREVIEW, {
  content: function content(data, t) {
    return _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'messages.demo-mode-preview',
      activate: _react2.default.createElement(
        'span',
        {
          style: { cursor: 'pointer', textDecoration: 'underline' },
          onClick: function onClick() {
            return _wixSdkPolyfill2.default.Preview.openSettingsDialog();
          }
        },
        t('messages.demo-mode-preview-activate')
      ),
      useDangerouslySetInnerHTML: true
    });
  },
  type: 'info'
}), _POST_DELETE$POST_UPD);

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

function deprecate(fn, message) {
  return function () {
     false ? _warning2['default'](false, '[history] ' + message) : undefined;
    return fn.apply(this, arguments);
  };
}

exports['default'] = deprecate;
module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Indicates that navigation was caused by a call to history.push.
 */


exports.__esModule = true;
var PUSH = 'PUSH';

exports.PUSH = PUSH;
/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = 'REPLACE';

exports.REPLACE = REPLACE;
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = 'POP';

exports.POP = POP;
exports['default'] = {
  PUSH: PUSH,
  REPLACE: REPLACE,
  POP: POP
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractPath = extractPath;
exports.parsePath = parsePath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = __webpack_require__(0);

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var arrayOf = _react.PropTypes.arrayOf;
var oneOfType = _react.PropTypes.oneOfType;
var element = _react.PropTypes.element;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPostsByOwnerIdAndPage = exports.getSortedPostsBySiteMemberId = exports.getPostsCountByOwnerId = exports.getSortedPosts = exports.getSortedPostsByOwnerId = exports.getPostsByCategoryIdAndPage = exports.getSortedPostsByCategoryId = exports.getPostBySlug = exports.getPost = exports.getPostMap = undefined;

var _lodash = __webpack_require__(2);

var _reselect = __webpack_require__(46);

var _sortPosts = __webpack_require__(456);

var _sortPosts2 = _interopRequireDefault(_sortPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPostMap = exports.getPostMap = function getPostMap(state) {
  return state.posts;
};

var getPost = exports.getPost = function getPost(state, postId) {
  return getPostMap(state)[postId];
};

var getCategoryId = function getCategoryId(state, categoryId) {
  return categoryId;
};

var getEntityIdsByPage = function getEntityIdsByPage(state, id, page) {
  return state.pagination.posts.entitiesByPage[page] || [];
};

var getSlug = function getSlug(state, slug) {
  return slug;
};

var getOwnerId = function getOwnerId(state, ownerId) {
  return ownerId;
};
var getSiteMemberId = function getSiteMemberId(state, siteMemberId) {
  return siteMemberId;
};

var getPostBySlug = exports.getPostBySlug = (0, _reselect.createSelector)([getPostMap, getSlug], function (posts, slug) {
  return (0, _lodash.find)(posts, ['slug', slug]);
});
var getSortedPostsByCategoryId = exports.getSortedPostsByCategoryId = (0, _reselect.createSelector)([getPostMap, getCategoryId], function (posts, categoryId) {
  return (0, _sortPosts2.default)((0, _lodash.filter)(posts, function (post) {
    return post.categoryId === categoryId;
  }));
});

var getPostsByCategoryIdAndPage = exports.getPostsByCategoryIdAndPage = (0, _reselect.createSelector)([getPostMap, getCategoryId, getEntityIdsByPage], function (posts, categoryId, entityIds) {
  return (0, _lodash.chain)(entityIds).map(function (id) {
    return posts[id];
  }).filter(function (post) {
    return post.categoryId === categoryId;
  }).value();
});

var getSortedPostsByOwnerId = exports.getSortedPostsByOwnerId = (0, _reselect.createSelector)([getPostMap, getOwnerId], function (posts, ownerId) {
  return (0, _sortPosts2.default)((0, _lodash.filter)(posts, function (post) {
    return post.ownerId === ownerId;
  }));
});

var getSortedPosts = exports.getSortedPosts = (0, _reselect.createSelector)([getPostMap], function (posts) {
  return (0, _sortPosts2.default)((0, _lodash.toArray)(posts));
});

var getPostsCountByOwnerId = exports.getPostsCountByOwnerId = (0, _reselect.createSelector)([getPostMap, getOwnerId], function (posts, ownerId) {
  return (0, _lodash.filter)(posts, function (post) {
    return post.ownerId === ownerId;
  }).length;
});

var getSortedPostsBySiteMemberId = exports.getSortedPostsBySiteMemberId = (0, _reselect.createSelector)([getPostMap, getSiteMemberId], function (posts, siteMemberId) {
  return (0, _sortPosts2.default)((0, _sortPosts2.default)((0, _lodash.filter)(posts, function (post) {
    return (0, _lodash.get)(post, 'owner.siteMemberId') === siteMemberId;
  })));
});

var getPostsByOwnerIdAndPage = exports.getPostsByOwnerIdAndPage = (0, _reselect.createSelector)([getPostMap, getOwnerId, getEntityIdsByPage], function (posts, ownerId, entityIds) {
  return (0, _lodash.chain)(entityIds).map(function (id) {
    return posts[id];
  }).filter(function (post) {
    return post.ownerId === ownerId;
  }).value();
});

/***/ }),
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _queryString = __webpack_require__(1028);

var _runTransitionHook = __webpack_require__(279);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(75);

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

var SEARCH_BASE_KEY = '$searchBase';

function defaultStringifyQuery(query) {
  return _queryString.stringify(query).replace(/%20/g, '+');
}

var defaultParseQueryString = _queryString.parse;

function isNestedObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
  }return false;
}

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;

    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    function addQuery(location) {
      if (location.query == null) {
        var search = location.search;

        location.query = parseQueryString(search.substring(1));
        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
      }

      // TODO: Instead of all the book-keeping here, this should just strip the
      // stringified query from the search.

      return location;
    }

    function appendQuery(location, query) {
      var _extends2;

      var searchBaseSpec = location[SEARCH_BASE_KEY];
      var queryString = query ? stringifyQuery(query) : '';
      if (!searchBaseSpec && !queryString) {
        return location;
      }

       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var searchBase = undefined;
      if (searchBaseSpec && location.search === searchBaseSpec.search) {
        searchBase = searchBaseSpec.searchBase;
      } else {
        searchBase = location.search || '';
      }

      var search = searchBase;
      if (queryString) {
        search += (search ? '&' : '?') + queryString;
      }

      return _extends({}, location, (_extends2 = {
        search: search
      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
    }

    // Override all read methods with query-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addQuery(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addQuery(location));
      });
    }

    // Override all write methods with query-aware versions.
    function push(location) {
      history.push(appendQuery(location, location.query));
    }

    function replace(location) {
      history.replace(appendQuery(location, location.query));
    }

    function createPath(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;

      return history.createPath(appendQuery(location, query || location.query));
    }

    function createHref(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;

      return history.createHref(appendQuery(location, query || location.query));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
      if (location.query) {
        fullLocation.query = location.query;
      }
      return addQuery(fullLocation);
    }

    // deprecated
    function pushState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path, { query: query }));
    }

    // deprecated
    function replaceState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path, { query: query }));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useQueries;
module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern);

  var regexpSource = _compilePattern2.regexpSource;
  var paramNames = _compilePattern2.paramNames;
  var tokens = _compilePattern2.tokens;


  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames;
  var paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern);

  var tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0;

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenCount += 1;
    } else if (token === ')') {
      parenCount -= 1;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURIComponent(paramValue);
    } else {
      pathname += token;
    }
  }

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataItem = __webpack_require__(529);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BiBaseDataItem = function (_DataItem) {
  _inherits(BiBaseDataItem, _DataItem);

  function BiBaseDataItem(evid, sessionId) {
    _classCallCheck(this, BiBaseDataItem);

    return _possibleConstructorReturn(this, (BiBaseDataItem.__proto__ || Object.getPrototypeOf(BiBaseDataItem)).call(this, {
      src: 72,
      evid: evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime() // cache buster
    }));
  }

  return BiBaseDataItem;
}(_dataItem2.default);

exports.default = BiBaseDataItem;

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loader = __webpack_require__(962);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loader2.default;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.getHashPath = getHashPath;
exports.replaceHashPath = replaceHashPath;
exports.getWindowPath = getWindowPath;
exports.go = go;
exports.getUserConfirmation = getUserConfirmation;
exports.supportsHistory = supportsHistory;
exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;

function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  return window.location.href.split('#')[1] || '';
}

function replaceHashPath(path) {
  window.location.replace(window.location.pathname + window.location.search + '#' + path);
}

function getWindowPath() {
  return window.location.pathname + window.location.search + window.location.hash;
}

function go(n) {
  if (n) window.history.go(n);
}

function getUserConfirmation(message, callback) {
  callback(window.confirm(message));
}

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
 */

function supportsHistory() {
  var ua = navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  var ua = navigator.userAgent;
  return ua.indexOf('Firefox') === -1;
}

/***/ }),
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseMembrane = undefined;

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseMembrane = exports.canUseMembrane = false;

// No-op by default.
var deprecateObjectProperties = function deprecateObjectProperties(object) {
  return object;
};

if (false) {
  try {
    if (Object.defineProperty({}, 'x', {
      get: function get() {
        return true;
      }
    }).x) {
      exports.canUseMembrane = canUseMembrane = true;
    }
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

  if (canUseMembrane) {
    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
      // Wrap the deprecated object in a membrane to warn on property access.
      var membrane = {};

      var _loop = function _loop(prop) {
        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
          return 'continue';
        }

        if (typeof object[prop] === 'function') {
          // Can't use fat arrow here because of use of arguments below.
          membrane[prop] = function () {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop].apply(object, arguments);
          };
          return 'continue';
        }

        // These properties are non-enumerable to prevent React dev tools from
        // seeing them and causing spurious warnings when accessing them. In
        // principle this could be done with a proxy, but support for the
        // ownKeys trap on proxies is not universal, even among browsers that
        // otherwise support proxies.
        Object.defineProperty(membrane, prop, {
          get: function get() {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop];
          }
        });
      };

      for (var prop in object) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }

      return membrane;
    };
  }
}

exports.default = deprecateObjectProperties;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _deprecateObjectProperties = __webpack_require__(188);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _getRouteParams = __webpack_require__(1038);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _RouteUtils = __webpack_require__(58);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var array = _React$PropTypes.array;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  propTypes: {
    history: object,
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    history: object,
    location: object.isRequired,
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    var _props = this.props;
    var router = _props.router;
    var history = _props.history;
    var location = _props.location;

    if (!router) {
       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;

      router = _extends({}, history, {
        setRouteLeaveHook: history.listenBeforeLeavingRoute
      });
      delete router.listenBeforeLeavingRoute;
    }

    if (false) {
      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
    }

    return { history: history, location: location, router: router };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props;
    var history = _props2.history;
    var location = _props2.location;
    var routes = _props2.routes;
    var params = _props2.params;
    var components = _props2.components;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          history: history,
          location: location,
          params: params,
          route: route,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;

var _RouteUtils = __webpack_require__(58);

Object.defineProperty(exports, 'createRoutes', {
  enumerable: true,
  get: function get() {
    return _RouteUtils.createRoutes;
  }
});

var _PropTypes2 = __webpack_require__(282);

Object.defineProperty(exports, 'locationShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.locationShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.routerShape;
  }
});

var _PatternUtils = __webpack_require__(120);

Object.defineProperty(exports, 'formatPattern', {
  enumerable: true,
  get: function get() {
    return _PatternUtils.formatPattern;
  }
});

var _Router2 = __webpack_require__(1032);

var _Router3 = _interopRequireDefault(_Router2);

var _Link2 = __webpack_require__(435);

var _Link3 = _interopRequireDefault(_Link2);

var _IndexLink2 = __webpack_require__(1039);

var _IndexLink3 = _interopRequireDefault(_IndexLink2);

var _withRouter2 = __webpack_require__(1040);

var _withRouter3 = _interopRequireDefault(_withRouter2);

var _IndexRedirect2 = __webpack_require__(1041);

var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);

var _IndexRoute2 = __webpack_require__(1042);

var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);

var _Redirect2 = __webpack_require__(436);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(1043);

var _Route3 = _interopRequireDefault(_Route2);

var _History2 = __webpack_require__(1044);

var _History3 = _interopRequireDefault(_History2);

var _Lifecycle2 = __webpack_require__(1045);

var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);

var _RouteContext2 = __webpack_require__(1046);

var _RouteContext3 = _interopRequireDefault(_RouteContext2);

var _useRoutes2 = __webpack_require__(1047);

var _useRoutes3 = _interopRequireDefault(_useRoutes2);

var _RouterContext2 = __webpack_require__(189);

var _RouterContext3 = _interopRequireDefault(_RouterContext2);

var _RoutingContext2 = __webpack_require__(1048);

var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);

var _PropTypes3 = _interopRequireDefault(_PropTypes2);

var _match2 = __webpack_require__(1049);

var _match3 = _interopRequireDefault(_match2);

var _useRouterHistory2 = __webpack_require__(438);

var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);

var _applyRouterMiddleware2 = __webpack_require__(1050);

var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);

var _browserHistory2 = __webpack_require__(1051);

var _browserHistory3 = _interopRequireDefault(_browserHistory2);

var _hashHistory2 = __webpack_require__(1052);

var _hashHistory3 = _interopRequireDefault(_hashHistory2);

var _createMemoryHistory2 = __webpack_require__(437);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _Router3.default; /* components */

exports.Link = _Link3.default;
exports.IndexLink = _IndexLink3.default;
exports.withRouter = _withRouter3.default;

/* components (configuration) */

exports.IndexRedirect = _IndexRedirect3.default;
exports.IndexRoute = _IndexRoute3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;

/* mixins */

exports.History = _History3.default;
exports.Lifecycle = _Lifecycle3.default;
exports.RouteContext = _RouteContext3.default;

/* utils */

exports.useRoutes = _useRoutes3.default;
exports.RouterContext = _RouterContext3.default;
exports.RoutingContext = _RoutingContext3.default;
exports.PropTypes = _PropTypes3.default;
exports.match = _match3.default;
exports.useRouterHistory = _useRouterHistory3.default;
exports.applyRouterMiddleware = _applyRouterMiddleware3.default;

/* histories */

exports.browserHistory = _browserHistory3.default;
exports.hashHistory = _hashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routeMap = exports.MEMBERS_PAGE = exports.CREATE_POST = exports.CATEGORIES_PAGE = exports.FEED_PAGE = exports.COMMENT_EDIT_PAGE = exports.POST_EDIT_PAGE = exports.POST_PAGE = exports.SEARCH_RESULTS = exports.NOTIFICATIONS = exports.FOLLOWING = exports.FOLLOWERS = exports.USER_EDIT_PROFILE = exports.USER_PROFILE = exports.USER_SETTINGS = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _routeMap;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var USER_SETTINGS = exports.USER_SETTINGS = 'user_settings';
var USER_PROFILE = exports.USER_PROFILE = 'user_profile';
var USER_EDIT_PROFILE = exports.USER_EDIT_PROFILE = 'user_edit_profile'; // no route
var FOLLOWERS = exports.FOLLOWERS = 'followers';
var FOLLOWING = exports.FOLLOWING = 'following';
var NOTIFICATIONS = exports.NOTIFICATIONS = 'notifications';
var SEARCH_RESULTS = exports.SEARCH_RESULTS = 'search_results';
var POST_PAGE = exports.POST_PAGE = 'post_page';
var POST_EDIT_PAGE = exports.POST_EDIT_PAGE = 'post_edit_page';
var COMMENT_EDIT_PAGE = exports.COMMENT_EDIT_PAGE = 'comment_edit_page';
var FEED_PAGE = exports.FEED_PAGE = 'feed_page';
var CATEGORIES_PAGE = exports.CATEGORIES_PAGE = 'categories_page';
var CREATE_POST = exports.CREATE_POST = 'create_post';
var MEMBERS_PAGE = exports.MEMBERS_PAGE = 'members_page';

var routeMap = exports.routeMap = (_routeMap = {}, _defineProperty(_routeMap, USER_SETTINGS, /^\/profiles\/.*?\/settings/), _defineProperty(_routeMap, USER_PROFILE, /^\/profiles\/[0-9a-zA-Z-_]+\/?$/), _defineProperty(_routeMap, FOLLOWERS, /^\/profiles\/[0-9a-zA-Z-_]+\/followers\/?$/), _defineProperty(_routeMap, FOLLOWING, /^\/profiles\/[0-9a-zA-Z-_]+\/following\/?$/), _defineProperty(_routeMap, NOTIFICATIONS, /^\/notifications\/?$/), _defineProperty(_routeMap, SEARCH_RESULTS, /^\/search(\/(posts|members))?\/?$/), _defineProperty(_routeMap, MEMBERS_PAGE, /^\/members\/?$/), _defineProperty(_routeMap, CREATE_POST, /^\/[0-9a-zA-Z-_]+\/create-post\/?/), _defineProperty(_routeMap, COMMENT_EDIT_PAGE, /^\/[0-9a-zA-Z-_]+\/([0-9a-zA-Z-_]+)\/edit-comment\/[0-9a-zA-Z-_]+\/?/), _defineProperty(_routeMap, POST_EDIT_PAGE, /^\/[0-9a-zA-Z-_]+\/([0-9a-zA-Z-_]+)\/edit\/?/), _defineProperty(_routeMap, POST_PAGE, /^\/[0-9a-zA-Z-_]+\/([0-9a-zA-Z-_]+)\/?/), _defineProperty(_routeMap, FEED_PAGE, /^\/([0-9a-zA-Z-_]+)\/?/), _defineProperty(_routeMap, CATEGORIES_PAGE, /^\/$/), _routeMap);

var testRoute = function testRoute(map, location) {
  return _lodash2.default.findKey(routeMap, function (regex) {
    return regex.test(location);
  });
};

var detectRoute = function detectRoute(location) {
  var pathname = (typeof location === 'undefined' ? 'undefined' : _typeof(location)) === 'object' ? location.pathname : location;
  return testRoute(routeMap, pathname);
};

exports.default = detectRoute;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getIsLoading = function getIsLoading(state) {
  return state.isLoading;
};

var getIsEntityLoading = exports.getIsEntityLoading = function getIsEntityLoading(state, entity) {
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return Boolean((getIsLoading(state)[entity] || {})[id]);
};

var getIsCategoryLoading = exports.getIsCategoryLoading = createIsLoadingSelector('category');
var getIsPostLoading = exports.getIsPostLoading = createIsLoadingSelector('post');
var getIsPostsLoading = exports.getIsPostsLoading = createIsLoadingSelector('posts');
var getIsProfilePostsLoading = exports.getIsProfilePostsLoading = createIsLoadingSelector('profile-posts');
var getIsProfileCommentsLoading = exports.getIsProfileCommentsLoading = createIsLoadingSelector('profile-comments');
var getIsProfileLikesLoading = exports.getIsProfileLikesLoading = createIsLoadingSelector('profile-likes');
var getIsCommentsLoading = exports.getIsCommentsLoading = createIsLoadingSelector('comments');
var getIsNotificationsLoading = exports.getIsNotificationsLoading = createIsLoadingSelector('notifications');
var getIsSearchLoading = exports.getIsSearchLoading = createIsLoadingSelector('search');
var getIsMembersLoading = exports.getIsMembersLoading = createIsLoadingSelector('members');
var getIsFollowersLoading = exports.getIsFollowersLoading = createIsLoadingSelector('followers');
var getIsFollowingLoading = exports.getIsFollowingLoading = createIsLoadingSelector('following');

function createIsLoadingSelector(entity) {
  return function (state, id) {
    return getIsEntityLoading(state, entity, id);
  };
}

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _animatedLoader = __webpack_require__(959);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _animatedLoader2.default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _protectedButton = __webpack_require__(968);

var _protectedButton2 = _interopRequireDefault(_protectedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _protectedButton2.default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _timeAgo = __webpack_require__(969);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _timeAgo2.default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixParams = __webpack_require__(24);

var _withSettingsColor = __webpack_require__(68);

var _withSettingsColor2 = _interopRequireDefault(_withSettingsColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withSettingsColor2.default)(_wixParams.BUTTON_COLOR_PATH, 'topCommentColor', 'color-8', 1);

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
  }
}

exports['default'] = runTransitionHook;
module.exports = exports['default'];

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(74);

var _PathUtils = __webpack_require__(75);

var _ExecutionEnvironment = __webpack_require__(149);

var _DOMUtils = __webpack_require__(186);

var _DOMStateStorage = __webpack_require__(428);

var _createDOMHistory = __webpack_require__(429);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
}

function ensureSlash() {
  var path = _DOMUtils.getHashPath();

  if (isAbsolutePath(path)) return true;

  _DOMUtils.replaceHashPath('/' + path);

  return false;
}

function addQueryStringValueToPath(path, key, value) {
  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
}

function stripQueryStringValueFromPath(path, key) {
  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
}

function getQueryStringValueFromPath(path, key) {
  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
  return match && match[1];
}

var DefaultQueryKey = '_k';

function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;

  var queryKey = options.queryKey;

  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;

  function getCurrentLocation() {
    var path = _DOMUtils.getHashPath();

    var key = undefined,
        state = undefined;
    if (queryKey) {
      key = getQueryStringValueFromPath(path, queryKey);
      path = stripQueryStringValueFromPath(path, queryKey);

      if (key) {
        state = _DOMStateStorage.readState(key);
      } else {
        state = null;
        key = history.createKey();
        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
      }
    } else {
      key = state = null;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startHashChangeListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function hashChangeListener() {
      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.

      transitionTo(getCurrentLocation());
    }

    ensureSlash();
    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    var path = (basename || '') + pathname + search;

    if (queryKey) {
      path = addQueryStringValueToPath(path, queryKey, key);
      _DOMStateStorage.saveState(key, state);
    } else {
      // Drop key and state.
      location.key = location.state = null;
    }

    var currentHash = _DOMUtils.getHashPath();

    if (action === _Actions.PUSH) {
      if (currentHash !== path) {
        window.location.hash = path;
      } else {
         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
      }
    } else if (currentHash !== path) {
      // REPLACE
      _DOMUtils.replaceHashPath(path);
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopHashChangeListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function push(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.push(location);
  }

  function replace(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replace(location);
  }

  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();

  function go(n) {
     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;

    history.go(n);
  }

  function createHref(path) {
    return '#' + history.createHref(path);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopHashChangeListener();
  }

  // deprecated
  function pushState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.pushState(state, path);
  }

  // deprecated
  function replaceState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replaceState(state, path);
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    push: push,
    replace: replace,
    go: go,
    createHref: createHref,

    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
    pushState: pushState, // deprecated - warning is in createHistory
    replaceState: replaceState // deprecated - warning is in createHistory
  });
}

exports['default'] = createHashHistory;
module.exports = exports['default'];

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(149);

var _PathUtils = __webpack_require__(75);

var _runTransitionHook = __webpack_require__(279);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var basename = options.basename;

    var checkedBaseHref = false;

    function checkBaseHref() {
      if (checkedBaseHref) {
        return;
      }

      // Automatically use the value of <base href> in HTML
      // documents as basename if it's not explicitly given.
      if (basename == null && _ExecutionEnvironment.canUseDOM) {
        var base = document.getElementsByTagName('base')[0];
        var baseHref = base && base.getAttribute('href');

        if (baseHref != null) {
          basename = baseHref;

           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
        }
      }

      checkedBaseHref = true;
    }

    function addBasename(location) {
      checkBaseHref();

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    }

    function prependBasename(location) {
      checkBaseHref();

      if (!basename) return location;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var pname = location.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    }

    // Override all read methods with basename-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addBasename(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addBasename(location));
      });
    }

    // Override all write methods with basename-aware versions.
    function push(location) {
      history.push(prependBasename(location));
    }

    function replace(location) {
      history.replace(prependBasename(location));
    }

    function createPath(location) {
      return history.createPath(prependBasename(location));
    }

    function createHref(location) {
      return history.createHref(prependBasename(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    }

    // deprecated
    function pushState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path));
    }

    // deprecated
    function replaceState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useBasename;
module.exports = exports['default'];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;

var _react = __webpack_require__(0);

var _deprecateObjectProperties = __webpack_require__(188);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _InternalPropTypes = __webpack_require__(76);

var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

// Deprecated stuff below:

var falsy = exports.falsy = InternalPropTypes.falsy;
var history = exports.history = InternalPropTypes.history;
var location = exports.location = locationShape;
var component = exports.component = InternalPropTypes.component;
var components = exports.components = InternalPropTypes.components;
var route = exports.route = InternalPropTypes.route;
var routes = exports.routes = InternalPropTypes.routes;
var router = exports.router = routerShape;

if (false) {
  (function () {
    var deprecatePropType = function deprecatePropType(propType, message) {
      return function () {
        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
        return propType.apply(undefined, arguments);
      };
    };

    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
    };

    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
    };

    exports.falsy = falsy = deprecateInternalPropType(falsy);
    exports.history = history = deprecateInternalPropType(history);
    exports.component = component = deprecateInternalPropType(component);
    exports.components = components = deprecateInternalPropType(components);
    exports.route = route = deprecateInternalPropType(route);
    exports.routes = routes = deprecateInternalPropType(routes);

    exports.location = location = deprecateRenamedPropType(location, 'location');
    exports.router = router = deprecateRenamedPropType(router, 'router');
  })();
}

var defaultExport = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route,
  // For some reason, routes was never here.
  router: router
};

if (false) {
  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
}

exports.default = defaultExport;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = __webpack_require__(1033);

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = __webpack_require__(1034);

var _isActive2 = __webpack_require__(1035);

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = __webpack_require__(1036);

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = __webpack_require__(1037);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location) {
    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

    var indexOnly = void 0;
    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
      indexOnly = deprecatedIndexOnly || false;
    } else {
      location = history.createLocation(location);
      indexOnly = indexOnlyOrDeprecatedQuery;
    }

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);

    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
    var changeRoutes = _computeChangedRoutes.changeRoutes;
    var enterRoutes = _computeChangedRoutes.enterRoutes;


    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.reduce(function (hooks, route) {
      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
      return hooks;
    }, []);
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route, false);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    // TODO: Warn if they register for a route that isn't currently
    // active. They're probably doing something wrong, like re-creating
    // route objects on every location change.
    var routeID = getRouteID(route);
    var hooks = RouteHooks[routeID];

    if (!hooks) {
      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);

      RouteHooks[routeID] = [hook];

      if (thereWereNoRouteHooks) {
        // setup transition & beforeunload hooks
        unlistenBefore = history.listenBefore(transitionHook);

        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
      }
    } else {
      if (hooks.indexOf(hook) === -1) {
         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;

        hooks.push(hook);
      }
    }

    return function () {
      var hooks = RouteHooks[routeID];

      if (hooks) {
        var newHooks = hooks.filter(function (item) {
          return item !== hook;
        });

        if (newHooks.length === 0) {
          removeListenBeforeHooksForRoute(route);
        } else {
          RouteHooks[routeID] = newHooks;
        }
      }
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    // TODO: Only use a single history listener. Otherwise we'll
    // end up with multiple concurrent calls to match.
    return history.listen(function (location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    });
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

//export default useRoutes

module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _emptyStates = __webpack_require__(1396);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _emptyStates2.default;

/***/ }),
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIONS_OPENED = exports.ACTIONS_OPENED = 'moreButton/ACTIONS_OPENED';

var actionsOpened = exports.actionsOpened = function actionsOpened(payload) {
  return {
    type: ACTIONS_OPENED,
    payload: payload
  };
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIONS_CLOSED = exports.ACTIONS_CLOSED = 'moreButton/ACTIONS_CLOSED';

var actionsClosed = exports.actionsClosed = function actionsClosed(payload) {
  return {
    type: ACTIONS_CLOSED,
    payload: payload
  };
};

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _scrollListener = __webpack_require__(617);

var _scrollListener2 = _interopRequireDefault(_scrollListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _scrollListener2.default;

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _highlighter = __webpack_require__(971);

var _highlighter2 = _interopRequireDefault(_highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _highlighter2.default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContentNode = __webpack_require__(980);

var _ContentNode2 = _interopRequireDefault(_ContentNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * creates nodes with entity keys and the endOffset
 */
function createEntityNodes(entityRanges, text) {
  var lastIndex = 0;
  var nodes = [];
  // if thers no entities will return just a single item
  if (entityRanges.length < 1) {
    nodes.push(new _ContentNode2.default({ start: 0, end: text.length }));
    return nodes;
  }

  entityRanges.forEach(function (range) {
    // create an empty node for content between previous and this entity
    if (range.offset > lastIndex) {
      nodes.push(new _ContentNode2.default({ start: lastIndex, end: range.offset }));
    }
    // push the node for the entity
    nodes.push(new _ContentNode2.default({
      entity: range.key,
      start: range.offset,
      end: range.offset + range.length
    }));
    lastIndex = range.offset + range.length;
  });

  // finaly add a node for the remaining text if any
  if (lastIndex < text.length) {
    nodes.push(new _ContentNode2.default({
      start: lastIndex,
      end: text.length
    }));
  }
  return nodes;
}

function addIndexes(indexes, ranges) {
  ranges.forEach(function (range) {
    indexes.push(range.offset);
    indexes.push(range.offset + range.length);
  });
  return indexes;
}

/**
 * Creates an array of sorted char indexes to avoid iterating over every single character
 */
function getRelevantIndexes(text, inlineRanges) {
  var entityRanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var relevantIndexes = [];
  // set indexes to corresponding keys to ensure uniquenes
  relevantIndexes = addIndexes(relevantIndexes, inlineRanges);
  relevantIndexes = addIndexes(relevantIndexes, entityRanges);
  // add text start and end to relevant indexes
  relevantIndexes.push(0);
  relevantIndexes.push(text.length);
  var uniqueRelevantIndexes = relevantIndexes.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
  // and sort it
  return uniqueRelevantIndexes.sort(function (aa, bb) {
    return aa - bb;
  });
}

var RawParser = function () {
  function RawParser() {
    _classCallCheck(this, RawParser);
  }

  _createClass(RawParser, [{
    key: 'relevantStyles',
    value: function relevantStyles(offset) {
      var styles = this.ranges.filter(function (range) {
        return offset >= range.offset && offset < range.offset + range.length;
      });
      return styles.map(function (style) {
        return style.style;
      });
    }

    /**
     * Loops over relevant text indexes
     */

  }, {
    key: 'nodeIterator',
    value: function nodeIterator(node, start, end) {
      var _this = this;

      var indexes = this.relevantIndexes.slice(this.relevantIndexes.indexOf(start), this.relevantIndexes.indexOf(end));
      // loops while next index is smaller than the endOffset
      indexes.forEach(function (index, key) {
        // figure out what styles this char and the next char need
        // (regardless of whether there *is* a next char or not)
        var characterStyles = _this.relevantStyles(index);

        // calculate distance or set it to 1 if thers no next index
        var distance = indexes[key + 1] ? indexes[key + 1] - index : 1;
        // add all the chars up to next relevantIndex
        var text = _this.text.substr(index, distance);
        node.pushContent(text, characterStyles);

        // if thers no next index and thers more text left to push
        if (!indexes[key + 1] && index < end) {
          node.pushContent(_this.text.substring(index + 1, end), _this.relevantStyles(end - 1));
        }
      });
      return node;
    }

    /**
     * Converts raw block to object with nested style objects,
     * while it returns an object not a string
     * the idea is still mostly same as backdraft.js (https://github.com/evanc/backdraft-js)
     */

  }, {
    key: 'parse',
    value: function parse(_ref) {
      var _this2 = this;

      var text = _ref.text;
      var ranges = _ref.inlineStyleRanges;
      var entityRanges = _ref.entityRanges;

      this.text = text;
      this.ranges = ranges;
      this.iterator = 0;
      // get all the relevant indexes for whole block
      this.relevantIndexes = getRelevantIndexes(text, ranges, entityRanges);
      // create entity or empty nodes to place the inline styles in
      var entityNodes = createEntityNodes(entityRanges, text);
      var parsedNodes = entityNodes.map(function (node) {
        // reset the stacks
        _this2.styleStack = [];
        _this2.stylesToRemove = [];
        return _this2.nodeIterator(node, node.start, node.end);
      });
      return new _ContentNode2.default({ content: parsedNodes });
    }
  }]);

  return RawParser;
}();

exports.default = RawParser;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _likeButton = __webpack_require__(988);

var _likeButton2 = _interopRequireDefault(_likeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _likeButton2.default;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location = __webpack_require__(1020);

var _location2 = _interopRequireDefault(_location);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * window.performance wrappers
 */
exports.default = {
  getNavigation: function getNavigation() {
    return window && window.performance ? window.performance.navigation : {};
  },


  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];
    try {
      return window && window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return window && window.performance ? window.performance.timing : {};
  },


  /**
   * Duration relative to navigation start (window.performance.timing.navigationStart)
   */
  now: function now() {
    return window && window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    if (_location2.default.isFedopsDev()) {
      window && window.performance && window.performance.mark && window.performance.mark(name);
    }
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    if (_location2.default.isFedopsDev()) {
      window && window.performance && window.performance.measure && window.performance.measure(name, startMark, endMark);
    }
  }
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}
//# sourceMappingURL=env.js.map


/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAGE_OPENED = exports.PAGE_OPENED = 'page/PAGE_OPENED';

var pageOpened = exports.pageOpened = function pageOpened(payload) {
  return {
    type: PAGE_OPENED,
    payload: payload
  };
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = ensureAuth;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _requestLogin = __webpack_require__(522);

var _requestLogin2 = _interopRequireDefault(_requestLogin);

var _preventClickInDemoMode = __webpack_require__(523);

var _preventClickInDemoMode2 = _interopRequireDefault(_preventClickInDemoMode);

var _createHocName = __webpack_require__(41);

var _createHocName2 = _interopRequireDefault(_createHocName);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'EnsureAuth';

function ensureAuth(WrappedComponent) {
  var ChildComponent = (0, _preventClickInDemoMode2.default)(WrappedComponent);

  var EnsureAuth = function (_Component) {
    _inherits(EnsureAuth, _Component);

    function EnsureAuth() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, EnsureAuth);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnsureAuth.__proto__ || Object.getPrototypeOf(EnsureAuth)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        var _this$props = _this.props,
            isAuthenticated = _this$props.isAuthenticated,
            onClick = _this$props.onClick,
            requestLogin = _this$props.requestLogin;

        if (isAuthenticated) {
          onClick && onClick(event);
        } else {
          event.preventDefault();
          event.stopPropagation();

          requestLogin().then(function () {
            return onClick && onClick(event);
          });
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnsureAuth, [{
      key: 'render',
      value: function render() {
        var otherProps = _lodash2.default.omit(this.props, ['isAuthenticated', 'onClick', 'requestLogin']);
        return _react2.default.createElement(ChildComponent, _extends({}, otherProps, { onClick: this.handleClick }));
      }
    }]);

    return EnsureAuth;
  }(_react.Component);

  EnsureAuth.displayName = (0, _createHocName2.default)(NAME, WrappedComponent);


  EnsureAuth.propTypes = {
    requestLogin: _propTypes2.default.func.isRequired,
    isAuthenticated: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
  };

  (0, _hoistNonReactStatics2.default)(EnsureAuth, ChildComponent);

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
      requestLogin: _requestLogin2.default
    }, dispatch);
  };

  return (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withAuth2.default)(EnsureAuth));
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getIsLoaded = function getIsLoaded(state) {
  return state.isLoaded;
};

var getIsEntityLoaded = exports.getIsEntityLoaded = function getIsEntityLoaded(state, entity) {
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return Boolean((getIsLoaded(state)[entity] || {})[id]);
};

var getIsCategoryLoaded = exports.getIsCategoryLoaded = createIsLoadedSelector('category');
var getIsPostLoaded = exports.getIsPostLoaded = createIsLoadedSelector('post');
var getIsPostsLoaded = exports.getIsPostsLoaded = createIsLoadedSelector('posts');
var getIsProfilePostsLoaded = exports.getIsProfilePostsLoaded = createIsLoadedSelector('profile-posts');
var getIsProfileCommentsLoaded = exports.getIsProfileCommentsLoaded = createIsLoadedSelector('profile-posts');
var getIsProfileLikesLoaded = exports.getIsProfileLikesLoaded = createIsLoadedSelector('profile-likes');
var getIsCommentsLoaded = exports.getIsCommentsLoaded = createIsLoadedSelector('comments');
var getIsNotificationsLoaded = exports.getIsNotificationsLoaded = createIsLoadedSelector('notifications');
var getIsSearchLoaded = exports.getIsSearchLoaded = createIsLoadedSelector('search');

function createIsLoadedSelector(entity) {
  return function (state, id) {
    return getIsEntityLoaded(state, entity, id);
  };
}

/***/ }),
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEntityCount = exports.getEntityCount = function getEntityCount(state, entityType) {
  return state.pagination[entityType].entityCount;
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biTabNames;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAIN_TAB_INDEX = exports.MAIN_TAB_INDEX = 0;
var CATEGORIES_TAB_INDEX = exports.CATEGORIES_TAB_INDEX = 1;
var SETTINGS_TAB_INDEX = exports.SETTINGS_TAB_INDEX = 2;
var LAYOUT_TAB_INDEX = exports.LAYOUT_TAB_INDEX = 3;
var DESIGN_TAB_INDEX = exports.DESIGN_TAB_INDEX = 4;
var SUPPORT_TAB_INDEX = exports.SUPPORT_TAB_INDEX = 5;
var ADDONS_TAB_INDEX = exports.ADDONS_TAB_INDEX = 6;

var biTabNames = exports.biTabNames = (_biTabNames = {}, _defineProperty(_biTabNames, MAIN_TAB_INDEX, 'Main'), _defineProperty(_biTabNames, CATEGORIES_TAB_INDEX, 'Categories'), _defineProperty(_biTabNames, SETTINGS_TAB_INDEX, 'Settings'), _defineProperty(_biTabNames, LAYOUT_TAB_INDEX, 'Layout'), _defineProperty(_biTabNames, DESIGN_TAB_INDEX, 'Design'), _defineProperty(_biTabNames, SUPPORT_TAB_INDEX, 'Support'), _defineProperty(_biTabNames, ADDONS_TAB_INDEX, 'Add-Ons'), _biTabNames);

var DESIGN_TAB_HEADER = exports.DESIGN_TAB_HEADER = 'design-tab.header';
var DESIGN_TAB_POSTS = exports.DESIGN_TAB_POSTS = 'design-tab.posts';
var DESIGN_TAB_ICONS_BUTTONS = exports.DESIGN_TAB_ICONS_BUTTONS = 'design-tab.icons-buttons';

var designTabNames = exports.designTabNames = {
  0: DESIGN_TAB_HEADER,
  1: DESIGN_TAB_POSTS,
  2: DESIGN_TAB_ICONS_BUTTONS
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(74);

var _PathUtils = __webpack_require__(75);

function createLocation() {
  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (typeof location === 'string') location = _PathUtils.parsePath(location);

  if (typeof action === 'object') {
     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

    location = _extends({}, location, { state: action });

    action = key || _Actions.POP;
    key = _fourthArg;
  }

  var pathname = location.pathname || '/';
  var search = location.search || '';
  var hash = location.hash || '';
  var state = location.state || null;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
}

exports['default'] = createLocation;
module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(74);

var _PathUtils = __webpack_require__(75);

var _ExecutionEnvironment = __webpack_require__(149);

var _DOMUtils = __webpack_require__(186);

var _DOMStateStorage = __webpack_require__(428);

var _createDOMHistory = __webpack_require__(429);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve URLs.
 */
function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;

  var forceRefresh = options.forceRefresh;

  var isSupported = _DOMUtils.supportsHistory();
  var useRefresh = !isSupported || forceRefresh;

  function getCurrentLocation(historyState) {
    try {
      historyState = historyState || window.history.state || {};
    } catch (e) {
      historyState = {};
    }

    var path = _DOMUtils.getWindowPath();
    var _historyState = historyState;
    var key = _historyState.key;

    var state = undefined;
    if (key) {
      state = _DOMStateStorage.readState(key);
    } else {
      state = null;
      key = history.createKey();

      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startPopStateListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function popStateListener(event) {
      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.

      transitionTo(getCurrentLocation(event.state));
    }

    _DOMUtils.addEventListener(window, 'popstate', popStateListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    _DOMStateStorage.saveState(key, state);

    var path = (basename || '') + pathname + search + hash;
    var historyState = {
      key: key
    };

    if (action === _Actions.PUSH) {
      if (useRefresh) {
        window.location.href = path;
        return false; // Prevent location update.
      } else {
          window.history.pushState(historyState, null, path);
        }
    } else {
      // REPLACE
      if (useRefresh) {
        window.location.replace(path);
        return false; // Prevent location update.
      } else {
          window.history.replaceState(historyState, null, path);
        }
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopPopStateListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopPopStateListener();
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    registerTransitionHook: registerTransitionHook,
    unregisterTransitionHook: unregisterTransitionHook
  });
}

exports['default'] = createBrowserHistory;
module.exports = exports['default'];

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable no-empty */


exports.__esModule = true;
exports.saveState = saveState;
exports.readState = readState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var KeyPrefix = '@@History/';
var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

var SecurityError = 'SecurityError';

function createKey(key) {
  return KeyPrefix + key;
}

function saveState(key, state) {
  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;

      return;
    }

    throw error;
  }
}

function readState(key) {
  var json = undefined;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;

      return null;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return null;
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(149);

var _DOMUtils = __webpack_require__(186);

var _createHistory = __webpack_require__(430);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createDOMHistory(options) {
  var history = _createHistory2['default'](_extends({
    getUserConfirmation: _DOMUtils.getUserConfirmation
  }, options, {
    go: _DOMUtils.go
  }));

  function listen(listener) {
    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;

    return history.listen(listener);
  }

  return _extends({}, history, {
    listen: listen
  });
}

exports['default'] = createDOMHistory;
module.exports = exports['default'];

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _deepEqual = __webpack_require__(187);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _PathUtils = __webpack_require__(75);

var _AsyncUtils = __webpack_require__(1027);

var _Actions = __webpack_require__(74);

var _createLocation2 = __webpack_require__(426);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _runTransitionHook = __webpack_require__(279);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

function createRandomKey(length) {
  return Math.random().toString(36).substr(2, length);
}

function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search &&
  //a.action === b.action && // Different action !== location change.
  a.key === b.key && _deepEqual2['default'](a.state, b.state);
}

var DefaultKeyLength = 6;

function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var finishTransition = options.finishTransition;
  var saveState = options.saveState;
  var go = options.go;
  var getUserConfirmation = options.getUserConfirmation;
  var keyLength = options.keyLength;

  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;

  var transitionHooks = [];

  function listenBefore(hook) {
    transitionHooks.push(hook);

    return function () {
      transitionHooks = transitionHooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var allKeys = [];
  var changeListeners = [];
  var location = undefined;

  function getCurrent() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) {
      return allKeys.indexOf(pendingLocation.key);
    } else if (location) {
      return allKeys.indexOf(location.key);
    } else {
      return -1;
    }
  }

  function updateLocation(newLocation) {
    var current = getCurrent();

    location = newLocation;

    if (location.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
    } else if (location.action === _Actions.REPLACE) {
      allKeys[current] = location.key;
    }

    changeListeners.forEach(function (listener) {
      listener(location);
    });
  }

  function listen(listener) {
    changeListeners.push(listener);

    if (location) {
      listener(location);
    } else {
      var _location = getCurrentLocation();
      allKeys = [_location.key];
      updateLocation(_location);
    }

    return function () {
      changeListeners = changeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function confirmTransitionTo(location, callback) {
    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
        if (result != null) {
          done(result);
        } else {
          next();
        }
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  }

  var pendingLocation = undefined;

  function transitionTo(nextLocation) {
    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted.

      if (ok) {
        // treat PUSH to current path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = createPath(location);
          var nextPath = createPath(nextLocation);

          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
      } else if (location && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(location.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
      }
    });
  }

  function push(location) {
    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
  }

  function replace(location) {
    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function createKey() {
    return createRandomKey(keyLength);
  }

  function createPath(location) {
    if (location == null || typeof location === 'string') return location;

    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;

    var result = pathname;

    if (search) result += search;

    if (hash) result += hash;

    return result;
  }

  function createHref(location) {
    return createPath(location);
  }

  function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];

    if (typeof action === 'object') {
       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      location = _extends({}, location, { state: action });

      action = key;
      key = arguments[3] || createKey();
    }

    return _createLocation3['default'](location, action, key);
  }

  // deprecated
  function setState(state) {
    if (location) {
      updateLocationState(location, state);
      updateLocation(location);
    } else {
      updateLocationState(getCurrentLocation(), state);
    }
  }

  function updateLocationState(location, state) {
    location.state = _extends({}, location.state, state);
    saveState(location.key, location.state);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    transitionHooks = transitionHooks.filter(function (item) {
      return item !== hook;
    });
  }

  // deprecated
  function pushState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    push(_extends({ state: state }, path));
  }

  // deprecated
  function replaceState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    replace(_extends({ state: state }, path));
  }

  return {
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: createPath,
    createHref: createHref,
    createLocation: createLocation,

    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
  };
}

exports['default'] = createHistory;
module.exports = exports['default'];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(75);

var _Actions = __webpack_require__(74);

var _createHistory = __webpack_require__(430);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
}

function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var history = _createHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: saveState,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;

  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    var key = history.createKey();

    if (typeof entry === 'string') return { pathname: entry, key: key };

    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });

     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
  }

  var storage = createStateStorage(entries);

  function saveState(key, state) {
    storage[key] = state;
  }

  function readState(key) {
    return storage[key];
  }

  function getCurrentLocation() {
    var entry = entries[current];
    var basename = entry.basename;
    var pathname = entry.pathname;
    var search = entry.search;

    var path = (basename || '') + pathname + (search || '');

    var key = undefined,
        state = undefined;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    } else {
      key = history.createKey();
      state = null;
      entry.key = key;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  }

  function go(n) {
    if (n) {
      if (!canGo(n)) {
         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
        return;
      }

      current += n;

      var currentLocation = getCurrentLocation();

      // change action to POP
      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
    }
  }

  function finishTransition(location) {
    switch (location.action) {
      case _Actions.PUSH:
        current += 1;

        // if we are not on the top of stack
        // remove rest and push new
        if (current < entries.length) entries.splice(current);

        entries.push(location);
        saveState(location.key, location.state);
        break;
      case _Actions.REPLACE:
        entries[current] = location;
        saveState(location.key, location.state);
        break;
    }
  }

  return history;
}

exports['default'] = createMemoryHistory;
module.exports = exports['default'];

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(149);

var _DOMUtils = __webpack_require__(186);

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
  function listener(event) {
    var message = getBeforeUnloadPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }
  }

  _DOMUtils.addEventListener(window, 'beforeunload', listener);

  return function () {
    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
  };
}

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
function useBeforeUnload(createHistory) {
  return function (options) {
    var history = createHistory(options);

    var stopBeforeUnloadListener = undefined;
    var beforeUnloadHooks = [];

    function getBeforeUnloadPromptMessage() {
      var message = undefined;

      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
        message = beforeUnloadHooks[i].call();
      }return message;
    }

    function listenBeforeUnload(hook) {
      beforeUnloadHooks.push(hook);

      if (beforeUnloadHooks.length === 1) {
        if (_ExecutionEnvironment.canUseDOM) {
          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
        } else {
           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
        }
      }

      return function () {
        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
          return item !== hook;
        });

        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
          stopBeforeUnloadListener();
          stopBeforeUnloadListener = null;
        }
      };
    }

    // deprecated
    function registerBeforeUnloadHook(hook) {
      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
        beforeUnloadHooks.push(hook);

        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
      }
    }

    // deprecated
    function unregisterBeforeUnloadHook(hook) {
      if (beforeUnloadHooks.length > 0) {
        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
          return item !== hook;
        });

        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
      }
    }

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload,

      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
    });
  };
}

exports['default'] = useBeforeUnload;
module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeStateWithLocation;

var _deprecateObjectProperties = __webpack_require__(188);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStateWithLocation(state, location) {
  if (false) {
    var stateWithLocation = _extends({}, state);

    // I don't use deprecateObjectProperties here because I want to keep the
    // same code path between development and production, in that we just
    // assign extra properties to the copy of the state object in both cases.

    var _loop = function _loop(prop) {
      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
        return 'continue';
      }

      Object.defineProperty(stateWithLocation, prop, {
        get: function get() {
          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
          return location[prop];
        }
      });
    };

    for (var prop in location) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }

    return stateWithLocation;
  }

  return _extends({}, state, location);
}
module.exports = exports['default'];

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.createRoutingHistory = createRoutingHistory;

var _deprecateObjectProperties = __webpack_require__(188);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouterObject(history, transitionManager) {
  return _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });
}

// deprecated
function createRoutingHistory(history, transitionManager) {
  history = _extends({}, history, transitionManager);

  if (false) {
    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
  }

  return history;
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__(282);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes;
var bool = _React$PropTypes.bool;
var object = _React$PropTypes.object;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;
var oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query;
  var hash = _ref.hash;
  var state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    var _props = this.props;
    var to = _props.to;
    var query = _props.query;
    var hash = _props.hash;
    var state = _props.state;

    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });

    this.context.router.push(location);
  },
  render: function render() {
    var _props2 = this.props;
    var to = _props2.to;
    var query = _props2.query;
    var hash = _props2.hash;
    var state = _props2.state;
    var activeClassName = _props2.activeClassName;
    var activeStyle = _props2.activeStyle;
    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;

    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;

    // Ignore if rendered outside the context of router, simplifies unit testing.
    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
      props.href = router.createHref(location);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(location, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(58);

var _PatternUtils = __webpack_require__(120);

var _InternalPropTypes = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */

var Redirect = _react2.default.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = (0, _RouteUtils.createRouteFromReactElement)(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location;
        var params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = __webpack_require__(119);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(281);

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = __webpack_require__(431);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useRoutes` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  history.__v2_compatible__ = true;
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(119);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(281);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = __webpack_require__(438);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];

/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortPosts;
var toDate = function toDate(value) {
  if (value instanceof Date) {
    return value;
  }
  return new Date(value);
};

var toComparable = function toComparable(isPinned, time) {
  return (isPinned ? 10000000000000 : 0) + time;
};

function sortPosts() {
  var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return posts.sort(function (postA, postB) {
    var postAValue = toComparable(postA.isPinned, toDate(postA.lastActivityDate).getTime());
    var postBValue = toComparable(postB.isPinned, toDate(postB.lastActivityDate).getTime());
    return postBValue - postAValue;
  });
}

/***/ }),
/* 457 */,
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _page = __webpack_require__(1390);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _messages = __webpack_require__(61);

Object.keys(_messages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _messages[key];
    }
  });
});

var _message = __webpack_require__(1060);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _message2.default;

/***/ }),
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postListItem = __webpack_require__(1064);

var _postListItem2 = _interopRequireDefault(_postListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postListItem2.default;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _contentExcerpt = __webpack_require__(974);

var _contentExcerpt2 = _interopRequireDefault(_contentExcerpt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _contentExcerpt2.default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPostCover;
exports.getPostVideoEmbedCover = getPostVideoEmbedCover;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPostCover() {
  var contentState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var entities = contentState.entityMap || {};
  var key = _lodash2.default.findKey(entities, function (entity) {
    return entity.type === 'IMAGE';
  });
  var entity = entities[key];

  return entity ? entity.data.src : null;
}

function getPostVideoEmbedCover() {
  var contentState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var entities = contentState.entityMap || {};
  var key = _lodash2.default.findKey(entities, function (entity) {
    return entity.type === 'VIDEO-EMBED';
  });
  var entity = entities[key];

  return entity ? entity.data.oembed : null;
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleUserSubscribe = undefined;

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _showMessage = __webpack_require__(159);

var _incrementFollowingCount = __webpack_require__(451);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _currentUserSelectors = __webpack_require__(67);

var _userSelectors = __webpack_require__(69);

var _searchSelectors = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggleUserSubscribe = exports.toggleUserSubscribe = function toggleUserSubscribe(userId) {
  return function (dispatch, getState) {
    var state = getState();
    var user = (0, _userSelectors.getUserById)(state, userId) || (0, _searchSelectors.getUserById)(state, userId);
    var currentUser = (0, _currentUserSelectors.getCurrentUser)(state);

    dispatch(user.isSubscribed ? (0, _incrementFollowingCount.decrementFollowingCount)(currentUser._id) : (0, _incrementFollowingCount.incrementFollowingCount)(currentUser._id));

    var message = user.isSubscribed ? _messages.USER_UNSUBSCRIBED : _messages.USER_SUBSCRIBED;
    var promise = user.isSubscribed ? dispatch((0, _unsubscribe.unsubscribe)({ _id: userId, type: 'user' })) : dispatch((0, _subscribe.subscribe)({ _id: userId, type: 'user' }));

    // The only one place where show message is dispatched
    return promise.then(function () {
      return dispatch((0, _showMessage.showMessage)(_messages2.default[message].content(), _messages2.default[message].type));
    });
  };
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _infiniteListLoader = __webpack_require__(990);

var _infiniteListLoader2 = _interopRequireDefault(_infiniteListLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _infiniteListLoader2.default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  _createClass(DataItem, [{
    key: 'isActive',
    value: function isActive() {
      return true;
    }
  }, {
    key: 'export',
    value: function _export() {
      return this.data;
    }
  }]);

  return DataItem;
}();

exports.default = DataItem;

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToAppTop = exports.scrollTop = undefined;
exports.default = scrollTo;

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _isInWix = __webpack_require__(77);

var _wixSdkUtils = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollTop = exports.scrollTop = function scrollTop() {
  if ((0, _wixSdkUtils.isMobile)() || !(0, _isInWix.isInWix)()) {
    scrollTo(0);
  } else {
    _wixSdkPolyfill2.default.scrollTo(0, 0);
  }
};

var scrollToAppTop = exports.scrollToAppTop = function scrollToAppTop() {
  if ((0, _wixSdkUtils.isMobile)() || !(0, _isInWix.isInWix)() || (0, _wixSdkUtils.isEditor)()) {
    scrollTo(0);
  } else {
    _wixSdkPolyfill2.default.getBoundingRectAndOffsets(function (_ref) {
      var _ref$offsets = _ref.offsets,
          x = _ref$offsets.x,
          y = _ref$offsets.y;
      return _wixSdkPolyfill2.default.scrollTo(x, y);
    });
  }
};

function scrollTo(position) {
  var parent = (0, _scrollParent2.default)();
  if (typeof parent.scrollTo === 'function') {
    parent.scrollTo(0, position);
  } else {
    parent.scrollTop = position;
  }
}

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contentStateToString;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _redraft = __webpack_require__(979);

var _redraft2 = _interopRequireDefault(_redraft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertToString = function convertToString(nodes) {
  return _lodash2.default.reduce(_lodash2.default.flattenDeep(nodes), function (result, node) {
    return result + _lodash2.default.flattenDeep(((node || {}).props || {}).children || []).join('');
  }, '');
};

var inlineRenderers = {
  BOLD: function BOLD(children) {
    return children;
  },
  ITALIC: function ITALIC(children) {
    return children;
  }
};

var blockRenderer = function blockRenderer(children) {
  return children.map(function (child, index) {
    return _react2.default.createElement(
      'span',
      { key: index },
      child,
      index === children.length - 1 ? null : ' '
    );
  });
};

var blockRenderers = {
  unstyled: blockRenderer,
  blockquote: blockRenderer,
  'header-one': blockRenderer,
  'header-two': blockRenderer,
  'unordered-list-item': blockRenderer,
  'ordered-list-item': blockRenderer,
  'code-block': blockRenderer
};

var entityRenderers = {
  LINK: function LINK(children) {
    return children;
  }
};

function contentStateToString(contentState) {
  if (!contentState) {
    return '';
  }

  var contentStateCopy = _lodash2.default.cloneDeep(contentState);

  // FIXME: Redraft does not render when the first block is unstyled & empty
  var firstBlock = contentStateCopy.blocks[0];
  if (firstBlock && firstBlock.type === 'unstyled' && !firstBlock.text) {
    firstBlock.text = ' ';
  }
  return convertToString((0, _redraft2.default)(contentStateCopy, { inline: inlineRenderers, blocks: blockRenderers, entities: entityRenderers }));
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postImage = __webpack_require__(986);

var _postImage2 = _interopRequireDefault(_postImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postImage2.default;

/***/ }),
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _permissionsProvider = __webpack_require__(596);

var _permissionsProvider2 = _interopRequireDefault(_permissionsProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _permissionsProvider2.default;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _applications = __webpack_require__(25);

var _experiments = __webpack_require__(32);

var _permissionsChecker = __webpack_require__(269);

var _categoriesSelectors = __webpack_require__(35);

var _postSelectors = __webpack_require__(117);

var _communitiesContextSelectors = __webpack_require__(47);

var _experimentsSelectors = __webpack_require__(121);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsProvider = function (_Component) {
  _inherits(PermissionsProvider, _Component);

  function PermissionsProvider(props, context) {
    _classCallCheck(this, PermissionsProvider);

    var _this = _possibleConstructorReturn(this, (PermissionsProvider.__proto__ || Object.getPrototypeOf(PermissionsProvider)).call(this, props, context));

    var store = props.store;
    var state = store.getState();

    var isMemberAreaInstalled = (0, _lodash.get)((0, _communitiesContextSelectors.getApplicationConfig)(store.getState(), _applications.SANTA_MEMBERS_APP_ID), 'isInstalled', false);
    var isMemberAreaEnabled = (0, _experimentsSelectors.isExperimentEnabled)(state, _experiments.EXPERIMENT_MEMBERS_AREA);
    var isTopCommentExperimentEnabled = (0, _experimentsSelectors.isExperimentEnabled)(state, _experiments.EXPERIMENT_TOP_COMMENT);
    var flags = { isMemberAreaInstalled: isMemberAreaInstalled, isMemberAreaEnabled: isMemberAreaEnabled, isTopCommentExperimentEnabled: isTopCommentExperimentEnabled };
    _this.permissions = (0, _permissionsChecker.permissionsChecker)(flags, props.currentUser, function (resource) {
      if (resource.postId) {
        resource = (0, _postSelectors.getPost)(store.getState(), resource.postId);
      }
      if (resource.categoryId) {
        resource = (0, _categoriesSelectors.getCategory)(store.getState(), resource.categoryId);
      }
      return resource;
    });
    return _this;
  }

  _createClass(PermissionsProvider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var currentUser = _ref.currentUser;

      this.permissions.setUserIdentity(currentUser);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return { permissions: this.permissions };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return PermissionsProvider;
}(_react.Component);

PermissionsProvider.propTypes = {
  store: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.element.isRequired,
  currentUser: _propTypes2.default.object
};

PermissionsProvider.childContextTypes = {
  permissions: _propTypes2.default.object.isRequired
};

exports.default = (0, _withAuth2.default)(PermissionsProvider);

/***/ }),
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollListener = function (_Component) {
  _inherits(ScrollListener, _Component);

  function ScrollListener() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollListener.__proto__ || Object.getPrototypeOf(ScrollListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleInnerScroll = (0, _lodash.throttle)(function () {
      return _this.props.onScroll({
        scrollTop: (0, _scrollParent2.default)().scrollTop,
        documentHeight: (0, _scrollParent2.default)().offsetHeight
      });
    }), _this.handleOuterScroll = (0, _lodash.throttle)(function (scroll) {
      return _this.props.onScroll(scroll);
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.isMobile ? this.startListeningToInnerScroll() : this.startListeningToOuterScroll();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.isMobile ? (0, _scrollParent2.default)().removeEventListener('scroll', this.handleInnerScroll) : _wixSdkPolyfill2.default.removeEventListener(_wixSdkPolyfill2.default.Events.SCROLL, this.handleOuterScroll);
    }
  }, {
    key: 'startListeningToInnerScroll',
    value: function startListeningToInnerScroll() {
      (0, _scrollParent2.default)().addEventListener('scroll', this.handleInnerScroll);
    }
  }, {
    key: 'startListeningToOuterScroll',
    value: function startListeningToOuterScroll() {
      _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.SCROLL, this.handleOuterScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);

  return ScrollListener;
}(_react.Component);

ScrollListener.propTypes = {
  onScroll: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool
};
exports.default = (0, _withDeviceType2.default)(ScrollListener);

/***/ }),
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TEXT_ALIGNMENT_CLASS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TEXT_ALIGNMENT_LEFT = exports.TEXT_ALIGNMENT_LEFT = 0;
var TEXT_ALIGNMENT_CENTER = exports.TEXT_ALIGNMENT_CENTER = 1;

var TEXT_ALIGNMENT_CLASS_NAMES = exports.TEXT_ALIGNMENT_CLASS_NAMES = (_TEXT_ALIGNMENT_CLASS = {}, _defineProperty(_TEXT_ALIGNMENT_CLASS, TEXT_ALIGNMENT_LEFT, 'left'), _defineProperty(_TEXT_ALIGNMENT_CLASS, TEXT_ALIGNMENT_CENTER, 'center'), _TEXT_ALIGNMENT_CLASS);

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(122);

var _loaderBox = __webpack_require__(960);

var _loaderBox2 = _interopRequireDefault(_loaderBox);

var _animatedLoader = __webpack_require__(965);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _animatedLoaderContainer = __webpack_require__(966);

var _animatedLoaderContainer2 = _interopRequireDefault(_animatedLoaderContainer);

var _animatedLoaderContent = __webpack_require__(967);

var _animatedLoaderContent2 = _interopRequireDefault(_animatedLoaderContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_TIMEOUT = 800;

var AnimatedLoader = function AnimatedLoader(_ref) {
  var shouldShowLoader = _ref.shouldShowLoader,
      isLoading = _ref.isLoading,
      children = _ref.children,
      isAnimated = _ref.isAnimated;
  return _react2.default.createElement(
    'div',
    { className: _animatedLoaderContainer2.default.container, 'data-hook': 'animated-loader__container' },
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        component: 'div',
        transitionName: _animatedLoader2.default,
        transitionEnter: false,
        transitionLeaveTimeout: ANIMATION_TIMEOUT
      },
      shouldShowLoader && isLoading ? _react2.default.createElement(_loaderBox2.default, { key: 'loaderBox' }) : null
    ),
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        component: 'div',
        transitionName: _animatedLoaderContent2.default,
        transitionEnter: isAnimated,
        transitionLeave: false,
        transitionEnterTimeout: ANIMATION_TIMEOUT
      },
      isLoading ? null : _react2.default.createElement(
        'div',
        { key: 'content' },
        children
      )
    )
  );
};

AnimatedLoader.propTypes = {
  shouldShowLoader: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  isAnimated: _propTypes2.default.bool
};

AnimatedLoader.defaultProps = {
  shouldShowLoader: true
};

exports.default = AnimatedLoader;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loaderBox = __webpack_require__(961);

var _loaderBox2 = _interopRequireDefault(_loaderBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loaderBox2.default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _loaderBox = __webpack_require__(964);

var _loaderBox2 = _interopRequireDefault(_loaderBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoaderBox = function LoaderBox() {
  return _react2.default.createElement(
    'div',
    { className: _loaderBox2.default.container, 'data-hook': 'loader-box' },
    _react2.default.createElement(_loader2.default, null)
  );
};

exports.default = LoaderBox;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _loader = __webpack_require__(963);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader() {
  return _react2.default.createElement(
    'div',
    { className: _loader2.default.container },
    _react2.default.createElement('span', { className: (0, _classnames2.default)(_loader2.default.dot, 'forum-text-background-color') }),
    _react2.default.createElement('span', { className: (0, _classnames2.default)(_loader2.default.dot, 'forum-text-background-color') }),
    _react2.default.createElement('span', { className: (0, _classnames2.default)(_loader2.default.dot, 'forum-text-background-color') })
  );
};

exports.default = Loader;

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2OmhB","dot":"_2UkhZ","opacitychange":"_9iVxk"};

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1BpcQ"};

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"leave":"_7Gmld","leaveActive":"_2NMpK"};

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2avmN"};

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"enter":"_2hbpk","enterActive":"_3b_XZ"};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ensureAuth = __webpack_require__(411);

var _ensureAuth2 = _interopRequireDefault(_ensureAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProtectedButton = function (_Component) {
  _inherits(ProtectedButton, _Component);

  function ProtectedButton() {
    _classCallCheck(this, ProtectedButton);

    return _possibleConstructorReturn(this, (ProtectedButton.__proto__ || Object.getPrototypeOf(ProtectedButton)).apply(this, arguments));
  }

  _createClass(ProtectedButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          CategoryName = _props.tagName,
          children = _props.children,
          onClick = _props.onClick,
          props = _objectWithoutProperties(_props, ['tagName', 'children', 'onClick']);

      var elementProps = (0, _lodash.omit)(props, 'currentUser', 'dispatch', 'isAuthenticated', 'isBlocked', 'isDemoMode', 'isOwner', 'openModal', 'titleFontClassName', 'tooltipText', 'viewMode', 'forPublicUser', 'isPrivate');

      return _react2.default.createElement(
        CategoryName,
        _extends({}, elementProps, { onClick: onClick }),
        children
      );
    }
  }]);

  return ProtectedButton;
}(_react.Component);

ProtectedButton.propTypes = {
  tagName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node
};
ProtectedButton.defaultProps = {
  tagName: 'button'
};
exports.default = (0, _ensureAuth2.default)(ProtectedButton);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var weekAgo = function weekAgo() {
  return new Date().getTime() - 1000 * 60 * 60 * 24 * 7;
};
var isLessThanWeek = function isLessThanWeek(time) {
  return new Date(time).getTime() > weekAgo();
};
var isNotCurrentYear = function isNotCurrentYear(time) {
  return new Date().getYear() !== new Date(time).getYear();
};
var getTimeAgoFormat = function getTimeAgoFormat(time) {
  if (isLessThanWeek(time)) {
    return 'time-relative';
  }
  if (isNotCurrentYear(time)) {
    return 'fullDate';
  }
  return 'date';
};

var TimeAgo = function TimeAgo(_ref) {
  var className = _ref.className,
      time = _ref.time,
      t = _ref.t;
  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(className, 'time-ago'), 'data-hook': 'time-ago' },
    t(getTimeAgoFormat(time), { time: time })
  );
};

TimeAgo.propTypes = {
  className: _propTypes2.default.string,
  t: _propTypes2.default.func,
  time: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.number])
};

exports.default = (0, _withTranslate2.default)(TimeAgo);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postTitle = __webpack_require__(1072);

var _postTitle2 = _interopRequireDefault(_postTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postTitle2.default;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHighlightWords = __webpack_require__(972);

var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);

var _getColors = __webpack_require__(265);

var _highlighter = __webpack_require__(973);

var _highlighter2 = _interopRequireDefault(_highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLE = {
  backgroundColor: 'rgba(' + (0, _getColors.getSecondaryColorNumbers)() + ', 0.3)'
};

var Highlighter = function Highlighter(_ref) {
  var text = _ref.text,
      query = _ref.query;
  return _react2.default.createElement(_reactHighlightWords2.default, {
    highlightClassName: _highlighter2.default.mark,
    highlightStyle: STYLE,
    textToHighlight: text,
    searchWords: query.split(' ')
  });
};

Highlighter.propTypes = {
  text: _propTypes2.default.string.isRequired,
  query: _propTypes2.default.string.isRequired
};

exports.default = Highlighter;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Highlighter = __webpack_require__(2);
	
	var _Highlighter2 = _interopRequireDefault(_Highlighter);
	
	var _utils = __webpack_require__(4);
	
	exports['default'] = _Highlighter2['default'];
	exports.combineChunks = _utils.combineChunks;
	exports.fillInChunks = _utils.fillInChunks;
	exports.findAll = _utils.findAll;
	exports.findChunks = _utils.findChunks;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Highlighter;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsJs = __webpack_require__(4);
	
	var Chunks = _interopRequireWildcard(_utilsJs);
	
	Highlighter.propTypes = {
	  highlightClassName: _react.PropTypes.string,
	  highlightStyle: _react.PropTypes.object,
	  searchWords: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  textToHighlight: _react.PropTypes.string.isRequired,
	  sanitize: _react.PropTypes.func
	};
	
	/**
	 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
	 * This function returns an array of strings and <span>s (wrapping highlighted words).
	 */
	
	function Highlighter(_ref) {
	  var _ref$highlightClassName = _ref.highlightClassName;
	  var highlightClassName = _ref$highlightClassName === undefined ? '' : _ref$highlightClassName;
	  var _ref$highlightStyle = _ref.highlightStyle;
	  var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
	  var searchWords = _ref.searchWords;
	  var textToHighlight = _ref.textToHighlight;
	  var sanitize = _ref.sanitize;
	
	  var chunks = Chunks.findAll(textToHighlight, searchWords, sanitize);
	
	  return _react2['default'].createElement(
	    'span',
	    null,
	    chunks.map(function (chunk, index) {
	      var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
	
	      if (chunk.highlight) {
	        return _react2['default'].createElement(
	          'mark',
	          {
	            className: highlightClassName,
	            key: index,
	            style: highlightStyle
	          },
	          text
	        );
	      } else {
	        return _react2['default'].createElement(
	          'span',
	          { key: index },
	          text
	        );
	      }
	    })
	  );
	}
	
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(0);

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
	 * @param searchWords string[]
	 * @param textToSearch string
	 * @return {start:number, end:number, highlight:boolean}[]
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var findAll = function findAll(textToSearch, wordsToFind, sanitize) {
	  return fillInChunks(combineChunks(findChunks(textToSearch, wordsToFind, sanitize)), textToSearch.length);
	};
	
	exports.findAll = findAll;
	/**
	 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
	 * @param chunks {start:number, end:number}[]
	 * @return {start:number, end:number}[]
	 */
	var combineChunks = function combineChunks(chunks) {
	  chunks = chunks.sort(function (first, second) {
	    return first.start - second.start;
	  }).reduce(function (processedChunks, nextChunk) {
	    // First chunk just goes straight in the array...
	    if (processedChunks.length === 0) {
	      return [nextChunk];
	    } else {
	      // ... subsequent chunks get checked to see if they overlap...
	      var prevChunk = processedChunks.pop();
	      if (nextChunk.start <= prevChunk.end) {
	        // It may be the case that prevChunk completely surrounds nextChunk, so take the
	        // largest of the end indeces.
	        var endIndex = Math.max(prevChunk.end, nextChunk.end);
	        processedChunks.push({ start: prevChunk.start, end: endIndex });
	      } else {
	        processedChunks.push(prevChunk, nextChunk);
	      }
	      return processedChunks;
	    }
	  }, []);
	
	  return chunks;
	};
	
	exports.combineChunks = combineChunks;
	/**
	 * Examine textToSearch for any matches.
	 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
	 * @param textToSearch string
	 * @param wordsToFind string[]
	 * @param sanitize Process and optionally modify textToSearch and wordsToFind before comparison; this can be used to eg. remove accents
	 * @return {start:number, end:number}[]
	 */
	var findChunks = function findChunks(textToSearch, wordsToFind) {
	  var sanitize = arguments.length <= 2 || arguments[2] === undefined ? identity : arguments[2];
	  return wordsToFind.filter(function (searchWord) {
	    return searchWord;
	  }) // Remove empty words
	  .reduce(function (chunks, searchWord) {
	    var normalizedWord = sanitize(searchWord);
	    var normalizedText = sanitize(textToSearch);
	    var regex = new RegExp(normalizedWord, 'gi');
	    var match = undefined;
	    while ((match = regex.exec(normalizedText)) != null) {
	      chunks.push({ start: match.index, end: regex.lastIndex });
	    }
	    return chunks;
	  }, []);
	};
	
	exports.findChunks = findChunks;
	/**
	 * Given a set of chunks to highlight, create an additional set of chunks
	 * to represent the bits of text between the highlighted text.
	 * @param chunksToHighlight {start:number, end:number}[]
	 * @param totalLength number
	 * @return {start:number, end:number, highlight:boolean}[]
	 */
	var fillInChunks = function fillInChunks(chunksToHighlight, totalLength) {
	  var allChunks = [];
	  var append = function append(start, end, highlight) {
	    if (end - start > 0) {
	      allChunks.push({ start: start, end: end, highlight: highlight });
	    }
	  };
	
	  if (chunksToHighlight.length === 0) {
	    append(0, totalLength, false);
	  } else {
	    (function () {
	      var lastIndex = 0;
	      chunksToHighlight.forEach(function (chunk) {
	        append(lastIndex, chunk.start, false);
	        append(chunk.start, chunk.end, true);
	        lastIndex = chunk.end;
	      });
	      append(lastIndex, totalLength, false);
	    })();
	  }
	  return allChunks;
	};
	
	exports.fillInChunks = fillInChunks;
	function identity(value) {
	  return value;
	}

/***/ }
/******/ ]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mark":"_3nXb0"};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDotdotdot = __webpack_require__(975);

var _reactDotdotdot2 = _interopRequireDefault(_reactDotdotdot);

var _simpleRenderer = __webpack_require__(977);

var _simpleRenderer2 = _interopRequireDefault(_simpleRenderer);

var _contentExcerpt = __webpack_require__(985);

var _contentExcerpt2 = _interopRequireDefault(_contentExcerpt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentExcerpt = function ContentExcerpt(_ref) {
  var content = _ref.content,
      query = _ref.query,
      type = _ref.type;

  var className = (0, _classnames2.default)(_contentExcerpt2.default.container, _contentExcerpt2.default[type]);
  return _react2.default.createElement(
    'div',
    { className: className, 'data-hook': 'post-description' },
    _react2.default.createElement(
      _reactDotdotdot2.default,
      { clamp: 4 },
      _react2.default.createElement(_simpleRenderer2.default, { contentState: content, query: query })
    )
  );
};

ContentExcerpt.SMALL = 'small';
ContentExcerpt.MEDIUM = 'medium';
ContentExcerpt.LARGE = 'large';
ContentExcerpt.LARGE = 'search';

ContentExcerpt.propTypes = {
  content: _propTypes2.default.object.isRequired,
  query: _propTypes2.default.string,
  type: _propTypes2.default.string
};

exports.default = ContentExcerpt;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(14);
var clamp = __webpack_require__(976);
var PropTypes = __webpack_require__(1);
/**
 * multuline text-overflow: ellipsis
 */
function Dotdotdot() {
  if(!(this instanceof Dotdotdot)) {
    throw new TypeError("Cannot call a class as a function");
  }
  this.update = this.update.bind(this);
}

Dotdotdot.prototype = Object.create(React.Component.prototype);
Dotdotdot.prototype.componentDidMount = function() {
  this.dotdotdot(ReactDOM.findDOMNode(this.refs.container));
  window.addEventListener('resize', this.update, false);
};
Dotdotdot.prototype.componentWillUnmount = function() {
  window.removeEventListener('resize', this.update, false);
};
Dotdotdot.prototype.componentDidUpdate = function() {
  this.dotdotdot(ReactDOM.findDOMNode(this.refs.container));
};

Dotdotdot.prototype.dotdotdot = function(container) {
  if (this.props.clamp) {
    if (container.length) {
      throw new Error('Please provide exacly one child to dotdotdot');
    }

    clamp(container, {
      clamp: this.props.clamp,
      useNativeClamp: this.props.useNativeClamp,
      truncationChar: this.props.truncationChar
    });
  }
};
Dotdotdot.prototype.update = function() {
    this.forceUpdate();
};

Dotdotdot.prototype.render = function() {
  return React.createElement(
    "div",
    { ref: "container", className: this.props.className },
    this.props.children
  );
};

// Statics:
Dotdotdot.propTypes = {
  children: PropTypes.node,
  clamp: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]).isRequired,
  truncationChar: PropTypes.string,
  useNativeClamp: PropTypes.bool,
  className: PropTypes.string
};

Dotdotdot.defaultProps = {
  truncationChar: '\u2026',
  useNativeClamp: true
};

module.exports = Dotdotdot;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Clamp.js 0.7.0
 * Based on: https://github.com/xavi160/Clamp.js/commit/e313818da231b8dd8fd603dd9c9a61a9d725c22f
 * Mixins:
 * - https://github.com/josephschmitt/Clamp.js/pull/50
 * - https://github.com/josephschmitt/Clamp.js/pull/49
 *
 * Copyright 2011-2013, Joseph Schmitt http://joe.sh
 * Released under the WTFPL license
 * http://sam.zoy.org/wtfpl/
 */

(function(root, factory) {
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory();
  } else {
    // Browser globals
    root.$clamp = factory();
  }
}(this, function() {
  /**
   * Clamps a text node.
   * @param {HTMLElement} element. Element containing the text node to clamp.
   * @param {Object} options. Options to pass to the clamper.
   */
  function clamp(element, options) {
    options = options || {};

    var self = this,
      win = window,
      opt = {
        clamp: options.clamp || 2,
        useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
        splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
        animate: options.animate || false,
        truncationChar: options.truncationChar || '…',
        truncationHTML: options.truncationHTML
      },

      sty = element.style,
      originalText = element.innerHTML,

      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
      clampValue = opt.clamp,
      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
      truncationHTMLContainer;

    if (opt.truncationHTML) {
      truncationHTMLContainer = document.createElement('span');
      truncationHTMLContainer.innerHTML = opt.truncationHTML;
    }


    // UTILITY FUNCTIONS __________________________________________________________

    /**
     * Return the current style for an element.
     * @param {HTMLElement} elem The element to compute.
     * @param {string} prop The style property.
     * @returns {number}
     */
    function computeStyle(elem, prop) {
      if (!win.getComputedStyle) {
        win.getComputedStyle = function(el, pseudo) {
          this.el = el;
          this.getPropertyValue = function(prop) {
            var re = /(\-([a-z]){1})/g;
            if (prop == 'float') prop = 'styleFloat';
            if (re.test(prop)) {
              prop = prop.replace(re, function() {
                return arguments[2].toUpperCase();
              });
            }
            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
          };
          return this;
        };
      }

      return win.getComputedStyle(elem, null).getPropertyValue(prop);
    }

    /**
     * Returns the maximum number of lines of text that should be rendered based
     * on the current height of the element and the line-height of the text.
     */
    function getMaxLines(height) {
      var availHeight = height || element.clientHeight,
        lineHeight = getLineHeight(element);

      return Math.max(Math.floor(availHeight / lineHeight), 0);
    }

    /**
     * Returns the maximum height a given element should have based on the line-
     * height of the text and the given clamp value.
     */
    function getMaxHeight(clmp) {
      var lineHeight = getLineHeight(element);
      return lineHeight * clmp;
    }

    /**
     * Returns the line-height of an element as an integer.
     */
    function getLineHeight(elem) {
      var lh = computeStyle(elem, 'line-height');
      if (lh == 'normal') {
        // Normal line heights vary from browser to browser. The spec recommends
        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
        lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
      }
      return parseInt(lh);
    }


    // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
    var splitOnChars = opt.splitOnChars.slice(0),
      splitChar = splitOnChars[0],
      chunks,
      lastChunk;

    /**
     * Gets an element's last child. That may be another node or a node's contents.
     */
    function getLastChild(elem) {
      if (!elem.lastChild) {
        return;
      }
      //Current element has children, need to go deeper and get last child as a text node
      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
        return getLastChild(Array.prototype.slice.call(elem.children).pop());
      }
      //Handle scenario where the last child is white-space node
      else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue == opt.truncationChar) {
        var sibling = elem.lastChild;
        do {
          if (!sibling) {
            return;
          }
          //TEXT_NODE
          if (sibling.nodeType === 3 && ['', opt.truncationChar].indexOf(sibling.nodeValue) === -1) {
            return sibling;
          }
          if (sibling.lastChild) {
            var lastChild = getLastChild(sibling);
            if (lastChild) {
              return lastChild;
            }
          }
          //Current sibling is pretty useless
          sibling.parentNode.removeChild(sibling);
        } while (sibling = sibling.previousSibling);
      }
      //This is the last child we want, return it
      else {
        return elem.lastChild;
      }
    }

    /**
     * Removes one character at a time from the text until its width or
     * height is beneath the passed-in max param.
     */
    function truncate(target, maxHeight) {
      if (!target || !maxHeight) {
        return;
      }

      /**
       * Resets global variables.
       */
      function reset() {
        splitOnChars = opt.splitOnChars.slice(0);
        splitChar = splitOnChars[0];
        chunks = null;
        lastChunk = null;
      }

      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

      //Grab the next chunks
      if (!chunks) {
        //If there are more characters to try, grab the next one
        if (splitOnChars.length > 0) {
          splitChar = splitOnChars.shift();
        }
        //No characters to chunk by. Go character-by-character
        else {
          splitChar = '';
        }

        chunks = nodeValue.split(splitChar);
      }

      //If there are chunks left to remove, remove the last one and see if
      // the nodeValue fits.
      if (chunks.length > 1) {
        // console.log('chunks', chunks);
        lastChunk = chunks.pop();
        // console.log('lastChunk', lastChunk);
        applyEllipsis(target, chunks.join(splitChar));
      }
      //No more chunks can be removed using this character
      else {
        chunks = null;
      }

      //Insert the custom HTML before the truncation character
      if (truncationHTMLContainer) {
        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
      }

      //Search produced valid chunks
      if (chunks) {
        //It fits
        if (element.clientHeight <= maxHeight) {
          //There's still more characters to try splitting on, not quite done yet
          if (splitOnChars.length >= 0 && splitChar !== '') {
            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
            chunks = null;
          }
          //Finished!
          else {
            return element.innerHTML;
          }
        }
      }
      //No valid chunks produced
      else {
        //No valid chunks even when splitting by letter, time to move
        //on to the next node
        if (splitChar === '') {
          applyEllipsis(target, '');
          target = getLastChild(element);

          reset();
        }
      }

      //If you get here it means still too big, let's keep truncating
      if (opt.animate) {
        setTimeout(function() {
          truncate(target, maxHeight);
        }, opt.animate === true ? 10 : opt.animate);
      } else {
        return truncate(target, maxHeight);
      }
    }

    function applyEllipsis(elem, str) {
      elem.nodeValue = str + opt.truncationChar;
    }


    // CONSTRUCTOR ________________________________________________________________

    if (clampValue == 'auto') {
      clampValue = getMaxLines();
    } else if (isCSSValue) {
      clampValue = getMaxLines(parseInt(clampValue));
    }

    var clampedText;
    if (supportsNativeClamp && opt.useNativeClamp) {
      sty.overflow = 'hidden';
      sty.textOverflow = 'ellipsis';
      sty.webkitBoxOrient = 'vertical';
      sty.display = '-webkit-box';
      sty.webkitLineClamp = clampValue;

      if (isCSSValue) {
        sty.height = opt.clamp + 'px';
      }
    } else {
      var height = getMaxHeight(clampValue);
      if (height < element.clientHeight) {
        clampedText = truncate(getLastChild(element), height);
      }
    }

    return {
      'original': originalText,
      'clamped': clampedText
    };
  }

  return clamp;
}));


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _simpleRenderer = __webpack_require__(978);

var _simpleRenderer2 = _interopRequireDefault(_simpleRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _simpleRenderer2.default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _highlighter = __webpack_require__(370);

var _highlighter2 = _interopRequireDefault(_highlighter);

var _contentStateToString = __webpack_require__(553);

var _contentStateToString2 = _interopRequireDefault(_contentStateToString);

var _simpleRenderer = __webpack_require__(984);

var _simpleRenderer2 = _interopRequireDefault(_simpleRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Renderer = function Renderer(_ref) {
  var contentState = _ref.contentState,
      query = _ref.query;

  var content = (0, _contentStateToString2.default)(contentState);
  return _react2.default.createElement(
    'div',
    { className: _simpleRenderer2.default.content },
    query ? _react2.default.createElement(_highlighter2.default, { text: content, query: query }) : content
  );
};

Renderer.propTypes = {
  type: _propTypes2.default.string,
  contentState: _propTypes2.default.object,
  query: _propTypes2.default.string
};

exports.default = Renderer;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderNode = exports.RawParser = undefined;

var _RawParser = __webpack_require__(371);

var _RawParser2 = _interopRequireDefault(_RawParser);

var _render = __webpack_require__(981);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RawParser = _RawParser2.default;
exports.renderNode = _render.renderNode;
exports.default = _render.render;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContentNode = function () {
  function ContentNode(props) {
    _classCallCheck(this, ContentNode);

    this.content = props.content || [];
    this.start = typeof props.start !== 'undefined' ? props.start : null;
    this.end = typeof props.end !== 'undefined' ? props.end : null;
    this.entity = typeof props.entity !== 'undefined' ? props.entity : null;
    this.style = props.style || null;
  }

  _createClass(ContentNode, [{
    key: 'getCurrentContent',
    value: function getCurrentContent() {
      return this.content[this.content.length - 1];
    }
  }, {
    key: 'addToCurrentContent',
    value: function addToCurrentContent(string) {
      this.content[this.content.length - 1] = this.content[this.content.length - 1] + string;
    }
  }, {
    key: 'pushContent',
    value: function pushContent(string) {
      var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // we can just concat strings in case when both the pushed item
      // and the last element of the content array is a string
      // log
      if (!stack || stack.length < 1) {
        if (typeof string === 'string' && typeof this.getCurrentContent() === 'string') {
          this.addToCurrentContent(string);
        } else {
          this.content.push(string);
        }
        return this;
      }

      var _stack = _toArray(stack);

      var head = _stack[0];

      var rest = _stack.slice(1);

      var current = this.getCurrentContent();
      if (current instanceof ContentNode && current.style === head) {
        current.pushContent(string, rest);
      } else {
        var newNode = new ContentNode({ style: head });
        newNode.pushContent(string, rest);
        this.content.push(newNode);
      }
      return this;
    }
  }]);

  return ContentNode;
}();

exports.default = ContentNode;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = exports.renderNode = undefined;

var _RawParser = __webpack_require__(371);

var _RawParser2 = _interopRequireDefault(_RawParser);

var _warn = __webpack_require__(982);

var _warn2 = _interopRequireDefault(_warn);

var _checkClenup = __webpack_require__(983);

var _checkClenup2 = _interopRequireDefault(_checkClenup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  joinOutput: false,
  cleanup: {
    after: ['atomic'],
    types: ['unstyled'],
    trim: false
  }
};

/**
 * Concats or insets a string at given array index
 */
var pushString = function pushString(string, array, index) {
  var tempArray = array;
  if (!array[index]) {
    tempArray[index] = string;
  } else {
    tempArray[index] += string;
  }
  return tempArray;
};

/**
 * Joins the input if the joinOutput option is enabled
 */
var checkJoin = function checkJoin(input, options) {
  if (Array.isArray(input) && options.joinOutput) {
    return input.join('');
  }
  return input;
};

/**
 * Recursively renders a node with nested nodes with given callbacks
 */
var renderNode = exports.renderNode = function renderNode(node, styleRenderers, entityRenderers, entityMap, options) {
  var children = [];
  var index = 0;
  node.content.forEach(function (part) {
    if (typeof part === 'string') {
      children = pushString(part, children, index);
    } else {
      index += 1;
      children[index] = renderNode(part, styleRenderers, entityRenderers, entityMap, options);
      index += 1;
    }
  });
  if (node.style && styleRenderers[node.style]) {
    return styleRenderers[node.style](checkJoin(children, options));
  }
  if (node.entity !== null) {
    var entity = entityMap[node.entity];
    if (entity && entityRenderers[entity.type]) {
      return entityRenderers[entity.type](checkJoin(children, options), entity.data);
    }
  }
  return children;
};

/**
 * Nests blocks by depth as children
 */
var byDepth = function byDepth(blocks) {
  var group = [];
  var depthStack = [];
  var prevDepth = 0;
  var unwind = function unwind(targetDepth) {
    var i = prevDepth - targetDepth;
    // in case depthStack is too short for target depth
    if (depthStack.length < i) {
      i = depthStack.length;
    }
    for (i; i > 0; i -= 1) {
      var tmp = group;
      group = depthStack.pop();
      group[group.length - 1].children = tmp;
    }
  };

  blocks.forEach(function (block) {
    // if type of the block has changed render the block and clear group
    if (prevDepth < block.depth) {
      depthStack.push(group);
      group = [];
    } else if (prevDepth > block.depth) {
      unwind(block.depth);
    }
    prevDepth = block.depth;
    group.push(block);
  });
  if (prevDepth !== 0) {
    unwind(0);
  }
  return group;
};

/**
 * Renders blocks grouped by type using provided blockStyleRenderers
 */
var renderBlocks = function renderBlocks(blocks) {
  var inlineRenderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var blockRenderers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var entityRenderers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var entityMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var userOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  // initialize
  var options = Object.assign({}, defaultOptions, userOptions);
  var rendered = [];
  var group = [];
  var prevType = null;
  var prevDepth = 0;
  var prevKeys = [];
  var prevData = [];
  var Parser = new _RawParser2.default();

  blocks.forEach(function (block) {
    if ((0, _checkClenup2.default)(block, prevType, options)) {
      return;
    }
    var node = Parser.parse(block);
    var renderedNode = renderNode(node, inlineRenderers, entityRenderers, entityMap, options);
    // if type of the block has changed render the block and clear group
    if (prevType && prevType !== block.type) {
      if (blockRenderers[prevType]) {
        rendered.push(blockRenderers[prevType](group, prevDepth, {
          keys: prevKeys,
          data: prevData
        }));
        prevKeys = [];
        prevData = [];
      } else {
        rendered.push(group);
      }
      group = [];
    }
    // handle children
    if (block.children) {
      var children = renderBlocks(block.children, inlineRenderers, blockRenderers, entityRenderers, entityMap, options);
      renderedNode.push(children);
    }
    // push current node to group
    group.push(renderedNode);

    // lastly save current type for refference
    prevType = block.type;
    prevDepth = block.depth;
    prevKeys.push(block.key);
    prevData.push(block.data);
  });
  // render last group
  if (blockRenderers[prevType]) {
    rendered.push(blockRenderers[prevType](group, prevDepth, {
      keys: prevKeys,
      data: prevData
    }));
  } else {
    rendered.push(group);
  }
  return checkJoin(rendered, options);
};

/**
 * Converts and renders each block of Draft.js rawState
 */
var render = exports.render = function render(raw) {
  var renderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!raw || !Array.isArray(raw.blocks)) {
    (0, _warn2.default)('invalid raw object');
    return null;
  }
  // If the lenght of the blocks array is 0 its should not log a warning but still return a null
  if (!raw.blocks.length) {
    return null;
  }
  var inlineRenderers = renderers.inline;
  var blockRenderers = renderers.blocks;
  var entityRenderers = renderers.entities;


  var blocks = byDepth(raw.blocks);
  return renderBlocks(blocks, inlineRenderers, blockRenderers, entityRenderers, raw.entityMap, options);
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Logs a warning message if not in production
 */
var warn = function warn(msg) {
  if (false) {
    console.warn('Redraft: ' + msg); // eslint-disable-line no-console
  }
};

exports.default = warn;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Check if block has any text, respects trim setting
 */
var hasText = function hasText(text, _ref) {
  var trim = _ref.trim;
  return !!(trim ? text.trim() : text);
};

/**
 * Check if block has any data like text, metadata or entities
 */
var hasData = function hasData(block, options) {
  if (hasText(block.text, options)) {
    return true;
  }
  if (block.data && Object.keys(block.data).length) {
    return true;
  }
  if (block.entityRanges && block.entityRanges.length) {
    return true;
  }
  return false;
};

/**
 * Checks if current block is empty and if it should be ommited according to passed settings
 */
var checkCleanup = function checkCleanup(block, prevType, _ref2) {
  var cleanup = _ref2.cleanup;

  if (!cleanup || hasData(block, cleanup)) {
    return false;
  }
  // Check if cleanup is enabled after prev type
  if (cleanup.after && cleanup.after !== 'all' && !(cleanup.after.indexOf(prevType) !== -1)) {
    return false;
  }
  // Handle the except array if passed
  if (cleanup.except && !(cleanup.except.indexOf(block.type) !== -1)) {
    return true;
  }
  // Finaly if cleanup is enabled for current type
  if (cleanup.types && (cleanup.types === 'all' || cleanup.types.indexOf(block.type) !== -1)) {
    return true;
  }
  return false;
};

exports.default = checkCleanup;

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"uFiAR"};

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2hMaY","medium":"vElw5","large":"_2vkIW","search":"_3xSXG"};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _resolveUserImage = __webpack_require__(249);

var _resolveUserImage2 = _interopRequireDefault(_resolveUserImage);

var _postImage = __webpack_require__(987);

var _postImage2 = _interopRequireDefault(_postImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostImage = function PostImage(_ref) {
  var image = _ref.image,
      url = _ref.url,
      isPublic = _ref.isPublic;

  var props = isPublic ? { 'data-pin-url': url } : { 'data-pin-nopin': true };
  return _react2.default.createElement(
    'div',
    { className: _postImage2.default.container },
    _react2.default.createElement('img', _extends({ className: _postImage2.default.image, src: (0, _resolveUserImage2.default)(image) }, props))
  );
};

PostImage.propTypes = {
  image: _propTypes2.default.object.isRequired,
  url: _propTypes2.default.string,
  isPublic: _propTypes2.default.bool
};

exports.default = PostImage;

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_323MJ","image":"_2yaPv"};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _likeButton = __webpack_require__(989);

var _likeButton2 = _interopRequireDefault(_likeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LikeButton = function (_Component) {
  _inherits(LikeButton, _Component);

  function LikeButton(props) {
    _classCallCheck(this, LikeButton);

    var _this = _possibleConstructorReturn(this, (LikeButton.__proto__ || Object.getPrototypeOf(LikeButton)).call(this, props));

    _this.state = {
      isAnimationEnabled: false
    };


    _this.handleAnimation = _this.handleAnimation.bind(_this);
    return _this;
  }

  _createClass(LikeButton, [{
    key: 'handleAnimation',
    value: function handleAnimation(event) {
      if (this.props.isDisabled) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }
      if (!this.props.isLiked) {
        this.setState({ isAnimationEnabled: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLiked = _props.isLiked,
          likeCount = _props.likeCount,
          t = _props.t;
      var isAnimationEnabled = this.state.isAnimationEnabled;

      var likedStatusLabel = isLiked ? t('like-button.is-liked') : t('like-button.is-unliked');

      return _react2.default.createElement(
        'div',
        {
          onClick: this.handleAnimation,
          className: (0, _classnames2.default)(_likeButton2.default.heart, _defineProperty({}, _likeButton2.default.active, isLiked), _defineProperty({}, _likeButton2.default.isAnimationEnabled, isAnimationEnabled)),
          'aria-label': t('like-button.total-likes', { count: likeCount }) + ' ' + likedStatusLabel,
          'data-hook': 'like-button'
        },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_likeButton2.default.pos1) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_likeButton2.default.heartSparkle) })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_likeButton2.default.pos2) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_likeButton2.default.heartSparkle) })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_likeButton2.default.pos3) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_likeButton2.default.heartSparkle) })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_likeButton2.default.pos4) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_likeButton2.default.heartSparkle) })
        ),
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_likeButton2.default.heartRing) }),
        _react2.default.createElement(
          'svg',
          { className: (0, _classnames2.default)(_likeButton2.default.heartBody), width: '18', viewBox: '0 0 18 16' },
          _react2.default.createElement('path', {
            d: 'M314,262.364a4.309,4.309,0,0,0-8-2.279,4.309,4.309,0,0,0-8,2.279,4.366,4.366,0,0,0,1.483,3.286l6.123,6.185a0.553,0.553,0,0,0,.788,0l6.123-6.185A4.366,4.366,0,0,0,314,262.364Z',
            transform: 'translate(-297.25 -257.25)'
          })
        )
      );
    }
  }]);

  return LikeButton;
}(_react.Component);

LikeButton.propTypes = {
  isLiked: _propTypes2.default.bool,
  likeCount: _propTypes2.default.number.isRequired,
  isDisabled: _propTypes2.default.bool,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(LikeButton);

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isLiked":"lFAne","heart":"_6sRW_","heartRing":"_2oSAD","active":"_2OB5V","heartSparkle":"_24ftW","isAnimationEnabled":"_39rvN","pop-bounce":"l4TRo","popBounce":"l4TRo","explode":"_1MNHb","shoot":"_1jaWg","pos1":"_127iX","pos2":"_3DVTl","pos3":"_12G5I","pos4":"_3JSSf"};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _scrollListener = __webpack_require__(323);

var _scrollListener2 = _interopRequireDefault(_scrollListener);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteListLoader = function (_Component) {
  _inherits(InfiniteListLoader, _Component);

  function InfiniteListLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InfiniteListLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfiniteListLoader.__proto__ || Object.getPrototypeOf(InfiniteListLoader)).call.apply(_ref, [this].concat(args))), _this), _this.shouldLoadMore = function (position) {
      var end = (0, _scrollParent2.default)().scrollHeight;
      return position > end && _this.props.hasMore && !_this.props.isLoading;
    }, _this.handleScroll = function (scroll) {
      var position = scroll.scrollTop + scroll.documentHeight + _this.props.threshold;
      if (_this.shouldLoadMore(position)) {
        _this.props.onLoad();
      }
    }, _this.render = function () {
      var _this$props = _this.props,
          Element = _this$props.element,
          loader = _this$props.loader,
          hasMore = _this$props.hasMore,
          props = _objectWithoutProperties(_this$props, ['element', 'loader', 'hasMore']);

      var passProps = (0, _lodash.omit)(props, ['scroll', 'onLoad', 'isLoading', 'threshold', 'dispatch']);

      return _react2.default.createElement(
        Element,
        passProps,
        _react2.default.createElement(_scrollListener2.default, { onScroll: _this.handleScroll }),
        hasMore && loader
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return InfiniteListLoader;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    scroll: state.scroll
  };
};

InfiniteListLoader.propTypes = {
  element: _propTypes2.default.string,
  scroll: _propTypes2.default.object,
  loader: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  onLoad: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  threshold: _propTypes2.default.number
};

InfiniteListLoader.defaultProps = {
  element: 'div',
  hasMore: false,
  threshold: 500
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(InfiniteListLoader);

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReferrer = getReferrer;
exports.getCurrentOrigin = getCurrentOrigin;
exports.createBi = createBi;
exports.getSelectedItem = getSelectedItem;
exports.getPostSlugFromPathname = getPostSlugFromPathname;
exports.getCategorySlugFromPathname = getCategorySlugFromPathname;
exports.getLayoutName = getLayoutName;
exports.getCardSizeName = getCardSizeName;
exports.getTextAlignmentName = getTextAlignmentName;
exports.getImageCount = getImageCount;
exports.getQuoteCount = getQuoteCount;
exports.getVideoCount = getVideoCount;
exports.hasBiToken = hasBiToken;
exports.isNotDummyVisitorId = isNotDummyVisitorId;
exports.isNotEditor = isNotEditor;
exports.hasMemberId = hasMemberId;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _webBiLogger = __webpack_require__(1139);

var _webBiLogger2 = _interopRequireDefault(_webBiLogger);

var _cardSizes = __webpack_require__(224);

var CARD_SIZES = _interopRequireWildcard(_cardSizes);

var _layoutTypes = __webpack_require__(263);

var LAYOUT_TYPES = _interopRequireWildcard(_layoutTypes);

var _textAlignment = __webpack_require__(958);

var CATEGORY_TEXT_ALIGNMENT = _interopRequireWildcard(_textAlignment);

var _detectRoute = __webpack_require__(266);

var _detectRoute2 = _interopRequireDefault(_detectRoute);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _locationHistorySelectors = __webpack_require__(162);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getReferrer(state) {
  return (0, _detectRoute2.default)((0, _locationHistorySelectors.getPreviousLocation)(state));
}

function getCurrentOrigin(state) {
  return (0, _detectRoute2.default)((0, _locationHistorySelectors.getCurrentLocation)(state));
}

function createBi(_ref) {
  var endpoint = _ref.endpoint,
      src = _ref.src;

  return _webBiLogger2.default.factory({ endpoint: endpoint }).setDefaults({
    src: src,
    app_id: '14724f35-6794-cd1a-0244-25fd138f9242',
    app_site_id: _wixSdkPolyfill2.default.Utils.getInstanceId(),
    instance_id: _wixSdkPolyfill2.default.Utils.getInstanceId()
  }).logger();
}

function getSelectedItem(action) {
  var payload = action.payload;

  var selected_item_position = parseInt(payload.selected_item_position, 10) + 1;
  var id = parseInt(payload.selected_item_name, 10);

  var selected_item_name = _lodash2.default.findKey(LAYOUT_TYPES, function (type) {
    return type === id;
  }).toLowerCase();
  return {
    selected_item_position: selected_item_position,
    selected_item_name: selected_item_name
  };
}

function getPostSlugFromPathname(pathname) {
  return pathname.match(_detectRoute.routeMap[_detectRoute.POST_PAGE])[1];
}

function getCategorySlugFromPathname(pathname) {
  return pathname.match(_detectRoute.routeMap[_detectRoute.FEED_PAGE])[1];
}

function getLayoutName(id) {
  id = parseInt(id, 10);
  return _lodash2.default.findKey(LAYOUT_TYPES, function (type) {
    return type === id;
  }).toLowerCase();
}

function getCardSizeName(id) {
  id = parseInt(id, 10);
  return _lodash2.default.findKey(CARD_SIZES, function (type) {
    return type === id;
  }).toLowerCase();
}

function getTextAlignmentName(id) {
  id = parseInt(id, 10);
  return _lodash2.default.findKey(CATEGORY_TEXT_ALIGNMENT, function (type) {
    return type === id;
  }).toLowerCase();
}

function getImageCount(entity) {
  var content = entity.content;
  return _lodash2.default.filter(content.entityMap, function (entity) {
    return entity.type === 'IMAGE';
  }).length;
}

function getQuoteCount(entity) {
  var content = entity.content;
  return _lodash2.default.filter(content.blocks, function (entity) {
    return entity.type === 'blockquote';
  }).length;
}

function getVideoCount(entity) {
  var content = entity.content;
  return _lodash2.default.filter(content.entityMap, function (entity) {
    return entity.type === 'VIDEO' || entity.type === 'VIDEO-EMBED';
  }).length;
}

function hasBiToken(event) {
  return !!event.biToken;
}

function isNotDummyVisitorId(event) {
  return event.visitor_id !== '00000000-0000-0000-0000-000000000000';
}

function isNotEditor() {
  return _wixSdkPolyfill2.default.Utils.getViewMode() !== 'editor';
}

function hasMemberId(event) {
  return !!event.member_id;
}

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(425);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRouterRedux = __webpack_require__(44);

var _hideModal = __webpack_require__(152);

var _modalTypes = __webpack_require__(26);

var modalTypes = _interopRequireWildcard(_modalTypes);

var _createPost = __webpack_require__(200);

var _movePost = __webpack_require__(177);

var _changeCategory = __webpack_require__(994);

var _changeCategory2 = _interopRequireDefault(_changeCategory);

var _deletePost = __webpack_require__(132);

var _deleteComment = __webpack_require__(137);

var _deleteCategory = __webpack_require__(180);

var _reportComment = __webpack_require__(995);

var _reportPost = __webpack_require__(996);

var _reportUser = __webpack_require__(997);

var _insertTextEditorLink = __webpack_require__(454);

var _insertTextEditorVideoEmbed = __webpack_require__(998);

var _promoteModerator = __webpack_require__(139);

var _demoteModerator = __webpack_require__(140);

var _toggleUserSubscribe = __webpack_require__(527);

var _blockUser = __webpack_require__(178);

var _unblockUser = __webpack_require__(179);

var _openSettingsDialog = __webpack_require__(999);

var _messages = __webpack_require__(61);

var messageTypes = _interopRequireWildcard(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (createShowMessage) {
  return function (store) {
    var _ON_HIDE;

    var showMessage = createShowMessage(store);

    var ON_HIDE = (_ON_HIDE = {
      FOR_TEST: function FOR_TEST() {
        return { type: 'TEST' };
      }
    }, _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_CREATE_POST, function (post) {
      return (0, _createPost.createPost)(post);
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_CHANGE_CATEGORY, function (categoryId) {
      return function (dispatch) {
        return dispatch((0, _changeCategory2.default)(categoryId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.CATEGORY_UPDATE].content(), messageTypes.default[messageTypes.CATEGORY_UPDATE].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_DELETE_COMMENT, function (payload) {
      return function (dispatch) {
        return dispatch((0, _deleteComment.deleteComment)(payload)).then(function () {
          return showMessage(messageTypes.default[messageTypes.COMMENT_DELETE].content(), messageTypes.default[messageTypes.COMMENT_DELETE].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_DELETE_POST, function (postId) {
      return function (dispatch) {
        return dispatch((0, _deletePost.deletePost)(postId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.POST_DELETE].content(), messageTypes.default[messageTypes.POST_DELETE].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_DELETE_CATEGORY, function (categoryId) {
      return function (dispatch) {
        return dispatch((0, _deleteCategory.deleteCategory)(categoryId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.COMMENT_DELETE].content(), messageTypes.default[messageTypes.COMMENT_DELETE].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_DISCARD_POST, function (categorySlug) {
      return (0, _reactRouterRedux.replace)('/' + categorySlug);
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_PROMOTE_MODERATOR, function (userId) {
      return function (dispatch) {
        return dispatch((0, _promoteModerator.promoteModerator)(userId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.MEMBER_PROMOTE_MODERATOR].content(), messageTypes.default[messageTypes.MEMBER_PROMOTE_MODERATOR].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_DEMOTE_MODERATOR, function (userId) {
      return function (dispatch) {
        return dispatch((0, _demoteModerator.demoteModerator)(userId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.MEMBER_DEMOTE_MODERATOR].content(), messageTypes.default[messageTypes.MEMBER_DEMOTE_MODERATOR].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_UNFOLLOW_MEMBER, function (userId) {
      return (0, _toggleUserSubscribe.toggleUserSubscribe)(userId);
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_BLOCK_MEMBER, function (userId) {
      return function (dispatch) {
        return dispatch((0, _blockUser.blockUser)(userId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.MEMBER_BLOCK].content(), messageTypes.default[messageTypes.MEMBER_BLOCK].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_UNBLOCK_MEMBER, function (userId) {
      return function (dispatch) {
        return dispatch((0, _unblockUser.unblockUser)(userId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.MEMBER_UNBLOCK].content(), messageTypes.default[messageTypes.MEMBER_UNBLOCK].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_MOVE_POST, function (_ref) {
      var postId = _ref.postId,
          categoryId = _ref.categoryId;
      return function (dispatch) {
        return dispatch((0, _movePost.movePost)(postId, categoryId)).then(function () {
          return showMessage(messageTypes.default[messageTypes.POST_MOVE].content(), messageTypes.default[messageTypes.POST_MOVE].type);
        });
      };
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_REPORT_COMMENT, function (report) {
      return (0, _reportComment.reportComment)(report);
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_REPORT_POST, function (report) {
      return (0, _reportPost.reportPost)(report);
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_REPORT_MEMBER, function (report) {
      return (0, _reportUser.reportUser)(report);
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_TEXT_EDITOR_LINK, function (data) {
      return (0, _insertTextEditorLink.insertTextEditorLink)(_extends({}, data));
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED, function (data) {
      return (0, _insertTextEditorVideoEmbed.insertTextEditorVideoEmbed)(_extends({}, data));
    }), _defineProperty(_ON_HIDE, modalTypes.MODAL_TYPE_DEMO_MODE, function (data) {
      return function (dispatch) {
        if (data) {
          dispatch((0, _openSettingsDialog.openSettingsDialog)());
        }
      };
    }), _ON_HIDE);

    return function (next) {
      return function (action) {
        var _store$getState$modal = store.getState().modal,
            type = _store$getState$modal.type,
            focusOnCloseId = _store$getState$modal.focusOnCloseId;

        var onHide = ON_HIDE[type];

        if (action.type === _hideModal.HIDE_MODAL && focusOnCloseId) {
          var element = document.getElementById(focusOnCloseId);
          element && element.focus();
        }

        if (action.type === _hideModal.HIDE_MODAL && onHide && action.payload) {
          store.dispatch(onHide(action.payload));
        }

        next(action);
      };
    };
  };
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = __webpack_require__(44);

var _reduxForm = __webpack_require__(40);

var _categoriesSelectors = __webpack_require__(35);

exports.default = function (categoryId) {
  return function (dispatch, getState) {
    var state = getState();
    var category = (0, _categoriesSelectors.getCategory)(state, categoryId);

    dispatch((0, _reactRouterRedux.replace)('/' + category.slug));
    dispatch((0, _reactRouterRedux.push)('/' + category.slug + '/create-post'));
    dispatch((0, _reduxForm.change)('post', 'categoryId', categoryId));
    return Promise.resolve();
  };
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportComment = reportComment;
var REPORT_COMMENT_REQUEST = exports.REPORT_COMMENT_REQUEST = 'comment/REPORT_REQUEST';
var REPORT_COMMENT_SUCCESS = exports.REPORT_COMMENT_SUCCESS = 'comment/REPORT_SUCCESS';
var REPORT_COMMENT_FAILURE = exports.REPORT_COMMENT_FAILURE = 'comment/REPORT_FAILURE';

function reportComment() {
  var report = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: REPORT_COMMENT_REQUEST
    });

    var promise = request.post('/_api/posts/' + report.postId + '/comments/' + report.commentId + '/report', {
      reportType: report.reportType
    });

    return promise.then(function () {
      return dispatch({
        type: REPORT_COMMENT_SUCCESS,
        payload: {
          _id: report.commentId
        }
      });
    }).catch(function () {
      return dispatch({
        type: REPORT_COMMENT_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportPost = reportPost;
var REPORT_POST_REQUEST = exports.REPORT_POST_REQUEST = 'post/REPORT_REQUEST';
var REPORT_POST_SUCCESS = exports.REPORT_POST_SUCCESS = 'post/REPORT_SUCCESS';
var REPORT_POST_FAILURE = exports.REPORT_POST_FAILURE = 'post/REPORT_FAILURE';

function reportPost() {
  var report = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: REPORT_POST_REQUEST
    });

    var promise = request.post('/_api/posts/' + report._id + '/report', { reportType: report.reportType });

    return promise.then(function () {
      return dispatch({
        type: REPORT_POST_SUCCESS,
        payload: {
          _id: report._id
        }
      });
    }).catch(function () {
      return dispatch({
        type: REPORT_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportUser = reportUser;
var REPORT_USER_REQUEST = exports.REPORT_USER_REQUEST = 'user/REPORT_REQUEST';
var REPORT_USER_SUCCESS = exports.REPORT_USER_SUCCESS = 'user/REPORT_SUCCESS';
var REPORT_USER_FAILURE = exports.REPORT_USER_FAILURE = 'user/REPORT_FAILURE';

var reportUserRequest = exports.reportUserRequest = function reportUserRequest() {
  return { type: REPORT_USER_REQUEST };
};
var reportUserSuccess = exports.reportUserSuccess = function reportUserSuccess(payload) {
  return { type: REPORT_USER_SUCCESS, payload: payload };
};
var reportUserFailure = exports.reportUserFailure = function reportUserFailure() {
  return { type: REPORT_USER_FAILURE };
};

function reportUser() {
  var report = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(reportUserRequest());

    var promise = request.post('/_api/users/' + report._id + '/report', { reportType: report.reportType });

    return promise.then(function () {
      return dispatch(reportUserSuccess({ _id: report._id }));
    }).catch(function () {
      return dispatch(reportUserFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertTextEditorVideoEmbed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetchOembed = __webpack_require__(363);

var _insertTextEditorEntity = __webpack_require__(167);

var _setTextEditorEntityData = __webpack_require__(125);

var _textEditorSelectors = __webpack_require__(236);

var _videoEmbed = __webpack_require__(146);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var insertTextEditorVideoEmbed = function insertTextEditorVideoEmbed(_ref) {
  var identifier = _ref.identifier,
      entityData = _objectWithoutProperties(_ref, ['identifier']);

  return function (dispatch, getState) {
    var editorState = (0, _textEditorSelectors.getTextEditorStateByKey)(getState(), identifier);
    var entityKey = editorState.getCurrentContent().createEntity('VIDEO-EMBED', 'IMMUTABLE', _extends({}, entityData, {
      isLoading: true
    })).getLastCreatedEntityKey();

    dispatch((0, _insertTextEditorEntity.insertTextEditorEntity)({ identifier: identifier, entityKey: entityKey }));
    var publicUrl = (0, _videoEmbed.buildUrl)(entityData.url);
    return dispatch((0, _fetchOembed.fetchOembed)(publicUrl)).then(function (oembed) {
      return dispatch((0, _setTextEditorEntityData.setTextEditorEntityData)({
        identifier: identifier,
        entityKey: entityKey,
        entityData: {
          oembed: oembed,
          isLoading: false
        }
      }));
    });
  };
};
exports.insertTextEditorVideoEmbed = insertTextEditorVideoEmbed;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openSettingsDialog = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openSettingsDialog = exports.openSettingsDialog = function openSettingsDialog() {
  return function () {
    _wixSdkPolyfill2.default.Preview.openSettingsDialog();
  };
};

/***/ }),
/* 1000 */,
/* 1001 */,
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onUpdate = onUpdate;

var _getScrollOffset = __webpack_require__(1003);

var _getScrollOffset2 = _interopRequireDefault(_getScrollOffset);

var _scrollTo = __webpack_require__(537);

var _scrollTo2 = _interopRequireDefault(_scrollTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OFFSET = 120;

var currentLocation = null;
var hasScrolled = false;

function hashLinkHandler(location) {
  if (location) {
    currentLocation = location;
    hasScrolled = false;
  }

  var _currentLocation = currentLocation,
      hash = _currentLocation.hash;


  if (hash && !hasScrolled) {
    setTimeout(function () {
      var id = hash.replace('#', '');
      var element = document.getElementById(id);

      if (element) {
        var elementTop = element.getBoundingClientRect().top;
        (0, _scrollTo2.default)(Math.max((0, _getScrollOffset2.default)() + elementTop - OFFSET, 0));
        hasScrolled = true;
      }
    });
  }
}

exports.default = hashLinkHandler;

// onUpdate callback for react-router

function onUpdate() {
  hashLinkHandler(this.state.location);
}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollOffset;

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getScrollOffset() {
  var parent = (0, _scrollParent2.default)();
  return parent.scrollY || parent.scrollTop || 0;
}

/***/ }),
/* 1004 */,
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _demoMessageRoot = __webpack_require__(1059);

var _demoMessageRoot2 = _interopRequireDefault(_demoMessageRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _demoMessageRoot2.default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _messageRoot = __webpack_require__(1062);

var _messageRoot2 = _interopRequireDefault(_messageRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _messageRoot2.default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectTo404 = undefined;

var _reactRouterRedux = __webpack_require__(44);

var redirectTo404 = exports.redirectTo404 = function redirectTo404(search, pathname) {
  return function (dispatch) {
    if (pathname !== '/404') {
      dispatch((0, _reactRouterRedux.push)({ pathname: '/404' + search, state: 301 }));
    }
    return Promise.resolve();
  };
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postHeader = __webpack_require__(1065);

var _postHeader2 = _interopRequireDefault(_postHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postHeader2.default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postActions = __webpack_require__(1066);

var _postActions2 = _interopRequireDefault(_postActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postActions2.default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showShare = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showShare = exports.showShare = function showShare() {
  return _wixSdkPolyfill2.default.Utils.getViewMode() !== 'editor' && _wixSdkPolyfill2.default.Utils.getViewMode() !== 'preview';
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _iconTooltip = __webpack_require__(1068);

var _iconTooltip2 = _interopRequireDefault(_iconTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _iconTooltip2.default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANGE_PAGE = exports.CHANGE_PAGE = 'app/CHANGE_PAGE';

var changePage = exports.changePage = function changePage(payload) {
  return {
    type: CHANGE_PAGE,
    payload: payload
  };
};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var forMobileOnly = function forMobileOnly(Component) {
  return (0, _withDeviceType2.default)(function (_ref) {
    var isMobile = _ref.isMobile,
        props = _objectWithoutProperties(_ref, ['isMobile']);

    return isMobile ? _react2.default.createElement(Component, props) : null;
  });
};

exports.default = forMobileOnly;

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"topComment":"_3Q59d","topCommentLabel":"fqcBx"};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapToQuery(data) {
  var res = [];

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      // eslint-disable-line
      res.push(key + '=' + encodeURIComponent(data[key]));
    }
  }

  return res.join('&');
}

/**
 * Generates a valid GUID
 *
 * @returns {String}  GUID
 */
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
    return v.toString(16);
  });
}

exports.default = {
  mapToQuery: mapToQuery,
  generateGuid: generateGuid
};

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataSource = __webpack_require__(1127);

var _dataSource2 = _interopRequireDefault(_dataSource);

var _biLoadPhaseItem = __webpack_require__(1128);

var _biLoadPhaseItem2 = _interopRequireDefault(_biLoadPhaseItem);

var _durationItem = __webpack_require__(1017);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biErrorItem = __webpack_require__(1021);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(373);

var _performance2 = _interopRequireDefault(_performance);

var _resourceItem = __webpack_require__(1129);

var _resourceItem2 = _interopRequireDefault(_resourceItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base Logger
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, BaseLogger);

    this.appName = appName;
    this.appVersion = appVersion;
    this.reporter = reporter;
    this.params = { sessionId: sessionId };
    this.errorHandlerToggle = errorHandlerToggle;
    this.disableAutoLoadFinish = disableAutoLoadFinish;
    this.dataSource = new _dataSource2.default({ appName: appName });
    if (errorHandlerToggle) {
      window.fedopsLoggerErrorHandler.subscribeListener(appName, this.reportError.bind(this));
    }
  }

  _createClass(BaseLogger, [{
    key: 'reportNetworkAnalysis',
    value: function reportNetworkAnalysis() {
      var _this = this;

      var resources = _performance2.default.getResources();
      setTimeout(function () {
        try {
          var resourceDataItem = new _resourceItem2.default(_this.sessionId);
          var analysis = resourceDataItem.performNetworkAnalysis(resources);
          if (!analysis) {
            return;
          }
          var dataSource = _this.dataSource.clone().addItem(resourceDataItem).addItem(analysis);
          _this._report(dataSource);
        } catch (e) {
          console.error('[fedops] Failed to report resource metrics', e);
        }
      }, 1000);
    }
  }, {
    key: 'reportError',
    value: function reportError(error, errorType, errorInfo) {
      var interactionName = void 0;

      if (!this._appLoadedCalled) {
        interactionName = '[APP LOAD]';
      } else {
        interactionName = Object.keys(this._outgoingInteractions)[0];
      }

      var dataSource = this.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: errorType }).addItem({ errorInfo: errorInfo }).addItem(new _biErrorItem2.default(this.sessionId));

      // const stackTrace = error.stack;

      if (interactionName) {
        this._report(dataSource);
      }
    }
  }, {
    key: '_report',
    value: function _report(dataSource) {
      return this.reporter.report(dataSource.mergeItems());
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      return this.appVersion;
    }
  }, {
    key: 'getReporter',
    value: function getReporter() {
      return this.reporter;
    }
  }, {
    key: 'getParam',
    value: function getParam(paramName) {
      return this.params[paramName];
    }
  }, {
    key: '_isDisableAutoLoadFinish',
    value: function _isDisableAutoLoadFinish() {
      return this.disableAutoLoadFinish;
    }
  }, {
    key: 'appLoadingPhase',


    /**
     * Custom phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
     * Call this method to report custom phases during initial application load.
     *
     * @param {String} phaseName  phase name
     */
    value: function appLoadingPhase(phaseName) {
      var dataSource = this.dataSource.clone().addItem({ name: phaseName }).addItem(new _biLoadPhaseItem2.default(this.sessionId)).addItem(new _durationItem2.default());

      return this._report(dataSource);
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = __webpack_require__(1018);

var _time2 = _interopRequireDefault(_time);

var _dataItem = __webpack_require__(529);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DurationDataItem = function (_DataItem) {
  _inherits(DurationDataItem, _DataItem);

  function DurationDataItem(appName) {
    _classCallCheck(this, DurationDataItem);

    var _this = _possibleConstructorReturn(this, (DurationDataItem.__proto__ || Object.getPrototypeOf(DurationDataItem)).call(this, {
      duration: Math.floor(_time2.default.appLoadTime(appName))
    }));

    _this.appName = appName;
    return _this;
  }

  _createClass(DurationDataItem, [{
    key: 'setFirstRequestDuration',
    value: function setFirstRequestDuration() {
      this.data.frd = Math.floor(_time2.default.firstRequestDuration(this.appName));
      return this;
    }
  }]);

  return DurationDataItem;
}(_dataItem2.default);

exports.default = DurationDataItem;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appData = __webpack_require__(1019);

var _appData2 = _interopRequireDefault(_appData);

var _performance = __webpack_require__(373);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startLoadTime(appName) {
  return _appData2.default.getStartLoadTime(appName) || 0;
}

function endLoadTime() {
  return _performance2.default.now();
}

/**
 * calculates the app load time
 */
exports.default = {
  appLoadTime: function appLoadTime(appName) {
    return endLoadTime() - startLoadTime(appName);
  },
  loadStarted: function loadStarted(appName) {
    _appData2.default.setStartLoadTime(appName, _performance2.default.now());
  },
  firstRequestDuration: function firstRequestDuration(appName) {
    return startLoadTime(appName);
  }
};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * window.fedops.apps wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAppData(appName) {
  return window.fedops.apps[appName];
}

exports.default = {
  init: function init(appName) {
    window.fedops.apps[appName] = window.fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var location = function location() {
  return typeof window !== 'undefined' && window.location;
};

exports.default = {
  getHost: function getHost() {
    return location() && window.location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf('fedops=dev') > -1;
  }
};

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVID = undefined;

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVID = exports.EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiErrorItem = function (_BiBaseDataItem) {
  _inherits(BiErrorItem, _BiBaseDataItem);

  function BiErrorItem(sessionId) {
    _classCallCheck(this, BiErrorItem);

    return _possibleConstructorReturn(this, (BiErrorItem.__proto__ || Object.getPrototypeOf(BiErrorItem)).call(this, EVID, sessionId));
  }

  return BiErrorItem;
}(_biBaseItem2.default);

exports.default = BiErrorItem;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = buildUrl;
exports.guid = guid;

var _performance = __webpack_require__(1146);

var _env = __webpack_require__(374);

var DEFAULT_ENDPOINT = '';

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(_ref, params) {
  var host = _ref.host,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === undefined ? DEFAULT_ENDPOINT : _ref$endpoint;

  host = host || (0, _env.getHost)();

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round((0, _performance.now)());

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  /*eslint-enable */
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.sendBeacon = sendBeacon;

var _env = __webpack_require__(374);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.provideBrowsingContext)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.provideBrowsingContext)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    var fromUrl = window.document.referrer;

    [onLoad, onPushState, onPopState].forEach(function (event) {
      return event(function (toUrl) {
        cb(fromUrl, toUrl);
        fromUrl = toUrl;
      });
    });
  });
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}
//# sourceMappingURL=navigator.js.map


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_ACTIVE_DESIGN_PAGE = exports.SET_ACTIVE_DESIGN_PAGE = 'designTab/SET_ACTIVE_PAGE';
var setActiveDesignPage = exports.setActiveDesignPage = function setActiveDesignPage() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
  return {
    type: SET_ACTIVE_DESIGN_PAGE,
    payload: payload
  };
};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

var _createLocation2 = __webpack_require__(426);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _createBrowserHistory = __webpack_require__(427);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

exports.createHistory = _createBrowserHistory2['default'];

var _createHashHistory2 = __webpack_require__(280);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

exports.createHashHistory = _createHashHistory3['default'];

var _createMemoryHistory2 = __webpack_require__(431);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

exports.createMemoryHistory = _createMemoryHistory3['default'];

var _useBasename2 = __webpack_require__(281);

var _useBasename3 = _interopRequireDefault(_useBasename2);

exports.useBasename = _useBasename3['default'];

var _useBeforeUnload2 = __webpack_require__(432);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

exports.useBeforeUnload = _useBeforeUnload3['default'];

var _useQueries2 = __webpack_require__(119);

var _useQueries3 = _interopRequireDefault(_useQueries2);

exports.useQueries = _useQueries3['default'];

var _Actions2 = __webpack_require__(74);

var _Actions3 = _interopRequireDefault(_Actions2);

exports.Actions = _Actions3['default'];

// deprecated

var _enableBeforeUnload2 = __webpack_require__(1029);

var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);

exports.enableBeforeUnload = _enableBeforeUnload3['default'];

var _enableQueries2 = __webpack_require__(1030);

var _enableQueries3 = _interopRequireDefault(_enableQueries2);

exports.enableQueries = _enableQueries3['default'];
var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
exports.createLocation = createLocation;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var _slice = Array.prototype.slice;
exports.loopAsync = loopAsync;

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = undefined;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(_slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(377);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return key;
		}

		if (Array.isArray(val)) {
			return val.slice().sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

var _useBeforeUnload = __webpack_require__(432);

var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);

exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
module.exports = exports['default'];

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deprecate = __webpack_require__(73);

var _deprecate2 = _interopRequireDefault(_deprecate);

var _useQueries = __webpack_require__(119);

var _useQueries2 = _interopRequireDefault(_useQueries);

exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
module.exports = exports['default'];

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHashHistory = __webpack_require__(280);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _useQueries = __webpack_require__(119);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager = __webpack_require__(283);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _InternalPropTypes = __webpack_require__(76);

var _RouterContext = __webpack_require__(189);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = __webpack_require__(58);

var _RouterUtils = __webpack_require__(434);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function isDeprecatedHistory(history) {
  return !history || !history.__v2_compatible__;
}

/* istanbul ignore next: sanity check */
function isUnsupportedHistory(history) {
  // v3 histories expose getCurrentLocation, but aren't currently supported.
  return history && history.getCurrentLocation;
}

var _React$PropTypes = _react2.default.PropTypes;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // Deprecated:
    parseQueryString: func,
    stringifyQuery: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    var _props = this.props;
    var parseQueryString = _props.parseQueryString;
    var stringifyQuery = _props.stringifyQuery;

     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;

    var _createRouterObjects = this.createRouterObjects();

    var history = _createRouterObjects.history;
    var transitionManager = _createRouterObjects.transitionManager;
    var router = _createRouterObjects.router;


    this._unlisten = transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        _this.setState(state, _this.props.onUpdate);
      }
    });

    this.history = history;
    this.router = router;
  },
  createRouterObjects: function createRouterObjects() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext;
    }

    var history = this.props.history;
    var _props2 = this.props;
    var routes = _props2.routes;
    var children = _props2.children;


    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;

    if (isDeprecatedHistory(history)) {
      history = this.wrapDeprecatedHistory(history);
    }

    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

    return { history: routingHistory, transitionManager: transitionManager, router: router };
  },
  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
    var _props3 = this.props;
    var parseQueryString = _props3.parseQueryString;
    var stringifyQuery = _props3.stringifyQuery;


    var createHistory = void 0;
    if (history) {
       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
      createHistory = function createHistory() {
        return history;
      };
    } else {
       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
      createHistory = _createHashHistory2.default;
    }

    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state;
    var location = _state.location;
    var routes = _state.routes;
    var params = _state.params;
    var components = _state.components;
    var _props4 = this.props;
    var createElement = _props4.createElement;
    var render = _props4.render;

    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      history: this.history,
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(120);

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = __webpack_require__(284);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTransitionHook(hook, route, asyncArity) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (hook.length < asyncArity) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));

    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location, deprecatedPathname, deprecatedQuery) {
    if (deprecatedPathname) {
       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      redirectInfo = {
        pathname: deprecatedPathname,
        query: deprecatedQuery,
        state: location
      };

      return;
    }

    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](nextState, replace, next);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](state, nextState, replace, next);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = __webpack_require__(120);

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname;
  var query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(284);

var _makeStateWithLocation = __webpack_require__(433);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (!getComponent) {
    callback();
    return;
  }

  var location = nextState.location;

  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);

  getComponent.call(route, nextStateWithLocation, callback);
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = __webpack_require__(284);

var _makeStateWithLocation = __webpack_require__(433);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

var _PatternUtils = __webpack_require__(120);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(120);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(435);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = _react2.default.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

exports.default = IndexLink;
module.exports = exports['default'];

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withRouter;

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(282);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = _react2.default.createClass({
    displayName: 'WithRouter',

    contextTypes: { router: _PropTypes.routerShape },
    propTypes: { router: _PropTypes.routerShape },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      var props = _extends({}, this.props, { router: router });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return _react2.default.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
}
module.exports = exports['default'];

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(436);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */

var IndexRedirect = _react2.default.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(58);

var _InternalPropTypes = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react2.default.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */

var IndexRoute = _react2.default.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: _InternalPropTypes.falsy,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRoute;
module.exports = exports['default'];

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(58);

var _InternalPropTypes = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _InternalPropTypes = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A mixin that adds the "history" instance variable to components.
 */
var History = {

  contextTypes: {
    history: _InternalPropTypes.history
  },

  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
    this.history = this.context.history;
  }
};

exports.default = History;
module.exports = exports['default'];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
 * component that may be used to cancel a transition or prompt the user
 * for confirmation.
 *
 * On standard transitions, routerWillLeave receives a single argument: the
 * location we're transitioning to. To cancel the transition, return false.
 * To prompt the user for confirmation, return a prompt message (string).
 *
 * During the beforeunload event (assuming you're using the useBeforeUnload
 * history enhancer), routerWillLeave does not receive a location object
 * because it isn't possible for us to know the location we're transitioning
 * to. In this case routerWillLeave must return a prompt message to prevent
 * the user from closing the window/tab.
 */

var Lifecycle = {

  contextTypes: {
    history: object.isRequired,
    // Nested children receive the route as context, either
    // set by the route component using the RouteContext mixin
    // or by some other ancestor.
    route: object
  },

  propTypes: {
    // Route components receive the route object as a prop.
    route: object
  },

  componentDidMount: function componentDidMount() {
     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;

    var route = this.props.route || this.context.route;

    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;

    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
  }
};

exports.default = Lifecycle;
module.exports = exports['default'];

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The RouteContext mixin provides a convenient way for route
 * components to set the route in context. This is needed for
 * routes that render elements that want to use the Lifecycle
 * mixin to prevent transitions.
 */

var RouteContext = {

  propTypes: {
    route: object.isRequired
  },

  childContextTypes: {
    route: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      route: this.props.route
    };
  },
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
  }
};

exports.default = RouteContext;
module.exports = exports['default'];

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _useQueries = __webpack_require__(119);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _createTransitionManager = __webpack_require__(283);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know about routing.
 *
 * Enhances history objects with the following methods:
 *
 * - listen((error, nextState) => {})
 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
 * - match(location, (error, redirectLocation, nextState) => {})
 * - isActive(pathname, query, indexOnly=false)
 */
function useRoutes(createHistory) {
   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;

  return function () {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var routes = _ref.routes;

    var options = _objectWithoutProperties(_ref, ['routes']);

    var history = (0, _useQueries2.default)(createHistory)(options);
    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
    return _extends({}, history, transitionManager);
  };
}

exports.default = useRoutes;
module.exports = exports['default'];

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(189);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutingContext = _react2.default.createClass({
  displayName: 'RoutingContext',
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
  },
  render: function render() {
    return _react2.default.createElement(_RouterContext2.default, this.props);
  }
});

exports.default = RoutingContext;
module.exports = exports['default'];

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = __webpack_require__(74);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = __webpack_require__(437);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = __webpack_require__(283);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = __webpack_require__(58);

var _RouterUtils = __webpack_require__(434);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history;
  var routes = _ref.routes;
  var location = _ref.location;

  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  var unlisten = void 0;

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    // Pick up the location from the history via synchronous history.listen
    // call if needed.
    unlisten = history.listen(function (historyLocation) {
      location = historyLocation;
    });
  }

  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
      history: history,
      router: router,
      matchContext: { history: history, transitionManager: transitionManager, router: router }
    }));

    // Defer removing the listener to here to prevent DOM histories from having
    // to unwind DOM event listeners unnecessarily, in case callback renders a
    // <Router> and attaches another history listener.
    if (unlisten) {
      unlisten();
    }
  });
}

exports.default = match;
module.exports = exports['default'];

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(189);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(22);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
};

module.exports = exports['default'];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(427);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(439);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(280);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(439);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _rootBase = __webpack_require__(1058);

var _rootBase2 = _interopRequireDefault(_rootBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _rootBase2.default;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactRouter = __webpack_require__(244);

var _hashLinkHandler = __webpack_require__(1002);

var _i18nProvider = __webpack_require__(201);

var _i18nUtils = __webpack_require__(133);

var _reactI18next = __webpack_require__(34);

var _environmentProvider = __webpack_require__(538);

var _environmentProvider2 = _interopRequireDefault(_environmentProvider);

var _permissionsProvider = __webpack_require__(595);

var _permissionsProvider2 = _interopRequireDefault(_permissionsProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RootBase = function RootBase(_ref) {
  var store = _ref.store,
      history = _ref.history,
      environment = _ref.environment,
      children = _ref.children;
  return _react2.default.createElement(
    _environmentProvider2.default,
    { environment: environment },
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _permissionsProvider2.default,
        { store: store },
        _react2.default.createElement(
          _reactI18next.I18nextProvider,
          { i18n: (0, _i18nProvider.initI18n)((0, _i18nUtils.getLanguage)(), (0, _i18nUtils.getTranslations)()) },
          _react2.default.createElement(
            _reactRouter.Router,
            { history: history, onUpdate: _hashLinkHandler.onUpdate },
            children
          )
        )
      )
    )
  );
};

RootBase.propTypes = {
  children: _propTypes2.default.object.isRequired,
  environment: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired,
  store: _propTypes2.default.object.isRequired
};

exports.default = RootBase;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _message = __webpack_require__(459);

var _message2 = _interopRequireDefault(_message);

var _isTemplate = __webpack_require__(406);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessageType = function getMessageType(viewMode) {
  if (viewMode === 'editor') {
    return _messages.DEMO_MODE_EDITOR;
  } else if (viewMode === 'preview') {
    return _messages.DEMO_MODE_PREVIEW;
  } else {
    return _messages.DEMO_MODE_SITE;
  }
};

var DemoMessageRoot = function DemoMessageRoot(_ref) {
  var viewMode = _ref.viewMode,
      isDemoMode = _ref.isDemoMode;

  if (isDemoMode && !(0, _isTemplate.isTemplate)()) {
    var messageType = getMessageType(viewMode);
    var message = _messages2.default[messageType];
    return _react2.default.createElement(_message2.default, { content: message.content(), type: message.type, alignment: 'center' });
  }
  return null;
};

DemoMessageRoot.propTypes = {
  viewMode: _propTypes2.default.string.isRequired,
  isDemoMode: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    viewMode: state.viewMode,
    isDemoMode: state.isDemoMode
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DemoMessageRoot);

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _message = __webpack_require__(1061);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = function Message(_ref) {
  var alignment = _ref.alignment,
      type = _ref.type,
      content = _ref.content,
      onClose = _ref.onClose,
      top = _ref.top,
      t = _ref.t;

  var isDefaultStyle = !type;
  var containerClassName = (0, _classnames2.default)(_message2.default.container, _message2.default[type], _message2.default[alignment], {
    'forum-card-color': isDefaultStyle,
    'icon-secondary-background-color': isDefaultStyle
  }, 'message');
  var style = {
    top: top + 'px'
  };

  if (typeof content !== 'function') {
    var element = content;
    content = function content() {
      return _react2.default.Children.only(element);
    };
  }

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: style },
    content(t),
    onClose && _react2.default.createElement('button', { className: (0, _classnames2.default)(_message2.default.close, 'message__close'), onClick: onClose })
  );
};

Message.propTypes = {
  onClose: _propTypes2.default.func,
  type: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.any,
  alignment: _propTypes2.default.string,
  top: _propTypes2.default.number,
  t: _propTypes2.default.func
};

Message.defaultProps = {
  top: 0,
  content: null
};

exports.default = (0, _withTranslate2.default)(Message);

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"LQjJp","error":"_1wsDM","info":"_1E5Pi","center":"_11-FA","close":"u7KRr"};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageRoot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(122);

var _reactRedux = __webpack_require__(5);

var _hideMessage = __webpack_require__(395);

var _message = __webpack_require__(459);

var _message2 = _interopRequireDefault(_message);

var _scrollListener = __webpack_require__(323);

var _scrollListener2 = _interopRequireDefault(_scrollListener);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLOSE_TIMEOUT = 3000;
var ANIMATION_TIMEOUT = 400;

var MessageRoot = exports.MessageRoot = function (_Component) {
  _inherits(MessageRoot, _Component);

  function MessageRoot() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MessageRoot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageRoot.__proto__ || Object.getPrototypeOf(MessageRoot)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.hideMessage = function () {
      _this.props.hideMessage();
      _this.timeout = undefined;
    }, _this.handleScroll = function (scroll) {
      var _this$state$scroll = _this.state.scroll;
      _this$state$scroll = _this$state$scroll === undefined ? {} : _this$state$scroll;
      var scrollTop = _this$state$scroll.scrollTop,
          height = _this$state$scroll.height;
      var isDesktop = _this.props.isDesktop;

      if (isDesktop && _this.timeout && scrollTop !== scroll.scrollTop && height === scroll.height) {
        clearTimeout(_this.timeout);
        _this.hideMessage();
      }
      _this.setState({ scroll: scroll });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MessageRoot, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var type = this.props.type;
      // TODO: implement this using middleware or something

      if (type !== nextProps.type) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.hideMessage, CLOSE_TIMEOUT);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state$scroll = this.state.scroll;
      _state$scroll = _state$scroll === undefined ? {} : _state$scroll;
      var scrollTop = _state$scroll.scrollTop,
          y = _state$scroll.y;
      var _props = this.props,
          type = _props.type,
          content = _props.content,
          hideMessage = _props.hideMessage,
          isDesktop = _props.isDesktop;

      var top = isDesktop ? Math.max(0, scrollTop - y) : 0;
      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransitionGroup,
        {
          component: 'div',
          transitionName: 'message',
          transitionEnterTimeout: ANIMATION_TIMEOUT,
          transitionLeaveTimeout: ANIMATION_TIMEOUT
        },
        content ? _react2.default.createElement(_message2.default, { type: type, content: content, onClose: hideMessage, top: top }) : null,
        _react2.default.createElement(_scrollListener2.default, { onScroll: this.handleScroll })
      );
    }
  }]);

  return MessageRoot;
}(_react.Component);

MessageRoot.propTypes = {
  hideMessage: _propTypes2.default.func.isRequired,
  type: _propTypes2.default.string,
  content: _propTypes2.default.any,
  isDesktop: _propTypes2.default.bool,
  scroll: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    type: state.message.type,
    content: state.message.content
  };
};

var mapDispatchToProps = {
  hideMessage: _hideMessage.hideMessage
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withDeviceType2.default)(MessageRoot);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _header = __webpack_require__(1475);

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _header2.default;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostListItem = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _postHeader = __webpack_require__(1008);

var _postHeader2 = _interopRequireDefault(_postHeader);

var _postTitle = __webpack_require__(970);

var _postTitle2 = _interopRequireDefault(_postTitle);

var _contentExcerpt = __webpack_require__(525);

var _contentExcerpt2 = _interopRequireDefault(_contentExcerpt);

var _postImage = __webpack_require__(554);

var _postImage2 = _interopRequireDefault(_postImage);

var _postVideoEmbed = __webpack_require__(1074);

var _postVideoEmbed2 = _interopRequireDefault(_postVideoEmbed);

var _protectedButton = __webpack_require__(274);

var _protectedButton2 = _interopRequireDefault(_protectedButton);

var _likeButton = __webpack_require__(372);

var _likeButton2 = _interopRequireDefault(_likeButton);

var _separator = __webpack_require__(18);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _getPostCover = __webpack_require__(526);

var _getPostCover2 = _interopRequireDefault(_getPostCover);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

var _categoriesSelectors = __webpack_require__(35);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _postListItem = __webpack_require__(1077);

var _postListItem2 = _interopRequireDefault(_postListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderImage = function renderImage(image, url, isPublic) {
  return image && _react2.default.createElement(_postImage2.default, { image: image, url: url, isPublic: isPublic });
};

var renderVideoEmbed = function renderVideoEmbed(oembed) {
  return oembed && _react2.default.createElement(_postVideoEmbed2.default, { oembed: oembed });
};

var PostListItem = exports.PostListItem = function PostListItem(_ref) {
  var type = _ref.type,
      t = _ref.t,
      category = _ref.category,
      post = _ref.post,
      query = _ref.query,
      onLikeClick = _ref.onLikeClick,
      borderWidth = _ref.borderWidth,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName,
      can = _ref.can,
      Link = _ref.navigation.Link,
      forPublicUser = _ref.forPublicUser;

  var handleLikeClick = function handleLikeClick(e) {
    e.preventDefault();
    onLikeClick('' + post._id);
  };
  var isSearch = type === PostListItem.SEARCH;
  var image = !isSearch && (0, _getPostCover2.default)(post.content);
  var videoEmbed = !isSearch && (0, _getPostCover.getPostVideoEmbedCover)(post.content);
  var showSeparator = !image;
  var className = (0, _classnames2.default)(_postListItem2.default.container, _postListItem2.default[type], contentFontClassName, 'forum-text-color', 'forum-card-background-color', 'forum-card-border-color', 'post-list-item', _defineProperty({}, _postListItem2.default.withImage, image || videoEmbed));
  var postLink = '/' + category.slug + '/' + post.slug;
  var likeCount = post.likeCount || 0;

  if (videoEmbed) {
    image = undefined;
  }

  return _react2.default.createElement(
    Link,
    {
      className: className,
      to: postLink,
      style: { borderWidth: borderWidth },
      renderInSeo: false,
      role: 'article',
      'data-hook': 'post-list-item'
    },
    _react2.default.createElement(_postHeader2.default, { type: type, post: post, showTopComment: true }),
    _react2.default.createElement(_postTitle2.default, { className: titleFontClassName, type: type, title: post.title, query: query, to: postLink }),
    _react2.default.createElement(
      'div',
      { className: _postListItem2.default.content },
      _react2.default.createElement(_contentExcerpt2.default, { type: type, content: post.content, query: query })
    ),
    renderImage(image, (0, _getOuterUrl2.default)(postLink), can('share', 'post', post)),
    renderVideoEmbed(videoEmbed),
    _react2.default.createElement(
      'div',
      { className: _postListItem2.default.footer },
      showSeparator && _react2.default.createElement(_separator.HorizontalSeparator, { className: _postListItem2.default.separator }),
      _react2.default.createElement(
        'div',
        { className: _postListItem2.default.footerContent },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_postListItem2.default.viewCount, 'post-list-item__view-count'),
            'data-hook': 'post-list-item__view-count'
          },
          t('post-list-item.view-count', { count: post.viewCount || 0 })
        ),
        _react2.default.createElement(
          'object',
          { type: 'communities/link' },
          _react2.default.createElement(
            Link,
            {
              className: (0, _classnames2.default)(_postListItem2.default.commentCount, 'forum-text-color'),
              to: '' + postLink,
              'data-hook': 'post-list-item__comment-count'
            },
            t('post-list-item.total-comments', { count: post.totalComments || 0 })
          )
        ),
        _react2.default.createElement(
          _protectedButton2.default,
          {
            className: (0, _classnames2.default)(_postListItem2.default.likeButton, contentFontClassName),
            onClick: forPublicUser(handleLikeClick, { preventDefault: true }),
            'aria-live': 'assertive',
            'data-hook': 'post-list-item__like-button'
          },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(_postListItem2.default.likeCount, 'forum-text-color'), 'data-hook': 'post-list-item__like-count' },
            t('post-list-item.like-count', { count: likeCount })
          ),
          _react2.default.createElement(_likeButton2.default, { isLiked: post.isLiked, likeCount: likeCount, isDisabled: post.isLikeInProgress })
        )
      )
    )
  );
};

PostListItem.SMALL = 'small';
PostListItem.MEDIUM = 'medium';
PostListItem.LARGE = 'large';
PostListItem.SEARCH = 'search';
PostListItem.MEMBERS_AREA = 'membersArea';

PostListItem.propTypes = {
  onLikeClick: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func,
  category: _propTypes2.default.object,
  post: _propTypes2.default.object.isRequired,
  query: _propTypes2.default.string,
  type: _propTypes2.default.string,
  borderWidth: _propTypes2.default.number,
  titleFontClassName: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string,
  can: _propTypes2.default.func,
  navigation: _propTypes2.default.object,
  forPublicUser: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    category: (0, _categoriesSelectors.getCategory)(state, ownProps.post.categoryId)
  };
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps), _withCardBorderWidth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withFontClassName2.default, _withPermissions2.default, _withPermissions2.default, _withTranslate2.default, _withAuth2.default)(PostListItem);

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTransitionGroup = __webpack_require__(122);

var _avatar = __webpack_require__(409);

var _avatar2 = _interopRequireDefault(_avatar);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _icons = __webpack_require__(9);

var _postActions = __webpack_require__(1009);

var _postActions2 = _interopRequireDefault(_postActions);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _postHeader = __webpack_require__(1067);

var _postHeader2 = _interopRequireDefault(_postHeader);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withTopCommentColor = __webpack_require__(276);

var _withTopCommentColor2 = _interopRequireDefault(_withTopCommentColor);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _experiments = __webpack_require__(32);

var _iconTooltip = __webpack_require__(1011);

var _iconTooltip2 = _interopRequireDefault(_iconTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIME_ANIMATION_TIMEOUT = 1000;
var ICON_ANIMATION_TIMEOUT = 200;

var renderPinIcon = function renderPinIcon(isPinned) {
  if (!isPinned) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: _postHeader2.default.iconWrapper, key: 'pin' },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_postHeader2.default.icon, 'pin-icon'), 'data-hook': 'pin-icon' },
      _react2.default.createElement(_icons.PinIcon, { className: 'icon-secondary-fill', isPinned: isPinned })
    )
  );
};

var renderLockIcon = function renderLockIcon(isCommentsDisabled) {
  if (!isCommentsDisabled) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: _postHeader2.default.iconWrapper, key: 'lock' },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_postHeader2.default.icon, 'lock-icon'), 'data-hook': 'lock-icon' },
      _react2.default.createElement(_icons.LockIcon, { className: 'icon-secondary-fill', isLocked: isCommentsDisabled })
    )
  );
};

var renderTopCommentIcon = function renderTopCommentIcon(topCommentColor, t) {
  return _react2.default.createElement(
    'div',
    { className: _postHeader2.default.iconWrapper, key: 'top-comment' },
    _react2.default.createElement(
      'div',
      { className: _postHeader2.default.icon, 'data-hook': 'top-comment-icon' },
      _react2.default.createElement(
        _iconTooltip2.default,
        { text: t('comment.top-comment') },
        _react2.default.createElement(_icons.TopCommentIcon, { className: 'button-fill', color: topCommentColor })
      )
    )
  );
};

var avatarTypeMap = {
  single: _avatar2.default.LARGE,
  search: _avatar2.default.LARGE,
  large: _avatar2.default.LARGE
};

function PostHeader(_ref) {
  var type = _ref.type,
      post = _ref.post,
      isAnimated = _ref.isAnimated,
      ProfileLink = _ref.navigation.ProfileLink,
      showTopComment = _ref.showTopComment,
      topCommentColor = _ref.topCommentColor,
      isTopCommentExperimentEnabled = _ref.isTopCommentExperimentEnabled,
      t = _ref.t;

  var owner = post.owner || {};
  var className = (0, _classnames2.default)(_postHeader2.default.container, _postHeader2.default[type], 'post-header');
  var avatarType = avatarTypeMap[type];
  var moreButtonId = 'more-button-' + post._id;
  var shouldShowTopComment = isTopCommentExperimentEnabled && showTopComment && Boolean(post.topCommentId);
  return _react2.default.createElement(
    'div',
    { className: className },
    owner.slug && _react2.default.createElement(
      'object',
      { type: 'communities/link' },
      _react2.default.createElement(
        ProfileLink,
        { user: owner },
        _react2.default.createElement(_avatar2.default, { type: avatarType, user: owner })
      )
    ),
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        className: _postHeader2.default.date,
        transitionName: _postHeader2.default,
        transitionEnterTimeout: TIME_ANIMATION_TIMEOUT,
        transitionAppearTimeout: TIME_ANIMATION_TIMEOUT,
        transitionLeaveTimeout: 0,
        transitionAppear: isAnimated
      },
      _react2.default.createElement(
        'div',
        { className: _postHeader2.default.status, key: 'timeago' },
        _react2.default.createElement(_timeAgo2.default, { time: post.createdDate })
      )
    ),
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        className: _postHeader2.default.icons,
        transitionName: 'post-header-icons',
        transitionEnterTimeout: ICON_ANIMATION_TIMEOUT,
        transitionLeaveTimeout: ICON_ANIMATION_TIMEOUT
      },
      renderPinIcon(post.isPinned),
      renderLockIcon(post.isCommentsDisabled),
      shouldShowTopComment && renderTopCommentIcon(topCommentColor, t)
    ),
    _react2.default.createElement(
      'div',
      { className: _postHeader2.default.moreButton },
      _react2.default.createElement(
        _moreButton2.default,
        { id: moreButtonId },
        _react2.default.createElement(_postActions2.default, { post: post, focusOnCloseId: moreButtonId })
      )
    )
  );
}

PostHeader.SINGLE = 'single';
PostHeader.SEARCH = 'search';
PostHeader.SMALL = 'small';
PostHeader.MEDIUM = 'medium';
PostHeader.LARGE = 'large';
PostHeader.MEMBERS_AREA = 'membersArea';

PostHeader.propTypes = {
  type: _propTypes2.default.string,
  isAnimated: _propTypes2.default.bool,
  post: _propTypes2.default.object.isRequired,
  navigation: _propTypes2.default.object,
  topCommentColor: _propTypes2.default.string,
  showTopComment: _propTypes2.default.bool,
  isTopCommentExperimentEnabled: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)((0, _withEnvironment2.default)({ navigation: 'navigation' }), _withTopCommentColor2.default, _withTranslate2.default, (0, _withExperiment2.default)({ isTopCommentExperimentEnabled: _experiments.EXPERIMENT_TOP_COMMENT }))(PostHeader);

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _icons = __webpack_require__(9);

var _actionButton = __webpack_require__(250);

var _actionButton2 = _interopRequireDefault(_actionButton);

var _pinPost = __webpack_require__(398);

var _unpinPost = __webpack_require__(399);

var _enablePostComments = __webpack_require__(400);

var _disablePostComments = __webpack_require__(401);

var _openModal = __webpack_require__(36);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _buttonClicked2 = __webpack_require__(57);

var _actionsOpened = __webpack_require__(293);

var _actionsClosed = __webpack_require__(294);

var _modalTypes = __webpack_require__(26);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _showShare = __webpack_require__(1010);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _categoriesSelectors = __webpack_require__(35);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostActions = exports.PostActions = function (_Component) {
  _inherits(PostActions, _Component);

  function PostActions(props) {
    _classCallCheck(this, PostActions);

    var _this = _possibleConstructorReturn(this, (PostActions.__proto__ || Object.getPrototypeOf(PostActions)).call(this, props));

    _this.navigateToEditPost = function () {
      var _this$props = _this.props,
          buttonClicked = _this$props.buttonClicked,
          category = _this$props.category,
          navigateToEditPost = _this$props.navigation.navigateToEditPost,
          post = _this$props.post;

      navigateToEditPost('/' + category.slug + '/' + post.slug + '/edit');
      buttonClicked({ action: 'edit' });
    };

    _this.handlePin = _this.handlePin.bind(_this);
    _this.handleComments = _this.handleComments.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.handleSubscription = _this.handleSubscription.bind(_this);
    return _this;
  }

  _createClass(PostActions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actionsOpened({ type: 'post' });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.actionsClosed({ type: 'post' });
    }
  }, {
    key: 'handlePin',
    value: function handlePin() {
      var _props = this.props,
          _props$post = _props.post,
          _id = _props$post._id,
          isPinned = _props$post.isPinned,
          buttonClicked = _props.buttonClicked,
          pinPost = _props.pinPost,
          unpinPost = _props.unpinPost,
          showMessage = _props.showMessage;


      buttonClicked({ action: 'pin', flag: Number(!isPinned) });
      if (isPinned) {
        unpinPost(_id).then(function () {
          return showMessage(_messages2.default[_messages.POST_UNPIN].content(), _messages2.default[_messages.POST_UNPIN].type);
        });
      } else {
        pinPost(_id).then(function () {
          return showMessage(_messages2.default[_messages.POST_PIN].content(), _messages2.default[_messages.POST_PIN].type);
        });
      }
    }
  }, {
    key: 'handleSubscription',
    value: function handleSubscription() {
      var _props2 = this.props,
          _props2$post = _props2.post,
          _id = _props2$post._id,
          isSubscribed = _props2$post.isSubscribed,
          buttonClicked = _props2.buttonClicked,
          subscribe = _props2.subscribe,
          unsubscribe = _props2.unsubscribe,
          showMessage = _props2.showMessage;


      buttonClicked({ action: 'follow_post', flag: Number(!isSubscribed) });
      if (isSubscribed) {
        unsubscribe({ _id: _id, type: 'post' }).then(function () {
          return showMessage(_messages2.default[_messages.POST_UNSUBSCRIBED].content(), _messages2.default[_messages.POST_UNSUBSCRIBED].type);
        });
      } else {
        subscribe({ _id: _id, type: 'post' }).then(function () {
          return showMessage(_messages2.default[_messages.POST_SUBSCRIBED].content(), _messages2.default[_messages.POST_SUBSCRIBED].type);
        });
      }
    }
  }, {
    key: 'handleComments',
    value: function handleComments() {
      var _props3 = this.props,
          _props3$post = _props3.post,
          _id = _props3$post._id,
          isCommentsDisabled = _props3$post.isCommentsDisabled,
          buttonClicked = _props3.buttonClicked,
          enablePostComments = _props3.enablePostComments,
          disablePostComments = _props3.disablePostComments,
          showMessage = _props3.showMessage;


      buttonClicked({ action: 'lock', flag: Number(!isCommentsDisabled) });
      if (isCommentsDisabled) {
        enablePostComments(_id).then(function () {
          return showMessage(_messages2.default[_messages.POST_ENABLE_COMMENTING].content(), _messages2.default[_messages.POST_ENABLE_COMMENTING].type);
        });
      } else {
        disablePostComments(_id).then(function () {
          return showMessage(_messages2.default[_messages.POST_DISABLE_COMMENTING].content(), _messages2.default[_messages.POST_DISABLE_COMMENTING].type);
        });
      }
    }
  }, {
    key: 'showModal',
    value: function showModal(type) {
      var props = {
        categoryId: this.props.category._id,
        categorySlug: this.props.category.slug,
        postId: this.props.post._id,
        postSlug: this.props.post.slug
      };
      var _props4 = this.props,
          buttonClicked = _props4.buttonClicked,
          openModal = _props4.openModal,
          focusOnCloseId = _props4.focusOnCloseId;


      return function () {
        buttonClicked({ action: type });
        openModal(type, props, focusOnCloseId);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          canRender = _props5.canRender,
          post = _props5.post,
          categoryCount = _props5.categoryCount,
          t = _props5.t,
          forPublicUser = _props5.forPublicUser;

      var editButton = canRender('edit', 'post', post, function (can) {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'post-actions__edit',
            onClick: can ? _this2.navigateToEditPost : forPublicUser(_this2.navigateToEditPost)
          },
          _react2.default.createElement(_icons.EditIcon, { className: 'forum-icon-fill' }),
          t('post-actions.edit-post')
        );
      });
      var shareButton = (0, _showShare.showShare)() && canRender('share', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'post-actions__share', onClick: _this2.showModal(_modalTypes.MODAL_TYPE_SHARE_POST) },
          _react2.default.createElement(_icons.ShareIcon, { className: 'forum-icon-fill' }),
          t('post-actions.share-post')
        );
      });
      var pinButton = canRender('pin', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'post-actions__pin', onClick: _this2.handlePin },
          _react2.default.createElement(_icons.PinIcon, { isPinned: post.isPinned, className: 'forum-icon-fill' }),
          post.isPinned ? t('post-actions.unpin-post') : t('post-actions.pin-post')
        );
      });
      var commentsButton = canRender('toggle-comments', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'post-actions__comments', onClick: _this2.handleComments },
          _react2.default.createElement(_icons.LockIcon, { isLocked: post.isCommentsDisabled, className: 'forum-icon-fill' }),
          post.isCommentsDisabled ? t('post-actions.enable-commenting') : t('post-actions.disable-commenting')
        );
      });
      var moveButton = categoryCount > 1 && canRender('move', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'post-actions__move', onClick: _this2.showModal(_modalTypes.MODAL_TYPE_MOVE_POST) },
          _react2.default.createElement(_icons.MoveIcon, { className: 'forum-icon-fill' }),
          t('post-actions.move-to-cateogory')
        );
      });
      var reportButton = canRender('report', 'post', post, function (can) {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'post-actions__report',
            onClick: can ? _this2.showModal(_modalTypes.MODAL_TYPE_REPORT_POST) : forPublicUser(_this2.showModal(_modalTypes.MODAL_TYPE_REPORT_POST))
          },
          _react2.default.createElement(_icons.ReportIcon, { className: 'forum-icon-fill' }),
          t('post-actions.report-post')
        );
      });
      var deleteButton = canRender('delete', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'post-actions__delete', onClick: _this2.showModal(_modalTypes.MODAL_TYPE_DELETE_POST) },
          _react2.default.createElement(_icons.DeleteIcon, { className: 'forum-icon-fill' }),
          t('post-actions.delete-post')
        );
      });
      var subscribeButton = canRender('subscribe', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'post-actions__subscriptions', onClick: forPublicUser(_this2.handleSubscription) },
          _react2.default.createElement(_icons.SubscribeIcon, { isSubscribed: post.isSubscribed, className: 'forum-icon-fill' }),
          post.isSubscribed ? t('post-actions.unfollow') : t('post-actions.follow')
        );
      });
      return _react2.default.createElement(
        'div',
        null,
        subscribeButton,
        editButton,
        shareButton,
        pinButton,
        commentsButton,
        moveButton,
        reportButton,
        deleteButton
      );
    }
  }]);

  return PostActions;
}(_react.Component);

PostActions.propTypes = {
  forPublicUser: _propTypes2.default.func,
  subscribe: _propTypes2.default.func,
  unsubscribe: _propTypes2.default.func,
  t: _propTypes2.default.func,
  buttonClicked: _propTypes2.default.func,
  post: _propTypes2.default.object.isRequired,
  category: _propTypes2.default.object,
  categoryCount: _propTypes2.default.number,
  openModal: _propTypes2.default.func,
  focusOnCloseId: _propTypes2.default.string,
  showMessage: _propTypes2.default.func,
  pinPost: _propTypes2.default.func,
  unpinPost: _propTypes2.default.func,
  enablePostComments: _propTypes2.default.func,
  disablePostComments: _propTypes2.default.func,
  actionsOpened: _propTypes2.default.func,
  actionsClosed: _propTypes2.default.func,
  goToEditPage: _propTypes2.default.func,
  canRender: _propTypes2.default.func,
  navigation: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state, _ref) {
  var post = _ref.post;
  return {
    category: (0, _categoriesSelectors.getCategory)(state, post.categoryId),
    categoryCount: (0, _categoriesSelectors.getCategoryCount)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openModal: _openModal.openModal,
    subscribe: _subscribe.subscribe,
    unsubscribe: _unsubscribe.unsubscribe,
    actionsOpened: _actionsOpened.actionsOpened,
    actionsClosed: _actionsClosed.actionsClosed,
    pinPost: _pinPost.pinPost,
    unpinPost: _unpinPost.unpinPost,
    enablePostComments: _enablePostComments.enablePostComments,
    disablePostComments: _disablePostComments.disablePostComments,
    buttonClicked: function buttonClicked(data) {
      return (0, _buttonClicked2.buttonClicked)(_extends({ name: 'action_click', type: 'post' }, data));
    }
  }, dispatch);
};

exports.default = (0, _lodash.flowRight)((0, _withEnvironment2.default)({
  navigation: 'navigation',
  showMessage: 'showMessage'
}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withAuth2.default, _withPermissions2.default, _withTranslate2.default)(PostActions);

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3xbLk","single":"_2czru","medium":"_1EB0G","search":"_2mzvI","large":"_3tFhP","membersArea":"_3xoQ5","date":"_27HWd","moreButton":"_3rXbM","icons":"_2mwEI","icon":"_2GWae","iconWrapper":"_1xL2F","status":"_12I_f","enter":"zJJgG","appear":"_1txAE","enterActive":"_37W2r","appearActive":"_16CaP"};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOverlays = __webpack_require__(154);

var _borderedTooltip = __webpack_require__(1069);

var _borderedTooltip2 = _interopRequireDefault(_borderedTooltip);

var _withSettingsColor = __webpack_require__(68);

var _withSettingsColor2 = _interopRequireDefault(_withSettingsColor);

var _wixParams = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconTooltip = function (_Component) {
  _inherits(IconTooltip, _Component);

  function IconTooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IconTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconTooltip.__proto__ || Object.getPrototypeOf(IconTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isTooltipVisible: false
    }, _this.handleMouseEnter = function () {
      _this.timeout = setTimeout(function () {
        _this.setState({
          isTooltipVisible: true
        });
      }, 500);
    }, _this.handleMouseLeave = function () {
      clearTimeout(_this.timeout);
      _this.setState({
        isTooltipVisible: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconTooltip, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleMouseLeave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          text = _props.text,
          backgroundColor = _props.backgroundColor,
          borderColor = _props.borderColor,
          className = _props.className;

      var tooltipClassName = (0, _classnames2.default)('forum-content-medium-font', 'forum-text-color');
      var tooltipStyle = { borderColor: borderColor, backgroundColor: backgroundColor, fontSize: 12 };
      return _react2.default.createElement(
        'div',
        {
          className: className,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        },
        children,
        _react2.default.createElement(
          _reactOverlays.Overlay,
          {
            show: this.state.isTooltipVisible,
            placement: 'top',
            target: this
          },
          _react2.default.createElement(
            _borderedTooltip2.default,
            { className: tooltipClassName, style: tooltipStyle },
            text
          )
        )
      );
    }
  }]);

  return IconTooltip;
}(_react.Component);

IconTooltip.propTypes = {
  children: _propTypes2.default.node.isRequired,
  text: _propTypes2.default.string.isRequired,
  backgroundColor: _propTypes2.default.string.isRequired,
  borderColor: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.default = (0, _lodash.flowRight)((0, _withSettingsColor2.default)(_wixParams.CARD_BACKGROUND_COLOR_PATH, 'backgroundColor', 'color-1', 1), (0, _withSettingsColor2.default)(_wixParams.APP_TEXT_COLOR_PATH, 'borderColor', 'color-5', 0.2))(IconTooltip);

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _borderedTooltip = __webpack_require__(1070);

var _borderedTooltip2 = _interopRequireDefault(_borderedTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _borderedTooltip2.default;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _borderedTooltip = __webpack_require__(1071);

var _borderedTooltip2 = _interopRequireDefault(_borderedTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BorderedTooltip = function BorderedTooltip(_ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      offset = _ref.offset;

  style.top -= offset;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_borderedTooltip2.default.container, className), style: style },
    children,
    _react2.default.createElement('span', { className: _borderedTooltip2.default.triangle })
  );
};

BorderedTooltip.propTypes = {
  children: _propTypes2.default.node.isRequired,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  offset: _propTypes2.default.number
};

BorderedTooltip.defaultProps = {
  offset: 10
};

exports.default = BorderedTooltip;

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_38vsq","triangle":"_3i0IH"};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _highlighter = __webpack_require__(370);

var _highlighter2 = _interopRequireDefault(_highlighter);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _postTitle = __webpack_require__(1073);

var _postTitle2 = _interopRequireDefault(_postTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTitle = function renderTitle(title, to, Link) {
  return to ? _react2.default.createElement(
    'object',
    { type: 'communities/link' },
    _react2.default.createElement(
      Link,
      { to: to, style: { color: 'inherit' } },
      title
    )
  ) : _react2.default.createElement(
    'span',
    null,
    title
  );
};

var PostTitle = function PostTitle(_ref) {
  var title = _ref.title,
      type = _ref.type,
      query = _ref.query,
      className = _ref.className,
      to = _ref.to,
      Component = _ref.component,
      Link = _ref.navigation.Link;

  var containerClassName = (0, _classnames2.default)(_postTitle2.default.title, _postTitle2.default[type], className, 'forum-text-color', 'post-title');
  return _react2.default.createElement(
    Component,
    { className: containerClassName, 'data-hook': 'post-title', tabIndex: '0' },
    renderTitle(query ? _react2.default.createElement(_highlighter2.default, { text: title, query: query }) : title, to, Link)
  );
};

PostTitle.SMALL = 'small';
PostTitle.MEDIUM = 'medium';
PostTitle.LARGE = 'large';
PostTitle.SINGLE = 'single';
PostTitle.SEARCH = 'search';
PostTitle.MEMBERS_AREA = 'membersArea';

PostTitle.propTypes = {
  title: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string,
  query: _propTypes2.default.string,
  className: _propTypes2.default.string,
  to: _propTypes2.default.string,
  component: _propTypes2.default.any,
  navigation: _propTypes2.default.object
};

PostTitle.defaultProps = {
  component: 'h2'
};

exports.default = (0, _withEnvironment2.default)({ navigation: 'navigation' })(PostTitle);

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"_1dN_D","single":"_1ipgj","medium":"_1qN9A","search":"sAGvv","large":"_1Iw0w","membersArea":"_3npnP"};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postVideoEmbed = __webpack_require__(1075);

var _postVideoEmbed2 = _interopRequireDefault(_postVideoEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postVideoEmbed2.default;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _videoEmbed = __webpack_require__(407);

var _videoEmbed2 = _interopRequireDefault(_videoEmbed);

var _postVideoEmbed = __webpack_require__(1076);

var _postVideoEmbed2 = _interopRequireDefault(_postVideoEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostImage = function PostImage(_ref) {
  var oembed = _ref.oembed;
  return _react2.default.createElement(
    'div',
    { className: _postVideoEmbed2.default.container },
    _react2.default.createElement(_videoEmbed2.default, { oembed: oembed })
  );
};

PostImage.propTypes = {
  oembed: _propTypes2.default.object.isRequired
};

exports.default = PostImage;

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"OP9It"};

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1HZQ5","membersArea":"_2Dwp6","search":"_27m14","likeCount":"_2HbU8","large":"_2yC7p","separator":"_1kcFW","withImage":"_3yema","footerContent":"_27Yfa","content":"_3PoZM","small":"_1xBLL","medium":"_2MwUY","footer":"WdcC4","viewCount":"_1U4OT","commentCount":"_2j8xA","likeButton":"_28WxH"};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _getUserPrivacyStatus = __webpack_require__(1079);

var _getUserPrivacyStatus2 = _interopRequireDefault(_getUserPrivacyStatus);

var _updateUserPrivacyStatus = __webpack_require__(389);

var _viewModes = __webpack_require__(161);

var _experiments = __webpack_require__(32);

var _wixSdkUtils = __webpack_require__(21);

var _experimentsSelectors = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listenToMemberDetailsUpdated = function listenToMemberDetailsUpdated(store) {
  var updatePrivacyStatus = function updatePrivacyStatus() {
    if ((0, _wixSdkUtils.getViewMode)() === _viewModes.VIEW_MODE_SITE) {
      (0, _getUserPrivacyStatus2.default)(function (privacyStatus) {
        store.dispatch((0, _updateUserPrivacyStatus.updateUserPrivacyStatus)(privacyStatus));
      });
    }
  };

  if ((0, _experimentsSelectors.isExperimentEnabled)(store.getState(), _experiments.EXPERIMENT_MEMBERS_AREA)) {
    _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.MEMBER_DETAILS_UPDATED, updatePrivacyStatus);
    updatePrivacyStatus();
  }
};

exports.default = listenToMemberDetailsUpdated;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserPrivacyStatus = function getUserPrivacyStatus(cb) {
  return _wixSdkPolyfill2.default.currentMember(function (member) {
    if (!member) {
      return cb(undefined);
    }

    var _ref = member.data || member,
        attributes = _ref.attributes;

    console.info('privacyStatus: ' + attributes.privacyStatus);
    cb(attributes.privacyStatus);
  });
};

exports.default = getUserPrivacyStatus;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _showMessage = __webpack_require__(159);

exports.default = function (store) {
  return function () {
    return store.dispatch(_showMessage.showMessage.apply(undefined, arguments));
  };
};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_FORUM_FORM = exports.SHOW_FORUM_FORM = 'forumForm/SHOW';
var showForumForm = exports.showForumForm = function showForumForm() {
  return { type: SHOW_FORUM_FORM };
};

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TEXTBOX_CHANGED = exports.TEXTBOX_CHANGED = 'settings/TEXTBOX_CHANGED';
var textboxChanged = exports.textboxChanged = function textboxChanged(payload) {
  return {
    type: TEXTBOX_CHANGED,
    payload: payload
  };
};

/***/ }),
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COVER_TYPE_COLOR = exports.COVER_TYPE_COLOR = 'color';
var COVER_TYPE_IMAGE = exports.COVER_TYPE_IMAGE = 'image';
// export const COVER_TYPE_NONE = 'none';

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentHeader = __webpack_require__(1108);

var _commentHeader2 = _interopRequireDefault(_commentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentHeader2.default;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentFooter = __webpack_require__(1119);

var _commentFooter2 = _interopRequireDefault(_commentFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentFooter2.default;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIVE_TAB_CHANGED = exports.ACTIVE_TAB_CHANGED = 'settings/ACTIVE_TAB_CHANGED';
var activeTabChanged = exports.activeTabChanged = function activeTabChanged(payload) {
  return {
    type: ACTIVE_TAB_CHANGED,
    payload: payload
  };
};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORUM_RENAMED = exports.FORUM_RENAMED = 'settings/FORUM_RENAMED';
var forumRenamed = exports.forumRenamed = function forumRenamed() {
  return {
    type: FORUM_RENAMED
  };
};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORUM_RENAME_STARTED = exports.FORUM_RENAME_STARTED = 'settings/FORUM_RENAME_STARTED';
var forumRenameStarted = exports.forumRenameStarted = function forumRenameStarted() {
  return {
    type: FORUM_RENAME_STARTED
  };
};

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LAYOUT_CHANGED = exports.LAYOUT_CHANGED = 'settings/LAYOUT_CHANGED';
var layoutChanged = exports.layoutChanged = function layoutChanged(payload) {
  return {
    type: LAYOUT_CHANGED,
    payload: payload
  };
};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CATEGORY_EDITED = exports.CATEGORY_EDITED = 'settings/CATEGORY_EDITED';
var categoryEdited = exports.categoryEdited = function categoryEdited() {
  return {
    type: CATEGORY_EDITED
  };
};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CATEGORY_RENAMED = exports.CATEGORY_RENAMED = 'settings/CATEGORY_RENAMED';
var categoryRenamed = exports.categoryRenamed = function categoryRenamed() {
  return {
    type: CATEGORY_RENAMED
  };
};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CATEGORY_RENAME_STARTED = exports.CATEGORY_RENAME_STARTED = 'settings/CATEGORY_RENAME_STARTED';
var categoryRenameStarted = exports.categoryRenameStarted = function categoryRenameStarted() {
  return {
    type: CATEGORY_RENAME_STARTED
  };
};

/***/ }),
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _infiniteList = __webpack_require__(1540);

var _infiniteList2 = _interopRequireDefault(_infiniteList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _infiniteList2.default;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _headerBackButton = __webpack_require__(1573);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _headerBackButton2.default;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postStats = __webpack_require__(1106);

var _postStats2 = _interopRequireDefault(_postStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postStats2.default;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _postStats = __webpack_require__(1107);

var _postStats2 = _interopRequireDefault(_postStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PostStats(_ref) {
  var _classNames;

  var viewCount = _ref.viewCount,
      commentCount = _ref.commentCount,
      t = _ref.t,
      type = _ref.type;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _postStats2.default.counter, type === PostStats.DEFAULT), _defineProperty(_classNames, _postStats2.default.counterMemberArea, type === PostStats.MEMBER_AREA), _classNames), 'post-stats')
    },
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(_postStats2.default.viewCount), 'data-hook': 'post-stats__view-count' },
      t('post-stats.view-count', { count: viewCount })
    ),
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(_postStats2.default.commentCount), 'data-hook': 'post-stats__comment-count' },
      t('post-stats.comment-count', { count: commentCount })
    )
  );
}

PostStats.DEFAULT = 'default';
PostStats.MEMBER_AREA = 'memberArea';

PostStats.propTypes = {
  commentCount: _propTypes2.default.number.isRequired,
  viewCount: _propTypes2.default.number.isRequired,
  t: _propTypes2.default.func,
  type: _propTypes2.default.string
};

PostStats.defaultProps = {
  commentCount: 0,
  viewCount: 0,
  type: PostStats.DEFAULT
};

exports.default = (0, _withTranslate2.default)(PostStats);

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"counter":"_14IkK","counterMemberArea":"_1LP5U","viewCount":"_1Im9V","commentCount":"_3zSyF"};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _commentActions = __webpack_require__(1109);

var _commentActions2 = _interopRequireDefault(_commentActions);

var _commentAvatar = __webpack_require__(1111);

var _commentAvatar2 = _interopRequireDefault(_commentAvatar);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _topComment = __webpack_require__(1114);

var _topComment2 = _interopRequireDefault(_topComment);

var _commentHeader = __webpack_require__(1118);

var _commentHeader2 = _interopRequireDefault(_commentHeader);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderMoreButton = function renderMoreButton(doRender, comment) {
  var moreButtonId = 'more-button-' + comment._id;

  if (doRender) {
    return _react2.default.createElement(
      'div',
      { className: _commentHeader2.default.moreButton },
      _react2.default.createElement(
        _moreButton2.default,
        { id: moreButtonId },
        _react2.default.createElement(_commentActions2.default, { comment: comment, focusOnCloseId: moreButtonId })
      )
    );
  }
};

var CommentHeader = function CommentHeader(_ref) {
  var type = _ref.type,
      comment = _ref.comment,
      showMoreButton = _ref.showMoreButton,
      ProfileLink = _ref.navigation.ProfileLink,
      showTopComment = _ref.showTopComment;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(_commentHeader2.default.commentHeader, _commentHeader2.default[type], _defineProperty({}, _commentHeader2.default.withMoreButton, showMoreButton), 'comment-header')
    },
    _react2.default.createElement(
      'object',
      { type: 'communities/link', className: _commentHeader2.default.commentAvatar },
      _react2.default.createElement(
        ProfileLink,
        { user: comment.owner },
        _react2.default.createElement(_commentAvatar2.default, { user: comment.owner, type: type })
      )
    ),
    _react2.default.createElement(
      'span',
      { className: _commentHeader2.default.commentTime },
      _react2.default.createElement(_timeAgo2.default, { time: comment.createdDate })
    ),
    showTopComment && _react2.default.createElement(_topComment2.default, null),
    renderMoreButton(showMoreButton, comment, showTopComment)
  );
};

CommentHeader.SEARCH = 'search';

CommentHeader.defaultProps = {
  showTopComment: false
};

CommentHeader.propTypes = {
  type: _propTypes2.default.string,
  comment: _propTypes2.default.object.isRequired,
  showMoreButton: _propTypes2.default.bool,
  navigation: _propTypes2.default.object,
  showTopComment: _propTypes2.default.bool
};

exports.default = (0, _withEnvironment2.default)({ navigation: 'navigation' })(CommentHeader);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentActions = __webpack_require__(1110);

var _commentActions2 = _interopRequireDefault(_commentActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentActions2.default;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _openModal = __webpack_require__(36);

var _startEditingComment = __webpack_require__(1000);

var _buttonClicked2 = __webpack_require__(57);

var _actionsOpened = __webpack_require__(293);

var _actionsClosed = __webpack_require__(294);

var _addTopComment = __webpack_require__(449);

var _removeTopComment = __webpack_require__(450);

var _icons = __webpack_require__(9);

var _actionButton = __webpack_require__(250);

var _actionButton2 = _interopRequireDefault(_actionButton);

var _modalTypes = __webpack_require__(26);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _postSelectors = __webpack_require__(117);

var _categoriesSelectors = __webpack_require__(35);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var showShare = function showShare() {
  return _wixSdkPolyfill2.default.Utils.getViewMode() !== 'editor' && _wixSdkPolyfill2.default.Utils.getViewMode() !== 'preview';
};

var CommentActions = exports.CommentActions = function (_Component) {
  _inherits(CommentActions, _Component);

  function CommentActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentActions.__proto__ || Object.getPrototypeOf(CommentActions)).call.apply(_ref, [this].concat(args))), _this), _this.openModal = function (type) {
      return function () {
        var _this$props = _this.props,
            buttonClicked = _this$props.buttonClicked,
            openModal = _this$props.openModal,
            focusOnCloseId = _this$props.focusOnCloseId,
            category = _this$props.category,
            post = _this$props.post,
            comment = _this$props.comment;

        buttonClicked({ action: type });

        return openModal(type, {
          categoryId: category._id,
          categorySlug: category.slug,
          postId: post._id,
          postSlug: post.slug,
          commentId: comment._id
        }, focusOnCloseId);
      };
    }, _this.handleEdit = function () {
      var _this$props2 = _this.props,
          isMobile = _this$props2.isMobile,
          push = _this$props2.push,
          startEditingComment = _this$props2.startEditingComment,
          comment = _this$props2.comment,
          category = _this$props2.category,
          post = _this$props2.post;


      if (isMobile) {
        push('/' + category.slug + '/' + post.slug + '/edit-comment/' + comment._id);
      } else {
        startEditingComment(comment._id);
      }
    }, _this.handleAddTopComment = function () {
      var _this$props3 = _this.props,
          post = _this$props3.post,
          comment = _this$props3.comment,
          buttonClicked = _this$props3.buttonClicked,
          addTopComment = _this$props3.addTopComment,
          showMessage = _this$props3.showMessage;

      buttonClicked({ action: 'add-top-comment' });
      addTopComment(post._id, comment._id).then(function () {
        return showMessage(_messages2.default[_messages.POST_ADD_TOP_COMMENT].content(), _messages2.default[_messages.POST_ADD_TOP_COMMENT].type);
      });
    }, _this.handleRemoveTopComment = function () {
      var _this$props4 = _this.props,
          post = _this$props4.post,
          buttonClicked = _this$props4.buttonClicked,
          removeTopComment = _this$props4.removeTopComment,
          showMessage = _this$props4.showMessage;

      buttonClicked({ action: 'remove-top-comment' });
      removeTopComment(post._id).then(function () {
        return showMessage(_messages2.default[_messages.POST_REMOVE_TOP_COMMENT].content(), _messages2.default[_messages.POST_REMOVE_TOP_COMMENT].type);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommentActions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actionsOpened({ type: 'comment' });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.actionsClosed({ type: 'comment' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canRender = _props.canRender,
          comment = _props.comment,
          t = _props.t,
          forPublicUser = _props.forPublicUser;

      var shareButton = canRender('share', 'comment', comment, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'comment-actions__share', onClick: _this2.openModal(_modalTypes.MODAL_TYPE_SHARE_COMMENT) },
          _react2.default.createElement(_icons.ShareIcon, { className: 'forum-icon-fill' }),
          t('comment-actions.share-comment')
        );
      });
      var reportButton = canRender('report', 'comment', comment, function (can) {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'comment-actions__report',
            onClick: can ? _this2.openModal(_modalTypes.MODAL_TYPE_REPORT_COMMENT) : forPublicUser(_this2.openModal(_modalTypes.MODAL_TYPE_REPORT_COMMENT))
          },
          _react2.default.createElement(_icons.ReportIcon, { className: 'forum-icon-fill' }),
          t('comment-actions.report-comment')
        );
      });
      var editButton = canRender('edit', 'comment', comment, function (can) {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'comment-actions__edit',
            onClick: can ? _this2.handleEdit : forPublicUser(_this2.handleEdit), className: 'comment-actions__edit'
          },
          _react2.default.createElement(_icons.EditIcon, { className: 'forum-icon-fill' }),
          t('comment-actions.edit-comment')
        );
      });
      var deleteButton = canRender('delete', 'comment', comment, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'comment-actions__delete', onClick: _this2.openModal(_modalTypes.MODAL_TYPE_DELETE_COMMENT) },
          _react2.default.createElement(_icons.DeleteIcon, { className: 'forum-icon-fill' }),
          t('comment-actions.delete-comment')
        );
      });
      return _react2.default.createElement(
        'div',
        null,
        showShare() && shareButton,
        this.renderTopCommentButton(),
        reportButton,
        editButton,
        deleteButton
      );
    }
  }, {
    key: 'renderTopCommentButton',
    value: function renderTopCommentButton() {
      var _this3 = this;

      var _props2 = this.props,
          canRender = _props2.canRender,
          post = _props2.post,
          comment = _props2.comment,
          t = _props2.t;


      if (post.topCommentId !== comment._id) {
        return canRender('add-top-comment', 'post', post, function () {
          return _react2.default.createElement(
            _actionButton2.default,
            { 'data-hook': 'comment-actions__add-top-comment', onClick: _this3.handleAddTopComment },
            _react2.default.createElement(_icons.TopCommentIcon, { className: 'forum-icon-fill' }),
            t('comment-actions.add-top-comment')
          );
        });
      }

      return canRender('remove-top-comment', 'post', post, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'comment-actions__remove-top-comment', onClick: _this3.handleRemoveTopComment },
          _react2.default.createElement(_icons.TopCommentIcon, { className: 'forum-icon-fill' }),
          t('comment-actions.remove-top-comment')
        );
      });
    }
  }]);

  return CommentActions;
}(_react.Component);

CommentActions.propTypes = {
  comment: _propTypes2.default.object.isRequired,
  post: _propTypes2.default.object.isRequired,
  category: _propTypes2.default.object.isRequired,
  currentUser: _propTypes2.default.object,
  isOwner: _propTypes2.default.bool,
  openModal: _propTypes2.default.func.isRequired,
  startEditingComment: _propTypes2.default.func.isRequired,
  buttonClicked: _propTypes2.default.func.isRequired,
  actionsOpened: _propTypes2.default.func.isRequired,
  actionsClosed: _propTypes2.default.func.isRequired,
  addTopComment: _propTypes2.default.func.isRequired,
  removeTopComment: _propTypes2.default.func.isRequired,
  canRender: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  push: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool.isRequired,
  focusOnCloseId: _propTypes2.default.string.isRequired,
  forPublicUser: _propTypes2.default.func,
  showMessage: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var comment = ownProps.comment;
  var post = (0, _postSelectors.getPost)(state, comment.postId);
  var category = (0, _categoriesSelectors.getCategory)(state, post.categoryId);
  return { category: category, post: post };
};

var mapDispatchToProps = {
  openModal: _openModal.openModal,
  startEditingComment: _startEditingComment.startEditingComment,
  actionsOpened: _actionsOpened.actionsOpened,
  actionsClosed: _actionsClosed.actionsClosed,
  addTopComment: _addTopComment.addTopComment,
  removeTopComment: _removeTopComment.removeTopComment,
  buttonClicked: function buttonClicked(data) {
    return (0, _buttonClicked2.buttonClicked)(_extends({ name: 'action_click', type: 'comment' }, data));
  },
  push: _routerUtils.push
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default, _withPermissions2.default, _withDeviceType2.default, (0, _withEnvironment2.default)({
  showMessage: 'showMessage'
}), _withAuth2.default)(CommentActions);

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentAvatar = __webpack_require__(1112);

var _commentAvatar2 = _interopRequireDefault(_commentAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentAvatar2.default;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _userBadge = __webpack_require__(272);

var _userBadge2 = _interopRequireDefault(_userBadge);

var _commentAvatar = __webpack_require__(1113);

var _commentAvatar2 = _interopRequireDefault(_commentAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CommentAvatar(_ref) {
  var type = _ref.type,
      _ref$user = _ref.user,
      user = _ref$user === undefined ? {} : _ref$user;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_commentAvatar2.default.avatar, _commentAvatar2.default[type], 'forum-text-color') },
    _react2.default.createElement(_userAvatarImage2.default, { type: type ? 'comment' + _lodash2.default.capitalize(type) : 'comment', user: user }),
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_commentAvatar2.default.profileName, 'comment-avatar__profile-name') },
      user.name
    ),
    _react2.default.createElement(_userBadge2.default, { user: user })
  );
}

CommentAvatar.SEARCH = 'search';

CommentAvatar.propTypes = {
  user: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.string
};

exports.default = CommentAvatar;

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"avatar":"ahzms","profileName":"xxETZ","search":"_1qGRX"};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _topComment = __webpack_require__(1115);

var _topComment2 = _interopRequireDefault(_topComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _topComment2.default;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _topCommentDesktop = __webpack_require__(1116);

var _topCommentDesktop2 = _interopRequireDefault(_topCommentDesktop);

var _topCommentMobile = __webpack_require__(1117);

var _topCommentMobile2 = _interopRequireDefault(_topCommentMobile);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _forDevice2.default)(_topCommentMobile2.default, _topCommentDesktop2.default);

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _separator = __webpack_require__(18);

var _icons = __webpack_require__(9);

var _withTopCommentColor = __webpack_require__(276);

var _withTopCommentColor2 = _interopRequireDefault(_withTopCommentColor);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _topComment = __webpack_require__(1014);

var _topComment2 = _interopRequireDefault(_topComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopCommentDesktop = function TopCommentDesktop(_ref) {
  var topCommentColor = _ref.topCommentColor,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: _topComment2.default.topComment },
    _react2.default.createElement(_separator.BulletSeparator, null),
    _react2.default.createElement(
      'span',
      { className: _topComment2.default.topCommentLabel },
      t('comment.top-comment')
    ),
    _react2.default.createElement(_icons.TopCommentIcon, { className: 'button-fill', color: topCommentColor })
  );
};

TopCommentDesktop.propTypes = {
  topCommentColor: _propTypes2.default.string,
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)((0, _withTopCommentColor2.default)(TopCommentDesktop));

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icons = __webpack_require__(9);

var _withTopCommentColor = __webpack_require__(276);

var _withTopCommentColor2 = _interopRequireDefault(_withTopCommentColor);

var _topComment = __webpack_require__(1014);

var _topComment2 = _interopRequireDefault(_topComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopCommentMobile = function TopCommentMobile(_ref) {
  var topCommentColor = _ref.topCommentColor;
  return _react2.default.createElement(
    'div',
    { className: _topComment2.default.topComment },
    _react2.default.createElement(_icons.TopCommentIcon, { className: 'button-fill', color: topCommentColor })
  );
};

TopCommentMobile.propTypes = {
  topCommentColor: _propTypes2.default.string,
  t: _propTypes2.default.func
};

exports.default = (0, _withTopCommentColor2.default)(TopCommentMobile);

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"commentHeader":"_2ikzD","search":"FLV8d","commentAvatar":"UZ0Uc","commentTime":"Pqu7S","withMoreButton":"_1M89s","moreButton":"_2DYEs"};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(2);

var _protectedButton = __webpack_require__(274);

var _protectedButton2 = _interopRequireDefault(_protectedButton);

var _likeButton = __webpack_require__(372);

var _likeButton2 = _interopRequireDefault(_likeButton);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _commentFooter = __webpack_require__(1120);

var _commentFooter2 = _interopRequireDefault(_commentFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentFooter = function (_Component) {
  _inherits(CommentFooter, _Component);

  function CommentFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentFooter.__proto__ || Object.getPrototypeOf(CommentFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handleLikeClick = function (e) {
      var _this$props = _this.props,
          comment = _this$props.comment,
          onLikeClick = _this$props.onLikeClick;

      e.preventDefault();
      if (onLikeClick) {
        onLikeClick({ postId: comment.postId, commentId: comment._id });
      }
    }, _this.handleReplyClick = function (e) {
      var _this$props2 = _this.props,
          comment = _this$props2.comment,
          onReplyClick = _this$props2.onReplyClick;

      e.preventDefault();
      if (onReplyClick) {
        onReplyClick(comment._id);
      }
    }, _this.renderReplyLink = function () {
      var _this$props3 = _this.props,
          t = _this$props3.t,
          showReplyLink = _this$props3.showReplyLink;

      return showReplyLink && _react2.default.createElement(
        'span',
        { onClick: _this.handleReplyClick, className: (0, _classnames2.default)(_commentFooter2.default.reply, 'comment-footer__reply') },
        t('comment.reply')
      );
    }, _this.render = function () {
      var _this$props4 = _this.props,
          comment = _this$props4.comment,
          t = _this$props4.t,
          type = _this$props4.type,
          contentFontClassName = _this$props4.contentFontClassName,
          forPublicUser = _this$props4.forPublicUser;

      var className = (0, _classnames2.default)(_commentFooter2.default.container, _commentFooter2.default[type], 'forum-text-color', 'comment-footer');
      var likeCount = comment.likeCount || 0;

      return _react2.default.createElement(
        'div',
        { className: className },
        _this.renderReplyLink(),
        _react2.default.createElement(
          _protectedButton2.default,
          {
            onClick: forPublicUser(_this.handleLikeClick, { preventDefault: true }),
            className: (0, _classnames2.default)(_commentFooter2.default.likeButton, contentFontClassName),
            'aria-live': 'assertive'
          },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(_commentFooter2.default.likeCount), 'data-hook': 'comment-footer__like-count' },
            t('comment.like-count', { count: likeCount })
          ),
          _react2.default.createElement(_likeButton2.default, { isLiked: comment.isLiked, likeCount: likeCount, isDisabled: comment.isLikeInProgress })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CommentFooter;
}(_react.Component);

CommentFooter.SEARCH = 'search';

CommentFooter.propTypes = {
  comment: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func.isRequired,
  type: _propTypes2.default.string,
  onLikeClick: _propTypes2.default.func,
  onReplyClick: _propTypes2.default.func,
  showReplyLink: _propTypes2.default.bool,
  contentFontClassName: _propTypes2.default.string.isRequired,
  forPublicUser: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)(_withTranslate2.default, _withFontClassName2.default, _withAuth2.default)(CommentFooter);

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1GANG","search":"_3ldLX","reply":"_2-Aa6","likeButton":"_2cnho","likeCount":"_1JeKO"};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = create;

var _loggerBuilder = __webpack_require__(1122);

var _loggerBuilder2 = _interopRequireDefault(_loggerBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
function create(appName) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$appId = _ref.appId,
        appId = _ref$appId === undefined ? null : _ref$appId,
        _ref$isWidgetLogger = _ref.isWidgetLogger,
        isWidgetLogger = _ref$isWidgetLogger === undefined ? false : _ref$isWidgetLogger,
        _ref$errorHandlerTogg = _ref.errorHandlerToggle,
        errorHandlerToggle = _ref$errorHandlerTogg === undefined ? false : _ref$errorHandlerTogg,
        _ref$disableAutoLoadF = _ref.disableAutoLoadFinish,
        disableAutoLoadFinish = _ref$disableAutoLoadF === undefined ? false : _ref$disableAutoLoadF,
        _ref$swallowException = _ref.swallowExceptions,
        swallowExceptions = _ref$swallowException === undefined ? false : _ref$swallowException,
        _ref$interactionTimeo = _ref.interactionTimeout,
        interactionTimeout = _ref$interactionTimeo === undefined ? null : _ref$interactionTimeo,
        _ref$timeoutHook = _ref.timeoutHook,
        timeoutHook = _ref$timeoutHook === undefined ? null : _ref$timeoutHook,
        _ref$startHook = _ref.startHook,
        startHook = _ref$startHook === undefined ? null : _ref$startHook,
        _ref$endHook = _ref.endHook,
        endHook = _ref$endHook === undefined ? null : _ref$endHook,
        _ref$networkAnalysis = _ref.networkAnalysis,
        networkAnalysis = _ref$networkAnalysis === undefined ? false : _ref$networkAnalysis;

    var appVersion = typeof window !== 'undefined' ? "1.407.0-SNAPSHOT" : null;

    return new _loggerBuilder2.default().setAppName(appName).setAppVersion(appVersion).setBaseUrl(baseUrl).setAppId(appId).setErrorHandlerToggle(errorHandlerToggle).setSwallowExceptions(swallowExceptions).setWidgetLogger(isWidgetLogger).setInteractionTimeout(interactionTimeout).setTimeoutHook(timeoutHook).setStartHook(startHook).setEndHook(endHook).setDisableAutoLoadFinish(disableAutoLoadFinish).setNetworkAnalysis(networkAnalysis).build();
}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setFactory = setFactory;

var _tools = __webpack_require__(1015);

var _tools2 = _interopRequireDefault(_tools);

var _storage = __webpack_require__(1123);

var _storage2 = _interopRequireDefault(_storage);

var _reporter = __webpack_require__(1124);

var _reporter2 = _interopRequireDefault(_reporter);

var _loggerInstance = __webpack_require__(1126);

var _loggerInstance2 = _interopRequireDefault(_loggerInstance);

var _widgetLoggerInstance = __webpack_require__(1133);

var _widgetLoggerInstance2 = _interopRequireDefault(_widgetLoggerInstance);

var _errorHandler = __webpack_require__(1135);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _conf = __webpack_require__(1136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getSessionId() {
  var res = typeof window !== 'undefined' && window.fedops && window.fedops.sessionId;
  res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
  res = res || _tools2.default.generateGuid();

  _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);

  return res;
}

var ReporterFactory = _reporter2.default; // good for tests

function setFactory(factory) {
  ReporterFactory = factory;
}
/**
 * Builds a logger instance.
 */

var LoggerBuilder = function () {
  function LoggerBuilder() {
    _classCallCheck(this, LoggerBuilder);
  }

  _createClass(LoggerBuilder, [{
    key: 'setAppName',
    value: function setAppName(name) {
      this.appName = name;
      return this;
    }
  }, {
    key: 'setAppVersion',
    value: function setAppVersion(version) {
      this.appVersion = version;
      return this;
    }
  }, {
    key: 'setErrorHandlerToggle',
    value: function setErrorHandlerToggle(toggle) {
      this.errorHandlerToggle = toggle;
      return this;
    }
  }, {
    key: 'setSwallowExceptions',
    value: function setSwallowExceptions(swallow) {
      this.swallowExceptions = swallow;
      return this;
    }
  }, {
    key: 'setAppId',
    value: function setAppId(appId) {
      this.appId = appId;
      return this;
    }
  }, {
    key: 'setBaseUrl',
    value: function setBaseUrl(url) {
      this.baseUrl = url;
      return this;
    }
  }, {
    key: 'setWidgetLogger',
    value: function setWidgetLogger(isWidgetLogger) {
      this.isWidgetLogger = isWidgetLogger;
      return this;
    }
  }, {
    key: 'setInteractionTimeout',
    value: function setInteractionTimeout(interactionTimeout) {
      this.interactionTimeout = interactionTimeout;
      return this;
    }
  }, {
    key: 'setTimeoutHook',
    value: function setTimeoutHook(timeoutHook) {
      this.timeoutHook = timeoutHook;
      return this;
    }
  }, {
    key: 'setStartHook',
    value: function setStartHook(startHook) {
      this.startHook = startHook;
      return this;
    }
  }, {
    key: 'setEndHook',
    value: function setEndHook(endHook) {
      this.endHook = endHook;
      return this;
    }
  }, {
    key: 'setDisableAutoLoadFinish',
    value: function setDisableAutoLoadFinish(disableAutoLoadFinish) {
      this.disableAutoLoadFinish = disableAutoLoadFinish;
      return this;
    }
  }, {
    key: 'setNetworkAnalysis',
    value: function setNetworkAnalysis() {
      // TODO - remove this API once no usage across wix
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      if (!this.appName) {
        return null;
      }

      if (!this.appVersion) {
        this.appVersion = _conf.DEFAULT_APP_VERSION;
      }

      var reporter = new ReporterFactory(this.baseUrl || _conf.BI_BASE_URL);
      var errorHandlerToggle = this.errorHandlerToggle;
      var swallowExceptions = this.swallowExceptions;
      var interactionTimeout = this.interactionTimeout;
      var timeoutHook = this.timeoutHook;
      var startHook = this.startHook;
      var endHook = this.endHook;
      var disableAutoLoadFinish = this.disableAutoLoadFinish;

      if (errorHandlerToggle) {
        window.fedopsLoggerErrorHandler = window.fedopsLoggerErrorHandler || new _errorHandler2.default({ swallowExceptions: swallowExceptions });
      }

      var logger = null;

      if (this.isWidgetLogger) {
        logger = new _widgetLoggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish });
      } else {
        logger = new _loggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish, interactionTimeout: interactionTimeout, timeoutHook: timeoutHook, startHook: startHook, endHook: endHook });
      }

      return logger;
    }
  }]);

  return LoggerBuilder;
}();

exports.default = LoggerBuilder;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local storage wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getItem: function getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return window.localStorage.setItem(key, value);
    } catch (e) {}
  }
};

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pixel = __webpack_require__(1125);

var _pixel2 = _interopRequireDefault(_pixel);

var _tools = __webpack_require__(1015);

var _tools2 = _interopRequireDefault(_tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
  }

  _createClass(Reporter, [{
    key: 'getBaseUrl',
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: 'report',
    value: function report(data) {
      if (!data) {
        return null;
      }

      return _pixel2.default.fetch(this.baseUrl + '?' + _tools2.default.mapToQuery(data));
    }
  }]);

  return Reporter;
}();

exports.default = Reporter;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple GET request wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fetch: function fetch(url) {
    return new window.Image().src = url;
  }
};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(1016);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadFinishItem = __webpack_require__(1130);

var _biLoadFinishItem2 = _interopRequireDefault(_biLoadFinishItem);

var _durationItem = __webpack_require__(1017);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biInteractionStartItem = __webpack_require__(1131);

var _biInteractionStartItem2 = _interopRequireDefault(_biInteractionStartItem);

var _biInteractionEndItem = __webpack_require__(1132);

var _biInteractionEndItem2 = _interopRequireDefault(_biInteractionEndItem);

var _biErrorItem = __webpack_require__(1021);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(373);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var LoggerInstance = function (_BaseLogger) {
  _inherits(LoggerInstance, _BaseLogger);

  function LoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish,
        interactionTimeout = _ref.interactionTimeout,
        timeoutHook = _ref.timeoutHook,
        startHook = _ref.startHook,
        endHook = _ref.endHook;

    _classCallCheck(this, LoggerInstance);

    var _this = _possibleConstructorReturn(this, (LoggerInstance.__proto__ || Object.getPrototypeOf(LoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, errorHandlerToggle: errorHandlerToggle, disableAutoLoadFinish: disableAutoLoadFinish }));

    _this._outgoingInteractions = {};
    _this.interactionTimeout = interactionTimeout;
    _this.timeoutHook = timeoutHook;
    _this.startHook = startHook;
    _this.endHook = endHook;
    return _this;
  }

  /**
   * Final phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11)
   * Call this method when your application finishes loading and after all custom phases.
   */


  _createClass(LoggerInstance, [{
    key: 'appLoaded',
    value: function appLoaded() {
      if (this._appLoadedCalled) {
        return;
      }

      if (window && window.fedops && typeof window.fedops.clearLoadTimeout === 'function') {
        window.fedops.clearLoadTimeout();
      }

      var dataSource = this.dataSource.clone().addItem(new _biLoadFinishItem2.default(this.sessionId)).addItem(new _durationItem2.default(this.appName).setFirstRequestDuration());

      this._appLoadedCalled = true;
      _performance2.default.mark('[fedops] app-loaded');
      _performance2.default.measure('[fedops] app-loaded', 'navigationStart', '[fedops] app-loaded');
      this.reportNetworkAnalysis();
      return this._report(dataSource);
    }

    /**
     * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionStarted',
    value: function interactionStarted(interactionName) {
      var _this2 = this;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          interactionTimeout = _ref2.interactionTimeout,
          startHook = _ref2.startHook,
          timeoutHook = _ref2.timeoutHook;

      _performance2.default.mark(interactionName + ' started');
      var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
        if (interactionTimeout || _this2.interactionTimeout) {
          return setTimeout(function () {
            var dataSource = _this2.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(new _biErrorItem2.default(_this2.sessionId));

            _this2._report(dataSource);
            callHook(timeoutHook || _this2.timeoutHook, { name: interactionName, timeout: interactionTimeout || _this2.interactionTimeout });
          }, interactionTimeout || _this2.interactionTimeout);
        }
      };
      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem(new _biInteractionStartItem2.default(this.sessionId));

      this._outgoingInteractions[interactionName] = {
        timestamp: _performance2.default.now(),
        timeout: interactionTimeout || this.interactionTimeout
      };
      this._report(dataSource);
      callHook(startHook || this.startHook, { name: interactionName });

      var timeoutId = scheduleTimeoutEvent();
      return {
        timeoutId: timeoutId
      };
    }

    /**
     * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionEnded',
    value: function interactionEnded(interactionName) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          timeoutId = _ref3.timeoutId,
          endHook = _ref3.endHook;

      _performance2.default.mark(interactionName + ' ended');
      _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      var duration = this._outgoingInteractions[interactionName] ? Math.floor(_performance2.default.now() - this._outgoingInteractions[interactionName].timestamp) : '';

      callHook(endHook || this.endHook, {
        name: interactionName,
        duration: duration,
        timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
      });

      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem({ duration: duration }).addItem(new _biInteractionEndItem2.default(this.sessionId));

      delete this._outgoingInteractions[interactionName];

      this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return LoggerInstance;
}(_baseLogger2.default);

// vim: set ts=2 sw=2 tw=80 et :


exports.default = LoggerInstance;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataItem = __webpack_require__(529);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data accumulator
 */
var DataSource = function () {
  function DataSource() {
    var _this = this;

    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, DataSource);

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }

  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  _createClass(DataSource, [{
    key: 'clone',
    value: function clone() {
      return new DataSource(this.items.slice());
    }

    /**
     * Adds a new item.
     *
     * @param {Object | DataItem} item
     *
     * @return {DataSource} self
     */

  }, {
    key: 'addItem',
    value: function addItem(item) {
      this.items.push(item instanceof _dataItem2.default ? item : new _dataItem2.default(item));

      return this;
    }

    /**
     * Merges all added items into one plain object.
     *
     * @returns {Object}
     */

  }, {
    key: 'mergeItems',
    value: function mergeItems() {
      var res = {};

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];

        if (!item.isActive()) {
          res = null;
          break;
        }

        var data = item.export();

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            // eslint-disable-line
            res[key] = data[key];
          }
        }
      }

      return res;
    }
  }]);

  return DataSource;
}();

exports.default = DataSource;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
var BiLoadPhaseDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadPhaseDataItem, _BiBaseDataItem);

  function BiLoadPhaseDataItem(sessionId) {
    _classCallCheck(this, BiLoadPhaseDataItem);

    return _possibleConstructorReturn(this, (BiLoadPhaseDataItem.__proto__ || Object.getPrototypeOf(BiLoadPhaseDataItem)).call(this, 13, sessionId));
  }

  return BiLoadPhaseDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadPhaseDataItem;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

var _location = __webpack_require__(1020);

var _location2 = _interopRequireDefault(_location);

var _performance = __webpack_require__(373);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOURCES_TYPES = {
  xmlhttprequest: {
    count: 'countXhr',
    unsupported: 'unsprtXhr',
    duration: 'timeXhr',
    total: 'sizeXhr',
    longest: 'longXhr',
    http2: 'h2Xhr'
  },
  script: {
    count: 'countJs',
    unsupported: 'unsprtJs',
    duration: 'timeJs',
    total: 'sizeJs',
    cached: 'cachedJs',
    http2: 'h2Js'
  },
  link: { // css
    count: 'countCss',
    unsupported: 'unsprtCss',
    duration: 'timeCss',
    total: 'sizeCss',
    cached: 'cachedCss',
    http2: 'h2Css'
  },
  img: {
    count: 'countImg',
    unsupported: 'unsprtImg',
    duration: 'timeImg',
    total: 'sizeImg',
    cached: 'cachedImages',
    http2: 'h2Images'
  }
};

var CUSTOM_VALIDATORS = {
  link: function link(resource) {
    return (/(.\.css$|.\.css?.)/g.test(resource.name)
    );
  }
};

var durationOf = function durationOf(item) {
  return item.responseEnd - item.startTime;
};

function filterResourcesByType(resources, type) {
  var validator = CUSTOM_VALIDATORS[type];
  return resources.filter(function (r) {
    return type === r.initiatorType && (validator ? validator(r) : true);
  });
}

function calculateTotalSizeOfResource(resources) {
  return resources.reduce(function (totalSize, resource) {
    return totalSize + resource.transferSize;
  }, 0);
}

function calculateResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var longest = resources.reduce(function (acc, cur) {
    return durationOf(cur) >= durationOf(acc) ? cur : acc;
  });
  return durationOf(longest);
}

function calculateResourceLoadDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };
  resources.forEach(function (r) {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }
    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });
  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function calculatePercentageOfUnsupportedResources(resources) {
  var totalCount = resources.length;
  if (totalCount === 0) {
    return 0;
  }
  var unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount / totalCount * 100);
}

function calculateCachedResourcesPercentage(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var cached = resources.filter(function (r) {
    return r.transferSize === 0;
  });
  return Math.round(cached.length / resources.length * 100);
}

function calculatePercentageOfHttp2(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var supported = false;
  var res = Math.round(resources.filter(function (r) {
    supported = supported || 'nextHopProtocol' in r;
    return r.nextHopProtocol === 'h2';
  }).length / resources.length * 100);
  return supported ? res : NaN;
}

function isResourceRelevant(resource) {
  return !resource.name.match(/http(s)?:\/\/frog.wix.com\//);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  var host = _location2.default.getHost();
  return host && resourceName.indexOf(host) === -1;
}

function normalizeValues(analysis) {
  return Object.keys(analysis).reduce(function (result, key) {
    var n = parseInt(analysis[key]);
    if (!isNaN(n) && typeof n === 'number') {
      result[key] = n;
    }
    return result;
  }, {});
}

function countAllResourcesByType(resources) {
  var supportedResources = resources.filter(function (r) {
    return !isResourceUnsupported(r);
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    var allSameTypeResources = filterResourcesByType(resources, currentType);
    var supportedSameTypeResources = filterResourcesByType(supportedResources, currentType);
    var type = RESOURCES_TYPES[currentType];
    result[type.count] = supportedSameTypeResources.length;
    result[type.duration] = calculateResourceLoadDuration(supportedSameTypeResources);
    result[type.total] = calculateTotalSizeOfResource(supportedSameTypeResources);
    result[type.unsupported] = calculatePercentageOfUnsupportedResources(allSameTypeResources);
    result[type.http2] = calculatePercentageOfHttp2(allSameTypeResources);
    if (type.longest) {
      result[type.longest] = calculateResourceLoadLongestDuration(supportedSameTypeResources);
    }
    if (type.cached) {
      result[type.cached] = calculateCachedResourcesPercentage(supportedSameTypeResources);
    }
    return result;
  }, {});
}

function extractResourceMetrics(resource) {
  return {
    url: resource.name,
    downloadDuration: resource.responseEnd - resource.startTime,
    bytesTransferred: resource.transferSize,
    isHTTP2: resource.nextHopProtocol === 'h2'
  };
}

function getResourcesBreakdown(resources) {
  var resourcesPartition = resources.reduce(function (result, r) {
    if (isResourceUnsupported(r)) {
      result.unsupported.push(r);
    } else {
      result.supported.push(r);
    }
    return result;
  }, { supported: [], unsupported: [] });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    result[currentType] = {};
    result[currentType].supported = filterResourcesByType(resourcesPartition.supported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    result[currentType].unsupported = filterResourcesByType(resourcesPartition.unsupported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    return result;
  }, {});
}

var ResourceDataItem = function (_BiBaseDataItem) {
  _inherits(ResourceDataItem, _BiBaseDataItem);

  function ResourceDataItem(sessionId) {
    _classCallCheck(this, ResourceDataItem);

    return _possibleConstructorReturn(this, (ResourceDataItem.__proto__ || Object.getPrototypeOf(ResourceDataItem)).call(this, 18, sessionId));
  }

  _createClass(ResourceDataItem, [{
    key: 'performNetworkAnalysis',
    value: function performNetworkAnalysis(resources) {
      if (resources.length === 0) {
        return null;
      }
      var t0 = _performance2.default.now();
      var resourcesToHandle = resources.filter(isResourceRelevant);
      var analysis = countAllResourcesByType(resourcesToHandle);
      analysis.overhead = _performance2.default.now() - t0;
      var result = normalizeValues(analysis);
      if (console.debug && _location2.default.isFedopsDev()) {
        var resourcesBreakdown = getResourcesBreakdown(resourcesToHandle);
        console.debug('[fedops network analysis] [bytes analysis]\n' + JSON.stringify(result, null, 4));
        console.debug('[fedops network analysis] [resources breakdown]\n', resourcesBreakdown);
      }
      return result;
    }
  }]);

  return ResourceDataItem;
}(_biBaseItem2.default);

exports.default = ResourceDataItem;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadFinishDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadFinishDataItem, _BiBaseDataItem);

  function BiLoadFinishDataItem(sessionId) {
    _classCallCheck(this, BiLoadFinishDataItem);

    return _possibleConstructorReturn(this, (BiLoadFinishDataItem.__proto__ || Object.getPrototypeOf(BiLoadFinishDataItem)).call(this, 11, sessionId));
  }

  return BiLoadFinishDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadFinishDataItem;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_START_EVID = undefined;

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_START_EVID = exports.INTERACTION_START_EVID = 15;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionStartDataItem, _BiBaseDataItem);

  function BiInteractionStartDataItem(sessionId) {
    _classCallCheck(this, BiInteractionStartDataItem);

    return _possibleConstructorReturn(this, (BiInteractionStartDataItem.__proto__ || Object.getPrototypeOf(BiInteractionStartDataItem)).call(this, INTERACTION_START_EVID, sessionId));
  }

  return BiInteractionStartDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionStartDataItem;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_END_EVID = undefined;

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_END_EVID = exports.INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionEndDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionEndDataItem, _BiBaseDataItem);

  function BiInteractionEndDataItem(sessionId) {
    _classCallCheck(this, BiInteractionEndDataItem);

    return _possibleConstructorReturn(this, (BiInteractionEndDataItem.__proto__ || Object.getPrototypeOf(BiInteractionEndDataItem)).call(this, INTERACTION_END_EVID, sessionId));
  }

  return BiInteractionEndDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionEndDataItem;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(1016);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadStartItem = __webpack_require__(1134);

var _biLoadStartItem2 = _interopRequireDefault(_biLoadStartItem);

var _time = __webpack_require__(1018);

var _time2 = _interopRequireDefault(_time);

var _appData = __webpack_require__(1019);

var _appData2 = _interopRequireDefault(_appData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var WidgetLoggerInstance = function (_BaseLogger) {
  _inherits(WidgetLoggerInstance, _BaseLogger);

  function WidgetLoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, WidgetLoggerInstance);

    var _this = _possibleConstructorReturn(this, (WidgetLoggerInstance.__proto__ || Object.getPrototypeOf(WidgetLoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, disableAutoLoadFinish: disableAutoLoadFinish }));

    _appData2.default.init(_this.appName);
    return _this;
  }

  /**
   * Manual report for widget load start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14)
   * Call this method at the earliest point possible when your widget starts loading
   */


  _createClass(WidgetLoggerInstance, [{
    key: 'appLoadStarted',
    value: function appLoadStarted() {

      _time2.default.loadStarted(this.appName);

      var dataSource = this.dataSource.clone().addItem(new _biLoadStartItem2.default(this.sessionId));

      return this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return WidgetLoggerInstance;
}(_baseLogger2.default);

exports.default = WidgetLoggerInstance;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(156);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadStartDataItem, _BiBaseDataItem);

  function BiLoadStartDataItem(sessionId) {
    _classCallCheck(this, BiLoadStartDataItem);

    return _possibleConstructorReturn(this, (BiLoadStartDataItem.__proto__ || Object.getPrototypeOf(BiLoadStartDataItem)).call(this, 14, sessionId));
  }

  return BiLoadStartDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadStartDataItem;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint-disable camelcase*/

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var ErrorHandler = function () {
  function ErrorHandler(_ref) {
    var swallowExceptions = _ref.swallowExceptions;

    _classCallCheck(this, ErrorHandler);

    this.swallowExceptions = swallowExceptions;
    this.listeners = {};

    //*************************************************************************
    // We are wrapping the browser's native methods with try/catch for several
    // reasons:
    //
    // 1. It provides us with a more elaborate stack trace.
    //    Currently we ignore the stack trace due to BI limitations, but it can
    //    be very useful for future support.
    //
    // 2. Makes it easier to classify the error types.
    //
    // 3. Some browsers don't support a global error handler.
    //*************************************************************************

    this.instrumentAjax();
    this.instrumentSetTimeout();
    this.instrumentSetInterval();
    this.instrumentAddEventListener();
    this.instrumentFetch();
    this.instrumentPromise();

    //Sometimes catches one of the instruments above? Need to verify...
    this.instrumentGloballyUnhandledError();
  }

  _createClass(ErrorHandler, [{
    key: 'subscribeListener',
    value: function subscribeListener(appName, cb) {
      this.listeners[appName] = cb;
    }
  }, {
    key: 'removeListener',
    value: function removeListener(appName) {
      delete this.listeners[appName];
    }
  }, {
    key: 'instrumentAjax',
    value: function instrumentAjax() {
      var self = this;

      if ('XMLHttpRequest' in _window) {
        var xhrproto = XMLHttpRequest.prototype;

        this._wrap(xhrproto, 'open', function (orig) {
          return function (method, url) {
            this.__fedops_xhr = {
              method: method,
              url: url,
              status_code: null
            };

            return orig.apply(this, arguments);
          };
        }, 'xhr');

        this._wrap(xhrproto, 'send', function (orig) {
          return function () {
            var xhr = this;

            function saveStatusCode() {
              if (xhr.readyState === 1 || xhr.readyState === 4) {
                try {
                  xhr.__fedops_xhr.status_code = xhr.status;
                } catch (e) {}

                if (self._isErrorStatusCode(xhr.__fedops_xhr.status_code)) {
                  self._reportError(xhr.__fedops_xhr, 'xhr', xhr.__fedops_xhr.status_code);
                }
              }
            }

            self._wrap(this, 'onload', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onerror', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onprogress', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
              self._wrap(xhr, 'onreadystatechange', function (orig) {
                return function () {
                  saveStatusCode();
                  return orig.apply(this, arguments);
                };
              });
            } else {
              xhr.onreadystatechange = saveStatusCode;
            }

            return orig.apply(this, arguments);
          };
        }, 'xhr');
      }
    }
  }, {
    key: 'instrumentSetTimeout',
    value: function instrumentSetTimeout() {
      var self = this;

      this._wrap(_window, 'setTimeout', function (globalSetTimeout) {
        return function (fn) {
          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          return globalSetTimeout.call.apply(globalSetTimeout, [this, self._wrapCallback(fn, 'setTimeout')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentSetInterval',
    value: function instrumentSetInterval() {
      var self = this;

      this._wrap(_window, 'setInterval', function (globalSetInterval) {
        return function (fn) {
          for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            rest[_key2 - 1] = arguments[_key2];
          }

          return globalSetInterval.call.apply(globalSetInterval, [this, self._wrapCallback(fn, 'setInterval')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentAddEventListener',
    value: function instrumentAddEventListener() {
      var self = this;

      function instrumentEventTarget(name) {
        var origTarget = _window[name] && _window[name].prototype;

        if (origTarget && Object.prototype.hasOwnProperty.call(origTarget, 'addEventListener')) {
          self._wrap(origTarget, 'addEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              var wrapped = self._wrapCallback(fn, 'addEventListener');

              if (fn) {
                fn.__fedopsWrapper__ = wrapped;
              }

              return orig.call(this, eventName, wrapped, capture, secure);
            };
          });

          self._wrap(origTarget, 'removeEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              fn = fn && (fn.__fedopsWrapper__ || fn);
              return orig.call(this, eventName, fn, capture, secure);
            };
          });
        }
      }

      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      eventTargets.forEach(function (name) {
        return instrumentEventTarget(name);
      });
    }
  }, {
    key: 'instrumentRequestAnimationFrame',
    value: function instrumentRequestAnimationFrame() {}
  }, {
    key: 'instrumentFetch',
    value: function instrumentFetch() {
      var self = this;

      this._wrap(_window, 'fetch', function (globalFetch) {
        return function (url, fetchOptions) {
          return globalFetch.apply(this, arguments).then(function (response) {
            var statusCode = response.status;

            if (self._isErrorStatusCode(statusCode)) {
              var requestInfo = {
                url: url,
                method: fetchOptions ? fetchOptions.method : 'GET',
                status_code: statusCode
              };

              self._reportError(requestInfo, 'fetch', statusCode);
            }

            return response;
          });
        };
      });
    }
  }, {
    key: 'instrumentPromise',
    value: function instrumentPromise() {
      var self = this;

      _window.addEventListener('unhandledrejection', function (err) {
        self._reportError(err, 'promise');
      });
    }
  }, {
    key: 'instrumentGloballyUnhandledError',
    value: function instrumentGloballyUnhandledError() {
      var _this = this;

      _window.addEventListener('error', function (err) {
        _this._reportError(err, 'windowOnError');
      });
    }
  }, {
    key: 'instrumentHistory',
    value: function instrumentHistory() {}
  }, {
    key: '_wrap',
    value: function _wrap(obj, fnName, replaced, errorType) {
      var self = this;
      var orig = obj[fnName];
      var r = replaced(orig);

      var wrapped = function wrapped() {
        try {
          return r.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };

      obj[fnName] = wrapped;
    }
  }, {
    key: '_wrapCallback',
    value: function _wrapCallback(fn, errorType) {
      var self = this;

      return function () {
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };
    }
  }, {
    key: '_reportError',
    value: function _reportError(err, errorType, errorInfo) {
      var self = this;

      var actualError = err && (err.error || err);

      if (!actualError.__fedopsHandledError__) {
        var appNames = Object.keys(this.listeners);

        appNames.forEach(function (appName) {
          self.listeners[appName](actualError, errorType, errorInfo);
        });

        actualError.__fedopsHandledError__ = true;
      }
    }
  }, {
    key: '_isErrorStatusCode',
    value: function _isErrorStatusCode(statusCode) {
      return statusCode >= 400 || statusCode === 0;
    }
  }]);

  return ErrorHandler;
}();

/*eslint-enable camelcase*/


exports.default = ErrorHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_BASE_URL = exports.BI_BASE_URL = 'https://frog.wix.com/fed';
var SESSION_ID_STORAGE_KEY = exports.SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = exports.DEFAULT_APP_VERSION = '0.0.0';

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wixlabsUsersBiMiddleware = exports.forumsUsersBiMiddleware = exports.forumsUouBiMiddleware = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _biMiddleware = __webpack_require__(1138);

var _biMiddleware2 = _interopRequireDefault(_biMiddleware);

var _biHelpers = __webpack_require__(991);

var _forumsUouEvents = __webpack_require__(1149);

var forumsUouEvents = _interopRequireWildcard(_forumsUouEvents);

var _forumsUsersEvents = __webpack_require__(1151);

var forumsUsersEvents = _interopRequireWildcard(_forumsUsersEvents);

var _wixlabsUsersEvents = __webpack_require__(1152);

var wixlabsUsersEvents = _interopRequireWildcard(_wixlabsUsersEvents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extendForumsUouEvent = function extendForumsUouEvent(event, state) {
  return _extends({
    member_id: (state.auth.currentUser || {})._id,
    biToken: _wixSdkPolyfill2.default.Utils.getInstanceValue('biToken'),
    visitor_id: _wixSdkPolyfill2.default.Utils.getInstanceValue('aid') || _wixSdkPolyfill2.default.Utils.getInstanceValue('uid')
  }, event);
};

var forumsUouBiMiddleware = exports.forumsUouBiMiddleware = (0, _biMiddleware2.default)({
  bi: (0, _biHelpers.createBi)({
    endpoint: forumsUouEvents.endpoint,
    src: forumsUouEvents.src
  }),
  eventMap: forumsUouEvents.eventMap,
  extendEvent: extendForumsUouEvent,
  shouldLogEvent: _lodash2.default.overEvery(_biHelpers.hasBiToken, _biHelpers.isNotDummyVisitorId)
});

var extendForumsUsersEvent = function extendForumsUsersEvent(event) {
  return _extends({
    biToken: _wixSdkPolyfill2.default.Utils.getInstanceValue('biToken')
  }, event);
};

var forumsUsersBiMiddleware = exports.forumsUsersBiMiddleware = (0, _biMiddleware2.default)({
  bi: (0, _biHelpers.createBi)({
    endpoint: forumsUsersEvents.endpoint,
    src: forumsUsersEvents.src
  }),
  eventMap: forumsUsersEvents.eventMap,
  extendEvent: extendForumsUsersEvent,
  shouldLogEvent: _biHelpers.hasBiToken
});

var extendWixlabsUsersEvent = function extendWixlabsUsersEvent(event) {
  return _extends({
    biToken: _wixSdkPolyfill2.default.Utils.getInstanceValue('biToken')
  }, event);
};

var wixlabsUsersBiMiddleware = exports.wixlabsUsersBiMiddleware = (0, _biMiddleware2.default)({
  bi: (0, _biHelpers.createBi)({
    endpoint: wixlabsUsersEvents.endpoint,
    src: wixlabsUsersEvents.src
  }),
  eventMap: wixlabsUsersEvents.eventMap,
  extendEvent: extendWixlabsUsersEvent,
  shouldLogEvent: _biHelpers.hasBiToken
});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = function log(level) {
  var _console;

  for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    message[_key - 1] = arguments[_key];
  }

  (0, _config.getConfig)().logBiToConsole && (_console = console)[level].apply(_console, message);
};

var tryTransformEvent = function tryTransformEvent(transformEvent) {
  return function (action, state) {
    try {
      return transformEvent(action, state);
    } catch (e) {
      log('error', 'BI: event transformation failed', e, action, state);
    }
  };
};

var tryLogEvent = function tryLogEvent(event) {
  return function (bi) {
    var promise = bi.log(event);
    promise.catch(function (e) {
      log('error', 'BI: external bi error', e, event);
    });
    return promise;
  };
};

var createBiMiddleware = function createBiMiddleware(_ref) {
  var bi = _ref.bi,
      eventMap = _ref.eventMap,
      _ref$extendEvent = _ref.extendEvent,
      extendEvent = _ref$extendEvent === undefined ? function (event) {
    return event;
  } : _ref$extendEvent,
      _ref$shouldInvokeEven = _ref.shouldInvokeEvent,
      shouldInvokeEvent = _ref$shouldInvokeEven === undefined ? function () {
    return true;
  } : _ref$shouldInvokeEven,
      _ref$shouldLogEvent = _ref.shouldLogEvent,
      shouldLogEvent = _ref$shouldLogEvent === undefined ? function () {
    return true;
  } : _ref$shouldLogEvent;

  var maybeLog = function maybeLog(action, store) {
    var transformEvent = eventMap[action.type];

    if (!transformEvent) {
      return _lodash2.default.identity;
    }

    if (!shouldInvokeEvent()) {
      log('error', 'BI: not logged action!', action);
      return _lodash2.default.identity;
    }

    var state = store.getState();
    var biEvent = tryTransformEvent(transformEvent)(action, state); // event => bi event
    if (!biEvent) {
      return _lodash2.default.identity;
    }

    biEvent._ = new Date().getTime();
    // Extend transformEvent with aditional params biToken, visitor_id, member_id
    var extendedEvent = extendEvent(biEvent, state);

    if (!shouldLogEvent(extendedEvent, state)) {
      // not valid because of technical reasons, e.g. missing BI token
      log('error', 'BI: not logged event!', extendedEvent);
      return _lodash2.default.identity;
    }

    return tryLogEvent(extendedEvent);
  };

  return function (store) {
    return function (next) {
      return function (action) {
        maybeLog(action, store)(bi);

        return next(action);
      };
    };
  };
};

exports.default = createBiMiddleware;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = __webpack_require__(1140);

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

var _env = __webpack_require__(374);

var _publishers = __webpack_require__(1145);

var _browsingSession = __webpack_require__(1148);

var browsingSession = _interopRequireWildcard(_browsingSession);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = _publishers.fetchPublisher;
  } else if (options.useBeacon) {
    publisher = _publishers.beaconPublisher;
  } else {
    publisher = _publishers.imagePublisher;
  }

  return publisher(options);
}

var _factory = function _factory(options) {
  return new _biLoggerFactory2.default().addPublisher(getPublisher(options));
};

var logger = {
  factory: function factory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';

    if (trackSession) {
      browsingSession.track(_factory);
    }

    return _factory(options);
  },
  setHost: _env.setHost
};

exports.default = logger;
//# sourceMappingURL=logger.js.map


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(1022);
var BiLogger = __webpack_require__(1141);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      return new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail
      }, context);
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(1022);

var _require = __webpack_require__(1142),
    mapValues = _require.mapValues;

var promise = __webpack_require__(1143);

var _require2 = __webpack_require__(1144),
    log = _require2.log;

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      return this._getDefaults().then(function (defaults) {
        var fullEvent = Object.assign({}, defaults, event);

        var validatorsResult = _this._validators.length === 0 ? true : _this._validators.some(function (validator) {
          return validator.match(fullEvent) && (validator.execute(fullEvent) || true);
        });

        if (!validatorsResult) {
          throw new Error('No validator accepted the event. Source: ' + fullEvent.src + ' Evid: ' + (fullEvent.evid || fullEvent.evtId));
        }

        return Promise.all(_this._publishers.map(function (publish) {
          var cloned = Object.assign({}, fullEvent);

          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          }).catch(function (error) {
            if (error && error.message && error.stack) {
              error.message = 'Publisher \'' + publish.name + '\' failed with error: \'' + error.message + '\'';
            }

            return Promise.reject(error);
          });
        }));
      });
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey !== 'string') {
        return eventOrKey;
      }
      var event = this._events[eventOrKey];
      if (!event) {
        throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
      }

      if (eventOrUndefined) {
        return Object.assign({}, event, eventOrUndefined);
      } else {
        return event;
      }
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this2 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this2._defaultValueTimeout
        }).catch(function (err) {
          if (_this2._defaultContinueOnFail) {
            log.error(err);
            return null;
          }
          return Promise.reject(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }
  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _utils = __webpack_require__(1023);

var _transport = __webpack_require__(1147);

function imagePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function imagePublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.pixel)(url, context.image);
  };
}

function beaconPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function beaconPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.beacon)(url).catch(function () {
      return (0, _transport.pixel)(url, context.image);
    });
  };
}

function fetchPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function fetchPublisher(params) {
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return fetch(url, { credentials: 'include' }).then(function (response) {
      if (!response.ok) {
        throw Error(response.status);
      }
      return response;
    });
  };
}
//# sourceMappingURL=publishers.js.map


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}
//# sourceMappingURL=performance.js.map


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beacon = beacon;
exports.pixel = pixel;

var _navigator = __webpack_require__(1024);

function beacon(url) {
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  });
}

function pixel(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new Image(0, 0);
    biImage.onload = resolve;
    biImage.onerror = reject;
    biImage.src = url;
  });
}
//# sourceMappingURL=transport.js.map


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = __webpack_require__(1023);

var _navigator = __webpack_require__(1024);

var _env = __webpack_require__(374);

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.provideBrowsingContext)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.provideBrowsingContext)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();

    var logger = getLogger(loggerFactory);
    var firstInSession = 1;

    (0, _navigator.listen)(function (fromUrl, toUrl) {
      logger.log({ from: fromUrl, to: toUrl, fis: firstInSession });
      firstInSession = 0;
    });
  }
}
//# sourceMappingURL=browsingSession.js.map


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.src = exports.endpoint = exports.eventMap = undefined;

var _eventMap;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _detectRoute = __webpack_require__(266);

var _detectRoute2 = _interopRequireDefault(_detectRoute);

var _biHelpers = __webpack_require__(991);

var _reactRouterRedux = __webpack_require__(44);

var _modalTypes = __webpack_require__(26);

var modalTypes = _interopRequireWildcard(_modalTypes);

var _actionsClosed = __webpack_require__(294);

var _actionsOpened = __webpack_require__(293);

var _applicationLoaded = __webpack_require__(1086);

var _buttonClicked = __webpack_require__(57);

var _changePage = __webpack_require__(1012);

var _createComment = __webpack_require__(176);

var _createPost = __webpack_require__(200);

var _deletePost = __webpack_require__(132);

var _demoteModerator = __webpack_require__(140);

var _fetchSearch = __webpack_require__(131);

var _hideModal = __webpack_require__(152);

var _incrementCommentLikeCount = __webpack_require__(246);

var _incrementPostLikeCount = __webpack_require__(160);

var _inlineToolbarShown = __webpack_require__(408);

var _pageOpened = __webpack_require__(410);

var _promoteModerator = __webpack_require__(139);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _updatePost = __webpack_require__(397);

var _updateUser = __webpack_require__(70);

var _upload = __webpack_require__(171);

var _uploadEnded = __webpack_require__(230);

var _uploadStarted = __webpack_require__(231);

var _getQueryString = __webpack_require__(1150);

var _getQueryString2 = _interopRequireDefault(_getQueryString);

var _categoriesSelectors = __webpack_require__(35);

var _locationHistorySelectors = __webpack_require__(162);

var _postSelectors = __webpack_require__(117);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventMap = exports.eventMap = (_eventMap = {}, _defineProperty(_eventMap, _applicationLoaded.APPLICATION_LOADED, function () {
  return {
    evid: 704,
    vsi: (0, _getQueryString2.default)('vsi')
  };
}), _defineProperty(_eventMap, _subscribe.SUBSCRIBE_SUCCESS, function (action, state) {
  switch (action.payload.type) {
    case 'user':
      return {
        evid: 515,
        flag: 1,
        origin: (0, _biHelpers.getCurrentOrigin)(state)
      };
    case 'post':
      return {
        evid: 553,
        flag: 1,
        origin: (0, _biHelpers.getCurrentOrigin)(state)
      };
    case 'category':
      return {
        evid: 554,
        flag: 1,
        origin: (0, _biHelpers.getCurrentOrigin)(state)
      };
    default:
      return;
  }
}), _defineProperty(_eventMap, _unsubscribe.UNSUBSCRIBE_SUCCESS, function (action, state) {
  switch (action.payload.type) {
    case 'user':
      return {
        evid: 515,
        flag: 0,
        origin: (0, _biHelpers.getCurrentOrigin)(state)
      };
    case 'post':
      return {
        evid: 553,
        flag: 0,
        origin: (0, _biHelpers.getCurrentOrigin)(state)
      };
    case 'category':
      return {
        evid: 554,
        flag: 0,
        origin: (0, _biHelpers.getCurrentOrigin)(state)
      };
    default:
      return;
  }
}), _defineProperty(_eventMap, _changePage.CHANGE_PAGE, function (action, state) {
  if (_lodash2.default.get(action.payload, 'meta.bi.buttonType')) {
    return {
      evid: 519,
      page_destination: action.payload.page,
      button_type: action.payload.buttonType,
      origin: (0, _biHelpers.getCurrentOrigin)(state)
    };
  }
}), _defineProperty(_eventMap, _fetchSearch.FETCH_SEARCH_SUCCESS, function (action, state) {
  return {
    evid: 511,
    origin: (0, _biHelpers.getReferrer)(state), //TODO: after release when searching 2nd time in search page it should show search page
    referral_info: 'direct',
    search_term: state.search.query,
    result_count_posts: action.payload.posts.length,
    result_count_members: action.payload.users.length
  };
}), _defineProperty(_eventMap, _deletePost.DELETE_POST_SUCCESS, function (action, state) {
  return {
    evid: 555,
    post_id: action.payload,
    is_admin: state.auth.currentUser.isOwner ? 1 : 0
  };
}), _defineProperty(_eventMap, _demoteModerator.DEMOTE_MODERATOR_SUCCESS, function () {
  return {
    evid: 580
  };
}), _defineProperty(_eventMap, _promoteModerator.PROMOTE_MODERATOR_SUCCESS, function () {
  return {
    evid: 582
  };
}), _defineProperty(_eventMap, _reactRouterRedux.LOCATION_CHANGE, function (action, state) {
  var callerLocation = (0, _locationHistorySelectors.getCurrentLocation)(state);
  var location = action.payload;
  var route = (0, _detectRoute2.default)(location);

  var origin = (0, _biHelpers.getCurrentOrigin)(state);
  if (route === _detectRoute.FEED_PAGE) {
    var categorySlug = (0, _biHelpers.getCategorySlugFromPathname)(location.pathname);
    var category = (0, _categoriesSelectors.getCategoryBySlug)(state, categorySlug);
    if (category) {
      return {
        evid: 502,
        category_id: category._id,
        category_slug: category.slug,
        origin: origin
      };
    }
  }

  if (route === _detectRoute.CREATE_POST) {
    return {
      evid: 505
    };
  }
  if (callerLocation && route === _detectRoute.POST_PAGE) {
    var evid = void 0,
        type = void 0;

    if (location.hash === '#comments') {
      evid = 518;
      type = 'post_comments';
    } else if (location.hash) {
      evid = 518;
      type = 'comment';
    } else {
      evid = 516;
    }
    var postSlug = (0, _biHelpers.getPostSlugFromPathname)(location.pathname);
    var post = (0, _postSelectors.getPostBySlug)(state, postSlug);
    var search_term = (0, _detectRoute2.default)(callerLocation) === _detectRoute.SEARCH_RESULTS ? state.search.query : null;

    if (post) {
      return {
        evid: evid,
        type: type,
        post_id: post._id,
        post_slug: postSlug,
        origin: origin,
        search_term: search_term
      };
    }
  }
}), _defineProperty(_eventMap, _uploadStarted.UPLOAD_STARTED, function (action, state) {
  if (action.payload.type === _upload.TYPE_IMAGE) {
    return {
      evid: 551,
      origin: (0, _biHelpers.getCurrentOrigin)(state)
    };
  }
}), _defineProperty(_eventMap, _uploadEnded.UPLOAD_ENDED, function (action, state) {
  if (action.payload.type === _upload.TYPE_IMAGE) {
    return {
      evid: 552,
      origin: (0, _biHelpers.getCurrentOrigin)(state)
    };
  }
}), _defineProperty(_eventMap, _inlineToolbarShown.INLINE_TOOLBAR_SHOW, function (action, state) {
  return {
    evid: 509,
    type: (0, _biHelpers.getCurrentOrigin)(state) === _detectRoute.CREATE_POST ? 'post' : 'comment'
  };
}), _defineProperty(_eventMap, _buttonClicked.BUTTON_CLICKED, function (action, state) {
  var origin = (0, _biHelpers.getCurrentOrigin)(state);
  switch (action.payload.name) {
    case 'back_to_categories_menu_click':
      return {
        evid: 548
      };
    case 'edit_profile_click':
      return {
        evid: 538
      };
    case 'change_avatar_click':
      return {
        evid: 556
      };
    case 'change_cover_photo_click':
      return {
        evid: 557
      };
    case 'back_to_site_click':
      return {
        evid: 547,
        origin: origin
      };
    case 'search_tab':
      return {
        evid: 536,
        tab_name: action.payload.type
      };
    case 'notification':
      return {
        evid: 544,
        post_id: state.notifications.byId[action.payload._id].postId,
        type: state.notifications.byId[action.payload._id].type
      };
    case 'action_click':
      return _extends({
        evid: 526,
        origin: origin
      }, action.payload);
    case 'cancel-promote-moderator':
      return {
        evid: 581
      };
    case 'cancel-demote-moderator':
      return {
        evid: 583
      };
    default:
      console.debug('unmapped event', action);
      return;
  }
}), _defineProperty(_eventMap, _pageOpened.PAGE_OPENED, function (action, state) {
  switch (action.payload.page) {
    case _detectRoute.POST_PAGE:
      return {
        evid: 517,
        post_id: action.payload.post._id,
        type: action.payload.page,
        post_slug: action.payload.post.title,
        origin: (0, _biHelpers.getReferrer)(state) || state.siteInfo.referrer,
        search_term: (0, _biHelpers.getReferrer)(state) === _detectRoute.SEARCH_RESULTS ? state.search.query : null
      };
    case _detectRoute.POST_EDIT_PAGE:
      return {
        evid: 506
      };
    case _detectRoute.USER_EDIT_PROFILE:
      return {
        evid: 539
      };
    case _detectRoute.CATEGORIES_PAGE:
      return {
        evid: 501,
        origin: (0, _biHelpers.getReferrer)(state) || state.siteInfo.referrer
      };
    case _detectRoute.FEED_PAGE:
      return {
        evid: 503,
        origin: (0, _biHelpers.getReferrer)(state) || state.siteInfo.referrer,
        category_id: action.payload.category._id,
        category_slug: action.payload.category.slug
      };
    case _detectRoute.SEARCH_RESULTS:
      return {
        evid: 535
      };
    case _detectRoute.USER_PROFILE:
      return {
        evid: 537,
        origin: (0, _biHelpers.getReferrer)(state) || state.siteInfo.referrer
      };
    case _detectRoute.NOTIFICATIONS:
      return {
        evid: 543
      };
    case _detectRoute.USER_SETTINGS:
      return {
        evid: 545
      };
    default:
      console.debug('unmapped event', action);
      return;
  }
}), _defineProperty(_eventMap, _createPost.CREATE_POST_SUCCESS, function (action, state) {
  return createEditPost(action, state, 'post', false);
}), _defineProperty(_eventMap, _updatePost.UPDATE_POST_SUCCESS, function (action, state) {
  return createEditPost(action, state, 'post', true);
}), _defineProperty(_eventMap, _createComment.CREATE_COMMENT_SUCCESS, function (action, state) {
  return createEditPost(action, state, 'comment', false);
}), _defineProperty(_eventMap, _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS, function (action, state) {
  return {
    evid: 521,
    post_id: action.payload._id,
    type: 'comment',
    flag: action.payload.isLiked ? 1 : 0,
    origin: (0, _biHelpers.getCurrentOrigin)(state)
  };
}), _defineProperty(_eventMap, _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_SUCCESS, function (action, state) {
  return {
    evid: 521,
    post_id: action.payload._id,
    type: 'post',
    flag: action.payload.isLiked ? 1 : 0,
    origin: (0, _biHelpers.getCurrentOrigin)(state)
  };
}), _defineProperty(_eventMap, 'redux-form/CHANGE', function reduxFormCHANGE(action) {
  switch (action.form) {
    case 'profile':
      return createProfileChangeEvent(action);
    default:
      return;
  }
}), _defineProperty(_eventMap, 'redux-form/START_SUBMIT', function reduxFormSTART_SUBMIT(action) {
  switch (action.form) {
    case 'post':
      return {
        evid: 508
      };
    default:
      return;
  }
}), _defineProperty(_eventMap, _actionsOpened.ACTIONS_OPENED, function (action, state) {
  return {
    evid: 524,
    type: action.payload.type,
    origin: (0, _biHelpers.getCurrentOrigin)(state)
  };
}), _defineProperty(_eventMap, _actionsClosed.ACTIONS_CLOSED, function (action, state) {
  return {
    evid: 525,
    type: action.payload.type,
    origin: (0, _biHelpers.getCurrentOrigin)(state)
  };
}), _defineProperty(_eventMap, _hideModal.HIDE_MODAL, function (action, state) {
  var type = state.modal.type;


  var isCancelClicked = action.type === _hideModal.HIDE_MODAL && !action.payload;
  if (isCancelClicked) {
    switch (type) {
      case modalTypes.MODAL_TYPE_PROMOTE_MODERATOR:
        return {
          evid: 581
        };
      case modalTypes.MODAL_TYPE_DEMOTE_MODERATOR:
        return {
          evid: 583
        };
      default:
        return;
    }
  }
}), _defineProperty(_eventMap, _updateUser.UPDATE_USER_REQUEST, function (action, state) {
  var emailSettings = _lodash2.default.get(action.payload.data, 'settings.email');
  var oldEmailSettings = _lodash2.default.get(state.auth.currentUser, 'settings.email');
  if (emailSettings) {
    var newSetting = getDifferentSetting(emailSettings, oldEmailSettings);
    return {
      evid: 546,
      settings_type: 'email_' + newSetting.key,
      flag: newSetting.value ? 1 : 0
    };
  }

  var pushSettings = action.payload.data.settings.push;
  var oldPushSettings = action.payload.data.settings.push;
  if (pushSettings) {
    var _newSetting = getDifferentSetting(pushSettings, oldPushSettings);
    return {
      evid: 546,
      settings_type: 'push_' + _newSetting.key,
      flag: _newSetting.value ? 1 : 0
    };
  }
}), _defineProperty(_eventMap, _updateUser.UPDATE_USER_SUCCESS, function (action, state) {
  if (action.payload.name !== state.auth.currentUser.name) {
    return {
      evid: 542
    };
  }
}), _eventMap);

function getDifferentSetting(settings, oldSettings) {
  return _lodash2.default.reduce(settings, function (newSetting, value, key) {
    if (oldSettings[key] !== value) {
      newSetting = {
        key: key,
        value: value
      };
    }
    return newSetting;
  }, {});
}

function createProfileChangeEvent(action) {
  var field = action.field,
      value = action.value;


  if (value.file_name) {
    switch (field) {
      case 'image':
        return {
          evid: 540
        };
      case 'cover':
        return {
          evid: 541
        };
      default:
        return;
    }
  }
}

function createEditPost(action, state, type, isEdit) {
  var entity = action.payload;
  var imageCount = (0, _biHelpers.getImageCount)(entity);
  var quoteCount = (0, _biHelpers.getQuoteCount)(entity);
  var videoCount = (0, _biHelpers.getVideoCount)(entity);
  return {
    evid: 523,
    post_id: entity._id,
    type: type,
    is_edited: Number(isEdit),
    has_image: imageCount > 0 ? 1 : 0,
    image_count: imageCount,
    has_video: videoCount > 0 ? 1 : 0,
    has_quote: quoteCount > 0 ? 1 : 0,
    is_admin: state.auth.currentUser.isOwner ? 1 : 0
  };
}

var endpoint = exports.endpoint = 'forums-uou';
var src = exports.src = 69;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryString;
/**
  * Get the value of a querystring
  * @param  {String} field The field to get the value of
  * @param  {String} url   The URL to get the value from (optional)
  * @return {String}       The field value
 */
function getQueryString(field, url) {
  var href = url ? url : window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
}

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.src = exports.endpoint = exports.eventMap = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _wixParams = __webpack_require__(24);

var _updateAppSettings = __webpack_require__(135);

var _getLayoutName = __webpack_require__(223);

var _getLayoutName2 = _interopRequireDefault(_getLayoutName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventMap = exports.eventMap = _defineProperty({}, _updateAppSettings.UPDATE_APP_SETTINGS_REQUEST, function (action) {
  if (action.meta && action.meta.bi && action.meta.bi.externalId !== 'draft') {
    return {
      evid: 12,
      setting_input_json: JSON.stringify({
        layoutName: (0, _getLayoutName2.default)(_lodash2.default.get(action.payload, _wixParams.LAYOUT_TYPE_PATH), _lodash2.default.get(action.payload, _wixParams.CARD_SIZE_PATH))
      })
    };
  }
});

var endpoint = exports.endpoint = 'forums-users';
var src = exports.src = 69;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.src = exports.endpoint = exports.eventMap = undefined;

var _eventMap;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeTabChanged = __webpack_require__(1090);

var _buttonClicked = __webpack_require__(57);

var _deleteCategory = __webpack_require__(180);

var _forumRenamed = __webpack_require__(1091);

var _forumRenameStarted = __webpack_require__(1092);

var _layoutChanged = __webpack_require__(1093);

var _setActiveDesignPage = __webpack_require__(1025);

var _showForumForm = __webpack_require__(1081);

var _categoryEdited = __webpack_require__(1094);

var _categoryRenamed = __webpack_require__(1095);

var _categoryRenameStarted = __webpack_require__(1096);

var _textboxChanged = __webpack_require__(1082);

var _constants = __webpack_require__(992);

var _constants2 = __webpack_require__(425);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventMap = exports.eventMap = (_eventMap = {}, _defineProperty(_eventMap, _activeTabChanged.ACTIVE_TAB_CHANGED, function (action) {
  return {
    evid: 11,
    tab_name: _constants.biTabNames[action.payload]
  };
}), _defineProperty(_eventMap, _buttonClicked.BUTTON_CLICKED, function (action) {
  return {
    evid: 18,
    button_description: action.payload.name
  };
}), _defineProperty(_eventMap, _layoutChanged.LAYOUT_CHANGED, function (action) {
  return _extends({
    evid: 13
  }, action.payload);
}), _defineProperty(_eventMap, _deleteCategory.DELETE_CATEGORY_REQUEST, function () {
  return {
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'category',
    selected_item_name: 'delete'
  };
}), _defineProperty(_eventMap, _categoryRenameStarted.CATEGORY_RENAME_STARTED, function () {
  return {
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'category',
    selected_item_name: 'rename'
  };
}), _defineProperty(_eventMap, _categoryEdited.CATEGORY_EDITED, function () {
  return {
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'category',
    selected_item_name: 'edit'
  };
}), _defineProperty(_eventMap, _showForumForm.SHOW_FORUM_FORM, function () {
  return {
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'forum',
    selected_item_name: 'edit'
  };
}), _defineProperty(_eventMap, _forumRenameStarted.FORUM_RENAME_STARTED, function () {
  return {
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'forum',
    selected_item_name: 'rename'
  };
}), _defineProperty(_eventMap, _categoryRenamed.CATEGORY_RENAMED, function () {
  return {
    evid: 18,
    tab_name: 'categories',
    button_description: 'done'
  };
}), _defineProperty(_eventMap, _forumRenamed.FORUM_RENAMED, function () {
  return {
    evid: 18,
    tab_name: 'forum',
    button_description: 'done'
  };
}), _defineProperty(_eventMap, _textboxChanged.TEXTBOX_CHANGED, function (action) {
  return {
    evid: 21,
    tab_name: 'categories',
    text_box: action.payload,
    text_input: 'string'
  };
}), _defineProperty(_eventMap, _setActiveDesignPage.SET_ACTIVE_DESIGN_PAGE, function (action) {
  var tab_name = _constants2.designTabNames[action.payload];
  if (tab_name) {
    return {
      evid: 11,
      tab_name: tab_name
    };
  }
}), _eventMap);

var endpoint = exports.endpoint = 'wixlabs-users';
var src = exports.src = 63;

/***/ }),
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _accountSuspended = __webpack_require__(1395);

var _accountSuspended2 = _interopRequireDefault(_accountSuspended);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _accountSuspended2.default;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _pageMetadata = __webpack_require__(1422);

var _pageMetadata2 = _interopRequireDefault(_pageMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _pageMetadata2.default;

/***/ }),
/* 1181 */,
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profileActionsButton = __webpack_require__(1489);

var _profileActionsButton2 = _interopRequireDefault(_profileActionsButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profileActionsButton2.default;

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3EoVZ","hasSpacing":"_1Jr6r","listItemMobile":"_3BCox","masonry":"_2CiWW","small":"_3RmDe","large":"_4RN5E","largeHeader":"N0z2j","listItem":"_2tyB_","medium":"ieH3H"};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouterRedux = __webpack_require__(44);

var _locationHistorySelectors = __webpack_require__(162);

var _categoriesSelectors = __webpack_require__(35);

var _detectRoute = __webpack_require__(266);

var _detectRoute2 = _interopRequireDefault(_detectRoute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return function (dispatch, getState) {
    var state = getState();
    var categories = (0, _categoriesSelectors.getCategories)(state);
    var hasOneCategory = categories.length === 1;
    var currentLocation = (0, _locationHistorySelectors.getCurrentLocation)(state);
    var route = (0, _detectRoute2.default)(currentLocation);

    var parts = _lodash2.default.trim(currentLocation.pathname, '/').split('/');
    parts.pop();

    if (route === _detectRoute.USER_PROFILE || route === _detectRoute.COMMENT_EDIT_PAGE) {
      parts.pop();
    }
    if (hasOneCategory && parts.length === 0) {
      parts.push(categories[0].slug);
    }
    var path = '/' + parts.join('/');

    return dispatch((0, _reactRouterRedux.push)(path));
  };
};

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postPageLayout = __webpack_require__(1565);

var _postPageLayout2 = _interopRequireDefault(_postPageLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postPageLayout2.default;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserAndRedirect = undefined;

var _reactRouterRedux = __webpack_require__(44);

var _fetchUser = __webpack_require__(420);

var defaultUrlBuilder = function defaultUrlBuilder(user, search) {
  return '/profiles/' + user.slug + search;
};

var fetchUserAndRedirect = exports.fetchUserAndRedirect = function fetchUserAndRedirect(userId, search) {
  var urlBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultUrlBuilder;

  return function (dispatch) {
    return dispatch((0, _fetchUser.fetchUser)(userId)).then(function (user) {
      if (userId !== user._id && userId !== user.slug) {
        dispatch((0, _reactRouterRedux.push)({ pathname: urlBuilder(user, search), state: 301 }));
      }
      return user;
    });
  };
};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defaultDesktopLayout = __webpack_require__(1588);

var _defaultDesktopLayout2 = _interopRequireDefault(_defaultDesktopLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _defaultDesktopLayout2.default;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _memberList = __webpack_require__(1590);

var _memberList2 = _interopRequireDefault(_memberList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _memberList2.default;

/***/ }),
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1202);


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(1203);
} else {
  module.exports = require('./patch.dev');
}

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* noop */


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1205);


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(1206);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(1207);

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(1208);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLUSH = exports.CANCEL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = middleware;

var _lodash = __webpack_require__(1210);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL = exports.CANCEL = 'redux-throttle/CANCEL';
var FLUSH = exports.FLUSH = 'redux-throttle/FLUSH';

function map(throttled, action, method) {
  if (action.payload && action.payload.type) {
    var _ret = function () {
      var types = action.payload.type;
      if (!Array.isArray(types)) {
        types = [types];
      }
      Object.keys(throttled).filter(function (t) {
        return types.includes(t);
      }).forEach(function (t) {
        return throttled[t][method]();
      });
      return {
        v: void 0
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
  Object.keys(throttled).forEach(function (t) {
    return throttled[t][method]();
  });
  return;
}

function middleware() {
  var defaultWait = arguments.length <= 0 || arguments[0] === undefined ? 300 : arguments[0];
  var defaultThrottleOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var throttled = {};
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === CANCEL) {
          map(throttled, action, 'cancel');
          return next(action);
        }

        if (action.type === FLUSH) {
          map(throttled, action, 'flush');
          return next(action);
        }

        var shouldThrottle = (action.meta || {}).throttle;

        // check if we don't need to throttle the action
        if (!shouldThrottle) {
          return next(action);
        }

        if (throttled[action.type]) {
          // if it's a action which was throttled already
          return throttled[action.type](action);
        }

        var wait = defaultWait;
        var options = defaultThrottleOption;

        if (!isNaN(shouldThrottle) && shouldThrottle !== true) {
          wait = shouldThrottle;
        } else if ((typeof shouldThrottle === 'undefined' ? 'undefined' : _typeof(shouldThrottle)) === 'object') {
          wait = shouldThrottle.wait || defaultWait;
          options = _extends({}, defaultThrottleOption, shouldThrottle);
        }

        throttled[action.type] = (0, _lodash2.default)(next, wait, options);

        return throttled[action.type](action);
      };
    };
  };
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var debounce = __webpack_require__(296);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide an options object to indicate whether
 * `func` should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the throttled function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=true] Specify invoking on the leading
 *  edge of the timeout.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = throttle;


/***/ }),
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullHeightLayout = exports.SimpleLayout = exports.EmptyLayout = undefined;

var _emptyLayout = __webpack_require__(1392);

var _emptyLayout2 = _interopRequireDefault(_emptyLayout);

var _simpleLayout = __webpack_require__(1393);

var _simpleLayout2 = _interopRequireDefault(_simpleLayout);

var _fullHeightLayout = __webpack_require__(1394);

var _fullHeightLayout2 = _interopRequireDefault(_fullHeightLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EmptyLayout = _emptyLayout2.default;
exports.SimpleLayout = _simpleLayout2.default;
exports.FullHeightLayout = _fullHeightLayout2.default;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _pageCover = __webpack_require__(1430);

var _pageCover2 = _interopRequireDefault(_pageCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _pageCover2.default;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryActions = __webpack_require__(1442);

var _categoryActions2 = _interopRequireDefault(_categoryActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryActions2.default;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return factory();
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),
/* 1242 */,
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createPostButton = __webpack_require__(1536);

var _createPostButton2 = _interopRequireDefault(_createPostButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _createPostButton2.default;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _paginationClassic = __webpack_require__(1537);

Object.keys(_paginationClassic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paginationClassic[key];
    }
  });
});

var _pagination = __webpack_require__(1310);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _pagination2.default;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPostAndRedirect = undefined;

var _reactRouterRedux = __webpack_require__(44);

var _fetchCategory = __webpack_require__(1304);

var _fetchPost = __webpack_require__(165);

var defaultUrlBuilder = function defaultUrlBuilder(category, post, search) {
  return '/' + category.slug + '/' + post.slug + search;
};

var fetchPostAndRedirect = exports.fetchPostAndRedirect = function fetchPostAndRedirect(categoryId, postId, search) {
  var urlBuilder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultUrlBuilder;

  return function (dispatch) {
    return Promise.all([dispatch((0, _fetchCategory.fetchCategory)(categoryId)), dispatch((0, _fetchPost.fetchPost)(postId))]).then(function (results) {
      var category = results[0];
      var post = results[1];

      var isCategorySlugDiffers = categoryId !== category._id && categoryId !== category.slug;
      var isPostSlugDiffers = postId !== post._id && postId !== post.slug;

      if (isCategorySlugDiffers || isPostSlugDiffers) {
        dispatch((0, _reactRouterRedux.push)({ pathname: urlBuilder(category, post, search), state: 301 }));
      }

      return post;
    });
  };
};

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentForm = __webpack_require__(1567);

var _commentForm2 = _interopRequireDefault(_commentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentForm2.default;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentFormWrapper = __webpack_require__(1569);

var _commentFormWrapper2 = _interopRequireDefault(_commentFormWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentFormWrapper2.default;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComment = exports.getCommentsByPostIdAndPage = exports.getCommentsByPostId = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getComments = function getComments(state) {
  return state.comments;
};

var getEntityIdsByPage = function getEntityIdsByPage(state, page) {
  return state.pagination.comments.entitiesByPage[page] || [];
};

var getCommentsByPostId = exports.getCommentsByPostId = function getCommentsByPostId(state, postId) {
  return getComments(state)[postId] || [];
};
var getCommentsByPostIdAndPage = exports.getCommentsByPostIdAndPage = function getCommentsByPostIdAndPage(state, postId, page) {
  var entityIds = getEntityIdsByPage(state, page);
  var comments = getComments(state)[postId] || [];
  return _lodash2.default.filter(comments, function (comment) {
    return entityIds.indexOf(comment._id) > -1;
  });
};

var getComment = exports.getComment = function getComment(state, commentId, postId) {
  return _lodash2.default.find(getCommentsByPostId(state, postId), function (comment) {
    return comment._id === commentId;
  });
};

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _publishButton = __webpack_require__(1576);

Object.keys(_publishButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _publishButton[key];
    }
  });
});

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _publicProfileActions = __webpack_require__(1597);

var _publicProfileActions2 = _interopRequireDefault(_publicProfileActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _publicProfileActions2.default;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  return (/^data:/.test(input)
  );
};

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = listenToAppInstall;

var _lodash = __webpack_require__(2);

var _applications = __webpack_require__(25);

var _applicationAdded = __webpack_require__(392);

var _applicationAdded2 = _interopRequireDefault(_applicationAdded);

var _applicationDeleted = __webpack_require__(393);

var _applicationDeleted2 = _interopRequireDefault(_applicationDeleted);

var _tpaInstallListener = __webpack_require__(1253);

var _tpaInstallListener2 = _interopRequireDefault(_tpaInstallListener);

var _communitiesContextSelectors = __webpack_require__(47);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function listenToAppInstall(store) {
  var isEditor = ['editor', 'preview'].indexOf(_wixSdkPolyfill2.default.Utils.getViewMode()) > -1;

  if (isEditor) {
    var context = (0, _communitiesContextSelectors.getCommunitiesContext)(store.getState());

    isMemberAppInstalled(context, store);
    isMemberAreaInstalled(context, store);

    var listener = new _tpaInstallListener2.default([_applications.MEMBERS_APP_ID, _applications.MEMBER_INFO_APP_ID], 2000);
    listener.onInstall(function (appDefinitionId, instanceId) {
      store.dispatch((0, _applicationAdded2.default)({
        appDefinitionId: getAppDefinitionId(appDefinitionId),
        instanceId: instanceId
      }));
    });
    listener.onDelete(function (appDefinitionId) {
      store.dispatch((0, _applicationDeleted2.default)({ appDefinitionId: getAppDefinitionId(appDefinitionId) }));
    });
    listener.listen();
  }
}

function isMemberAppInstalled(context, store) {
  _wixSdkPolyfill2.default.isApplicationInstalled(_applications.MEMBERS_APP_ID, function (isInstalled) {
    if (isInstalled !== (0, _lodash.get)(context, '[' + _applications.MEMBERS_APP_ID + '].isInstalled')) {
      if (isInstalled) {
        _wixSdkPolyfill2.default.getInstalledInstance(_applications.MEMBERS_APP_ID, function (_ref) {
          var instanceId = _ref.instanceId;

          store.dispatch((0, _applicationAdded2.default)({ appDefinitionId: _applications.MEMBERS_APP_ID, instanceId: instanceId }));
        });
      } else {
        store.dispatch((0, _applicationDeleted2.default)({ appDefinitionId: _applications.MEMBERS_APP_ID }));
      }
    }
  });
}

function isMemberAreaInstalled(context, store) {
  _wixSdkPolyfill2.default.isApplicationInstalled(_applications.MEMBER_INFO_APP_ID, function (isInstalled) {
    if (isInstalled !== (0, _lodash.get)(context, '[' + _applications.SANTA_MEMBERS_APP_ID + '].isInstalled')) {
      if (isInstalled) {
        store.dispatch((0, _applicationAdded2.default)({ appDefinitionId: _applications.SANTA_MEMBERS_APP_ID, instanceId: null }));
      } else {
        store.dispatch((0, _applicationDeleted2.default)({ appDefinitionId: _applications.SANTA_MEMBERS_APP_ID }));
      }
    }
  });
}

function getAppDefinitionId(appDefinitionId) {
  return appDefinitionId === _applications.MEMBER_INFO_APP_ID ? _applications.SANTA_MEMBERS_APP_ID : appDefinitionId;
}

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TpaInstallListener = function () {
  function TpaInstallListener() {
    var _this = this;

    var appDefinitionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

    _classCallCheck(this, TpaInstallListener);

    this.onInstallCallbacks = [];
    this.onDeleteCallbacks = [];
    this.status = {};

    this.appDefinitionIds = appDefinitionIds;
    this.interval = interval;
    this.appDefinitionIds.forEach(function (appDefinitionId) {
      return _wixSdkPolyfill2.default.isApplicationInstalled(appDefinitionId, function (isInstalled) {
        _this.status[appDefinitionId] = isInstalled;
      });
    });
  }

  _createClass(TpaInstallListener, [{
    key: 'onInstall',
    value: function onInstall(cb) {
      this.onInstallCallbacks.push(cb);
    }
  }, {
    key: 'onDelete',
    value: function onDelete(cb) {
      this.onDeleteCallbacks.push(cb);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.listenInterval = setInterval(function () {
        _this2.appDefinitionIds.forEach(function (appDefinitionId) {
          return _wixSdkPolyfill2.default.isApplicationInstalled(appDefinitionId, function (isInstalled) {
            if (_this2.status[appDefinitionId] !== isInstalled) {
              if (isInstalled) {
                _wixSdkPolyfill2.default.getInstalledInstance(appDefinitionId, function (_ref) {
                  var instanceId = _ref.instanceId;

                  _this2.onInstallCallbacks.forEach(function (cb) {
                    return setTimeout(function () {
                      return cb(appDefinitionId, instanceId);
                    });
                  });
                });
              } else {
                _this2.onDeleteCallbacks.forEach(function (cb) {
                  return setTimeout(function () {
                    return cb(appDefinitionId);
                  });
                });
              }
            }
            _this2.status[appDefinitionId] = isInstalled;
          });
        });
      }, this.interval);
    }
  }, {
    key: 'stop',
    value: function stop() {
      clearInterval(this.listenInterval);
    }
  }]);

  return TpaInstallListener;
}();

exports.default = TpaInstallListener;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = listenToEditModeChange;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _wixSdkUtils = __webpack_require__(21);

var _setViewMode = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function listenToEditModeChange(store) {
  if (!(0, _wixSdkUtils.isEditor)()) {
    return;
  }

  store.dispatch((0, _setViewMode.setViewMode)(_wixSdkPolyfill2.default.Utils.getViewMode()));

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.EDIT_MODE_CHANGE, function (_ref) {
    var editMode = _ref.editMode;

    store.dispatch((0, _setViewMode.setViewMode)(editMode));
  });
}

/***/ }),
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3TJjA"};

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1414)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageDescriptionDesktop = exports.default = undefined;

var _pageDescription = __webpack_require__(1429);

Object.defineProperty(exports, 'PageDescriptionDesktop', {
  enumerable: true,
  get: function get() {
    return _pageDescription.PageDescriptionDesktop;
  }
});

var _pageDescription2 = _interopRequireDefault(_pageDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _pageDescription2.default;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withCategoryTextAlignment;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wixParams = __webpack_require__(24);

var params = _interopRequireWildcard(_wixParams);

var _textAlignment = __webpack_require__(958);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _getDisplayName = __webpack_require__(48);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ALIGNMENT = _textAlignment.TEXT_ALIGNMENT_CENTER;

function withCategoryTextAlignment(WrappedComponent) {
  var _class, _temp;

  var Wrapper = (_temp = _class = function (_Component) {
    _inherits(Wrapper, _Component);

    function Wrapper() {
      _classCallCheck(this, Wrapper);

      return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
    }

    _createClass(Wrapper, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            categoryTextAlignment = _props.categoryTextAlignment,
            otherProps = _objectWithoutProperties(_props, ['categoryTextAlignment']);

        return _react2.default.createElement(WrappedComponent, _extends({ categoryTextAlignment: categoryTextAlignment }, otherProps));
      }
    }]);

    return Wrapper;
  }(_react.Component), _class.displayName = 'WithCategoryTextAlignment(' + (0, _getDisplayName2.default)(WrappedComponent) + ')', _class.propTypes = {
    categoryTextAlignment: _propTypes2.default.number
  }, _class.defaultProps = {
    categoryTextAlignment: DEFAULT_ALIGNMENT
  }, _temp);

  (0, _hoistNonReactStatics2.default)(Wrapper, WrappedComponent);

  return (0, _withAppSettings2.default)({
    categoryTextAlignment: params.CATEGORY_TEXT_ALIGNMENT_PATH
  })(Wrapper);
}

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _masonryWrapper = __webpack_require__(1437);

var _masonryWrapper2 = _interopRequireDefault(_masonryWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _masonryWrapper2.default;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var isBrowser = typeof window !== 'undefined';
var Masonry = isBrowser ? window.Masonry || __webpack_require__(1447) : null;
var imagesloaded = isBrowser ? __webpack_require__(1452) : null;
var assign = __webpack_require__(1453);
var elementResizeDetectorMaker = __webpack_require__(1454);
var debounce = __webpack_require__(296);
var omit = __webpack_require__(1465);
var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);
var createReactClass = __webpack_require__(1300);
var refName = 'masonryContainer';

var propTypes = {
  enableResizableChildren: PropTypes.bool,
  disableImagesLoaded: PropTypes.bool,
  onImagesLoaded: PropTypes.func,
  updateOnEachImageLoad: PropTypes.bool,
  options: PropTypes.object,
  elementType: PropTypes.string,
  onLayoutComplete: PropTypes.func,
  onRemoveComplete: PropTypes.func
};

var MasonryComponent = createReactClass({
  masonry: false,
  erd: undefined,
  latestKnownDomChildren: [],
  displayName: 'MasonryComponent',
  propTypes: propTypes,

  getDefaultProps: function() {
    return {
      enableResizableChildren: false,
      disableImagesLoaded: false,
      updateOnEachImageLoad: false,
      options: {},
      className: '',
      elementType: 'div',
      onLayoutComplete: function() {
      },
      onRemoveComplete: function() {
      }
    };
  },

  initializeMasonry: function(force) {
    if (!this.masonry || force) {
      this.masonry = new Masonry(
        this.refs[refName],
        this.props.options
      );

      if (this.props.onLayoutComplete) {
        this.masonry.on('layoutComplete', this.props.onLayoutComplete);
      }

      if (this.props.onRemoveComplete) {
        this.masonry.on('removeComplete', this.props.onRemoveComplete);
      }

      this.latestKnownDomChildren = this.getCurrentDomChildren();
    }
  },

  getCurrentDomChildren: function() {
    var node = this.refs[refName];
    var children = this.props.options.itemSelector ? node.querySelectorAll(this.props.options.itemSelector) : node.children;
    return Array.prototype.slice.call(children);
  },

  diffDomChildren: function() {
    var forceItemReload = false;

    var knownChildrenStillAttached = this.latestKnownDomChildren.filter(function(element) {
      /*
       * take only elements attached to DOM
       * (aka the parent is the masonry container, not null)
       * otherwise masonry would try to "remove it" again from the DOM
       */
      return !!element.parentNode;
    });

    /*
     * If not all known children are attached to the dom - we have no other way of notifying
     * masonry to remove the ones not still attached besides invoking a complete item reload.
     * basically all the rest of the code below does not matter in that case.
     */
    if (knownChildrenStillAttached.length !== this.latestKnownDomChildren) {
      forceItemReload = true;
    }

    var currentDomChildren = this.getCurrentDomChildren();

    /*
     * Since we are looking for a known child which is also attached to the dom AND
     * not attached to the dom at the same time - this would *always* produce an empty array.
     */
    var removed = knownChildrenStillAttached.filter(function(attachedKnownChild) {
      return !~currentDomChildren.indexOf(attachedKnownChild);
    });

    /*
     * This would get any children which are attached to the dom but are *unkown* to us
     * from previous renders
     */
    var newDomChildren = currentDomChildren.filter(function(currentChild) {
      return !~knownChildrenStillAttached.indexOf(currentChild);
    });

    var beginningIndex = 0;

    // get everything added to the beginning of the DOMNode list
    var prepended = newDomChildren.filter(function(newChild) {
      var prepend = (beginningIndex === currentDomChildren.indexOf(newChild));

      if (prepend) {
        // increase the index
        beginningIndex++;
      }

      return prepend;
    });

    // we assume that everything else is appended
    var appended = newDomChildren.filter(function(el) {
      return prepended.indexOf(el) === -1;
    });

    /*
     * otherwise we reverse it because so we're going through the list picking off the items that
     * have been added at the end of the list. this complex logic is preserved in case it needs to be
     * invoked
     *
     * var endingIndex = currentDomChildren.length - 1;
     *
     * newDomChildren.reverse().filter(function(newChild, i){
     *     var append = endingIndex == currentDomChildren.indexOf(newChild);
     *
     *     if (append) {
     *         endingIndex--;
     *     }
     *
     *     return append;
     * });
     */

    // get everything added to the end of the DOMNode list
    var moved = [];

    /*
     * This would always be true (see above about the lofic for "removed")
     */
    if (removed.length === 0) {
      /*
       * 'moved' will contain some random elements (if any) since the "knownChildrenStillAttached" is a filter
       * of the "known" children which are still attached - All indexes could basically change. (for example
       * if the first element is not attached)
       * Don't trust this array.
       */
      moved = knownChildrenStillAttached.filter(function(child, index) {
        return index !== currentDomChildren.indexOf(child);
      });
    }

    this.latestKnownDomChildren = currentDomChildren;

    return {
      old: knownChildrenStillAttached, // Not used
      new: currentDomChildren, // Not used
      removed: removed,
      appended: appended,
      prepended: prepended,
      moved: moved,
      forceItemReload: forceItemReload
    };
  },

  performLayout: function() {
    var diff = this.diffDomChildren();

    // Would never be true. (see comments of 'diffDomChildren' about 'removed')
    if (diff.removed.length > 0) {
      if (this.props.enableResizableChildren) {
        diff.removed.forEach(this.erd.removeAllListeners, this.erd);
      }
      this.masonry.remove(diff.removed);
      this.masonry.reloadItems();
    }

    if (diff.appended.length > 0) {
      this.masonry.appended(diff.appended);

      if (diff.prepended.length === 0) {
        this.masonry.reloadItems();
      }

      if (this.props.enableResizableChildren) {
        diff.appended.forEach(this.listenToElementResize, this);
      }
    }

    if (diff.prepended.length > 0) {
      this.masonry.prepended(diff.prepended);

      if (this.props.enableResizableChildren) {
        diff.prepended.forEach(this.listenToElementResize, this);
      }
    }

    if (diff.forceItemReload || diff.moved.length > 0) {
      this.masonry.reloadItems();
    }

    this.masonry.layout();
  },

  imagesLoaded: function() {
    if (this.props.disableImagesLoaded) {
      return;
    }

    imagesloaded(this.refs[refName])
      .on(
        this.props.updateOnEachImageLoad ? 'progress' : 'always',
        debounce(
          function(instance) {
            if (this.props.onImagesLoaded) {
              this.props.onImagesLoaded(instance);
            }
            this.masonry.layout();
          }.bind(this), 100)
      );
  },

  initializeResizableChildren: function() {
    if (!this.props.enableResizableChildren) {
      return;
    }

    this.erd = elementResizeDetectorMaker({
      strategy: 'scroll'
    });

    this.latestKnownDomChildren.forEach(this.listenToElementResize, this);
  },

  listenToElementResize: function(el) {
    this.erd.listenTo(el, function() {
      this.masonry.layout()
    }.bind(this))
  },

  destroyErd: function() {
    if (this.erd) {
      this.latestKnownDomChildren.forEach(this.erd.uninstall, this.erd);
    }
  },

  componentDidMount: function() {
    this.initializeMasonry();
    this.initializeResizableChildren();
    this.imagesLoaded();
  },

  componentDidUpdate: function() {
    this.performLayout();
    this.imagesLoaded();
  },

  componentWillUnmount: function() {
    this.destroyErd();

    // unregister events
    if (this.props.onLayoutComplete) {
      this.masonry.off('layoutComplete', this.props.onLayoutComplete);
    }

    if (this.props.onRemoveComplete) {
      this.masonry.off('removeComplete', this.props.onRemoveComplete);
    }

    this.masonry.destroy();
  },

  render: function() {
    var props = omit(this.props, Object.keys(propTypes));
    return React.createElement(this.props.elementType, assign({}, props, {ref: refName}), this.props.children);
  }
});

module.exports = MasonryComponent;
module.exports.default = MasonryComponent;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1466);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 1301 */,
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _headerTitle = __webpack_require__(1499);

var _headerTitle2 = _interopRequireDefault(_headerTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _headerTitle2.default;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixParams = __webpack_require__(24);

var _withSettingsColor = __webpack_require__(68);

var _withSettingsColor2 = _interopRequireDefault(_withSettingsColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withSettingsColor2.default)(_wixParams.BUTTON_COLOR_PATH, 'buttonColor', 'color-8', 1);

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCategory = fetchCategory;
var FETCH_CATEGORY_REQUEST = exports.FETCH_CATEGORY_REQUEST = 'category/FETCH_REQUEST';
var FETCH_CATEGORY_SUCCESS = exports.FETCH_CATEGORY_SUCCESS = 'category/FETCH_SUCCESS';
var FETCH_CATEGORY_FAILURE = exports.FETCH_CATEGORY_FAILURE = 'category/FETCH_FAILURE';

var fetchCategoryRequest = exports.fetchCategoryRequest = function fetchCategoryRequest() {
  return { type: FETCH_CATEGORY_REQUEST };
};
var fetchCategorySuccess = exports.fetchCategorySuccess = function fetchCategorySuccess(payload) {
  return { type: FETCH_CATEGORY_SUCCESS, payload: payload };
};
var fetchCategoryFailure = exports.fetchCategoryFailure = function fetchCategoryFailure() {
  return { type: FETCH_CATEGORY_FAILURE };
};

function fetchCategory(categoryId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchCategoryRequest());

    var promise = request('/_api/categories/' + categoryId);

    return promise.then(function (category) {
      return dispatch(fetchCategorySuccess(category));
    }).catch(function () {
      return dispatch(fetchCategoryFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_IS_CATEGORY_LOADED = exports.SET_IS_CATEGORY_LOADED = 'category/SET_IS_LOADED';

var setIsCategoryLoaded = exports.setIsCategoryLoaded = function setIsCategoryLoaded(categoryId, isLoaded) {
  return {
    type: SET_IS_CATEGORY_LOADED,
    payload: {
      categoryId: categoryId,
      isLoaded: isLoaded
    }
  };
};

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postList = __webpack_require__(1511);

var _postList2 = _interopRequireDefault(_postList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postList2.default;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createPostCta = __webpack_require__(1513);

var _createPostCta2 = _interopRequireDefault(_createPostCta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _createPostCta2.default;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createPostHandler = __webpack_require__(1517);

var _createPostHandler2 = _interopRequireDefault(_createPostHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _createPostHandler2.default;

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page":"_1ewQd","previous":"C9lRN","first":"_2YNcq","next":"_249Tx","last":"_3ygNh","active":"_1GhzZ","large":"_3VJ3c","arrow":"_2qECG","inner":"_2BWQO"};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _pagination = __webpack_require__(1309);

var _pagination2 = _interopRequireDefault(_pagination);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = exports.Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination(props) {
    _classCallCheck(this, Pagination);

    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    var entityCount = props.entityCount,
        showPerPage = props.showPerPage,
        page = props.page;

    _this.state = {
      currentPage: page || 1,
      numberCount: Math.ceil(entityCount / (showPerPage || 1))
    };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var entityCount = _ref.entityCount,
          showPerPage = _ref.showPerPage,
          page = _ref.page;

      if (entityCount && showPerPage) {
        var numberCount = Math.ceil(entityCount / (showPerPage || 1));
        this.setState({ numberCount: numberCount });
      }
      if (page) {
        this.setState({ currentPage: page });
      }
    }
  }, {
    key: 'renderNumbers',
    value: function renderNumbers() {
      var _this2 = this;

      var _state = this.state,
          currentPage = _state.currentPage,
          numberCount = _state.numberCount;


      if (numberCount < 5) {
        return _lodash2.default.range(1, numberCount + 1).map(function (page) {
          return _this2.renderPage(page);
        });
      }

      if (currentPage + 3 > numberCount) {
        return _lodash2.default.range(numberCount - 4, numberCount + 1).map(function (page) {
          return _this2.renderPage(page);
        });
      }

      if (currentPage > 3) {
        return _lodash2.default.range(currentPage - 2, currentPage + 3).map(function (page) {
          return _this2.renderPage(page);
        });
      }

      return _lodash2.default.range(1, 6).map(function (page) {
        return _this2.renderPage(page);
      });
    }
  }, {
    key: 'renderPage',
    value: function renderPage(page) {
      var _classNames;

      var _props = this.props,
          activeClass = _props.activeClass,
          innerClass = _props.innerClass,
          t = _props.t;

      var isActive = page === this.state.currentPage;
      var pageClassName = (0, _classnames2.default)(_pagination2.default.page, innerClass, (_classNames = {}, _defineProperty(_classNames, activeClass, isActive), _defineProperty(_classNames, 'button-color', isActive), _classNames));
      var handleClick = this.handleClick(page, Pagination.PAGE);
      return _react2.default.createElement(
        'div',
        {
          key: page,
          className: pageClassName,
          onClick: handleClick,
          onKeyUp: (0, _accessibility.handleEnterKeyUp)(handleClick),
          tabIndex: !isActive && '0',
          'aria-label': t('pagination.page', { page: page }),
          'data-hook': 'pagination__' + page
        },
        page
      );
    }
  }, {
    key: 'renderFirst',
    value: function renderFirst() {
      var _props2 = this.props,
          arrowClass = _props2.arrowClass,
          arrowLeft = _props2.arrowLeft,
          t = _props2.t;
      var currentPage = this.state.currentPage;

      var handleClick = this.handleClick(1, Pagination.FIRST);

      if (currentPage > 3) {
        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_pagination2.default.first, arrowClass),
            onClick: handleClick,
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(handleClick),
            tabIndex: '0',
            'aria-label': t('pagination.first-page'),
            'data-hook': 'pagination__first'
          },
          arrowLeft,
          arrowLeft
        );
      }
      return null;
    }
  }, {
    key: 'renderPrevious',
    value: function renderPrevious() {
      var _props3 = this.props,
          arrowClass = _props3.arrowClass,
          arrowLeft = _props3.arrowLeft,
          t = _props3.t;
      var currentPage = this.state.currentPage;

      var handleClick = this.handleClick(currentPage - 1, Pagination.PREVIOUS);

      if (currentPage > 1) {
        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_pagination2.default.previous, arrowClass),
            onClick: handleClick,
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(handleClick),
            tabIndex: '0',
            'aria-label': t('pagination.previous-page'),
            'data-hook': 'pagination__previous'
          },
          arrowLeft
        );
      }
      return null;
    }
  }, {
    key: 'renderNext',
    value: function renderNext() {
      var _props4 = this.props,
          arrowClass = _props4.arrowClass,
          arrowRight = _props4.arrowRight,
          t = _props4.t;
      var _state2 = this.state,
          currentPage = _state2.currentPage,
          numberCount = _state2.numberCount;

      var handleClick = this.handleClick(currentPage + 1, Pagination.NEXT);

      if (currentPage < numberCount) {
        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_pagination2.default.next, arrowClass),
            onClick: handleClick,
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(handleClick),
            tabIndex: '0',
            'aria-label': t('pagination.next-page'),
            'data-hook': 'pagination__next'
          },
          arrowRight
        );
      }
      return null;
    }
  }, {
    key: 'renderLast',
    value: function renderLast() {
      var _props5 = this.props,
          arrowClass = _props5.arrowClass,
          arrowRight = _props5.arrowRight,
          t = _props5.t;
      var _state3 = this.state,
          currentPage = _state3.currentPage,
          numberCount = _state3.numberCount;

      var handleClick = this.handleClick(numberCount, Pagination.LAST);

      if (currentPage < numberCount - 2) {
        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_pagination2.default.last, arrowClass),
            onClick: handleClick,
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(handleClick),
            tabIndex: '0',
            'aria-label': t('pagination.last-page'),
            'data-hook': 'pagination__last'
          },
          arrowRight,
          arrowRight
        );
      }
      return null;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(page, buttonType) {
      var _this3 = this;

      var _props6 = this.props,
          onChange = _props6.onChange,
          showPerPage = _props6.showPerPage;

      return function () {
        _this3.setState({ currentPage: page });
        var from = (page - 1) * showPerPage;
        var to = page * showPerPage;
        onChange({ page: page, from: from, to: to, buttonType: buttonType });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          entityCount = _props7.entityCount,
          showPerPage = _props7.showPerPage,
          className = _props7.className,
          contentFontClassName = _props7.contentFontClassName;


      if (entityCount <= showPerPage) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, contentFontClassName, 'forum-text-color'), 'aria-live': 'polite' },
        this.renderFirst(),
        this.renderPrevious(),
        this.renderNumbers(),
        this.renderNext(),
        this.renderLast()
      );
    }
  }]);

  return Pagination;
}(_react.Component);

Pagination.propTypes = {
  entityCount: _propTypes2.default.number.isRequired,
  showPerPage: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  activeClass: _propTypes2.default.string,
  arrowClass: _propTypes2.default.string,
  innerClass: _propTypes2.default.string,
  arrowLeft: _propTypes2.default.node,
  arrowRight: _propTypes2.default.node,
  className: _propTypes2.default.string,
  page: _propTypes2.default.number,
  contentFontClassName: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};
Pagination.defaultProps = {
  arrowLeft: _react2.default.createElement(_icons.ArrowLeftIcon, { className: 'forum-icon-fill' }),
  arrowRight: _react2.default.createElement(_icons.ArrowRightIcon, { className: 'forum-icon-fill' })
};


Pagination.FIRST = 'first';
Pagination.LAST = 'last';
Pagination.NEXT = 'next';
Pagination.PREVIOUS = 'previous';
Pagination.PAGE = 'page';

exports.default = _lodash2.default.flowRight(_withFontClassName2.default, _withTranslate2.default)(Pagination);

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _paginationRegular = __webpack_require__(1543);

var _paginationRegular2 = _interopRequireDefault(_paginationRegular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _paginationRegular2.default;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loadMore = __webpack_require__(1545);

var _loadMore2 = _interopRequireDefault(_loadMore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loadMore2.default;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notFound = __webpack_require__(1552);

var _notFound2 = _interopRequireDefault(_notFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notFound2.default;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  form: 'comment',
  fields: ['content', 'ownerId'],
  validate: function validate(_ref) {
    var content = _ref.content;

    var hasContent = content && content.blocks && content.blocks.some(function (block) {
      return block.text;
    });
    var isUploading = content && _lodash2.default.some(content.entityMap, function (entity) {
      return _lodash2.default.get(entity, 'data.isLoading');
    });

    if (!hasContent) {
      return { content: 'empty' };
    }

    if (isUploading) {
      return { image: 'loading' };
    }
  }
};

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _backButton = __webpack_require__(1574);

var _backButton2 = _interopRequireDefault(_backButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backButton2.default;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _menu = __webpack_require__(1582);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _menu2.default;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _menuTab = __webpack_require__(1584);

var _menuTab2 = _interopRequireDefault(_menuTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _menuTab2.default;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followUserButtonSecure = __webpack_require__(1593);

var _followUserButtonSecure2 = _interopRequireDefault(_followUserButtonSecure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followUserButtonSecure2.default;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _breadcrumbs = __webpack_require__(1615);

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _breadcrumbs2.default;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _desktopHeader = __webpack_require__(1624);

var _desktopHeader2 = _interopRequireDefault(_desktopHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _desktopHeader2.default;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchInput = __webpack_require__(1628);

var _searchInput2 = _interopRequireDefault(_searchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchInput2.default;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _breadcrumbsWidget = __webpack_require__(1632);

var _breadcrumbsWidget2 = _interopRequireDefault(_breadcrumbsWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _breadcrumbsWidget2.default;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _memberFilter = __webpack_require__(1643);

var _memberFilter2 = _interopRequireDefault(_memberFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembersFilter = function MembersFilter(_ref) {
  var className = _ref.className,
      contentFontClassName = _ref.contentFontClassName,
      value = _ref.value,
      _onChange = _ref.onChange,
      _ref$count = _ref.count,
      count = _ref$count === undefined ? 0 : _ref$count,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_memberFilter2.default.container, 'forum-text-color', contentFontClassName, className) },
    _react2.default.createElement('input', {
      className: _memberFilter2.default.input,
      type: 'text',
      value: value,
      placeholder: t('member-filter.placeholder'),
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    }),
    _react2.default.createElement(
      'span',
      { className: _memberFilter2.default.count },
      count
    )
  );
};

MembersFilter.propTypes = {
  className: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  count: _propTypes2.default.number,
  t: _propTypes2.default.func
};

exports.default = _lodash2.default.flowRight(_withFontClassName2.default, _withTranslate2.default)(MembersFilter);

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MembersSortFieldDesktop = exports.MembersSortFieldMobile = undefined;

var _memberSortFieldMobile = __webpack_require__(1644);

var _memberSortFieldMobile2 = _interopRequireDefault(_memberSortFieldMobile);

var _memberSortFieldDesktop = __webpack_require__(1646);

var _memberSortFieldDesktop2 = _interopRequireDefault(_memberSortFieldDesktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MembersSortFieldMobile = _memberSortFieldMobile2.default;
exports.MembersSortFieldDesktop = _memberSortFieldDesktop2.default;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SORT_OPTIONS = exports.SORT_OPTIONS = {
  postsCount: 'member-sort-field.posts-count',
  followerCount: 'member-sort-field.follower-count',
  newestFirst: 'member-sort-field.newest-first',
  oldestFirst: 'member-sort-field.oldest-first',
  role: 'member-sort-field.role'
};

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMembers = exports.getMembersIdList = exports.getMembersCount = undefined;

var _userSelectors = __webpack_require__(69);

var getMembersCount = exports.getMembersCount = function getMembersCount(state) {
  return state.members.metadata.count;
};

var getMembersIdList = exports.getMembersIdList = function getMembersIdList(state) {
  return state.members.idList;
};

var getMembers = exports.getMembers = function getMembers(state) {
  return (0, _userSelectors.getUsersByIdList)(state, getMembersIdList(state));
};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_20JEo","avatar":"_3n8YU","column1":"_3FSAm","column2":"_9acGw","column3":"_2m6cG","message":"_15wu7","timeAgo":"_2scSD","dot":"qVu7G"};

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEditedCommentId = exports.getEditedCommentId = function getEditedCommentId(state) {
  return state.commentEdit;
};
var isEditingComment = exports.isEditingComment = function isEditingComment(state) {
  return Boolean(getEditedCommentId(state));
};

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_37OPu","card":"_1Fhsz","moreButton":"_2nR4V","cover":"_2r3ng","uploadCoverButton":"_2SkiL","uploadPhotoButton":"_1bJUV","photo":"_3Y75r","flexContainer":"lF2sX","userInfo":"nPerC","name":"BDc7Z","nameFieldWrapper":"EzZpx","editIcon":"_38cDs","nameField":"_2lpuH","nameInput":"_2FfQj","date":"_2cshH","childrenContainer":"_2uP0o","viewProfileEdit":"_3JLIl","cancelButton":"_1AqaR","statsContainer":"_3l5zw"};

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentSearchListItem = __webpack_require__(1790);

var _commentSearchListItem2 = _interopRequireDefault(_commentSearchListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentSearchListItem2.default;

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2z1oa","wrapper":"_3iCa0","listItemMobile":"_3EmXZ","pagination":"So-sr","separator":"_349Md"};

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _search = __webpack_require__(394);

var _search2 = _interopRequireDefault(_search);

var _setIsLoaded = __webpack_require__(198);

var _setIsLoading = __webpack_require__(418);

var _pageOpened = __webpack_require__(410);

var _searchInput = __webpack_require__(1321);

var _searchInput2 = _interopRequireDefault(_searchInput);

var _breadcrumbsWidget = __webpack_require__(1322);

var _breadcrumbsWidget2 = _interopRequireDefault(_breadcrumbsWidget);

var _detectRoute = __webpack_require__(266);

var _locationHistorySelectors = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEBOUNCE_WAIT = 200;

var SearchHeader = exports.SearchHeader = function (_Component) {
  _inherits(SearchHeader, _Component);

  function SearchHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchHeader.__proto__ || Object.getPrototypeOf(SearchHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleQueryChange = (0, _lodash.debounce)(function (query) {
      return _this.props.onQueryChange(query);
    }, DEBOUNCE_WAIT), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchHeader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          query = _props.query,
          isInitialLocation = _props.isInitialLocation;

      if (query && query.length >= _search.MIN_QUERY_LENGTH && !isInitialLocation) {
        this.props.setIsLoading('search', '', true);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSearch(this.props.query);
      this.props.pageOpened({ page: _detectRoute.SEARCH_RESULTS });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.query !== nextProps.query) {
        this.props.onSearch(nextProps.query);
        this.props.setIsLoading('search', '', true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          Component = _props2.component,
          left = _props2.left,
          query = _props2.query,
          inputClassName = _props2.inputClassName,
          iconClassName = _props2.iconClassName,
          borderClassName = _props2.borderClassName,
          showWidget = _props2.showWidget,
          props = _objectWithoutProperties(_props2, ['component', 'left', 'query', 'inputClassName', 'iconClassName', 'borderClassName', 'showWidget']);

      var searchInput = _react2.default.createElement(_searchInput2.default, {
        isExpanded: true,
        isFullWidth: !showWidget,
        value: query,
        onChange: this.handleQueryChange,
        inputClassName: inputClassName,
        iconClassName: iconClassName,
        borderClassName: borderClassName
      });

      var right = void 0;
      if (showWidget) {
        right = _react2.default.createElement(_breadcrumbsWidget2.default, { searchInput: searchInput });
      } else {
        right = searchInput;
      }

      return _react2.default.createElement(Component, _extends({ left: left, right: right }, props));
    }
  }]);

  return SearchHeader;
}(_react.Component);

SearchHeader.propTypes = {
  component: _propTypes2.default.any,
  left: _propTypes2.default.node,
  query: _propTypes2.default.string.isRequired,
  onQueryChange: _propTypes2.default.func.isRequired,
  onSearch: _propTypes2.default.func.isRequired,
  borderClassName: _propTypes2.default.string,
  inputClassName: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  pageOpened: _propTypes2.default.func,
  isInitialLocation: _propTypes2.default.bool.isRequired,
  setIsLoading: _propTypes2.default.func.isRequired,
  showWidget: _propTypes2.default.bool
};

SearchHeader.defaultProps = {
  showWidget: true
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    query: ownProps.location.query.query || '',
    isInitialLocation: (0, _locationHistorySelectors.isInitialLocation)(state)
  };
};

var buildLocation = function buildLocation(location, query) {
  if (query) {
    return _extends({}, location, {
      pathname: location.pathname === '/search' ? '/search/posts' : location.pathname,
      query: { query: query }
    });
  }
  return '/search';
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    onQueryChange: function onQueryChange(query) {
      return (0, _routerUtils.replace)(buildLocation(ownProps.location, query));
    },
    onSearch: _search2.default,
    pageOpened: _pageOpened.pageOpened,
    setIsLoading: _setIsLoading.setIsLoading,
    setIsLoaded: _setIsLoaded.setIsLoaded
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchHeader);

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAuthWrapper = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _factory = __webpack_require__(1803);

var _factory2 = _interopRequireDefault(_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAuthWrapper = exports.UserAuthWrapper = (0, _factory2.default)(_react2.default, 'div');

/***/ }),
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(278);

__webpack_require__(1201);

var _reactHotLoader = __webpack_require__(1204);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _history = __webpack_require__(1026);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(244);

var _reactRouterRedux = __webpack_require__(44);

var _reduxThrottle = __webpack_require__(1209);

var _reduxThrottle2 = _interopRequireDefault(_reduxThrottle);

var _reduxThunk = __webpack_require__(285);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(1289);

var _reducers2 = _interopRequireDefault(_reducers);

var _experiments = __webpack_require__(32);

var _fetchNotifications = __webpack_require__(158);

var _setSiteInfo = __webpack_require__(452);

var _updateUser = __webpack_require__(70);

var _userSocket = __webpack_require__(78);

var _fetchAndSetSitePages = __webpack_require__(1374);

var _root = __webpack_require__(1375);

var _root2 = _interopRequireDefault(_root);

var _config = __webpack_require__(29);

var _createRequest = __webpack_require__(277);

var _createRequest2 = _interopRequireDefault(_createRequest);

var _fixViewport = __webpack_require__(1809);

var _listenToAppInstall = __webpack_require__(1252);

var _listenToAppInstall2 = _interopRequireDefault(_listenToAppInstall);

var _listenToEditModeChange = __webpack_require__(1254);

var _listenToEditModeChange2 = _interopRequireDefault(_listenToEditModeChange);

var _listenToHistoryStateChange = __webpack_require__(1810);

var _listenToHistoryStateChange2 = _interopRequireDefault(_listenToHistoryStateChange);

var _listenToSettingsChange = __webpack_require__(555);

var _listenToSettingsChange2 = _interopRequireDefault(_listenToSettingsChange);

var _listenToMemberDetailsUpdated = __webpack_require__(1078);

var _listenToMemberDetailsUpdated2 = _interopRequireDefault(_listenToMemberDetailsUpdated);

var _parseGetParam = __webpack_require__(175);

var _requestCredentials = __webpack_require__(326);

var _requestCredentials2 = _interopRequireDefault(_requestCredentials);

var _createShowMessage = __webpack_require__(1080);

var _createShowMessage2 = _interopRequireDefault(_createShowMessage);

var _routerUtils = __webpack_require__(55);

var _scrollOnHistoryChange = __webpack_require__(1811);

var _scrollOnHistoryChange2 = _interopRequireDefault(_scrollOnHistoryChange);

var _uploadFile = __webpack_require__(1334);

var _uploadFile2 = _interopRequireDefault(_uploadFile);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _wixSdkUtils = __webpack_require__(21);

var _fedopsLogger = __webpack_require__(1814);

var _fedopsLogger2 = _interopRequireDefault(_fedopsLogger);

var _appLifecycleService = __webpack_require__(170);

var appLifecycleService = _interopRequireWildcard(_appLifecycleService);

var _experimentsSelectors = __webpack_require__(121);

var _initMiddleware = __webpack_require__(1137);

var _createWebsocketMiddleware = __webpack_require__(1335);

var _createWebsocketMiddleware2 = _interopRequireDefault(_createWebsocketMiddleware);

var _modalMiddleware = __webpack_require__(993);

var _modalMiddleware2 = _interopRequireDefault(_modalMiddleware);

var _publishMiddleware = __webpack_require__(1817);

var _publishMiddleware2 = _interopRequireDefault(_publishMiddleware);

var _redirectMiddleware = __webpack_require__(1818);

var _redirectMiddleware2 = _interopRequireDefault(_redirectMiddleware);

var _uploadMiddleware = __webpack_require__(1336);

var _uploadMiddleware2 = _interopRequireDefault(_uploadMiddleware);

var _actionLoggerMiddleware = __webpack_require__(1153);

var _actionLoggerMiddleware2 = _interopRequireDefault(_actionLoggerMiddleware);

var _configureStore = __webpack_require__(295);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _reduxDebounce = __webpack_require__(287);

var _reduxDebounce2 = _interopRequireDefault(_reduxDebounce);

var _wsClient = __webpack_require__(1337);

var _wsClient2 = _interopRequireDefault(_wsClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _config.setConfig)(window.__CONFIG__);
var baseUrl = window.__BASE_PATH__ || '';
var instance = (0, _wixSdkUtils.getInstance)();
var locale = window.__LOCALE__;
var request = (0, _createRequest2.default)({ baseUrl: baseUrl, instance: instance, locale: locale });

var browserHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
  basename: window.__BASE_PATH__ || ''
});

var config = {
  url: window.__WS_CONFIG__.url,
  token: window.__WS_CONFIG__.token
};
var wsClient = (0, _wsClient2.default)({ wsUrl: config.url, token: config.token });

var middlewares = [(0, _reactRouterRedux.routerMiddleware)(browserHistory), (0, _reduxThrottle2.default)(), (0, _reduxDebounce2.default)(), _redirectMiddleware2.default, (0, _uploadMiddleware2.default)(_uploadFile2.default, _requestCredentials2.default, request), _reduxThunk2.default.withExtraArgument({
  request: request,
  baseUrl: window.__BASE_PATH__ || window.location.protocol + '//' + window.location.host,
  fedopsLogger: _fedopsLogger2.default
}), (0, _createWebsocketMiddleware2.default)(wsClient, _wixSdkPolyfill2.default.Utils.getInstanceId()), _initMiddleware.forumsUouBiMiddleware, _initMiddleware.forumsUsersBiMiddleware, (0, _publishMiddleware2.default)(_wixSdkPolyfill2.default.PubSub.publish, [_updateUser.UPDATE_USER_SUCCESS, _userSocket.NEW_NOTIFICATION, _fetchNotifications.FETCH_NOTIFICATIONS_SUCCESS]), (0, _modalMiddleware2.default)(_createShowMessage2.default)];

(0, _actionLoggerMiddleware.shouldLogReduxActions)() && middlewares.push(_actionLoggerMiddleware2.default);
var store = (0, _configureStore2.default)(_lodash2.default.omit(window.__INITIAL_STATE__ || {}, ['textEditor']), middlewares, _reducers2.default);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, store);

if ((0, _wixSdkUtils.isMobile)() && !(0, _experimentsSelectors.isExperimentEnabled)(store.getState(), _experiments.EXPERIMENT_DISABLE_FIX_VIEWPORT)) {
  (0, _fixViewport.fixViewport)();
  window.addEventListener('orientationchange', _fixViewport.fixViewport);
}

_wixSdkPolyfill2.default.getSiteInfo(function (data) {
  store.dispatch((0, _setSiteInfo.setSiteInfo)(data));
});

store.dispatch((0, _fetchAndSetSitePages.fetchAndSetSitePages)());
(0, _listenToAppInstall2.default)(store);
(0, _listenToEditModeChange2.default)(store);
(0, _listenToSettingsChange2.default)(store, true);
(0, _listenToHistoryStateChange2.default)(history, store);
(0, _listenToMemberDetailsUpdated2.default)(store);
(0, _scrollOnHistoryChange2.default)(history);

var lastLocation = {};
history.listen(function (location) {
  return lastLocation = location;
});

var redirect = (0, _parseGetParam.parseGetParam)('redirect');
if (redirect) {
  store.dispatch((0, _routerUtils.replace)(lastLocation.pathname + '?redirect=' + redirect));
}

var renderApp = function renderApp(Application) {
  appLifecycleService.appIsLoading({ logInSdk: true });
  _reactDom2.default.render(_react2.default.createElement(
    _reactHotLoader.AppContainer,
    null,
    _react2.default.createElement(Application, { store: store, history: history })
  ), document.getElementById('root'));
};

renderApp(_root2.default);

if (false) {
  module.hot.accept('./containers/root', function () {
    console.log('HOT RELOAD START');
    // While using 'separateCss: true', external css files must be manually reloaded
    document.querySelectorAll('link[href][rel=stylesheet]').forEach(function (link) {
      var nextStyleHref = link.href.replace(/(\?\d+)?$/, '?' + Date.now());
      link.href = nextStyleHref;
    });

    renderApp(require('./containers/root').default);
    console.log('HOT RELOAD END');
  });
}

/***/ }),
/* 1373 */,
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAndSetSitePages = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _lodash = __webpack_require__(2);

var _setSitePages = __webpack_require__(1001);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fetchAndSetSitePages = exports.fetchAndSetSitePages = function fetchAndSetSitePages() {
  return function (dispatch) {
    return Promise.all([new Promise(function (resolve) {
      return _wixSdkPolyfill2.default.getCurrentPageId(resolve);
    }), new Promise(function (resolve) {
      return _wixSdkPolyfill2.default.getSiteMap(resolve);
    })]).then(function (values) {
      var _values = _slicedToArray(values, 2),
          currentPageId = _values[0],
          sitePages = _values[1];

      var pages = (0, _lodash.chain)(sitePages).flatMap(function (page) {
        return page.subPages ? [page].concat(_toConsumableArray(page.subPages)) : page;
      }).filter(function (page) {
        return page.type === 'PageLink';
      }).map(function (page) {
        return _extends({}, page, { pageId: (0, _lodash.trimStart)(page.pageId, '#') });
      }).value();

      var currentPage = (0, _lodash.find)(pages, function (page) {
        return page.pageId === currentPageId;
      }) || {};
      currentPage.isCurrent = true;
      dispatch((0, _setSitePages.setSitePages)(pages));
    });
  };
};

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _root = __webpack_require__(1376);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _root2.default;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _showMessage = __webpack_require__(159);

var _rootBase = __webpack_require__(1057);

var _rootBase2 = _interopRequireDefault(_rootBase);

var _createNavigation = __webpack_require__(1290);

var _communitiesContextSelectors = __webpack_require__(47);

var _getRoutes = __webpack_require__(1383);

var _getRoutes2 = _interopRequireDefault(_getRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root(props) {
    _classCallCheck(this, Root);

    var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));

    _initialiseProps.call(_this);

    var state = _this.props.store.getState();
    var context = (0, _communitiesContextSelectors.getCommunitiesContext)(state);

    _this.state = {
      navigation: (0, _createNavigation.createNavigation)(props.store),
      context: context
    };
    return _this;
  }

  _createClass(Root, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.unregisterListener = this.props.store.subscribe(this.contextListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _lodash.invoke)(this, 'unregisterListener');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          history = _props.history;
      var navigation = this.state.navigation;

      var actions = (0, _redux.bindActionCreators)({ showMessage: _showMessage.showMessage }, store.dispatch);

      return _react2.default.createElement(
        _rootBase2.default,
        { store: store, history: history, environment: { showMessage: actions.showMessage, navigation: navigation } },
        (0, _getRoutes2.default)()
      );
    }
  }]);

  return Root;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.contextListener = function () {
    var state = _this2.props.store.getState();
    var context = (0, _communitiesContextSelectors.getCommunitiesContext)(state);

    if (context !== _this2.state.context) {
      _this2.setState({
        navigation: (0, _createNavigation.createNavigation)(_this2.props.store),
        context: context
      });
    }
  };
};

Root.propTypes = {
  store: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
};

exports.default = Root;

/***/ }),
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(244);

var _experiments = __webpack_require__(32);

var _overlay = __webpack_require__(1384);

var _overlay2 = _interopRequireDefault(_overlay);

var _accountSuspendedPage = __webpack_require__(1387);

var _accountSuspendedPage2 = _interopRequireDefault(_accountSuspendedPage);

var _app = __webpack_require__(1398);

var _app2 = _interopRequireDefault(_app);

var _categoriesLink = __webpack_require__(1417);

var _categoriesLink2 = _interopRequireDefault(_categoriesLink);

var _categoriesPage = __webpack_require__(1420);

var _categoriesPage2 = _interopRequireDefault(_categoriesPage);

var _categoriesPageHeader = __webpack_require__(1473);

var _categoriesPageHeader2 = _interopRequireDefault(_categoriesPageHeader);

var _categoryPage = __webpack_require__(1502);

var _categoryPage2 = _interopRequireDefault(_categoryPage);

var _categoryPageHeader = __webpack_require__(1561);

var _categoryPageHeader2 = _interopRequireDefault(_categoryPageHeader);

var _commentEditPage = __webpack_require__(1563);

var _commentEditPage2 = _interopRequireDefault(_commentEditPage);

var _commentEditPageHeader = __webpack_require__(1571);

var _commentEditPageHeader2 = _interopRequireDefault(_commentEditPageHeader);

var _followersMenu = __webpack_require__(1580);

var _followersMenu2 = _interopRequireDefault(_followersMenu);

var _followersPage = __webpack_require__(1586);

var _followersPage2 = _interopRequireDefault(_followersPage);

var _followingPage = __webpack_require__(1610);

var _followingPage2 = _interopRequireDefault(_followingPage);

var _internalPageHeader = __webpack_require__(1613);

var _internalPageHeader2 = _interopRequireDefault(_internalPageHeader);

var _loginPage = __webpack_require__(1635);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _membersMenu = __webpack_require__(1638);

var _membersMenu2 = _interopRequireDefault(_membersMenu);

var _membersPage = __webpack_require__(1650);

var _membersPage2 = _interopRequireDefault(_membersPage);

var _notFoundPage = __webpack_require__(1657);

var _notFoundPage2 = _interopRequireDefault(_notFoundPage);

var _notificationsPage = __webpack_require__(1659);

var _notificationsPage2 = _interopRequireDefault(_notificationsPage);

var _postCreatePage = __webpack_require__(1668);

var _postCreatePage2 = _interopRequireDefault(_postCreatePage);

var _postCreatePageHeader = __webpack_require__(1670);

var _postCreatePageHeader2 = _interopRequireDefault(_postCreatePageHeader);

var _postEditPage = __webpack_require__(1672);

var _postEditPage2 = _interopRequireDefault(_postEditPage);

var _postEditPageHeader = __webpack_require__(1674);

var _postEditPageHeader2 = _interopRequireDefault(_postEditPageHeader);

var _postPage = __webpack_require__(1676);

var _postPage2 = _interopRequireDefault(_postPage);

var _profileNotificationsPage = __webpack_require__(1742);

var _profileNotificationsPage2 = _interopRequireDefault(_profileNotificationsPage);

var _profilePage = __webpack_require__(1750);

var _profilePage2 = _interopRequireDefault(_profilePage);

var _profilePosts = __webpack_require__(1775);

var _profilePosts2 = _interopRequireDefault(_profilePosts);

var _resultsPage = __webpack_require__(1780);

var _resultsPage2 = _interopRequireDefault(_resultsPage);

var _searchDesktopHeader = __webpack_require__(1793);

var _searchDesktopHeader2 = _interopRequireDefault(_searchDesktopHeader);

var _searchMobileHeader = __webpack_require__(1794);

var _searchMobileHeader2 = _interopRequireDefault(_searchMobileHeader);

var _searchMenu = __webpack_require__(1795);

var _searchMenu2 = _interopRequireDefault(_searchMenu);

var _searchPage = __webpack_require__(1797);

var _searchPage2 = _interopRequireDefault(_searchPage);

var _forAuthenticatedOnly = __webpack_require__(1800);

var _forAuthenticatedOnly2 = _interopRequireDefault(_forAuthenticatedOnly);

var _forExperiment = __webpack_require__(1801);

var _forExperiment2 = _interopRequireDefault(_forExperiment);

var _forMobileOnly = __webpack_require__(1013);

var _forMobileOnly2 = _interopRequireDefault(_forMobileOnly);

var _requireAuth = __webpack_require__(1802);

var _requireAuth2 = _interopRequireDefault(_requireAuth);

var _requireNotBlocked = __webpack_require__(1808);

var _requireNotBlocked2 = _interopRequireDefault(_requireNotBlocked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// DANGER!!! New routes can only be 4 chars length or shorter!
// If you are lucky you can take route from black listed slugs in - communities-node-server/app/services/slug-service.js

exports.default = function () {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', name: 'Wix Forum', component: _app2.default },
    _react2.default.createElement(_reactRouter.Route, {
      path: '404',
      breadcrumbIgnore: true,
      components: { main: _notFoundPage2.default, simpleHeader: _categoriesPageHeader2.default, desktopHeader: _internalPageHeader.InternalPageDesktopHeader }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'profiles/:userSlug',
      name: 'Profile',
      breadcrumbName: ':userSlug',
      components: {
        main: _profilePage2.default,
        children: _profilePosts2.default,
        headroomHeader: _internalPageHeader2.default,
        desktopHeader: _internalPageHeader.InternalPageDesktopHeader,
        overlay: _overlay2.default
      }
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'profiles/:userSlug', name: 'Profile', breadcrumbName: ':userSlug' },
      _react2.default.createElement(_reactRouter.Route, {
        path: 'settings',
        name: 'Settings',
        breadcrumbName: 'breadcrumbs.profile-settings',
        components: {
          main: (0, _requireAuth2.default)(_profileNotificationsPage2.default),
          headroomHeader: _internalPageHeader2.default,
          desktopHeader: _internalPageHeader.InternalPageDesktopHeader
        }
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'followers',
        name: 'Followers',
        breadcrumbName: 'breadcrumbs.followers',
        components: {
          main: _followersPage2.default,
          headroomHeader: _internalPageHeader2.default,
          desktopHeader: _internalPageHeader.InternalPageDesktopHeader,
          menu: _followersMenu2.default
        }
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'following',
        name: 'Following',
        breadcrumbName: 'breadcrumbs.following',
        components: {
          main: _followingPage2.default,
          headroomHeader: _internalPageHeader2.default,
          desktopHeader: _internalPageHeader.InternalPageDesktopHeader,
          menu: _followersMenu2.default
        }
      })
    ),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'notifications',
      name: 'Notifications',
      breadcrumbName: 'breadcrumbs.notifications',
      components: {
        main: _notificationsPage2.default,
        stickyHeader: _internalPageHeader2.default,
        desktopHeader: _internalPageHeader.InternalPageDesktopHeader
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'members',
      name: 'Members',
      breadcrumbName: 'breadcrumbs.members',
      components: {
        main: _membersPage2.default,
        headroomHeader: _internalPageHeader2.default,
        desktopHeader: _internalPageHeader.InternalPageDesktopHeader,
        menu: (0, _forAuthenticatedOnly2.default)(_membersMenu2.default)
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'search',
      name: 'Search',
      breadcrumbName: 'breadcrumbs.search',
      components: {
        main: _searchPage2.default,
        headroomHeader: _searchMobileHeader2.default,
        desktopHeader: _searchDesktopHeader2.default,
        menu: (0, _forExperiment2.default)(_experiments.EXPERIMENT_MEMBERS_AREA, function () {
          return null;
        }, _searchMenu2.default)
      }
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'search', name: 'Search', breadcrumbName: 'breadcrumbs.search' },
      _react2.default.createElement(_reactRouter.Route, {
        path: 'posts',
        breadcrumbIgnore: true,
        components: {
          main: (0, _resultsPage2.default)('posts', 'members'),
          headroomHeader: _searchMobileHeader2.default,
          desktopHeader: _searchDesktopHeader2.default,
          menu: (0, _forExperiment2.default)(_experiments.EXPERIMENT_MEMBERS_AREA, function () {
            return null;
          }, _searchMenu2.default)
        }
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: 'members',
        breadcrumbIgnore: true,
        components: {
          main: (0, _resultsPage2.default)('members', 'posts'),
          headroomHeader: _searchMobileHeader2.default,
          desktopHeader: _searchDesktopHeader2.default,
          menu: (0, _forExperiment2.default)(_experiments.EXPERIMENT_MEMBERS_AREA, function () {
            return null;
          }, _searchMenu2.default)
        }
      })
    ),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'login',
      name: 'Login',
      breadcrumbName: 'breadcrumbs.login',
      components: { main: _loginPage2.default, desktopHeader: _internalPageHeader.InternalPageDesktopHeader }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'account-suspended',
      name: 'Account Suspended',
      breadcrumbName: 'breadcrumbs.account-suspended',
      components: {
        main: _accountSuspendedPage2.default,
        headroomHeader: _internalPageHeader2.default,
        desktopHeader: _internalPageHeader.InternalPageDesktopHeader
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: ':categorySlug',
      name: 'Category',
      breadcrumbName: ':categorySlug',
      components: {
        main: _categoryPage2.default,
        headroomHeader: _categoryPageHeader2.default,
        desktopHeader: _internalPageHeader.InternalPageDesktopHeader,
        menu: (0, _forMobileOnly2.default)(_categoriesLink2.default)
      }
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':categorySlug', name: 'Category', breadcrumbName: ':categorySlug' },
      _react2.default.createElement(_reactRouter.Route, {
        path: 'create-post',
        name: 'Create Post',
        breadcrumbName: 'breadcrumbs.create-post',
        components: {
          main: (0, _requireAuth2.default)((0, _requireNotBlocked2.default)(_postCreatePage2.default)),
          stickyHeader: _postCreatePageHeader2.default,
          desktopHeader: _internalPageHeader.InternalPageDesktopHeader
        }
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: ':postSlug',
        name: 'Post',
        breadcrumbName: ':postSlug',
        components: { main: _postPage2.default, headroomHeader: _internalPageHeader2.default, desktopHeader: _internalPageHeader.InternalPageDesktopHeader }
      }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: ':postSlug', name: 'Post', breadcrumbName: ':postSlug' },
        _react2.default.createElement(_reactRouter.Route, {
          path: 'edit',
          name: 'Edit Post',
          breadcrumbName: 'breadcrumbs.edit-post',
          components: {
            main: (0, _requireAuth2.default)((0, _requireNotBlocked2.default)(_postEditPage2.default)),
            stickyHeader: _postEditPageHeader2.default,
            desktopHeader: _internalPageHeader.InternalPageDesktopHeader
          }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'edit-comment/:commentId',
          name: 'Edit Comment',
          breadcrumbName: 'breadcrumbs.edit-comment',
          components: {
            main: (0, _requireAuth2.default)((0, _requireNotBlocked2.default)(_commentEditPage2.default)),
            stickyHeader: _commentEditPageHeader2.default,
            desktopHeader: _internalPageHeader.InternalPageDesktopHeader
          }
        })
      )
    ),
    _react2.default.createElement(_reactRouter.IndexRoute, {
      breadcrumbIgnore: true,
      components: {
        main: _categoriesPage2.default,
        simpleHeader: _categoriesPageHeader2.default,
        desktopHeader: _internalPageHeader.InternalPageDesktopHeader,
        overlay: _overlay2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: '*',
      breadcrumbIgnore: true,
      components: { main: _notFoundPage2.default, simpleHeader: _categoriesPageHeader2.default, desktopHeader: _internalPageHeader.InternalPageDesktopHeader }
    })
  );
};

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _overlay = __webpack_require__(1385);

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _overlay2.default;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _overlay = __webpack_require__(1386);

var _overlay2 = _interopRequireDefault(_overlay);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Overlay = function Overlay() {
  return _react2.default.createElement('div', { className: (0, _classnames2.default)(_overlay2.default.overlay, 'overlay', 'button-background-color') });
};

exports.default = Overlay;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1T69t"};

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _accountSuspendedPage = __webpack_require__(1388);

var _accountSuspendedPage2 = _interopRequireDefault(_accountSuspendedPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _accountSuspendedPage2.default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _layout = __webpack_require__(1237);

var _accountSuspended = __webpack_require__(1179);

var _accountSuspended2 = _interopRequireDefault(_accountSuspended);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layout = (0, _forDevice2.default)(_layout.FullHeightLayout, _layout.SimpleLayout);

var AccountSuspendedPage = function AccountSuspendedPage() {
  return _react2.default.createElement(
    _page2.default,
    null,
    _react2.default.createElement(
      Layout,
      null,
      _react2.default.createElement(_accountSuspended2.default, null)
    ),
    _react2.default.createElement(_appLoaded2.default, null)
  );
};

exports.default = AccountSuspendedPage;

/***/ }),
/* 1389 */,
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _page = __webpack_require__(1391);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Page = function Page(_ref) {
  var className = _ref.className,
      noSpacing = _ref.noSpacing,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_page2.default.container, _defineProperty({}, _page2.default.noSpacing, noSpacing), className) },
    children
  );
};

Page.propTypes = {
  className: _propTypes2.default.string,
  noSpacing: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

exports.default = Page;

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3G44M","noSpacing":"_1-Zl5"};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyLayout = function EmptyLayout(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    children
  );
};

EmptyLayout.propTypes = {
  children: _propTypes2.default.node
};

exports.default = EmptyLayout;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _simpleLayout = __webpack_require__(1291);

var _simpleLayout2 = _interopRequireDefault(_simpleLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleLayout = function SimpleLayout(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: _simpleLayout2.default.container },
    children
  );
};

SimpleLayout.propTypes = {
  children: _propTypes2.default.node
};

exports.default = SimpleLayout;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _simpleLayout = __webpack_require__(1291);

var _simpleLayout2 = _interopRequireDefault(_simpleLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullHeightLayout = function FullHeightLayout(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: _simpleLayout2.default.container },
    children
  );
};

FullHeightLayout.propTypes = {
  children: _propTypes2.default.node
};

exports.default = FullHeightLayout;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AccountSuspended = function AccountSuspended(_ref) {
  var t = _ref.t,
      props = _objectWithoutProperties(_ref, ['t']);

  return _react2.default.createElement(_emptyStates2.default, _extends({
    title: t('account-suspended.account-suspended'),
    content: t('account-suspended.contact-owner')
  }, props));
};

AccountSuspended.propTypes = {
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(AccountSuspended);

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _emptyStates = __webpack_require__(1397);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyStates = function EmptyStates(_ref) {
  var title = _ref.title,
      content = _ref.content,
      className = _ref.className,
      children = _ref.children,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName,
      borderWidth = _ref.borderWidth;

  var containerClassName = (0, _classnames2.default)(_emptyStates2.default.container, className, contentFontClassName, 'forum-card-background-color', 'forum-text-color', 'forum-card-border-color');
  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: { borderWidth: borderWidth } },
    _react2.default.createElement(
      'div',
      { className: titleFontClassName },
      _react2.default.createElement(
        'div',
        { className: _emptyStates2.default.header, 'data-hook': 'empty-states__header' },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _emptyStates2.default.content, 'data-hook': 'empty-states__content' },
      content
    ),
    children && _react2.default.createElement(
      'div',
      { className: _emptyStates2.default.controls, 'data-hook': 'empty-states__sign-up' },
      children
    )
  );
};

EmptyStates.propTypes = {
  children: _propTypes2.default.node,
  title: _propTypes2.default.string,
  content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  className: _propTypes2.default.string,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  borderWidth: _propTypes2.default.number.isRequired
};

exports.default = (0, _withFontClassName2.default)((0, _withCardBorderWidth2.default)(EmptyStates));

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kFaa","header":"njNdH","content":"ZvzgE","controls":"U1pmg"};

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _app = __webpack_require__(1399);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _fetchCurrentMember = __webpack_require__(1102);

var _fetchUserSettings = __webpack_require__(531);

var _setCommunitiesContext = __webpack_require__(247);

var _setDemoMode = __webpack_require__(317);

var _setExperiments = __webpack_require__(157);

var _setCurrentUser = __webpack_require__(80);

var _setViewMode = __webpack_require__(256);

var _setUserAgent = __webpack_require__(1236);

var _fetchCategories = __webpack_require__(248);

var _fetchCategories2 = _interopRequireDefault(_fetchCategories);

var _userSocket = __webpack_require__(78);

var _forumSocket = __webpack_require__(1400);

var _fetchForumData = __webpack_require__(197);

var _fetchAppSettings = __webpack_require__(194);

var _enableNotificationsCountChange = __webpack_require__(1175);

var _currentUserSelectors = __webpack_require__(67);

var _forumDataSelectors = __webpack_require__(457);

var _wixSdkUtils = __webpack_require__(21);

var _app = __webpack_require__(1401);

var _app2 = _interopRequireDefault(_app);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = exports.App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ((0, _lodash.isEmpty)(this.props.appSettings)) {
        this.props.fetchAppSettings();
      }
      if ((0, _lodash.isEmpty)(this.props.forumData)) {
        this.props.fetchForumData();
      }
      if (!(0, _wixSdkUtils.isEditor)() && !(0, _wixSdkUtils.isPreview)()) {
        this.props.fetchCurrentMember();
      }
      if (!this.props.categories.length) {
        this.props.fetchCategories();
      }
      if (this.props.currentUser) {
        this.props.emitUserConnected(this.props.currentUser);
      }
      this.props.emitForumOpened();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.categories.length && nextProps.categories.length === 1 && this.props.location.pathname === '/') {
        this.props.onCategoriesFetched(nextProps.categories);
      }

      if (!this.props.currentUser && nextProps.currentUser) {
        this.props.emitUserConnected(nextProps.currentUser);
      }
      if (nextProps.location.pathname === '/notifications') {
        this.props.enableNotificationCountChanges(false);
      } else {
        this.props.enableNotificationCountChanges(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return this.props.categories.length ? _react2.default.createElement(_app2.default, this.props) : _react2.default.createElement(
        'div',
        null,
        t('app.loading')
      );
    }
  }]);

  return App;
}(_react.Component);

App.fetchData = function (_ref) {
  var store = _ref.store,
      pathname = _ref.pathname,
      search = _ref.search,
      user = _ref.user,
      demoMode = _ref.demoMode,
      experiments = _ref.experiments,
      userAgent = _ref.userAgent,
      communitiesContext = _ref.communitiesContext;

  var promises = [store.dispatch((0, _setViewMode.setViewMode)((0, _wixSdkUtils.getViewMode)())), store.dispatch((0, _setCommunitiesContext.setCommunitiesContext)(communitiesContext)), store.dispatch((0, _setDemoMode.setDemoMode)(Boolean(demoMode))), store.dispatch((0, _setExperiments.setExperiments)(experiments)), store.dispatch((0, _setUserAgent.setUserAgent)(userAgent)), store.dispatch((0, _fetchCategories2.default)()).then(function () {
    var _store$getState = store.getState(),
        categories = _store$getState.categories;

    if (categories.length === 1 && pathname === '/') {
      return store.dispatch((0, _routerUtils.push)('/' + categories[0].slug + search));
    }
  }), store.dispatch((0, _fetchAppSettings.fetchAppSettings)(search)), store.dispatch((0, _fetchForumData.fetchForumData)())];
  if (user) {
    if (pathname === '/notifications') {
      promises.push(store.dispatch((0, _enableNotificationsCountChange.enableNotificationCountChanges)(false)));
    }

    promises.push(store.dispatch((0, _setCurrentUser.setCurrentUser)(user)));
    promises.push(store.dispatch((0, _fetchUserSettings.fetchUserSettings)(user._id)));
  }
  return promises;
};

App.propTypes = {
  fetchCurrentMember: _propTypes2.default.func.isRequired,
  appSettings: _propTypes2.default.object.isRequired,
  forumData: _propTypes2.default.object.isRequired,
  fetchForumData: _propTypes2.default.func.isRequired,
  fetchAppSettings: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  fetchCategories: _propTypes2.default.func,
  emitUserConnected: _propTypes2.default.func,
  emitForumOpened: _propTypes2.default.func,
  enableNotificationCountChanges: _propTypes2.default.func,
  location: _propTypes2.default.object,
  currentUser: _propTypes2.default.object,
  categories: _propTypes2.default.array,
  onCategoriesFetched: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appSettings: state.appSettings,
    forumData: (0, _forumDataSelectors.getForumData)(state),
    categories: state.categories,
    location: ownProps.location,
    currentUser: (0, _currentUserSelectors.getCurrentUser)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    emitUserConnected: _userSocket.emitUserConnected,
    emitForumOpened: _forumSocket.emitForumOpened,
    fetchForumData: _fetchForumData.fetchForumData,
    fetchCurrentMember: _fetchCurrentMember.fetchCurrentMember,
    fetchCategories: _fetchCategories2.default,
    onCategoriesFetched: function onCategoriesFetched(categories) {
      return (0, _routerUtils.push)('/' + categories[0].slug);
    },
    enableNotificationCountChanges: _enableNotificationsCountChange.enableNotificationCountChanges,
    fetchAppSettings: _fetchAppSettings.fetchAppSettings
  }, dispatch);
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default)(App);

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitForumOpened = emitForumOpened;

var _wsActions = __webpack_require__(128);

var _wsChannel = __webpack_require__(151);

function emitForumOpened() {
  return (0, _wsActions.joinChannel)((0, _wsChannel.getForumChannel)());
}

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _app = __webpack_require__(1402);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appDesktop = __webpack_require__(1403);

var _appDesktop2 = _interopRequireDefault(_appDesktop);

var _appMobile = __webpack_require__(1406);

var _appMobile2 = _interopRequireDefault(_appMobile);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _forDevice2.default)(_appMobile2.default, _appDesktop2.default);

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppDesktop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactGateway = __webpack_require__(405);

var _demoMessageRoot = __webpack_require__(1005);

var _demoMessageRoot2 = _interopRequireDefault(_demoMessageRoot);

var _messageRoot = __webpack_require__(1006);

var _messageRoot2 = _interopRequireDefault(_messageRoot);

var _modalRoot = __webpack_require__(460);

var _modalRoot2 = _interopRequireDefault(_modalRoot);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _reactWindowResizeListener = __webpack_require__(1404);

var _wixSdkUtils = __webpack_require__(21);

var _isInWix = __webpack_require__(77);

var _accessibilityListener = __webpack_require__(324);

var _accessibilityListener2 = _interopRequireDefault(_accessibilityListener);

var _app = __webpack_require__(455);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MIN_WIDTH = 980;

var AppDesktop = exports.AppDesktop = function (_Component) {
  _inherits(AppDesktop, _Component);

  function AppDesktop() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppDesktop);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppDesktop.__proto__ || Object.getPrototypeOf(AppDesktop)).call.apply(_ref, [this].concat(args))), _this), _this.handleResize = function (windowSize) {
      if (_wixSdkPolyfill2.default.Utils.getViewMode() !== 'editor') {
        return;
      }
      _wixSdkPolyfill2.default.resizeComponent({
        width: Math.max(MIN_WIDTH, windowSize.windowWidth),
        height: windowSize.windowHeight
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppDesktop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.documentElement.classList.add('no-scroll');
    }
  }, {
    key: 'renderResizeListener',
    value: function renderResizeListener() {
      return (0, _wixSdkUtils.isEditor)() && _react2.default.createElement(_reactWindowResizeListener.WindowResizeListener, { onResize: this.handleResize });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          desktopHeader = _props.desktopHeader,
          menu = _props.menu,
          main = _props.main,
          children = _props.children;

      return _react2.default.createElement(
        _reactGateway.GatewayProvider,
        null,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_app2.default.app, 'app-desktop', 'forum-background-color') },
          this.renderResizeListener(),
          _react2.default.createElement(_accessibilityListener2.default, null),
          _react2.default.createElement(_messageRoot2.default, null),
          _react2.default.createElement(_demoMessageRoot2.default, null),
          _react2.default.createElement(
            'div',
            { id: 'content-wrapper' },
            desktopHeader && _react2.default.cloneElement(desktopHeader, { menu: menu }),
            _react2.default.cloneElement(main, { children: children })
          ),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'footer' }),
          !(0, _isInWix.isInWix)() && _react2.default.createElement(_modalRoot2.default, null),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'floating-action-button' }),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'tooltip' })
        )
      );
    }
  }]);

  return AppDesktop;
}(_react.Component);

AppDesktop.propTypes = {
  desktopHeader: _propTypes2.default.node,
  main: _propTypes2.default.node.isRequired,
  children: _propTypes2.default.node,
  menu: _propTypes2.default.node
};
exports.default = AppDesktop;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * WindowResizeListener
 * React component for listening to window resize events
 */
var React = __webpack_require__(0)
var debounce = __webpack_require__(1405)

var WindowResizeListener = React.createClass({
  displayName: 'WindowResizeListener',

  propTypes: {
    /**
     * Called at least once soon after being mounted
     * type WindowSize = { windowWidth: number, windowHeight: number }
     * type onResize = (windowSize: WindowSize) => void
     */
    onResize: React.PropTypes.func.isRequired
  },

  statics: {
    /**
     * List of resize listeners
     * @private
     */
    _listeners: [],

    /**
     * Maximum debounce wait time
     * @public
     */
    DEBOUNCE_TIME: 100,

    /**
     * Resize handler
     * Gets the window size and calls each listener
     * @private
     */
    _onResize: function _onResize () {
      var windowWidth = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      var windowHeight = window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight

      WindowResizeListener._listeners.forEach(function (listener) {
        listener({
          windowWidth: windowWidth,
          windowHeight: windowHeight
        })
      })
    }
  },

  shouldComponentUpdate: function shouldComponentUpdate (nextProps) {
    return nextProps.onResize !== this.props.onResize
  },

  componentDidMount: function componentDidMount () {
    // Defer creating _debouncedResize until it's mounted
    // This allows users to change DEBOUNCE_TIME if they want
    // If there's no listeners, we need to attach the window listener
    if (!WindowResizeListener._listeners.length) {
      WindowResizeListener._debouncedResize = debounce(
        WindowResizeListener._onResize,
        WindowResizeListener.DEBOUNCE_TIME
      )
      window.addEventListener('resize', WindowResizeListener._debouncedResize, false)
    }
    WindowResizeListener._listeners.push(this.props.onResize)
    WindowResizeListener._debouncedResize()
  },

  componentWillUnmount: function componentWillUnmount () {
    var idx = WindowResizeListener._listeners.indexOf(this.props.onResize)
    WindowResizeListener._listeners.splice(idx, 1)
    if (!WindowResizeListener._listeners.length) {
      window.removeEventListener('resize', WindowResizeListener._debouncedResize, false)
    }
  },

  componentWillReceiveProps: function componentWillReceiveProps (nextProps) {
    if (nextProps.onResize !== this.props.onResize) {
      var idx = WindowResizeListener._listeners.indexOf(this.props.onResize)
      WindowResizeListener._listeners.splice(idx, 1, nextProps.onResize)
    }
  },

  render: function resize () {
    return null
  }
})

exports.default = exports.WindowResizeListener = WindowResizeListener


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(1292);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppMobile = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactGateway = __webpack_require__(405);

var _wrapperHeadroom = __webpack_require__(1407);

var _wrapperHeadroom2 = _interopRequireDefault(_wrapperHeadroom);

var _messageRoot = __webpack_require__(1006);

var _messageRoot2 = _interopRequireDefault(_messageRoot);

var _demoMessageRoot = __webpack_require__(1005);

var _demoMessageRoot2 = _interopRequireDefault(_demoMessageRoot);

var _modalRoot = __webpack_require__(460);

var _modalRoot2 = _interopRequireDefault(_modalRoot);

var _accessibilityListener = __webpack_require__(324);

var _accessibilityListener2 = _interopRequireDefault(_accessibilityListener);

var _app = __webpack_require__(455);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import 'react-fastclick';

var AppMobile = exports.AppMobile = function (_Component) {
  _inherits(AppMobile, _Component);

  function AppMobile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppMobile.__proto__ || Object.getPrototypeOf(AppMobile)).call.apply(_ref, [this].concat(args))), _this), _this.scrollable = null, _this.setScrollable = function (node) {
      _this.scrollable = node;
    }, _this.handleSafariTouchStart = function (event) {
      if (_this.scrollable) {
        _this.allowUp = _this.scrollable.scrollTop > 0;
        _this.allowDown = _this.scrollable.scrollTop < _this.scrollable.scrollHeight - _this.scrollable.clientHeight;
        _this.slideBeginY = event.changedTouches[0].pageY;
      }
    }, _this.handleSafariTouchMove = function (event) {
      if (_this.scrollable) {
        var up = event.changedTouches[0].pageY > _this.slideBeginY;
        var down = event.changedTouches[0].pageY < _this.slideBeginY;
        _this.slideBeginY = event.changedTouches[0].pageY;
        if (up && _this.allowUp || down && _this.allowDown) {
          event.stopPropagation();
        } else if (!_this.isEditableOnFocus()) {
          event.preventDefault();
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppMobile, [{
    key: 'renderOutsideScroll',
    value: function renderOutsideScroll() {
      var _props = this.props,
          headroomHeader = _props.headroomHeader,
          stickyHeader = _props.stickyHeader,
          menu = _props.menu;


      if (headroomHeader) {
        var header = _react2.default.cloneElement(headroomHeader, { menu: menu });
        return _react2.default.createElement(
          _wrapperHeadroom2.default,
          { menu: menu },
          header
        );
      }
      if (stickyHeader) {
        return _react2.default.cloneElement(stickyHeader, { menu: menu });
      }

      return null;
    }
  }, {
    key: 'renderInsideScroll',
    value: function renderInsideScroll() {
      var _props2 = this.props,
          simpleHeader = _props2.simpleHeader,
          menu = _props2.menu;

      var header = null;

      if (simpleHeader) {
        header = _react2.default.cloneElement(simpleHeader, { menu: menu });
      }
      return header;
    }
  }, {
    key: 'getOutsideScrollHeaderSize',
    value: function getOutsideScrollHeaderSize() {
      var _props3 = this.props,
          headroomHeader = _props3.headroomHeader,
          categories = _props3.categories,
          menu = _props3.menu;

      if (headroomHeader) {
        return 50 + (categories.length > 1 && menu ? 50 : 0);
      }
      return 0;
    }
  }, {
    key: 'getHeaderClass',
    value: function getHeaderClass() {
      var headerSize = this.getOutsideScrollHeaderSize();
      return {
        'no-gap': headerSize === 0,
        'medium-gap': headerSize === 50,
        'large-gap': headerSize === 100
      };
    }

    ///start patch for ios safari scroll down bug (app is not responsive if scroll on top 0 and the user pulls down the browser)

  }, {
    key: 'isEditableOnFocus',
    value: function isEditableOnFocus() {
      return document.activeElement.tagName === 'DIV' && document.activeElement.getAttribute('contenteditable') === 'true' || document.activeElement.tagName === 'TEXTAREA' || document.activeElement.tagName === 'INPUT';
    }
  }, {
    key: 'clearActive',


    ///end patch for ios safari

    /// start fast active - allow setting css when user taps on an element => need to add '.active' css rule to elements that you want to change
    value: function clearActive() {
      if (this.activeElement && this.activeElement.classList) {
        this.activeElement.classList.remove('active');
        this.activeElement = null;
      }
    }
  }, {
    key: 'setActive',
    value: function setActive(e) {
      this.clearActive();
      if (this.activeElement && this.activeElement.classList) {
        this.activeElement = e.target;
        this.activeElement.classList.add('active');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ('ontouchstart' in window || window.DocumentTouch && window.document instanceof window.DocumentTouch) {
        window.document.body.addEventListener('touchstart', this.setActive.bind(this), false);
        window.document.body.addEventListener('touchmove', this.clearActive.bind(this), false);
      }
    }
    /// end fast active - allow setting css when user taps on an element => need to add '.active' css rule to elements that you want to change

  }, {
    key: 'renderScroll',
    value: function renderScroll() {
      var _props4 = this.props,
          main = _props4.main,
          overlay = _props4.overlay,
          children = _props4.children;

      return _react2.default.createElement(
        'div',
        {
          ref: this.setScrollable,
          className: (0, _classnames2.default)(_app2.default.scrollable, 'app-mobile__scrollable'),
          onTouchStart: this.handleSafariTouchStart,
          onTouchMove: this.handleSafariTouchMove
        },
        overlay,
        this.renderInsideScroll(),
        _react2.default.cloneElement(main, { children: children })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactGateway.GatewayProvider,
        null,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_app2.default.app, this.getHeaderClass(), 'app-mobile', 'forum-background-color') },
          _react2.default.createElement(_accessibilityListener2.default, null),
          _react2.default.createElement(_messageRoot2.default, null),
          _react2.default.createElement(_demoMessageRoot2.default, null),
          this.renderOutsideScroll(),
          this.renderScroll(),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'footer' }),
          _react2.default.createElement(_modalRoot2.default, null),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'floating-action-button' }),
          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'tooltip' })
        )
      );
    }
  }]);

  return AppMobile;
}(_react.Component);

AppMobile.propTypes = {
  children: _propTypes2.default.node,
  simpleHeader: _propTypes2.default.node,
  stickyHeader: _propTypes2.default.node,
  headroomHeader: _propTypes2.default.node,
  main: _propTypes2.default.node,
  menu: _propTypes2.default.node,
  categories: _propTypes2.default.array,
  overlay: _propTypes2.default.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    categories: state.categories
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AppMobile);

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _wrapperHeadroom = __webpack_require__(1408);

var _wrapperHeadroom2 = _interopRequireDefault(_wrapperHeadroom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _wrapperHeadroom2.default;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperHeadroom = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHeadroom = __webpack_require__(1409);

var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _reactRedux = __webpack_require__(5);

var _updateHeader = __webpack_require__(1172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WrapperHeadroom = exports.WrapperHeadroom = function (_Component) {
  _inherits(WrapperHeadroom, _Component);

  function WrapperHeadroom(props) {
    _classCallCheck(this, WrapperHeadroom);

    var _this = _possibleConstructorReturn(this, (WrapperHeadroom.__proto__ || Object.getPrototypeOf(WrapperHeadroom)).call(this, props));

    _this.handlePin = _this.handlePin.bind(_this);
    _this.handleUnpin = _this.handleUnpin.bind(_this);
    _this.handleHeaderHeightChange = _this.handleHeaderHeightChange.bind(_this);
    _this.setHeadroom = _this.setHeadroom.bind(_this);
    return _this;
  }

  _createClass(WrapperHeadroom, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var isAuthenticated = _ref.isAuthenticated;

      if (!this.props.isAuthenticated && isAuthenticated) {
        this.headroom.pin();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.updateHeader({
        offset: 0,
        height: this.getHeight()
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.updateHeader({
        offset: 0,
        height: 0
      });
    }
  }, {
    key: 'handleHeaderHeightChange',
    value: function handleHeaderHeightChange() {}
  }, {
    key: 'handlePin',
    value: function handlePin() {
      this.props.updateHeader({
        offset: 0,
        height: this.getHeight()
      });
    }
  }, {
    key: 'handleUnpin',
    value: function handleUnpin() {
      this.props.updateHeader({
        offset: this.getOffset() || 0,
        height: this.getHeight()
      });
    }
  }, {
    key: 'getOffset',
    value: function getOffset() {
      return this.props.menu ? -50 : undefined;
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this.props.menu ? 100 : 50;
    }
  }, {
    key: 'setHeadroom',
    value: function setHeadroom(element) {
      this.headroom = element;
    }
  }, {
    key: 'render',
    value: function render() {
      var pinStart = this.getHeight() - 20;
      var children = this.props.children;

      var params = {
        pinStart: pinStart,
        disableInlineStyles: true,
        onPin: this.handlePin,
        onUnpin: this.handleUnpin,
        parent: function parent() {
          return (0, _scrollParent2.default)();
        },
        style: { height: 0 }
      };

      return _react2.default.createElement(
        _reactHeadroom2.default,
        _extends({ ref: this.setHeadroom }, params),
        children
      );
    }
  }]);

  return WrapperHeadroom;
}(_react.Component);

WrapperHeadroom.propTypes = {
  updateHeader: _propTypes2.default.func,
  children: _propTypes2.default.node,
  isAuthenticated: _propTypes2.default.bool,
  menu: _propTypes2.default.node
};


var mapDispatchToProps = {
  updateHeader: _updateHeader.updateHeader
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WrapperHeadroom);

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowequal = __webpack_require__(1410);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _raf = __webpack_require__(1293);

var _raf2 = _interopRequireDefault(_raf);

var _shouldUpdate2 = __webpack_require__(1416);

var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved


var noop = function noop() {};

var Headroom = function (_Component) {
  _inherits(Headroom, _Component);

  function Headroom(props) {
    _classCallCheck(this, Headroom);

    // Class variables.
    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));

    _this.setRef = function (ref) {
      return _this.inner = ref;
    };

    _this.setHeightOffset = function () {
      _this.setState({
        height: _this.inner.offsetHeight
      });
      _this.resizeTicking = false;
    };

    _this.getScrollY = function () {
      if (_this.props.parent().pageYOffset !== void 0) {
        return _this.props.parent().pageYOffset;
      } else if (_this.props.parent().scrollTop !== void 0) {
        return _this.props.parent().scrollTop;
      } else {
        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
      }
    };

    _this.getViewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };

    _this.getDocumentHeight = function () {
      var body = document.body;
      var documentElement = document.documentElement;

      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
    };

    _this.getElementPhysicalHeight = function (elm) {
      return Math.max(elm.offsetHeight, elm.clientHeight);
    };

    _this.getElementHeight = function (elm) {
      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
    };

    _this.getScrollerPhysicalHeight = function () {
      var parent = _this.props.parent();

      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
    };

    _this.getScrollerHeight = function () {
      var parent = _this.props.parent();

      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
    };

    _this.isOutOfBound = function (currentScrollY) {
      var pastTop = currentScrollY < 0;

      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
      var scrollerHeight = _this.getScrollerHeight();

      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;

      return pastTop || pastBottom;
    };

    _this.handleScroll = function () {
      if (!_this.scrollTicking) {
        _this.scrollTicking = true;
        (0, _raf2.default)(_this.update);
      }
    };

    _this.handleResize = function () {
      if (!_this.resizeTicking) {
        _this.resizeTicking = true;
        (0, _raf2.default)(_this.setHeightOffset);
      }
    };

    _this.unpin = function () {
      _this.props.onUnpin();

      _this.setState({
        translateY: '-100%',
        className: 'headroom headroom--unpinned'
      }, function () {
        setTimeout(function () {
          _this.setState({ state: 'unpinned' });
        }, 0);
      });
    };

    _this.pin = function () {
      _this.props.onPin();

      _this.setState({
        translateY: 0,
        className: 'headroom headroom--pinned',
        state: 'pinned'
      });
    };

    _this.unfix = function () {
      _this.props.onUnfix();

      _this.setState({
        translateY: 0,
        className: 'headroom headroom--unfixed',
        state: 'unfixed'
      });
    };

    _this.update = function () {
      _this.currentScrollY = _this.getScrollY();

      if (!_this.isOutOfBound(_this.currentScrollY)) {
        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
            action = _shouldUpdate.action;

        if (action === 'pin') {
          _this.pin();
        } else if (action === 'unpin') {
          _this.unpin();
        } else if (action === 'unfix') {
          _this.unfix();
        }
      }

      _this.lastKnownScrollY = _this.currentScrollY;
      _this.scrollTicking = false;
    };

    _this.currentScrollY = 0;
    _this.lastKnownScrollY = 0;
    _this.scrollTicking = false;
    _this.resizeTicking = false;
    _this.state = {
      state: 'unfixed',
      translateY: 0,
      className: 'headroom headroom--unfixed'
    };
    return _this;
  }

  _createClass(Headroom, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setHeightOffset();
      if (!this.props.disable) {
        this.props.parent().addEventListener('scroll', this.handleScroll);

        if (this.props.calcHeightOnResize) {
          this.props.parent().addEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disable && !this.props.disable) {
        this.unfix();
        this.props.parent().removeEventListener('scroll', this.handleScroll);
        this.props.parent().removeEventListener('resize', this.handleResize);
      } else if (!nextProps.disable && this.props.disable) {
        this.props.parent().addEventListener('scroll', this.handleScroll);

        if (this.props.calcHeightOnResize) {
          this.props.parent().addEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // If children have changed, remeasure height.
      if (prevProps.children !== this.props.children) {
        this.setHeightOffset();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.parent().removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.handleScroll);
      this.props.parent().removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userClassName = _props.className,
          divProps = _objectWithoutProperties(_props, ['className']);

      delete divProps.onUnpin;
      delete divProps.onPin;
      delete divProps.onUnfix;
      delete divProps.disableInlineStyles;
      delete divProps.disable;
      delete divProps.parent;
      delete divProps.children;
      delete divProps.upTolerance;
      delete divProps.downTolerance;
      delete divProps.pinStart;
      delete divProps.calcHeightOnResize;

      var style = divProps.style,
          wrapperStyle = divProps.wrapperStyle,
          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);

      var innerStyle = {
        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        WebkitTransform: 'translateY(' + this.state.translateY + ')',
        MsTransform: 'translateY(' + this.state.translateY + ')',
        transform: 'translateY(' + this.state.translateY + ')'
      };

      var className = this.state.className;

      // Don't add css transitions until after we've done the initial
      // negative transform when transitioning from 'unfixed' to 'unpinned'.
      // If we don't do this, the header will flash into view temporarily
      // while it transitions from 0 — -100%.
      if (this.state.state !== 'unfixed') {
        innerStyle = _extends({}, innerStyle, {
          WebkitTransition: 'all .2s ease-in-out',
          MozTransition: 'all .2s ease-in-out',
          OTransition: 'all .2s ease-in-out',
          transition: 'all .2s ease-in-out'
        });
        className += ' headroom--scrolled';
      }

      if (!this.props.disableInlineStyles) {
        innerStyle = _extends({}, innerStyle, style);
      } else {
        innerStyle = style;
      }

      var wrapperStyles = _extends({}, wrapperStyle, {
        height: this.state.height ? this.state.height : null
      });

      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';

      return _react2.default.createElement(
        'div',
        { style: wrapperStyles, className: wrapperClassName },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setRef
          }, rest, {
            style: innerStyle,
            className: className
          }),
          this.props.children
        )
      );
    }
  }]);

  return Headroom;
}(_react.Component);

Headroom.propTypes = {
  className: _propTypes2.default.string,
  parent: _propTypes2.default.func,
  children: _propTypes2.default.any.isRequired,
  disableInlineStyles: _propTypes2.default.bool,
  disable: _propTypes2.default.bool,
  upTolerance: _propTypes2.default.number,
  downTolerance: _propTypes2.default.number,
  onPin: _propTypes2.default.func,
  onUnpin: _propTypes2.default.func,
  onUnfix: _propTypes2.default.func,
  wrapperStyle: _propTypes2.default.object,
  pinStart: _propTypes2.default.number,
  style: _propTypes2.default.object,
  calcHeightOnResize: _propTypes2.default.bool
};
Headroom.defaultProps = {
  parent: function parent() {
    return window;
  },
  disableInlineStyles: false,
  disable: false,
  upTolerance: 5,
  downTolerance: 0,
  onPin: noop,
  onUnpin: noop,
  onUnfix: noop,
  wrapperStyle: {},
  pinStart: 0,
  calcHeightOnResize: true
};
exports.default = Headroom;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(1411);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(1292),
    isArguments = __webpack_require__(1412),
    isArray = __webpack_require__(1413);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 1412 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1413 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1415)))

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};

  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);

  // We're disabled
  if (props.disable) {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
    // We're at the top and not fixed yet.
  } else if (currentScrollY <= props.pinStart && state.state !== 'unfixed') {
    return {
      action: 'unfix',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
    // We're unfixed and headed down. Carry on.
  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
    // We're past the header and scrolling down.
    // We transition to "unpinned" if necessary.
  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart && distanceScrolled > props.downTolerance) {
    return {
      action: 'unpin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
    // We're scrolling up, we transition to "pinned"
  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
    return {
      action: 'pin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
    // We're scrolling up, and inside the header.
    // We transition to pin regardless of upTolerance
  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
    return {
      action: 'pin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
  } else {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
  }
};

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoriesLink = __webpack_require__(1418);

var _categoriesLink2 = _interopRequireDefault(_categoriesLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoriesLink2.default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _icons = __webpack_require__(9);

var _separator = __webpack_require__(18);

var _categoriesSelectors = __webpack_require__(35);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _categoriesLink = __webpack_require__(1419);

var _categoriesLink2 = _interopRequireDefault(_categoriesLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoriesLink = function CategoriesLink(_ref) {
  var categories = _ref.categories,
      currentCategory = _ref.currentCategory,
      _onChange = _ref.onChange,
      cardBackgroundColor = _ref.cardBackgroundColor;

  var className = (0, _classnames2.default)(_categoriesLink2.default.container, 'default-forum-card-background-color', 'forum-text-color', 'categories-button');
  return _react2.default.createElement(
    'div',
    { className: className, style: { backgroundColor: cardBackgroundColor } },
    _react2.default.createElement(_separator.VerticalSeparator, null),
    _react2.default.createElement(
      'div',
      { className: _categoriesLink2.default.selectContainer },
      _react2.default.createElement(
        'span',
        null,
        currentCategory && currentCategory.label
      ),
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_icons.ArrowDownIcon, { className: 'forum-icon-fill' })
      ),
      _react2.default.createElement(
        'select',
        {
          className: _categoriesLink2.default.select,
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          defaultValue: currentCategory && currentCategory.slug
        },
        categories.map(function (category) {
          return _react2.default.createElement(
            'option',
            { key: category._id, value: category.slug },
            category.label
          );
        })
      )
    )
  );
};

CategoriesLink.propTypes = {
  categories: _propTypes2.default.array,
  currentCategory: _propTypes2.default.object,
  cardBackgroundColor: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    categories: (0, _categoriesSelectors.getCategories)(state),
    currentCategory: (0, _categoriesSelectors.getCategoryBySlug)(state, ownProps.params.categorySlug)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onChange: function onChange(slug) {
      return (0, _routerUtils.push)('/' + slug);
    }
  }, dispatch);
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withCardBackgroundColor2.default)(CategoriesLink);

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Jp01","link":"_3y--N","selectContainer":"_2Izv7","select":"_3ECkD"};

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoriesPage = __webpack_require__(1421);

var _categoriesPage2 = _interopRequireDefault(_categoriesPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoriesPage2.default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoriesPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _pageMetadata = __webpack_require__(1180);

var _pageMetadata2 = _interopRequireDefault(_pageMetadata);

var _pageDescription = __webpack_require__(1294);

var _masonryWrapper = __webpack_require__(1296);

var _masonryWrapper2 = _interopRequireDefault(_masonryWrapper);

var _categoryList = __webpack_require__(1438);

var _categoryList2 = _interopRequireDefault(_categoryList);

var _categoryListMasonry = __webpack_require__(1445);

var _categoryListMasonry2 = _interopRequireDefault(_categoryListMasonry);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _categoriesSelectors = __webpack_require__(35);

var _forumDataSelectors = __webpack_require__(457);

var _appSettingsSelectors = __webpack_require__(222);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _pageOpened = __webpack_require__(410);

var _detectRoute = __webpack_require__(266);

var _routerUtils = __webpack_require__(55);

var _redux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import CreateCategoryCard from '../../components/create-category-card';

// import forAdminOnly from '../../hoc/for-admin-only';
// import forMobileOnly from '../../hoc/for-mobile-only';


// const CreateNewCategory = forMobileOnly(forAdminOnly(() => <CreateCategoryCard to="/create-category"/>));
var List = (0, _withDeviceType2.default)(function (_ref) {
  var isMobile = _ref.isMobile,
      categories = _ref.categories;

  var Component = isMobile ? _categoryList2.default : _categoryListMasonry2.default;
  return _react2.default.createElement(
    _masonryWrapper2.default,
    { isEnabled: !isMobile },
    _react2.default.createElement(Component, { categories: categories })
  );
});

var CategoriesPage = exports.CategoriesPage = function (_Component) {
  _inherits(CategoriesPage, _Component);

  function CategoriesPage() {
    _classCallCheck(this, CategoriesPage);

    return _possibleConstructorReturn(this, (CategoriesPage.__proto__ || Object.getPrototypeOf(CategoriesPage)).apply(this, arguments));
  }

  _createClass(CategoriesPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          categories = _props.categories,
          redirectToCategory = _props.redirectToCategory;

      if (categories.length === 1) {
        redirectToCategory(categories[0].slug);
      } else {
        this.props.pageOpened({ page: _detectRoute.CATEGORIES_PAGE });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          forumData = _props2.forumData,
          categories = _props2.categories,
          isHeaderEnabled = _props2.isHeaderEnabled;

      return _react2.default.createElement(
        _page2.default,
        null,
        _react2.default.createElement(_pageMetadata2.default, { description: forumData.description, image: forumData.cover }),
        _react2.default.createElement(_pageDescription.PageDescriptionDesktop, {
          title: forumData.label,
          description: forumData.description,
          cover: forumData.cover,
          coverType: forumData.coverType,
          overlayColor: forumData.overlayColor,
          backgroundColor: forumData.backgroundColor,
          textColor: forumData.textColor,
          isCoverVisible: isHeaderEnabled
        }),
        _react2.default.createElement(List, { categories: categories }),
        _react2.default.createElement(_appLoaded2.default, { parent: this, selector: '[data-hook=category-list-item]' })
      );
    }
  }]);

  return CategoriesPage;
}(_react.Component);

CategoriesPage.propTypes = {
  forumData: _propTypes2.default.object.isRequired,
  categories: _propTypes2.default.array,
  redirectToCategory: _propTypes2.default.func,
  pageOpened: _propTypes2.default.func,
  isHeaderEnabled: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    categories: (0, _categoriesSelectors.getCategories)(state),
    forumData: (0, _forumDataSelectors.getForumData)(state),
    isHeaderEnabled: (0, _appSettingsSelectors.getIsHeaderEnabled)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    pageOpened: _pageOpened.pageOpened,
    redirectToCategory: function redirectToCategory(categorySlug) {
      return (0, _routerUtils.replace)('/' + categorySlug);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CategoriesPage);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageMetadata = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactHelmet = __webpack_require__(1423);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _getImageUrl = __webpack_require__(183);

var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

var _viewMode = __webpack_require__(423);

var _forumDataSelectors = __webpack_require__(457);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_DESCRIPTION_LENGTH = 160;

var getMetaCategories = function getMetaCategories(_ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      type = _ref.type,
      noIndex = _ref.noIndex;

  var metaCategories = [{
    property: 'og:title',
    content: title
  }, {
    name: 'description',
    content: description
  }, {
    property: 'og:description',
    content: description.slice(0, MAX_DESCRIPTION_LENGTH)
  }, {
    property: 'og:type',
    content: type
  }];

  if (image) {
    metaCategories.push({
      property: 'og:image',
      content: (0, _getImageUrl2.default)(image)
    });
    metaCategories.push({
      property: 'og:image:width',
      content: image.width
    });
    metaCategories.push({
      property: 'og:image:height',
      content: image.height
    });
  }

  if (noIndex) {
    metaCategories.push({
      name: 'robots',
      content: 'noindex'
    });
  }

  return metaCategories;
};

var PageMetadata = exports.PageMetadata = function PageMetadata(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      image = _ref2.image,
      type = _ref2.type,
      noIndex = _ref2.noIndex;
  return _react2.default.createElement(_reactHelmet2.default, {
    title: title,
    meta: getMetaCategories({ title: title, description: description, image: image, type: type, noIndex: noIndex }),
    onChangeClientState: function onChangeClientState() {
      try {
        if ((0, _viewMode.isInSite)()) {
          _wixSdkPolyfill2.default.setPageMetadata({ title: title, description: description });
        }
      } catch (e) {
        console.error(e);
      }
    }
  });
};

PageMetadata.propTypes = {
  title: _propTypes2.default.string,
  type: _propTypes2.default.string,
  description: _propTypes2.default.string,
  image: _propTypes2.default.object,
  noIndex: _propTypes2.default.bool
};

PageMetadata.defaultProps = {
  title: '',
  description: '',
  type: 'website'
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var forumTitle = (0, _forumDataSelectors.getForumTitle)(state);
  return {
    title: ownProps.title ? ownProps.title + ' | ' + forumTitle : forumTitle
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PageMetadata);

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__(1424);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(187);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__(519);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(1427);

var _PlainComponent = __webpack_require__(1428);

var _PlainComponent2 = _interopRequireDefault(_PlainComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HELMET_ATTRIBUTE = "data-react-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, _deepEqual2.default)(this.props, nextProps);
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }], [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
            /**
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {String} title: "Title"
             * @param {String} defaultTitle: "Default Title"
             * @param {String} titleTemplate: "MySite.com - %s"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             */

        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        htmlAttributes: _react2.default.PropTypes.object,
        title: _react2.default.PropTypes.string,
        defaultTitle: _react2.default.PropTypes.string,
        titleTemplate: _react2.default.PropTypes.string,
        titleAttributes: _react2.default.PropTypes.object,
        base: _react2.default.PropTypes.object,
        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        onChangeClientState: _react2.default.PropTypes.func
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;


    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(_PlainComponent2.default);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1425);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(1426);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlainComponent = function (_React$Component) {
    _inherits(PlainComponent, _React$Component);

    function PlainComponent() {
        _classCallCheck(this, PlainComponent);

        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
    }

    _createClass(PlainComponent, [{
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return PlainComponent;
}(_react2.default.Component);

exports.default = PlainComponent;
module.exports = exports["default"];

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageDescriptionDesktop = exports.PageDescription = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _pageCover = __webpack_require__(1238);

var _pageCover2 = _interopRequireDefault(_pageCover);

var _textAlignment = __webpack_require__(958);

var _forDesktopOnly = __webpack_require__(1435);

var _forDesktopOnly2 = _interopRequireDefault(_forDesktopOnly);

var _withCategoryTextAlignment = __webpack_require__(1295);

var _withCategoryTextAlignment2 = _interopRequireDefault(_withCategoryTextAlignment);

var _pageDescription = __webpack_require__(1436);

var _pageDescription2 = _interopRequireDefault(_pageDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_HEIGHT = 200;

var getContainerStyle = function getContainerStyle() {
  var textColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isCoverVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var style = { color: textColor.color };
  if (!isCoverVisible) {
    style.display = 'none';
  }
  return style;
};

var PageDescription = exports.PageDescription = function PageDescription(props) {
  var title = props.title,
      description = props.description,
      cover = props.cover,
      coverType = props.coverType,
      overlayColor = props.overlayColor,
      backgroundColor = props.backgroundColor,
      _props$textColor = props.textColor,
      textColor = _props$textColor === undefined ? {} : _props$textColor,
      categoryTextAlignment = props.categoryTextAlignment,
      children = props.children,
      isCoverVisible = props.isCoverVisible;


  var textAlignmentClassName = _pageDescription2.default[_textAlignment.TEXT_ALIGNMENT_CLASS_NAMES[categoryTextAlignment]];
  var containerClassName = (0, _classnames2.default)(_pageDescription2.default.container, 'default-desktop-header-text-color', 'page-description', _defineProperty({}, textAlignmentClassName, textAlignmentClassName));

  var NoCover = function NoCover(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  };

  var CoverComponent = isCoverVisible ? _pageCover2.default : NoCover;

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: getContainerStyle(textColor, isCoverVisible) },
    _react2.default.createElement(
      CoverComponent,
      {
        cover: cover,
        coverType: coverType,
        overlayColor: overlayColor,
        backgroundColor: backgroundColor,
        height: DEFAULT_HEIGHT,
        hasActiveState: false
      },
      _react2.default.createElement(
        'div',
        { className: _pageDescription2.default.wrapper },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_pageDescription2.default.titleWrapper, 'page-description-title-font', 'page-description__title'),
            'data-hook': 'page-description__title'
          },
          _react2.default.createElement(
            'h1',
            { className: _pageDescription2.default.title },
            title
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_pageDescription2.default.descriptionWrapper, 'page-description-font'),
            'data-hook': 'page-description__description'
          },
          _react2.default.createElement(
            'p',
            { className: _pageDescription2.default.description },
            description
          )
        ),
        children
      )
    )
  );
};

PageDescription.propTypes = {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  cover: _propTypes2.default.object,
  coverType: _propTypes2.default.string,
  overlayColor: _propTypes2.default.object,
  backgroundColor: _propTypes2.default.object,
  textColor: _propTypes2.default.object,
  categoryTextAlignment: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node,
  isCoverVisible: _propTypes2.default.bool.isRequired
};

PageDescription.defaultProps = {
  isCoverVisible: true
};

exports.default = (0, _withCategoryTextAlignment2.default)(PageDescription);
var PageDescriptionDesktop = exports.PageDescriptionDesktop = (0, _forDesktopOnly2.default)((0, _withCategoryTextAlignment2.default)(PageDescription));

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _coverTypes = __webpack_require__(1087);

var _cover = __webpack_require__(1431);

var _cover2 = _interopRequireDefault(_cover);

var _pageCover = __webpack_require__(1434);

var _pageCover2 = _interopRequireDefault(_pageCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOverlayStyle = function getOverlayStyle(coverType) {
  var backgroundColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var overlayColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  switch (coverType) {
    case _coverTypes.COVER_TYPE_COLOR:
      return {
        backgroundColor: backgroundColor.color,
        opacity: backgroundColor.opacity
      };

    case _coverTypes.COVER_TYPE_IMAGE:
      return {
        backgroundColor: overlayColor.color,
        opacity: overlayColor.opacity
      };

    default:
      return {};
  }
};

var PageCover = function PageCover(_ref) {
  var coverType = _ref.coverType,
      cover = _ref.cover,
      overlayColor = _ref.overlayColor,
      backgroundColor = _ref.backgroundColor,
      width = _ref.width,
      height = _ref.height,
      children = _ref.children,
      hasActiveState = _ref.hasActiveState;
  return _react2.default.createElement(
    _cover2.default,
    {
      cover: cover,
      showCover: coverType === _coverTypes.COVER_TYPE_IMAGE,
      width: width,
      height: height,
      hasActiveState: hasActiveState
    },
    _react2.default.createElement('div', {
      className: _pageCover2.default.overlay,
      style: getOverlayStyle(coverType, backgroundColor, overlayColor),
      'data-hook': 'page-cover'
    }),
    _react2.default.createElement(
      'div',
      { className: _pageCover2.default.content },
      children
    )
  );
};

PageCover.propTypes = {
  coverType: _propTypes2.default.string,
  cover: _propTypes2.default.object,
  overlayColor: _propTypes2.default.object,
  backgroundColor: _propTypes2.default.object,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node,
  hasActiveState: _propTypes2.default.bool
};

exports.default = PageCover;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _cover = __webpack_require__(1432);

var _cover2 = _interopRequireDefault(_cover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _cover2.default;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _getImageUrl = __webpack_require__(183);

var _resolveUserImage = __webpack_require__(249);

var _resolveUserImage2 = _interopRequireDefault(_resolveUserImage);

var _wixSdkUtils = __webpack_require__(21);

var _cover = __webpack_require__(1433);

var _cover2 = _interopRequireDefault(_cover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getWindowWidth = function getWindowWidth() {
  return typeof window !== 'undefined' && window.innerWidth;
};

var getStyle = function getStyle(cover, showCover, width, height) {
  return {
    backgroundImage: showCover && cover ? 'url(' + (0, _resolveUserImage2.default)(cover, _getImageUrl.RESIZE_COVER, width, height) + ')' : ''
  };
};

var Cover = function (_Component) {
  _inherits(Cover, _Component);

  function Cover(props) {
    _classCallCheck(this, Cover);

    var _this = _possibleConstructorReturn(this, (Cover.__proto__ || Object.getPrototypeOf(Cover)).call(this, props));

    _this.setCover = function (node) {
      _this.cover = node;
    };

    _this.state = {
      width: props.width || getWindowWidth() || (0, _wixSdkUtils.getWidth)(),
      height: props.height
    };
    return _this;
  }

  _createClass(Cover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        width: this.cover.clientWidth,
        height: this.cover.clientHeight
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          width = _state.width,
          height = _state.height;
      var _props = this.props,
          className = _props.className,
          cover = _props.cover,
          showCover = _props.showCover,
          children = _props.children,
          hasActiveState = _props.hasActiveState;

      var containerClassName = (0, _classnames2.default)(_cover2.default.cover, className, _defineProperty({}, _cover2.default.hasActiveState, hasActiveState));
      var style = getStyle(cover, showCover, width, height);

      return _react2.default.createElement(
        'div',
        { ref: this.setCover, className: containerClassName, style: style, role: 'img' },
        children
      );
    }
  }]);

  return Cover;
}(_react.Component);

Cover.propTypes = {
  className: _propTypes2.default.string,
  cover: _propTypes2.default.object,
  showCover: _propTypes2.default.bool,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node,
  hasActiveState: _propTypes2.default.bool
};

Cover.defaultProps = {
  showCover: true,
  hasActiveState: true
};

exports.default = Cover;

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cover":"_1HFtm","hasActiveState":"LOmoW"};

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cover":"_1hnpb","overlay":"_2h1FT","content":"_1CXwb"};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var forDesktopOnly = function forDesktopOnly(Component) {
  return (0, _withDeviceType2.default)(function (_ref) {
    var isMobile = _ref.isMobile,
        props = _objectWithoutProperties(_ref, ['isMobile']);

    return !isMobile ? _react2.default.createElement(Component, props) : null;
  });
};

exports.default = forDesktopOnly;

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"PQ--k","left":"_3UGsV","wrapper":"a_zC1","titleWrapper":"_3FpAV","title":"_3EBa0","descriptionWrapper":"Cvyi1","description":"CrPBO"};

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _locationHistorySelectors = __webpack_require__(162);

var _wixSdkUtils = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isServer = typeof window === 'undefined';

var MasonryWrapper = function (_Component) {
  _inherits(MasonryWrapper, _Component);

  function MasonryWrapper(props) {
    _classCallCheck(this, MasonryWrapper);

    var _this = _possibleConstructorReturn(this, (MasonryWrapper.__proto__ || Object.getPrototypeOf(MasonryWrapper)).call(this, props));

    _this.state = {
      isContentVisible: !props.isEnabled || !isServer && props.historyEntryCount > 1 || (0, _wixSdkUtils.isSeoViewMode)()
    };
    return _this;
  }

  _createClass(MasonryWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ isContentVisible: true });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _animatedLoader2.default,
        { shouldShowLoader: false, isLoading: !this.state.isContentVisible },
        this.props.children
      );
    }
  }]);

  return MasonryWrapper;
}(_react.Component);

MasonryWrapper.propTypes = {
  historyEntryCount: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node,
  isEnabled: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    historyEntryCount: (0, _locationHistorySelectors.getCount)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MasonryWrapper);

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryList = __webpack_require__(1439);

var _categoryList2 = _interopRequireDefault(_categoryList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryList2.default;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _categoryListItem = __webpack_require__(1440);

var _categoryListItem2 = _interopRequireDefault(_categoryListItem);

var _categoryList = __webpack_require__(1444);

var _categoryList2 = _interopRequireDefault(_categoryList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMaxColumnsClass = function getMaxColumnsClass(listLength) {
  switch (listLength) {
    case 1:
      return _categoryList2.default.maxColumns1;
    case 2:
      return _categoryList2.default.maxColumns2;
    case 3:
      return _categoryList2.default.maxColumns3;
    case 4:
      return _categoryList2.default.maxColumns4;
    default:
      return _categoryList2.default.maxColumns5;
  }
};

var CategoryList = function CategoryList(_ref) {
  var _ref$categories = _ref.categories,
      categories = _ref$categories === undefined ? [] : _ref$categories;

  //this line is good for debugging different number of items
  // categories = categories.concat(categories).concat(categories).slice(0, 2);
  return _react2.default.createElement(
    'div',
    { className: _categoryList2.default.container },
    _react2.default.createElement(
      'ul',
      { className: (0, _classnames2.default)(_categoryList2.default.list, 'category-list__list') },
      categories.map(function (category, index) {
        return _react2.default.createElement(
          'li',
          {
            className: (0, _classnames2.default)(_categoryList2.default.listItem, getMaxColumnsClass(categories.length), 'category-list__list-item'),
            key: index
          },
          _react2.default.createElement(_categoryListItem2.default, { category: category })
        );
      })
    )
  );
};

CategoryList.propTypes = {
  categories: _propTypes2.default.array
};

exports.default = CategoryList;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryListItem = __webpack_require__(1441);

var _categoryListItem2 = _interopRequireDefault(_categoryListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryListItem2.default;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _categoryActions = __webpack_require__(1239);

var _categoryActions2 = _interopRequireDefault(_categoryActions);

var _pageCover = __webpack_require__(1238);

var _pageCover2 = _interopRequireDefault(_pageCover);

var _icons = __webpack_require__(9);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _categoryListItem = __webpack_require__(1443);

var _categoryListItem2 = _interopRequireDefault(_categoryListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COVER_WIDTH = 296;
var COVER_HEIGHT = 220;

var CategoryListItem = function (_Component) {
  _inherits(CategoryListItem, _Component);

  function CategoryListItem() {
    _classCallCheck(this, CategoryListItem);

    return _possibleConstructorReturn(this, (CategoryListItem.__proto__ || Object.getPrototypeOf(CategoryListItem)).apply(this, arguments));
  }

  _createClass(CategoryListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$category = _props.category,
          category = _props$category === undefined ? {} : _props$category,
          t = _props.t,
          titleFontClassName = _props.titleFontClassName,
          contentFontClassName = _props.contentFontClassName,
          borderWidth = _props.borderWidth,
          isAuthenticated = _props.isAuthenticated;

      var containerClassName = (0, _classnames2.default)(_categoryListItem2.default.container, 'forum-card-border-color', 'category-list-item');
      var textColor = _lodash2.default.get(category, 'textColor.color', '#000000');
      var titleClassName = (0, _classnames2.default)(_categoryListItem2.default.titleContainer, titleFontClassName, 'category-list-item__title');
      var style = { borderWidth: borderWidth, color: textColor };
      var categoryLink = '/' + category.slug;
      var moreButton = void 0;

      if (isAuthenticated) {
        var icon = _react2.default.createElement(_icons.MoreIcon, { fill: textColor });
        moreButton = _react2.default.createElement(
          'div',
          { className: _categoryListItem2.default.moreButton },
          _react2.default.createElement(
            _moreButton2.default,
            { icon: icon },
            _react2.default.createElement(_categoryActions2.default, { category: category })
          )
        );
      }

      var linkClassName = (0, _classnames2.default)(_categoryListItem2.default.overlay, contentFontClassName, 'category-list-item__link');

      return _react2.default.createElement(
        'div',
        { className: containerClassName, style: style, 'data-hook': 'category-list-item' },
        _react2.default.createElement(
          _pageCover2.default,
          {
            cover: category.cover,
            coverType: category.coverType,
            overlayColor: category.overlayColor,
            backgroundColor: category.backgroundColor,
            width: COVER_WIDTH,
            height: COVER_HEIGHT
          },
          _react2.default.createElement(
            _internalLink2.default,
            {
              className: linkClassName,
              to: categoryLink,
              renderInSeo: false
            },
            _react2.default.createElement(
              'div',
              { className: titleClassName },
              _react2.default.createElement(
                'h2',
                { className: _categoryListItem2.default.title },
                _react2.default.createElement(
                  'object',
                  { type: 'communities/link' },
                  _react2.default.createElement(
                    _internalLink2.default,
                    { to: categoryLink, style: { color: 'inherit' } },
                    category.label
                  )
                )
              )
            ),
            _react2.default.createElement(
              'p',
              { className: (0, _classnames2.default)(_categoryListItem2.default.statistics, 'category-list-item__statistics') },
              t('category-list-item.total-views', { count: category.totalViews || 0 }),
              ' | ',
              t('category-list-item.total-posts', { count: category.totalPosts || 0 })
            ),
            _react2.default.createElement(
              'p',
              { className: _categoryListItem2.default.description },
              category.description
            )
          ),
          moreButton
        )
      );
    }
  }]);

  return CategoryListItem;
}(_react.Component);

CategoryListItem.propTypes = {
  category: _propTypes2.default.object,
  t: _propTypes2.default.func,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  isAuthenticated: _propTypes2.default.bool.isRequired
};

exports.default = (0, _withFontClassName2.default)((0, _withCardBorderWidth2.default)((0, _withTranslate2.default)((0, _withAuth2.default)(CategoryListItem))));

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryActions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _icons = __webpack_require__(9);

var _actionButton = __webpack_require__(250);

var _actionButton2 = _interopRequireDefault(_actionButton);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryActions = exports.CategoryActions = function (_Component) {
  _inherits(CategoryActions, _Component);

  function CategoryActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryActions.__proto__ || Object.getPrototypeOf(CategoryActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubscribe = function () {
      var _this$props = _this.props,
          _id = _this$props.category._id,
          subscribe = _this$props.subscribe,
          showMessage = _this$props.showMessage;

      return subscribe({ _id: _id, type: 'category' }).then(function () {
        return showMessage(_messages2.default[_messages.CATEGORY_SUBSCRIBED].content(), _messages2.default[_messages.CATEGORY_SUBSCRIBED].type);
      });
    }, _this.handleUnsubscribe = function () {
      var _this$props2 = _this.props,
          _id = _this$props2.category._id,
          unsubscribe = _this$props2.unsubscribe,
          showMessage = _this$props2.showMessage;

      return unsubscribe({ _id: _id, type: 'category' }).then(function () {
        return showMessage(_messages2.default[_messages.CATEGORY_UNSUBSCRIBED].content(), _messages2.default[_messages.CATEGORY_UNSUBSCRIBED].type);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryActions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canRender = _props.canRender,
          category = _props.category,
          t = _props.t,
          forPublicUser = _props.forPublicUser;

      var followButton = canRender('subscribe', 'category', category, function (can) {
        var action = category.isSubscribed ? _this2.handleUnsubscribe : _this2.handleSubscribe;
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'category-actions__subscriptions',
            onClick: can ? action : forPublicUser(action)
          },
          _react2.default.createElement(_icons.SubscribeIcon, { className: 'forum-icon-fill' }),
          t(category.isSubscribed ? 'category-actions.unsubscribe-category' : 'category-actions.subscribe-category')
        );
      });

      return _react2.default.createElement(
        'div',
        null,
        followButton
      );
    }
  }]);

  return CategoryActions;
}(_react.Component);

CategoryActions.propTypes = {
  category: _propTypes2.default.object.isRequired,
  openModal: _propTypes2.default.func.isRequired,
  showMessage: _propTypes2.default.func.isRequired,
  subscribe: _propTypes2.default.func.isRequired,
  unsubscribe: _propTypes2.default.func.isRequired,
  canRender: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  forPublicUser: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = {
  subscribe: _subscribe.subscribe,
  unsubscribe: _unsubscribe.unsubscribe
};

// prettier-ignore
exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }), _withPermissions2.default, _withTranslate2.default, _withAuth2.default)(CategoryActions);

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kFO0","moreButton":"_3LwV1","overlay":"_2JDpA","titleContainer":"_2rtGi","title":"_4jCg7","description":"_2Z4Hj","statistics":"_2-oj5"};

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2sxaN","list":"_1N4gw","listItem":"_3eDns"};

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryListMasonry = __webpack_require__(1446);

var _categoryListMasonry2 = _interopRequireDefault(_categoryListMasonry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryListMasonry2.default;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMasonryComponent = __webpack_require__(1297);

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _categoryListItemMasonry = __webpack_require__(1469);

var _categoryListItemMasonry2 = _interopRequireDefault(_categoryListItemMasonry);

var _categoryListMasonry = __webpack_require__(1472);

var _categoryListMasonry2 = _interopRequireDefault(_categoryListMasonry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MASONRY_OPTIONS = {
  transitionDuration: 0,
  fitWidth: true,
  gutter: 30
};

var CategoryListMasonry = function CategoryListMasonry(_ref) {
  var className = _ref.className,
      categories = _ref.categories;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_categoryListMasonry2.default.container, className) },
    _react2.default.createElement(
      _reactMasonryComponent2.default,
      { className: _categoryListMasonry2.default.masonry, options: MASONRY_OPTIONS },
      categories.map(function (category) {
        return _react2.default.createElement(
          'div',
          { key: category._id, className: _categoryListMasonry2.default.listItem },
          _react2.default.createElement(_categoryListItemMasonry2.default, { category: category })
        );
      })
    )
  );
};

CategoryListMasonry.propTypes = {
  className: _propTypes2.default.string,
  categories: _propTypes2.default.array.isRequired
};

exports.default = CategoryListMasonry;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Masonry v4.2.1
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(1448),
        __webpack_require__(1241)
      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {

'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  var proto = Masonry.prototype;

  proto._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
    this.horizontalColIndex = 0;
  };

  proto.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  proto.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  proto._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ?
      '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[ colPosMethod ]( colSpan, item );
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for ( var i = colPosition.col; i < setMax; i++ ) {
      this.colYs[i] = setHeight;
    }

    return position;
  };

  proto._getTopColPosition = function( colSpan ) {
    var colGroup = this._getTopColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );

    return {
      col: colGroup.indexOf( minimumY ),
      y: minimumY,
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      colGroup[i] = this._getColGroupY( i, colSpan );
    }
    return colGroup;
  };

  proto._getColGroupY = function( col, colSpan ) {
    if ( colSpan < 2 ) {
      return this.colYs[ col ];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice( col, col + colSpan );
    // and get the max value of the array
    return Math.max.apply( Math, groupColYs );
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function( colSpan, item ) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

    return {
      col: col,
      y: this._getColGroupY( col, colSpan ),
    };
  };

  proto._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  proto._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  proto._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  proto.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(1240),
        __webpack_require__(1241),
        __webpack_require__(1449),
        __webpack_require__(1451)
      ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  this.updateStagger();
  queue.forEach( function( obj, i ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
  }, this );
};

// set stagger from option in milliseconds number
proto.updateStagger = function() {
  var stagger = this.options.stagger;
  if ( stagger === null || stagger === undefined ) {
    this.stagger = 0;
    return;
  }
  this.stagger = getMilliseconds( stagger );
  return this.stagger;
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant, i ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.stagger( i * this.stagger );
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- helpers ----- //

// how many milliseconds are in each unit
var msUnits = {
  ms: 1,
  s: 1000
};

// munge time-like parameter into millisecond number
// '0.4s' -> 40
function getMilliseconds( time ) {
  if ( typeof time == 'number' ) {
    return time;
  }
  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
  var num = matches && matches[1];
  var unit = matches && matches[2];
  if ( !num.length ) {
    return 0;
  }
  num = parseFloat( num );
  var mult = msUnits[ unit ] || 1;
  return num * mult;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.5
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(1450)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( matchesSelector ) {
      return factory( window, matchesSelector );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( obj && typeof obj == 'object' &&
    typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    if ( timeout ) {
      clearTimeout( timeout );
    }
    var args = arguments;

    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold || 100 );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(1240),
        __webpack_require__(1241)
      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties that could have vendor prefix
var vendorProperties = {
  transform: transformProperty,
  transition: transitionProperty,
  transitionDuration: transitionProperty + 'Duration',
  transitionProperty: transitionProperty + 'Property',
  transitionDelay: transitionProperty + 'Delay'
};

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  var x = parseFloat( xValue );
  var y = parseFloat( yValue );
  // convert percent to pixels
  var layoutSize = this.layout.size;
  if ( xValue.indexOf('%') != -1 ) {
    x = ( x / 100 ) * layoutSize.width;
  }
  if ( yValue.indexOf('%') != -1 ) {
    y = ( y / 100 ) * layoutSize.height;
  }
  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var didNotMove = x == this.position.x && y == this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseFloat( x );
  this.position.y = parseFloat( y );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto.transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' + toDashedAll( transformProperty );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // munge number to millisecond, to match stagger
  var duration = this.layout.options.transitionDuration;
  duration = typeof duration == 'number' ? duration + 'ms' : duration;
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: duration,
    transitionDelay: this.staggerDelay || 0
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: '',
  transitionDelay: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- stagger ----- //

proto.stagger = function( delay ) {
  delay = isNaN( delay ) ? 0 : delay;
  this.staggerDelay = delay + 'ms';
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(1240)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
      return factory( window, EvEmitter );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
function makeArray( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  var queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = extend( {}, this.options );
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__(1298).forEach;
var elementUtilsMaker       = __webpack_require__(1455);
var listenerHandlerMaker    = __webpack_require__(1456);
var idGeneratorMaker        = __webpack_require__(1457);
var idHandlerMaker          = __webpack_require__(1458);
var reporterMaker           = __webpack_require__(1459);
var browserDetector         = __webpack_require__(1299);
var batchProcessorMaker     = __webpack_require__(1460);
var stateHandler            = __webpack_require__(1462);

//Detection strategies.
var objectStrategyMaker     = __webpack_require__(1463);
var scrollStrategyMaker     = __webpack_require__(1464);

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1461);

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__(1299);

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        if(!getObject(element)) {
            throw new Error("Element is not detectable by this strategy.");
        }

        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.position = "relative";

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style[property] = 0;
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            setTimeout(function checkForObjectDocument() {
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if(browserDetector.isIE(8)) {
            element.detachEvent("onresize", getState(element).object.proxy);
        } else {
            element.removeChild(getObject(element));
        }
        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__(1298).forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    injectScrollStyle(styleId, detectionContainerClass);

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";

        var container = document.createElement("div");
        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                document.head.appendChild(element);
            };

            var styleElement = document.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!document.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.position = "relative";

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.width     = expandWidth + "px";
                expandChild.style.height    = expandHeight + "px";
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify the if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                var width = element.offsetWidth;
                var height = element.offsetHeight;

                if (width !== getState(element).lastWidth || height !== getState(element).lastHeight) {
                    debug("Element size changed.");
                    updateDetectorElements(notifyListenersIfNeeded);
                } else {
                    debug("Element size has not changed (" + width + "x" + height + ").");
                }
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable string keyed properties of `object` that are
 * not omitted.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = baseRest(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap(baseFlatten(props, 1), toKey);
  return basePick(object, baseDifference(getAllKeysIn(object), props));
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = omit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(519);

var emptyObject = __webpack_require__(1467);
var _invariant = __webpack_require__(1468);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryListItemMasonry = __webpack_require__(1470);

var _categoryListItemMasonry2 = _interopRequireDefault(_categoryListItemMasonry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryListItemMasonry2.default;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _coverTypes = __webpack_require__(1087);

var _pageCover = __webpack_require__(1238);

var _pageCover2 = _interopRequireDefault(_pageCover);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _textAlignment = __webpack_require__(958);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _categoryActions = __webpack_require__(1239);

var _categoryActions2 = _interopRequireDefault(_categoryActions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withCategoryTextAlignment = __webpack_require__(1295);

var _withCategoryTextAlignment2 = _interopRequireDefault(_withCategoryTextAlignment);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _categoryListItemMasonry = __webpack_require__(1471);

var _categoryListItemMasonry2 = _interopRequireDefault(_categoryListItemMasonry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var COVER_WIDTH = 455;
var COVER_HEIGHT = 265;

var CategoryListItemMasonry = function CategoryListItemMasonry(props) {
  var _classNames;

  var category = props.category,
      t = props.t,
      borderWidth = props.borderWidth,
      titleFontClassName = props.titleFontClassName,
      contentFontClassName = props.contentFontClassName,
      categoryTextAlignment = props.categoryTextAlignment,
      isAuthenticated = props.isAuthenticated;

  var textAlignmentClassName = _categoryListItemMasonry2.default[_textAlignment.TEXT_ALIGNMENT_CLASS_NAMES[categoryTextAlignment]];
  var hasCover = category.coverType === _coverTypes.COVER_TYPE_IMAGE;
  var className = (0, _classnames2.default)(_categoryListItemMasonry2.default.container, 'forum-card-background-color', 'forum-card-border-color', 'category-list-item', (_classNames = {}, _defineProperty(_classNames, _categoryListItemMasonry2.default.hasCover, hasCover), _defineProperty(_classNames, textAlignmentClassName, textAlignmentClassName), _classNames));
  var categoryLink = '/' + category.slug;
  var categoryActions = void 0;

  if (isAuthenticated) {
    categoryActions = _react2.default.createElement(
      'div',
      { className: _categoryListItemMasonry2.default.actions },
      _react2.default.createElement(
        _moreButton2.default,
        null,
        _react2.default.createElement(_categoryActions2.default, { category: category })
      )
    );
  }
  return _react2.default.createElement(
    'div',
    { className: className, style: { borderWidth: borderWidth }, 'data-hook': 'category-list-item' },
    _react2.default.createElement(
      _internalLink2.default,
      {
        className: (0, _classnames2.default)(_categoryListItemMasonry2.default.link, 'forum-text-color'),
        to: categoryLink,
        renderInSeo: false,
        'data-hook': 'category-list-item__link'
      },
      _react2.default.createElement(
        'div',
        { className: _categoryListItemMasonry2.default.cover },
        _react2.default.createElement(_pageCover2.default, {
          cover: category.cover,
          coverType: category.coverType,
          backgroundColor: category.backgroundColor,
          width: COVER_WIDTH,
          height: COVER_HEIGHT
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _categoryListItemMasonry2.default.contentWrapper },
        categoryActions,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_categoryListItemMasonry2.default.content, contentFontClassName) },
          _react2.default.createElement(
            'div',
            { className: titleFontClassName },
            _react2.default.createElement(
              'h2',
              { name: category.label, className: _categoryListItemMasonry2.default.title, 'data-hook': 'category-list-item__title' },
              _react2.default.createElement(
                'object',
                { type: 'communities/link' },
                _react2.default.createElement(
                  _internalLink2.default,
                  { to: categoryLink, style: { color: 'inherit' } },
                  category.label
                )
              )
            )
          ),
          _react2.default.createElement(
            'p',
            { className: _categoryListItemMasonry2.default.statistics, 'data-hook': 'category-list-item__statistics' },
            t('category-list-item.total-views', { count: category.totalViews || 0 }),
            ' | ',
            t('category-list-item.total-posts', { count: category.totalPosts || 0 })
          ),
          _react2.default.createElement(
            'p',
            { className: _categoryListItemMasonry2.default.description, 'data-hook': 'category-list-item__description' },
            category.description
          ),
          _react2.default.createElement(
            'p',
            { className: _categoryListItemMasonry2.default.button },
            _react2.default.createElement(
              _button2.default,
              { 'data-hook': 'category-list-item__view-category' },
              t('category-list-item.view-category')
            )
          )
        )
      )
    )
  );
};

CategoryListItemMasonry.propTypes = {
  category: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func.isRequired,
  borderWidth: _propTypes2.default.number,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  categoryTextAlignment: _propTypes2.default.number.isRequired,
  isAuthenticated: _propTypes2.default.bool.isRequired
};

exports.default = (0, _lodash.flowRight)(_withAuth2.default, _withCardBorderWidth2.default, _withCategoryTextAlignment2.default, _withFontClassName2.default, _withTranslate2.default)(CategoryListItemMasonry);

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_12jHn","center":"_2Xy4L","left":"_29KW1","hasCover":"hv6Wy","cover":"_2ttRg","contentWrapper":"_2SN6b","content":"_1oZiG","title":"_1Bn1k","statistics":"g946p","description":"y-5Kl","button":"_29-hJ","actions":"_2Geh5"};

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3pJd6","masonry":"_3E4iN","listItem":"_38E54"};

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoriesPageHeader = __webpack_require__(1474);

var _categoriesPageHeader2 = _interopRequireDefault(_categoriesPageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoriesPageHeader2.default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _header2.default;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _headerButtons = __webpack_require__(1476);

var _headerButtons2 = _interopRequireDefault(_headerButtons);

var _pageMenuButton = __webpack_require__(1492);

var _pageMenuButton2 = _interopRequireDefault(_pageMenuButton);

var _headerTitle = __webpack_require__(1302);

var _headerTitle2 = _interopRequireDefault(_headerTitle);

var _withButtonColor = __webpack_require__(1303);

var _withButtonColor2 = _interopRequireDefault(_withButtonColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _header = __webpack_require__(1501);

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = exports.Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          left = _props.left,
          right = _props.right,
          menu = _props.menu,
          contentFontClassName = _props.contentFontClassName,
          buttonColor = _props.buttonColor;

      var containerClassName = (0, _classnames2.default)(_header2.default.headerContainer, 'button-primary-text-color', contentFontClassName);
      var wrapperClassName = (0, _classnames2.default)(_header2.default.header, 'default-button-background-color');

      return _react2.default.createElement(
        'div',
        { className: containerClassName },
        _react2.default.createElement(
          'div',
          { className: wrapperClassName, style: { backgroundColor: buttonColor } },
          left,
          right
        ),
        menu || null
      );
    }
  }]);

  return Header;
}(_react.Component);

Header.propTypes = {
  contentFontClassName: _propTypes2.default.string.isRequired,
  buttonColor: _propTypes2.default.string.isRequired,
  left: _propTypes2.default.node,
  right: _propTypes2.default.node,
  menu: _propTypes2.default.node
};

Header.defaultProps = {
  right: _react2.default.createElement(_headerButtons2.default, null),
  left: _react2.default.createElement(
    'div',
    { className: _header2.default.left },
    _react2.default.createElement(
      'span',
      { className: _header2.default.menuButton },
      _react2.default.createElement(_pageMenuButton2.default, null)
    ),
    _react2.default.createElement(_headerTitle2.default, null)
  )
};

exports.default = (0, _withButtonColor2.default)((0, _withFontClassName2.default)(Header));

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _headerButtons = __webpack_require__(1477);

var _headerButtons2 = _interopRequireDefault(_headerButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _headerButtons2.default;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderButtons = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _notificationButton = __webpack_require__(1242);

var _notificationButton2 = _interopRequireDefault(_notificationButton);

var _searchButton = __webpack_require__(1483);

var _searchButton2 = _interopRequireDefault(_searchButton);

var _iconButton = __webpack_require__(1181);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _icons = __webpack_require__(9);

var _protectedButton = __webpack_require__(274);

var _protectedButton2 = _interopRequireDefault(_protectedButton);

var _headerAvatarImage = __webpack_require__(1486);

var _headerAvatarImage2 = _interopRequireDefault(_headerAvatarImage);

var _profileActionsButton = __webpack_require__(1182);

var _profileActionsButton2 = _interopRequireDefault(_profileActionsButton);

var _privateProfileActions = __webpack_require__(520);

var _privateProfileActions2 = _interopRequireDefault(_privateProfileActions);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _headerButtons = __webpack_require__(1491);

var _headerButtons2 = _interopRequireDefault(_headerButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderButtons = exports.HeaderButtons = function HeaderButtons(_ref) {
  var currentUser = _ref.currentUser,
      isAuthenticated = _ref.isAuthenticated,
      _ref$navigation = _ref.navigation,
      MembersLink = _ref$navigation.MembersLink,
      NotificationsLink = _ref$navigation.NotificationsLink,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_headerButtons2.default.container, 'header-buttons') },
    _react2.default.createElement(
      'div',
      { className: _headerButtons2.default.searchButtonSpacing },
      _react2.default.createElement(_searchButton2.default, null)
    ),
    _react2.default.createElement(
      'div',
      { className: _headerButtons2.default.membersButtonSpacing },
      _react2.default.createElement(_iconButton2.default, { component: MembersLink, icon: _icons.MemberIcon, iconClassName: 'button-primary-icon-fill' })
    ),
    renderNotificationButton(isAuthenticated, NotificationsLink),
    renderAvatar(isAuthenticated, currentUser, t)
  );
};

function renderNotificationButton(isAuthenticated, NotificationsLink) {
  if (isAuthenticated) {
    return _react2.default.createElement(
      'div',
      { className: _headerButtons2.default.notificationButtonSpacing },
      _react2.default.createElement(_notificationButton2.default, {
        component: NotificationsLink,
        iconClassName: 'button-primary-icon-fill',
        bubbleClassName: 'icon-secondary-background-color'
      })
    );
  }
}

function renderAvatar(isAuthenticated, currentUser, t) {
  if (isAuthenticated) {
    return _react2.default.createElement(
      _profileActionsButton2.default,
      {
        actionsContainerClassName: _headerButtons2.default.profileActions,
        position: _profileActionsButton2.default.POSITION_RIGHT,
        icon: _react2.default.createElement(_headerAvatarImage2.default, { user: currentUser })
      },
      _react2.default.createElement(_privateProfileActions2.default, { user: currentUser })
    );
  }

  return _react2.default.createElement(
    _protectedButton2.default,
    {
      tagName: 'span',
      className: (0, _classnames2.default)(_headerButtons2.default.signUp, 'button-primary-text-color', 'header-buttons__sign-up')
    },
    t('header-buttons.sign-up')
  );
}

HeaderButtons.propTypes = {
  currentUser: _propTypes2.default.object,
  isAuthenticated: _propTypes2.default.bool,
  navigation: _propTypes2.default.object,
  t: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)(_withAuth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withTranslate2.default)(HeaderButtons);

/***/ }),
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchButton = __webpack_require__(1484);

var _searchButton2 = _interopRequireDefault(_searchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchButton2.default;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _icons = __webpack_require__(9);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _searchButton = __webpack_require__(1485);

var _searchButton2 = _interopRequireDefault(_searchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchButton = function (_Component) {
  _inherits(SearchButton, _Component);

  function SearchButton() {
    _classCallCheck(this, SearchButton);

    return _possibleConstructorReturn(this, (SearchButton.__proto__ || Object.getPrototypeOf(SearchButton)).apply(this, arguments));
  }

  _createClass(SearchButton, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _internalLink2.default,
        { className: (0, _classnames2.default)(_searchButton2.default.button, 'search-button'), to: '/search' },
        _react2.default.createElement(_icons.SearchIcon, { className: 'button-primary-icon-fill' }),
        _react2.default.createElement(
          'span',
          { className: _searchButton2.default.hiddenLabel },
          t('search-button.search')
        )
      );
    }
  }]);

  return SearchButton;
}(_react.Component);

SearchButton.propTypes = {
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(SearchButton);

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_1JF4l","hiddenLabel":"_1WOoS"};

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _headerAvatarImage = __webpack_require__(1487);

var _headerAvatarImage2 = _interopRequireDefault(_headerAvatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _headerAvatarImage2.default;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _fluidAvatarImage = __webpack_require__(545);

var _fluidAvatarImage2 = _interopRequireDefault(_fluidAvatarImage);

var _resolveUserImage = __webpack_require__(249);

var _resolveUserImage2 = _interopRequireDefault(_resolveUserImage);

var _headerAvatarImage = __webpack_require__(1488);

var _headerAvatarImage2 = _interopRequireDefault(_headerAvatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderAvatarImage = function HeaderAvatarImage(_ref) {
  var user = _ref.user;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_headerAvatarImage2.default.container, 'header-avatar-image') },
    _react2.default.createElement(
      'div',
      { className: _headerAvatarImage2.default.image },
      _react2.default.createElement(_fluidAvatarImage2.default, { image: (0, _resolveUserImage2.default)(user.image) })
    )
  );
};

HeaderAvatarImage.propTypes = {
  user: _propTypes2.default.object.isRequired
};

exports.default = HeaderAvatarImage;

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2ZGIi","image":"_2_Tht"};

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _icons = __webpack_require__(9);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _profileActionsButton = __webpack_require__(1490);

var _profileActionsButton2 = _interopRequireDefault(_profileActionsButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POSITION_RIGHT = 'right';
var POSITION_CENTER = 'center';

var ICON_RIGHT_OFFSET = 22;

var ProfileActionsButton = function (_Component) {
  _inherits(ProfileActionsButton, _Component);

  function ProfileActionsButton(props) {
    _classCallCheck(this, ProfileActionsButton);

    var _this = _possibleConstructorReturn(this, (ProfileActionsButton.__proto__ || Object.getPrototypeOf(ProfileActionsButton)).call(this, props));

    _this.setActionsContainer = function (node) {
      _this.actionsContainer = node;
    };

    _this.reposition = function () {
      if (!_this.actionsContainer) {
        return;
      }

      var position = _this.state.position;

      var trigger = (0, _reactDom.findDOMNode)(_this).getBoundingClientRect();
      var actionsRect = (0, _reactDom.findDOMNode)(_this.actionsContainer).getBoundingClientRect();
      var scrollParentRect = (0, _scrollParent2.default)().getBoundingClientRect();
      var positionOffset = ICON_RIGHT_OFFSET - Math.ceil(trigger.width / 2);

      if (scrollParentRect.bottom - actionsRect.bottom < 0) {
        _this.setState({
          top: true
        });
      }

      if (position === POSITION_CENTER && actionsRect.right > window.innerWidth) {
        _this.setState({
          position: POSITION_RIGHT,
          positionOffset: positionOffset
        });
      }

      if (position === POSITION_RIGHT) {
        _this.setState({
          positionOffset: positionOffset
        });
      }
    };

    _this.handleClick = function (event) {
      if (_this.state.isVisible) {
        _this.hideComponent();
      } else {
        _this.showComponent();
      }
      event.preventDefault();
    };

    _this.hideComponent = function () {
      document.removeEventListener('click', _this.hideComponent);
      _this.setState({
        isMenuVisible: false
      });
    };

    _this.state = {
      position: props.position || POSITION_CENTER,
      isMenuVisible: false,
      top: false
    };
    return _this;
  }

  _createClass(ProfileActionsButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.hideComponent);
    }
  }, {
    key: 'showComponent',
    value: function showComponent() {
      document.addEventListener('click', this.hideComponent);
      this.setState({
        isMenuVisible: true
      }, this.reposition);
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          contentFontClassName = _props.contentFontClassName,
          cardBackgroundColor = _props.cardBackgroundColor,
          actionsContainerClassName = _props.actionsContainerClassName;
      var _state = this.state,
          isMenuVisible = _state.isMenuVisible,
          position = _state.position,
          positionOffset = _state.positionOffset,
          top = _state.top;


      var actionsClassName = (0, _classnames2.default)(actionsContainerClassName, _profileActionsButton2.default.actionsContainer, contentFontClassName, 'forum-text-color', 'forum-card-border-color', _defineProperty({}, _profileActionsButton2.default.top, top));
      var triangleClassName = (0, _classnames2.default)(_profileActionsButton2.default.triangle, 'forum-card-border-color', 'default-forum-card-background-color');
      var style = {
        backgroundColor: cardBackgroundColor
      };

      var actionsStyle = {};
      if (position === POSITION_RIGHT) {
        actionsStyle.transform = 'translateX(' + positionOffset + 'px)';
      }

      if (isMenuVisible) {
        return _react2.default.createElement(
          'div',
          {
            className: actionsClassName,
            style: actionsStyle,
            ref: function ref(node) {
              return _this2.setActionsContainer(node);
            },
            'data-hook': 'profile-actions'
          },
          _react2.default.createElement('div', { className: triangleClassName, style: style }),
          _react2.default.createElement(
            'div',
            { className: 'default-forum-card-background-color', style: style },
            children
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var icon = this.props.icon;
      var _state2 = this.state,
          position = _state2.position,
          isMenuVisible = _state2.isMenuVisible;


      var moreButton = _react2.default.createElement(
        _button2.default,
        {
          className: (0, _classnames2.default)(_profileActionsButton2.default.button, 'profile-actions-button'),
          isSecondary: !isMenuVisible,
          'data-hook': 'profile-actions-button__more-button'
        },
        _react2.default.createElement(_icons.MoreIcon, { className: isMenuVisible ? 'button-primary-icon-fill' : 'button-fill' })
      );
      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)(_profileActionsButton2.default.container, _profileActionsButton2.default[position]), onClick: this.handleClick },
        icon ? icon : moreButton,
        this.renderMenu()
      );
    }
  }]);

  return ProfileActionsButton;
}(_react.Component);

ProfileActionsButton.propTypes = {
  children: _propTypes2.default.node,
  icon: _propTypes2.default.node,
  position: _propTypes2.default.string,
  actionsContainerClassName: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string.isRequired,
  cardBackgroundColor: _propTypes2.default.string.isRequired
};

ProfileActionsButton.POSITION_RIGHT = POSITION_RIGHT;

exports.default = _lodash2.default.flowRight(_withFontClassName2.default, _withCardBackgroundColor2.default)(ProfileActionsButton);

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2sDTt","button":"_1yJ9o","actionsContainer":"E149l","center":"_1M_JM","right":"_2Jkeq","top":"_18KhU","triangle":"_11um0"};

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2d_Na","profileActions":"_2pIli","signUp":"_13cW-"};

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _pageMenuButton = __webpack_require__(1493);

var _pageMenuButton2 = _interopRequireDefault(_pageMenuButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _pageMenuButton2.default;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _menuButton = __webpack_require__(1494);

var _menuButton2 = _interopRequireDefault(_menuButton);

var _navigateToSitePage = __webpack_require__(1497);

var _sitePagesSelectors = __webpack_require__(1498);

var _locationHistorySelectors = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ROOT_PATH = '/';

var PageMenuButton = function (_Component) {
  _inherits(PageMenuButton, _Component);

  function PageMenuButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PageMenuButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageMenuButton.__proto__ || Object.getPrototypeOf(PageMenuButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      return _this.props.navigateToSitePage(event.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PageMenuButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          sitePages = _props.sitePages,
          location = _props.location;

      var items = (0, _lodash.map)(sitePages, function (_ref2) {
        var pageId = _ref2.pageId,
            title = _ref2.title;
        return {
          value: pageId,
          label: title
        };
      });
      var buttonProps = {
        value: this.props.currentPageId,
        items: items,
        onChange: this.handleChange
      };

      if (location.pathname !== ROOT_PATH) {
        buttonProps.navigateTo = ROOT_PATH;
      }

      return _react2.default.createElement(_menuButton2.default, buttonProps);
    }
  }]);

  return PageMenuButton;
}(_react.Component);

PageMenuButton.propTypes = {
  sitePages: _propTypes2.default.array,
  currentPageId: _propTypes2.default.string,
  navigateToSitePage: _propTypes2.default.func,
  location: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    sitePages: (0, _sitePagesSelectors.getMenuButtonSitePages)(state),
    currentPageId: (0, _sitePagesSelectors.getCurrentSitePageId)(state),
    location: (0, _locationHistorySelectors.getCurrentLocation)(state)
  };
};

var mapDispatchToProps = {
  navigateToSitePage: _navigateToSitePage.navigateToSitePage
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PageMenuButton);

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _menuButton = __webpack_require__(1495);

var _menuButton2 = _interopRequireDefault(_menuButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _menuButton2.default;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icons = __webpack_require__(9);

var _menuButton = __webpack_require__(1496);

var _menuButton2 = _interopRequireDefault(_menuButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MenuButton = function MenuButton(_ref) {
  var items = _ref.items,
      value = _ref.value,
      handleChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ['items', 'value', 'onChange']);

  return _react2.default.createElement(
    'span',
    _extends({ className: _menuButton2.default.container }, rest, { 'data-hook': 'menu-button' }),
    _react2.default.createElement(_icons.MenuIcon, { className: 'button-primary-icon-fill' }),
    _react2.default.createElement(
      'span',
      { className: _menuButton2.default.clickable },
      _react2.default.createElement(
        'select',
        { className: _menuButton2.default.select, onChange: handleChange, value: value, 'data-hook': 'menu-button__select' },
        (0, _lodash.map)(items, function (_ref2) {
          var value = _ref2.value,
              label = _ref2.label;
          return _react2.default.createElement(
            'option',
            { key: value, value: value },
            label
          );
        })
      )
    )
  );
};

MenuButton.propTypes = {
  items: _propTypes2.default.array,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

exports.default = MenuButton;

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_39Ny5","clickable":"_2X0fj","select":"_2A_YX"};

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToSitePage = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigateToSitePage = exports.navigateToSitePage = function navigateToSitePage(pageId) {
  return function () {
    return _wixSdkPolyfill2.default.navigateToPage(pageId);
  };
};

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuButtonSitePages = exports.getVisibleSitePages = exports.getCurrentSitePageTitle = exports.getCurrentSitePageId = exports.getCurrentSitePage = exports.getSitePages = undefined;

var _lodash = __webpack_require__(2);

var getSitePages = exports.getSitePages = function getSitePages(state) {
  return state.sitePages;
};
var getCurrentSitePage = exports.getCurrentSitePage = function getCurrentSitePage(state) {
  return (0, _lodash.find)(getSitePages(state), function (page) {
    return page.isCurrent;
  });
};
var getCurrentSitePageId = exports.getCurrentSitePageId = function getCurrentSitePageId(state) {
  return (0, _lodash.get)(getCurrentSitePage(state), 'pageId');
};
var getCurrentSitePageTitle = exports.getCurrentSitePageTitle = function getCurrentSitePageTitle(state) {
  return (0, _lodash.get)(getCurrentSitePage(state), 'title');
};
var getVisibleSitePages = exports.getVisibleSitePages = function getVisibleSitePages(state) {
  return (0, _lodash.filter)(getSitePages(state), function (page) {
    return !page.hidden;
  });
};
var getMenuButtonSitePages = exports.getMenuButtonSitePages = function getMenuButtonSitePages(state) {
  return (0, _lodash.filter)(getSitePages(state), function (page) {
    return !page.hidden || page.pageId === getCurrentSitePageId(state);
  });
};

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTitle = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _forumDataSelectors = __webpack_require__(457);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _headerTitle = __webpack_require__(1500);

var _headerTitle2 = _interopRequireDefault(_headerTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderTitle = exports.HeaderTitle = function HeaderTitle(_ref) {
  var title = _ref.title,
      t = _ref.t,
      to = _ref.to;

  var Component = to === undefined ? 'span' : _internalLink2.default;
  return _react2.default.createElement(
    'h1',
    { className: _headerTitle2.default.title },
    _react2.default.createElement(
      Component,
      { to: to },
      title || t('header-title.default-title')
    )
  );
};

HeaderTitle.propTypes = {
  title: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired,
  to: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    title: (0, _forumDataSelectors.getForumTitle)(state)
  };
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps), _withTranslate2.default)(HeaderTitle);

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"_3SrIQ"};

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"Bdz6_","header":"_1XU7E","left":"cOr8e","menuButton":"_2dh7K","profile":"_1ppxk"};

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryPage = __webpack_require__(1503);

var _categoryPage2 = _interopRequireDefault(_categoryPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryPage2.default;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(5);

var _fetchCategoryAndRedirect = __webpack_require__(1504);

var _redirectTo = __webpack_require__(1007);

var _fetchCategoryPosts = __webpack_require__(1505);

var _setIsCategoryLoaded = __webpack_require__(1305);

var _incrementPostLikeCount = __webpack_require__(160);

var _pageOpened = __webpack_require__(410);

var _categorySocket = __webpack_require__(260);

var _setIsLoaded = __webpack_require__(198);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _categoryDescription = __webpack_require__(1508);

var _categoryDescription2 = _interopRequireDefault(_categoryDescription);

var _postList = __webpack_require__(1306);

var _postList2 = _interopRequireDefault(_postList);

var _postSelectors = __webpack_require__(117);

var _accountSuspended = __webpack_require__(1179);

var _accountSuspended2 = _interopRequireDefault(_accountSuspended);

var _restriction = __webpack_require__(1546);

var _restriction2 = _interopRequireDefault(_restriction);

var _restrictionPrivateMember = __webpack_require__(1549);

var _restrictionPrivateMember2 = _interopRequireDefault(_restrictionPrivateMember);

var _pageMetadata = __webpack_require__(1180);

var _pageMetadata2 = _interopRequireDefault(_pageMetadata);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _notFound = __webpack_require__(1313);

var _notFound2 = _interopRequireDefault(_notFound);

var _noPosts = __webpack_require__(1553);

var _noPosts2 = _interopRequireDefault(_noPosts);

var _layout = __webpack_require__(1237);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _newPostMessageRoot = __webpack_require__(1555);

var _newPostMessageRoot2 = _interopRequireDefault(_newPostMessageRoot);

var _pagination = __webpack_require__(166);

var _wixParams = __webpack_require__(24);

var _layoutTypes = __webpack_require__(263);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _categoriesSelectors = __webpack_require__(35);

var _isLoadingSelectors = __webpack_require__(267);

var _isLoadedSelectors = __webpack_require__(412);

var _outerHeight = __webpack_require__(1560);

var _outerHeight2 = _interopRequireDefault(_outerHeight);

var _getScrollOffset = __webpack_require__(1003);

var _getScrollOffset2 = _interopRequireDefault(_getScrollOffset);

var _scrollTo = __webpack_require__(537);

var _scrollTo2 = _interopRequireDefault(_scrollTo);

var _detectRoute = __webpack_require__(266);

var _routerUtils = __webpack_require__(55);

var _paginationSelectors = __webpack_require__(424);

var _appSettingsSelectors = __webpack_require__(222);

var _memberAreaSelectors = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layout = _layout.EmptyLayout;
var NotFoundLayout = (0, _forDevice2.default)(_layout.FullHeightLayout, _layout.SimpleLayout);

var resetPage = function resetPage() {
  return { page: 1 };
};
var incrementPage = function incrementPage(state) {
  return { page: state.page + 1 };
};

var CategoryPage = exports.CategoryPage = function (_Component) {
  _inherits(CategoryPage, _Component);

  function CategoryPage(props) {
    _classCallCheck(this, CategoryPage);

    var _this = _possibleConstructorReturn(this, (CategoryPage.__proto__ || Object.getPrototypeOf(CategoryPage)).call(this, props));

    _this.fetchPosts = function () {
      var categoryId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.category._id;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.page;

      if (!_this.shouldShowPosts()) {
        return;
      }

      _this.props.fetchPosts({
        categoryId: categoryId,
        page: page,
        pageSize: _pagination.POSTS_PER_PAGE
      });
    };

    _this.handleLikeClick = function (postId) {
      return _this.props.incrementPostLikeCount(postId);
    };

    _this.changePage = function (page) {
      var _this$props = _this.props,
          categorySlug = _this$props.categorySlug,
          category = _this$props.category;

      _this.fetchPosts(category._id, page);
      _this.props.push({
        pathname: '/' + categorySlug,
        query: { page: page }
      });
    };

    _this.handleLoad = function () {
      return _this.setState(incrementPage, _this.fetchPosts);
    };

    _this.state = {
      isAnimated: !props.allPosts.length,
      page: props.layoutType === _layoutTypes.LAYOUT_TYPE_CLASSIC ? props.page : 1
    };
    return _this;
  }

  _createClass(CategoryPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          category = _props.category,
          isPostsLoaded = _props.isPostsLoaded;

      this.props.pageOpened({
        page: _detectRoute.FEED_PAGE,
        category: category
      });
      this.props.emitOpenCategory(category);

      if (!isPostsLoaded) {
        this.fetchPosts();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var category = this.props.category;

      this.props.setIsCategoryLoaded(category._id, false);
      this.props.setIsLoaded('posts', category._id, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var _this2 = this;

      var categorySlug = _ref.categorySlug,
          category = _ref.category,
          newPostId = _ref.newPostId,
          page = _ref.page;

      var currentCategorySlug = this.props.categorySlug;

      if (currentCategorySlug !== categorySlug) {
        this.props.emitOpenCategory(category);
        this.setState(resetPage, function () {
          return _this2.fetchPosts(category._id);
        });
      } else if (this.state.page !== page && this.props.page !== page) {
        this.setState({ page: page }, function () {
          return _this2.fetchPosts(category._id);
        });
      }

      if (newPostId && newPostId !== this.props.newPostId) {
        var postElement = document.getElementById(newPostId);
        if (!postElement) {
          return;
        }

        var rect = postElement.getBoundingClientRect();
        var height = (0, _outerHeight2.default)(postElement);
        if (rect.top < 0) {
          (0, _scrollTo2.default)((0, _getScrollOffset2.default)() + height);
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref2) {
      var isAuthenticated = _ref2.isAuthenticated,
          isBlocked = _ref2.isBlocked,
          isPrivate = _ref2.isPrivate;

      if (this.props.isAuthenticated !== isAuthenticated || this.props.isBlocked !== isBlocked || this.props.isPrivate !== isPrivate) {
        this.fetchPosts();
      }
    }
  }, {
    key: 'shouldShowPosts',
    value: function shouldShowPosts() {
      var _props2 = this.props,
          category = _props2.category,
          isAuthenticated = _props2.isAuthenticated,
          isBlocked = _props2.isBlocked,
          isPrivate = _props2.isPrivate,
          isMemberAreaActive = _props2.isMemberAreaActive;

      var hasPrivateSocialProfile = isMemberAreaActive && isPrivate;
      var canSeePrivateCategory = isAuthenticated && !isBlocked && !hasPrivateSocialProfile;
      return !category.isPrivate || canSeePrivateCategory;
    }
  }, {
    key: 'renderPosts',
    value: function renderPosts() {
      var _props3 = this.props,
          isBlocked = _props3.isBlocked,
          currentPagePosts = _props3.currentPagePosts,
          allPosts = _props3.allPosts,
          entityCount = _props3.entityCount,
          category = _props3.category,
          isLoading = _props3.isLoading,
          isPostsLoaded = _props3.isPostsLoaded,
          isAuthenticated = _props3.isAuthenticated,
          isPrivate = _props3.isPrivate,
          isMemberAreaActive = _props3.isMemberAreaActive;

      var hasPosts = allPosts.length;

      if (isBlocked) {
        return _react2.default.createElement(_accountSuspended2.default, null);
      } else if (category.isPrivate && !isAuthenticated) {
        return _react2.default.createElement(_restriction2.default, null);
      } else if (category.isPrivate && isMemberAreaActive && isPrivate) {
        return _react2.default.createElement(_restrictionPrivateMember2.default, null);
      } else if (!hasPosts) {
        return _react2.default.createElement(_noPosts2.default, { category: category });
      } else {
        return _react2.default.createElement(_postList2.default, {
          page: this.props.page,
          entityCount: entityCount,
          allPosts: allPosts,
          changePage: this.changePage,
          loadMore: this.handleLoad // eslint-disable-line react/jsx-handler-names
          , currentPagePosts: currentPagePosts,
          onLikeClick: this.handleLikeClick,
          isLoading: isLoading,
          category: category,
          isLoaded: isPostsLoaded
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          category = _props4.category,
          isLoading = _props4.isLoading,
          isCategoryLoaded = _props4.isCategoryLoaded,
          allPosts = _props4.allPosts,
          isPostsLoaded = _props4.isPostsLoaded,
          isHeaderEnabled = _props4.isHeaderEnabled;

      if (_lodash2.default.isEmpty(category)) {
        return _react2.default.createElement(
          _page2.default,
          null,
          _react2.default.createElement(
            NotFoundLayout,
            null,
            _react2.default.createElement(_notFound2.default, null)
          )
        );
      }

      return _react2.default.createElement(
        _page2.default,
        null,
        _react2.default.createElement(
          Layout,
          null,
          _react2.default.createElement(_pageMetadata2.default, { title: category.label, description: category.description, image: category.cover }),
          _react2.default.createElement(_newPostMessageRoot2.default, { pathname: this.props.location.pathname }),
          _react2.default.createElement(_categoryDescription2.default, { category: category, isCoverVisible: isHeaderEnabled }),
          _react2.default.createElement(
            _animatedLoader2.default,
            {
              isLoading: isLoading && !isCategoryLoaded && !allPosts.length,
              isAnimated: this.state.isAnimated
            },
            this.renderPosts()
          )
        ),
        isPostsLoaded && _react2.default.createElement(_appLoaded2.default, { parent: this, selector: '[data-hook=post-list]' })
      );
    }
  }]);

  return CategoryPage;
}(_react.Component);

CategoryPage.fetchData = function (_ref3) {
  var store = _ref3.store,
      params = _ref3.params,
      search = _ref3.search,
      user = _ref3.user,
      query = _ref3.query;

  return store.dispatch((0, _fetchCategoryAndRedirect.fetchCategoryAndRedirect)(params.categorySlug, search)).then(function (category) {
    var isClassicLayout = (0, _appSettingsSelectors.getStyleSetting)(store.getState(), _wixParams.LAYOUT_TYPE_PATH);
    if (!category.isPrivate || user) {
      return store.dispatch((0, _fetchCategoryPosts.fetchCategoryPosts)({
        categoryId: category._id,
        page: isClassicLayout ? _lodash2.default.toNumber(query.page) || 1 : 1,
        pageSize: _pagination.POSTS_PER_PAGE
      }));
    }
  }).catch(function () {
    return store.dispatch((0, _redirectTo.redirectTo404)(search));
  });
};

CategoryPage.propTypes = {
  categorySlug: _propTypes2.default.string.isRequired,
  fetchPosts: _propTypes2.default.func.isRequired,
  emitOpenCategory: _propTypes2.default.func.isRequired,
  pageOpened: _propTypes2.default.func.isRequired,
  incrementPostLikeCount: _propTypes2.default.func.isRequired,
  categoryId: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.object.isRequired,
  setIsCategoryLoaded: _propTypes2.default.func.isRequired,
  setIsLoaded: _propTypes2.default.func.isRequired,
  push: _propTypes2.default.func,
  entityCount: _propTypes2.default.number,
  page: _propTypes2.default.number,
  allPosts: _propTypes2.default.array,
  currentPagePosts: _propTypes2.default.array,
  category: _propTypes2.default.object,
  isAuthenticated: _propTypes2.default.bool,
  isBlocked: _propTypes2.default.bool,
  isPrivate: _propTypes2.default.bool,
  params: _propTypes2.default.object,
  t: _propTypes2.default.func,
  newPostId: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool,
  isPostsLoaded: _propTypes2.default.bool,
  isCategoryLoaded: _propTypes2.default.bool,
  layoutType: _propTypes2.default.number,
  isMemberAreaActive: _propTypes2.default.bool,
  isHeaderEnabled: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var category = (0, _categoriesSelectors.getCategoryBySlug)(state, ownProps.params.categorySlug) || {};
  var categoryId = category._id;
  var page = _lodash2.default.toNumber(_lodash2.default.get(ownProps, 'location.query.page', 1));

  return {
    categorySlug: ownProps.params.categorySlug,
    category: category,
    allPosts: (0, _postSelectors.getSortedPostsByCategoryId)(state, categoryId),
    currentPagePosts: (0, _postSelectors.getPostsByCategoryIdAndPage)(state, categoryId, page),
    newPostId: state.newPostMessage,
    entityCount: (0, _paginationSelectors.getEntityCount)(state, 'posts'),
    categoryId: categoryId,
    isLoading: (0, _isLoadingSelectors.getIsCategoryLoading)(state, categoryId),
    isCategoryLoaded: (0, _isLoadedSelectors.getIsCategoryLoaded)(state, categoryId),
    isPostsLoaded: (0, _isLoadedSelectors.getIsPostsLoaded)(state, categoryId),
    isMemberAreaActive: (0, _memberAreaSelectors.isMemberAreaActive)(state),
    page: page,
    isHeaderEnabled: (0, _appSettingsSelectors.getIsHeaderEnabled)(state)
  };
};

var mapDispatchToProps = {
  fetchPosts: _fetchCategoryPosts.fetchCategoryPosts,
  setIsCategoryLoaded: _setIsCategoryLoaded.setIsCategoryLoaded,
  setIsLoaded: _setIsLoaded.setIsLoaded,
  incrementPostLikeCount: _incrementPostLikeCount.incrementPostLikeCount,
  emitOpenCategory: _categorySocket.emitOpenCategory,
  pageOpened: _pageOpened.pageOpened,
  push: _routerUtils.push
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withAuth2.default, (0, _withAppSettings2.default)({ layoutType: _wixParams.LAYOUT_TYPE_PATH }))(CategoryPage);

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCategoryAndRedirect = undefined;

var _reactRouterRedux = __webpack_require__(44);

var _fetchCategory = __webpack_require__(1304);

var fetchCategoryAndRedirect = exports.fetchCategoryAndRedirect = function fetchCategoryAndRedirect(categoryId, search) {
  return function (dispatch) {
    return dispatch((0, _fetchCategory.fetchCategory)(categoryId)).then(function (category) {
      if (categoryId !== category._id && categoryId !== category.slug) {
        dispatch((0, _reactRouterRedux.push)({ pathname: '/' + category.slug + search, state: 301 }));
      }
      return category;
    });
  };
};

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCategoryPosts = undefined;

var _startLoadingCategory = __webpack_require__(1506);

var _stopLoadingCategory = __webpack_require__(1507);

var _setIsCategoryLoaded = __webpack_require__(1305);

var _fetchPosts = __webpack_require__(138);

var _fetchPosts2 = _interopRequireDefault(_fetchPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var finishLoading = function finishLoading(dispatch, categoryId) {
  dispatch((0, _stopLoadingCategory.stopLoadingCategory)(categoryId));
  dispatch((0, _setIsCategoryLoaded.setIsCategoryLoaded)(categoryId, true));
};

var fetchCategoryPosts = exports.fetchCategoryPosts = function fetchCategoryPosts(_ref) {
  var categoryId = _ref.categoryId,
      page = _ref.page,
      pageSize = _ref.pageSize;
  return function (dispatch) {
    dispatch((0, _startLoadingCategory.startLoadingCategory)(categoryId));
    var promise = dispatch((0, _fetchPosts2.default)({ categoryId: categoryId, page: page, pageSize: pageSize }));

    return promise.then(function () {
      return finishLoading(dispatch, categoryId);
    }).catch(function () {
      return finishLoading(dispatch, categoryId);
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startLoadingCategory = undefined;

var _setIsLoading = __webpack_require__(418);

var startLoadingCategory = exports.startLoadingCategory = function startLoadingCategory(categoryId) {
  return (0, _setIsLoading.setIsLoading)('category', categoryId, true);
};

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopLoadingCategory = undefined;

var _setIsLoading = __webpack_require__(418);

var stopLoadingCategory = exports.stopLoadingCategory = function stopLoadingCategory(categoryId) {
  return (0, _setIsLoading.setIsLoading)('category', categoryId, false);
};

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryDescription = __webpack_require__(1509);

var _categoryDescription2 = _interopRequireDefault(_categoryDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryDescription2.default;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _pageDescription = __webpack_require__(1294);

var _pageDescription2 = _interopRequireDefault(_pageDescription);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _icons = __webpack_require__(9);

var _categoryActions = __webpack_require__(1239);

var _categoryActions2 = _interopRequireDefault(_categoryActions);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _categoryDescription = __webpack_require__(1510);

var _categoryDescription2 = _interopRequireDefault(_categoryDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryDescription = function CategoryDescription(_ref) {
  var category = _ref.category,
      isAuthenticated = _ref.isAuthenticated,
      isCoverVisible = _ref.isCoverVisible;

  var actions = void 0;

  if (isAuthenticated) {
    var icon = _react2.default.createElement(_icons.MoreIcon, { fill: _lodash2.default.get(category, 'textColor.color') });
    actions = _react2.default.createElement(
      'div',
      { className: _categoryDescription2.default.actions },
      _react2.default.createElement(
        _moreButton2.default,
        { icon: icon },
        _react2.default.createElement(_categoryActions2.default, { category: category })
      )
    );
  }

  return _react2.default.createElement(
    _pageDescription2.default,
    {
      title: category.label,
      description: category.description,
      cover: category.cover,
      coverType: category.coverType,
      overlayColor: category.overlayColor,
      backgroundColor: category.backgroundColor,
      textColor: category.textColor,
      isCoverVisible: isCoverVisible
    },
    actions
  );
};

CategoryDescription.propTypes = {
  category: _propTypes2.default.object.isRequired,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  isCoverVisible: _propTypes2.default.bool.isRequired
};

exports.default = (0, _withAuth2.default)(CategoryDescription);

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actions":"_3C9lt"};

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _wixParams = __webpack_require__(24);

var _layoutTypes = __webpack_require__(263);

var _cardSizes = __webpack_require__(224);

var _masonryWrapper = __webpack_require__(1296);

var _masonryWrapper2 = _interopRequireDefault(_masonryWrapper);

var _postListMasonry = __webpack_require__(1512);

var _postListMasonry2 = _interopRequireDefault(_postListMasonry);

var _postListClassic = __webpack_require__(1529);

var _postListClassic2 = _interopRequireDefault(_postListClassic);

var _postListMobile = __webpack_require__(1539);

var _postListMobile2 = _interopRequireDefault(_postListMobile);

var _postListLarge = __webpack_require__(1542);

var _postListLarge2 = _interopRequireDefault(_postListLarge);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _loadMore = __webpack_require__(1312);

var _loadMore2 = _interopRequireDefault(_loadMore);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _incrementPostLikeCount = __webpack_require__(160);

var _postList = __webpack_require__(1183);

var _postList2 = _interopRequireDefault(_postList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostList = function (_Component) {
  _inherits(PostList, _Component);

  function PostList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostList.__proto__ || Object.getPrototypeOf(PostList)).call.apply(_ref, [this].concat(args))), _this), _this.getListComponent = function () {
      var Component = void 0;
      var _this$props = _this.props,
          isMobile = _this$props.isMobile,
          layout = _this$props.layout,
          cardSize = _this$props.cardSize;

      if (isMobile) {
        Component = _postListMobile2.default;
      } else if (layout === _layoutTypes.LAYOUT_TYPE_PINBOARD && cardSize === _cardSizes.CARD_SIZE_LARGE) {
        Component = _postListLarge2.default;
      } else if (layout === _layoutTypes.LAYOUT_TYPE_PINBOARD) {
        Component = _postListMasonry2.default;
      } else {
        Component = _postListClassic2.default;
      }

      return Component;
    }, _this.isInfiniteList = function () {
      var _this$props2 = _this.props,
          isMobile = _this$props2.isMobile,
          layout = _this$props2.layout,
          cardSize = _this$props2.cardSize;

      return isMobile || layout === _layoutTypes.LAYOUT_TYPE_PINBOARD && cardSize !== _cardSizes.CARD_SIZE_LARGE;
    }, _this.shouldFadeIn = function () {
      var _this$props3 = _this.props,
          layout = _this$props3.layout,
          cardSize = _this$props3.cardSize,
          isMobile = _this$props3.isMobile;

      return !isMobile && layout === _layoutTypes.LAYOUT_TYPE_PINBOARD && cardSize !== _cardSizes.CARD_SIZE_LARGE;
    }, _this.renderComponent = function () {
      var Component = _this.getListComponent();

      var _this$props4 = _this.props,
          isLoading = _this$props4.isLoading,
          currentPagePosts = _this$props4.currentPagePosts,
          allPosts = _this$props4.allPosts,
          page = _this$props4.page,
          entityCount = _this$props4.entityCount,
          isLoaded = _this$props4.isLoaded,
          loadMore = _this$props4.loadMore,
          handlePageChange = _this$props4.changePage,
          props = _objectWithoutProperties(_this$props4, ['isLoading', 'currentPagePosts', 'allPosts', 'page', 'entityCount', 'isLoaded', 'loadMore', 'changePage']);

      if (_this.isInfiniteList()) {
        return _react2.default.createElement(
          _loadMore2.default,
          { loadMore: loadMore, loader: _react2.default.createElement(_loader2.default, null), isLoading: isLoading, hasMore: allPosts.length < entityCount },
          _react2.default.createElement(Component, _extends({ posts: allPosts, entityCount: entityCount }, props))
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Component, _extends({
          page: page,
          entityCount: entityCount,
          onPageChange: handlePageChange,
          isLoading: isLoading,
          isLoaded: isLoaded,
          posts: currentPagePosts
        }, props))
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PostList, [{
    key: 'render',
    value: function render() {
      var hasSpacing = this.props.hasSpacing;


      var containerClassName = (0, _classnames2.default)(_postList2.default.container, 'post-list', _defineProperty({}, _postList2.default.hasSpacing, hasSpacing));

      return _react2.default.createElement(
        'div',
        { className: containerClassName },
        _react2.default.createElement(
          _masonryWrapper2.default,
          { isEnabled: this.shouldFadeIn() },
          this.renderComponent()
        )
      );
    }
  }]);

  return PostList;
}(_react.Component);

PostList.propTypes = {
  onLikeClick: _propTypes2.default.func.isRequired,
  loadMore: _propTypes2.default.func.isRequired,
  changePage: _propTypes2.default.func,
  currentPagePosts: _propTypes2.default.array,
  category: _propTypes2.default.object,
  allPosts: _propTypes2.default.array,
  location: _propTypes2.default.object,
  query: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  layout: _propTypes2.default.number,
  cardSize: _propTypes2.default.number,
  entityCount: _propTypes2.default.number,
  page: _propTypes2.default.number,
  isLoading: _propTypes2.default.bool,
  isLoaded: _propTypes2.default.bool,
  hasSpacing: _propTypes2.default.bool
};

PostList.defaultProps = {
  layout: _layoutTypes.LAYOUT_TYPE_PINBOARD,
  cardSize: _cardSizes.CARD_SIZE_SMALL,
  hasSpacing: true
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var category = _ref2.category,
      canSee = _ref2.canSee;
  return {
    showCreatePostAction: category && (!category.isWriteProtected || canSee('create-post', 'category', category))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onLikeClick: _incrementPostLikeCount.incrementPostLikeCount
  }, dispatch);
};

exports.default = (0, _lodash.flowRight)((0, _withAppSettings2.default)({
  cardSize: _wixParams.CARD_SIZE_PATH,
  layout: _wixParams.LAYOUT_TYPE_PATH
}), _withDeviceType2.default, _withPermissions2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps) // Should stay last
)(PostList);

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TYPES;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMasonryComponent = __webpack_require__(1297);

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _postListItem = __webpack_require__(524);

var _postListItem2 = _interopRequireDefault(_postListItem);

var _createPostCta = __webpack_require__(1307);

var _createPostCta2 = _interopRequireDefault(_createPostCta);

var _cardSizes = __webpack_require__(224);

var _wixParams = __webpack_require__(24);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _postList = __webpack_require__(1183);

var _postList2 = _interopRequireDefault(_postList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPES = (_TYPES = {}, _defineProperty(_TYPES, _cardSizes.CARD_SIZE_SMALL, 'small'), _defineProperty(_TYPES, _cardSizes.CARD_SIZE_MEDIUM, 'medium'), _defineProperty(_TYPES, _cardSizes.CARD_SIZE_LARGE, 'large'), _TYPES);

var MASONRY_OPTIONS = {
  transitionDuration: 0,
  fitWidth: false,
  gutter: 20
};

var PostListMasonry = function PostListMasonry(_ref) {
  var category = _ref.category,
      posts = _ref.posts,
      cardSize = _ref.cardSize,
      onLikeClick = _ref.onLikeClick,
      showCreatePostAction = _ref.showCreatePostAction;

  var type = TYPES[cardSize];
  var className = (0, _classnames2.default)(_postList2.default.masonry, _postList2.default[type]);
  return _react2.default.createElement(
    _reactMasonryComponent2.default,
    { className: className, options: MASONRY_OPTIONS, 'data-hook': 'post-list' },
    showCreatePostAction && _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_postList2.default.listItem), key: 'create-post' },
      _react2.default.createElement(_createPostCta2.default, { categorySlug: category.slug })
    ),
    posts.map(function (post) {
      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(_postList2.default.listItem, 'post-list__post-list-item'),
          key: post._id,
          id: post._id,
          'data-hook': 'post-list-item'
        },
        _react2.default.createElement(_postListItem2.default, { type: type, post: post, onLikeClick: onLikeClick })
      );
    })
  );
};

PostListMasonry.propTypes = {
  onLikeClick: _propTypes2.default.func.isRequired,
  category: _propTypes2.default.object,
  posts: _propTypes2.default.array,
  query: _propTypes2.default.string,
  cardSize: _propTypes2.default.number,
  showCreatePostAction: _propTypes2.default.bool
};

PostListMasonry.defaultProps = {
  cardSize: _cardSizes.CARD_SIZE_MEDIUM
};

exports.default = (0, _withAppSettings2.default)({
  cardSize: _wixParams.CARD_SIZE_PATH
})(PostListMasonry);

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ctaToFab = __webpack_require__(1514);

var _ctaToFab2 = _interopRequireDefault(_ctaToFab);

var _createPostHandler = __webpack_require__(1308);

var _createPostHandler2 = _interopRequireDefault(_createPostHandler);

var _createPostCard = __webpack_require__(1518);

var _createPostCard2 = _interopRequireDefault(_createPostCard);

var _floatingActionButton = __webpack_require__(1523);

var _floatingActionButton2 = _interopRequireDefault(_floatingActionButton);

var _floatingCreateButton = __webpack_require__(1526);

var _floatingCreateButton2 = _interopRequireDefault(_floatingCreateButton);

var _ensureAuth = __webpack_require__(411);

var _ensureAuth2 = _interopRequireDefault(_ensureAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOBILE_SCROLL_OFFSET = 50;

var CreatePostCardSecure = (0, _ensureAuth2.default)(_createPostCard2.default);
var FloatingCreateButtonSecure = (0, _ensureAuth2.default)(_floatingCreateButton2.default);

var CreatePostCta = function CreatePostCta(_ref) {
  var categorySlug = _ref.categorySlug;

  var cta = _react2.default.createElement(
    _createPostHandler2.default,
    { categorySlug: categorySlug },
    _react2.default.createElement(CreatePostCardSecure, null)
  );
  var floatingButton = _react2.default.createElement(
    _createPostHandler2.default,
    { categorySlug: categorySlug },
    _react2.default.createElement(FloatingCreateButtonSecure, null)
  );

  return _react2.default.createElement(_ctaToFab2.default, { cta: cta, fab: _react2.default.createElement(_floatingActionButton2.default, { button: floatingButton }), scrollOffset: MOBILE_SCROLL_OFFSET });
};

CreatePostCta.propTypes = {
  categorySlug: _propTypes2.default.string.isRequired
};

exports.default = CreatePostCta;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ctaToFab = __webpack_require__(1515);

var _ctaToFab2 = _interopRequireDefault(_ctaToFab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ctaToFab2.default;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rafThrottle = __webpack_require__(1516);

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALWAYS_VISIBLE_HEIGHT = 500;

var CtaToFab = function (_Component) {
  _inherits(CtaToFab, _Component);

  function CtaToFab() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CtaToFab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CtaToFab.__proto__ || Object.getPrototypeOf(CtaToFab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false
    }, _this.onScroll = (0, _rafThrottle2.default)(function () {
      var position = (0, _scrollParent2.default)().scrollTop;
      var isButtonHidden = _this.positionHidden < position + _this.props.scrollOffset;
      var isInAlwaysVisibleZone = _this.positionHidden + ALWAYS_VISIBLE_HEIGHT > position;
      var isScrollUp = _this.position > position;
      _this.setState({ isVisible: isButtonHidden && (isInAlwaysVisibleZone || isScrollUp) });
      _this.position = position;
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CtaToFab, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var el = _reactDom2.default.findDOMNode(this);
      var box = el.getBoundingClientRect();
      this.position = window.pageYOffset;
      this.positionHidden = this.position + box.bottom;
      this.startListening();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening();
    }
  }, {
    key: 'startListening',
    value: function startListening() {
      (0, _scrollParent2.default)().addEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'stopListening',
    value: function stopListening() {
      (0, _scrollParent2.default)().removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        this.props.cta,
        _react2.default.cloneElement(this.props.fab, { isVisible: this.state.isVisible })
      );
    }
  }]);

  return CtaToFab;
}(_react.Component);

exports.default = CtaToFab;


CtaToFab.propTypes = {
  className: _propTypes2.default.string,
  cta: _propTypes2.default.node,
  fab: _propTypes2.default.node,
  scrollOffset: _propTypes2.default.number
};

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raf = __webpack_require__(1293);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var rafThrottle = function rafThrottle(callback) {
  var requestId = void 0;

  var later = function later(args) {
    return function () {
      requestId = null;
      callback.apply(undefined, _toConsumableArray(args));
    };
  };

  var throttled = function throttled() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (requestId == null) {
      requestId = (0, _raf2.default)(later(args));
    }
  };

  throttled.cancel = function () {
    return _raf2.default.cancel(requestId);
  };

  return throttled;
};

exports.default = rafThrottle;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _reactRedux = __webpack_require__(5);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _routerUtils = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePostHandler = function (_Component) {
  _inherits(CreatePostHandler, _Component);

  function CreatePostHandler() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreatePostHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreatePostHandler.__proto__ || Object.getPrototypeOf(CreatePostHandler)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          push = _this$props.push,
          categorySlug = _this$props.categorySlug;


      push('/' + categorySlug + '/create-post');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreatePostHandler, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          forPublicUser = _props.forPublicUser;

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, { onClick: forPublicUser(this.handleClick) });
    }
  }]);

  return CreatePostHandler;
}(_react.Component);

CreatePostHandler.propTypes = {
  children: _propTypes2.default.node.isRequired,
  categorySlug: _propTypes2.default.string.isRequired,
  push: _propTypes2.default.func.isRequired,
  forPublicUser: _propTypes2.default.func.isRequired
};


var mapDispatchToProps = {
  push: _routerUtils.push
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(undefined, mapDispatchToProps), _withAuth2.default)(CreatePostHandler);

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createPostCard = __webpack_require__(1519);

var _createPostCard2 = _interopRequireDefault(_createPostCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _createPostCard2.default;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TYPES;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _avatarImage = __webpack_require__(544);

var _avatarImage2 = _interopRequireDefault(_avatarImage);

var _currentUserAvatarImage = __webpack_require__(1520);

var _currentUserAvatarImage2 = _interopRequireDefault(_currentUserAvatarImage);

var _cardSizes = __webpack_require__(224);

var _wixParams = __webpack_require__(24);

var _icons = __webpack_require__(9);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _createPostCard = __webpack_require__(1522);

var _createPostCard2 = _interopRequireDefault(_createPostCard);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPES = (_TYPES = {}, _defineProperty(_TYPES, _cardSizes.CARD_SIZE_SMALL, 'small'), _defineProperty(_TYPES, _cardSizes.CARD_SIZE_MEDIUM, 'medium'), _defineProperty(_TYPES, _cardSizes.CARD_SIZE_LARGE, 'large'), _TYPES);

var CreatePostCard = function CreatePostCard(_ref) {
  var cardSize = _ref.cardSize,
      isAuthenticated = _ref.isAuthenticated,
      onClick = _ref.onClick,
      contentFontClassName = _ref.contentFontClassName,
      t = _ref.t;

  var type = TYPES[cardSize];
  var className = (0, _classnames2.default)(_createPostCard2.default.button, contentFontClassName, 'button-background-color', 'button-primary-text-color', 'create-post', _defineProperty({}, _createPostCard2.default[type], type));

  return _react2.default.createElement(
    'div',
    {
      className: className,
      onClick: onClick,
      tabIndex: '0',
      onKeyUp: (0, _accessibility.handleEnterAndSpaceKeyUp)(onClick),
      'data-hook': 'create-post',
      role: 'button',
      'aria-labelledby': 'create-post-label'
    },
    isAuthenticated ? _react2.default.createElement(_currentUserAvatarImage2.default, null) : _react2.default.createElement(_avatarImage2.default, null),
    _react2.default.createElement(
      'span',
      { id: 'create-post-label', className: _createPostCard2.default.text },
      t('create-post-card.create-post')
    ),
    _react2.default.createElement(_icons.EditIcon, { className: (0, _classnames2.default)(_createPostCard2.default.icon, 'button-primary-icon-fill') })
  );
};

CreatePostCard.propTypes = {
  t: _propTypes2.default.func.isRequired,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  cardSize: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  contentFontClassName: _propTypes2.default.string.isRequired
};

CreatePostCard.defaultProps = {
  cardSize: _cardSizes.CARD_SIZE_SMALL
};

exports.default = _lodash2.default.flowRight((0, _withAppSettings2.default)({ cardSize: _wixParams.CARD_SIZE_PATH }), _withAuth2.default, _withFontClassName2.default, _withTranslate2.default)(CreatePostCard);

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _currentUserAvatarImage = __webpack_require__(1521);

var _currentUserAvatarImage2 = _interopRequireDefault(_currentUserAvatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _currentUserAvatarImage2.default;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(5);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _currentUserSelectors = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: (0, _currentUserSelectors.getCurrentUser)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_userAvatarImage2.default);

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_386T_","medium":"_1jias","text":"_2S-XM","icon":"MufoH"};

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _floatingActionButton = __webpack_require__(1524);

var _floatingActionButton2 = _interopRequireDefault(_floatingActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _floatingActionButton2.default;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(122);

var _styles = __webpack_require__(1525);

var _styles2 = _interopRequireDefault(_styles);

var _reactGateway = __webpack_require__(405);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FloatingActionButton = function FloatingActionButton(_ref) {
  var button = _ref.button,
      isVisible = _ref.isVisible;

  var component = null;
  if (isVisible) {
    component = button;
  }
  return _react2.default.createElement(
    _reactGateway.Gateway,
    { into: 'floating-action-button' },
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        className: _styles2.default.button,
        transitionName: _styles2.default,
        transitionEnterTimeout: 600,
        transitionLeaveTimeout: 600
      },
      component
    )
  );
};

FloatingActionButton.propTypes = {
  button: _propTypes2.default.node.isRequired,
  isVisible: _propTypes2.default.bool
};

exports.default = FloatingActionButton;

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_3FMsQ","enter":"_367Y3","enterActive":"_1Valv","leave":"g7FDl","leaveActive":"_3tJ58"};

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _floatingCreateButton = __webpack_require__(1527);

var _floatingCreateButton2 = _interopRequireDefault(_floatingCreateButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _floatingCreateButton2.default;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withButtonColor = __webpack_require__(1303);

var _withButtonColor2 = _interopRequireDefault(_withButtonColor);

var _floatingCreateButton = __webpack_require__(1528);

var _floatingCreateButton2 = _interopRequireDefault(_floatingCreateButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FloatingCreateButton = function FloatingCreateButton(_ref) {
  var buttonColor = _ref.buttonColor,
      otherProps = _objectWithoutProperties(_ref, ['buttonColor']);

  var className = (0, _classnames2.default)(_floatingCreateButton2.default.button, 'floating-create-button', 'default-button-background-color', 'button-primary-icon-fill');
  var buttonProps = (0, _lodash.omit)(otherProps, 'forPublicUser', 'currentUser', 'isBlocked', 'isOwner', 'isPrivate', 'dispatch', 'viewMode', 'isDemoMode', 'openModal', 'isAuthenticated');

  return _react2.default.createElement('span', _extends({ className: className, style: { backgroundColor: buttonColor } }, buttonProps));
};

FloatingCreateButton.propTypes = {
  buttonColor: _propTypes2.default.string.isRequired
};

exports.default = (0, _withButtonColor2.default)(FloatingCreateButton);

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"i9V8x"};

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TYPES;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _cardSizes = __webpack_require__(224);

var _postListClassicHeader = __webpack_require__(1530);

var _postListClassicHeader2 = _interopRequireDefault(_postListClassicHeader);

var _postListItemClassic = __webpack_require__(1533);

var _postListItemClassic2 = _interopRequireDefault(_postListItemClassic);

var _createPostButton = __webpack_require__(1243);

var _createPostButton2 = _interopRequireDefault(_createPostButton);

var _separator = __webpack_require__(18);

var _pagination = __webpack_require__(1244);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _changePage = __webpack_require__(1012);

var _pagination2 = __webpack_require__(166);

var _postListClassic = __webpack_require__(1538);

var _postListClassic2 = _interopRequireDefault(_postListClassic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPES = (_TYPES = {}, _defineProperty(_TYPES, _cardSizes.CARD_SIZE_SMALL, 'small'), _defineProperty(_TYPES, _cardSizes.CARD_SIZE_MEDIUM, 'medium'), _defineProperty(_TYPES, _cardSizes.CARD_SIZE_LARGE, 'large'), _TYPES);

var PostListClassic = function (_Component) {
  _inherits(PostListClassic, _Component);

  function PostListClassic() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostListClassic);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostListClassic.__proto__ || Object.getPrototypeOf(PostListClassic)).call.apply(_ref, [this].concat(args))), _this), _this.handlePageChange = function (_ref2) {
      var page = _ref2.page,
          buttonType = _ref2.buttonType;

      _this.props.changePage({
        page: page,
        meta: {
          bi: {
            buttonType: buttonType
          }
        }
      });
      _this.props.onPageChange(page);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PostListClassic, [{
    key: 'renderCreateNewPostButton',
    value: function renderCreateNewPostButton() {
      var _props = this.props,
          category = _props.category,
          showCreatePostAction = _props.showCreatePostAction;

      return showCreatePostAction && _react2.default.createElement(
        'div',
        { className: _postListClassic2.default.buttonContainer },
        _react2.default.createElement(_createPostButton2.default, { categorySlug: category.slug })
      );
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      return _react2.default.createElement(
        'div',
        { className: _postListClassic2.default.paginationContainer },
        _react2.default.createElement(_pagination.PaginationClassic, {
          page: this.props.page,
          entityCount: this.props.entityCount,
          showPerPage: _pagination2.POSTS_PER_PAGE,
          onChange: this.handlePageChange
        })
      );
    }
  }, {
    key: 'hasControls',
    value: function hasControls() {
      var _props2 = this.props,
          entityCount = _props2.entityCount,
          showCreatePostAction = _props2.showCreatePostAction;

      var hasPages = entityCount > _pagination2.POSTS_PER_PAGE;
      return showCreatePostAction || hasPages;
    }
  }, {
    key: 'renderControls',
    value: function renderControls() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_postListClassic2.default.controls, _postListClassic2.default.spacing) },
        this.renderPagination(),
        this.renderCreateNewPostButton()
      );
    }
  }, {
    key: 'renderSeparator',
    value: function renderSeparator() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'separator';

      return _react2.default.createElement(
        'tr',
        { key: key },
        _react2.default.createElement(
          'td',
          { className: _postListClassic2.default.separatorColumn, colSpan: '100' },
          _react2.default.createElement(_separator.HorizontalSeparator, null)
        )
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _this2 = this;

      var _props3 = this.props,
          posts = _props3.posts,
          query = _props3.query,
          cardSize = _props3.cardSize,
          onLikeClick = _props3.onLikeClick;

      var type = TYPES[cardSize];
      var hasControls = this.hasControls();

      return _react2.default.createElement(
        'div',
        { className: _postListClassic2.default.spacing },
        _react2.default.createElement(
          'table',
          { className: (0, _classnames2.default)(_postListClassic2.default.table, _defineProperty({}, _postListClassic2.default.single, !hasControls)) },
          _react2.default.createElement(_postListClassicHeader2.default, null),
          _react2.default.createElement(
            'tbody',
            null,
            posts.map(function (post) {
              return [_this2.renderSeparator('separator-' + post._id), _react2.default.createElement(_postListItemClassic2.default, { key: post._id, type: type, post: post, query: query, onLikeClick: onLikeClick })];
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          isLoading = _props4.isLoading,
          cardSize = _props4.cardSize,
          borderWidth = _props4.borderWidth,
          contentFontClassName = _props4.contentFontClassName,
          isLoaded = _props4.isLoaded;

      var type = TYPES[cardSize];
      var className = (0, _classnames2.default)(_postListClassic2.default.container, _postListClassic2.default[type], 'forum-card-background-color', 'forum-card-border-color', contentFontClassName);
      var hasControls = this.hasControls();

      return _react2.default.createElement(
        'div',
        { className: className, style: { borderWidth: borderWidth }, 'data-hook': 'post-list' },
        hasControls && isLoaded && this.renderControls(),
        hasControls && _react2.default.createElement(_separator.HorizontalSeparator, null),
        isLoading ? _react2.default.createElement(_loader2.default, null) : this.renderTable(),
        hasControls && _react2.default.createElement(_separator.HorizontalSeparator, null),
        hasControls && isLoaded && this.renderControls()
      );
    }
  }]);

  return PostListClassic;
}(_react.Component);

PostListClassic.propTypes = {
  onLikeClick: _propTypes2.default.func.isRequired,
  category: _propTypes2.default.object,
  posts: _propTypes2.default.array,
  query: _propTypes2.default.string,
  cardSize: _propTypes2.default.number,
  page: _propTypes2.default.number,
  entityCount: _propTypes2.default.number,
  borderWidth: _propTypes2.default.number.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired,
  changePage: _propTypes2.default.func.isRequired,
  showCreatePostAction: _propTypes2.default.bool,
  onPageChange: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  isLoaded: _propTypes2.default.bool
};

PostListClassic.defaultProps = {
  cardSize: _cardSizes.CARD_SIZE_SMALL
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    changePage: _changePage.changePage
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(undefined, mapDispatchToProps), _withCardBorderWidth2.default, _withFontClassName2.default, _withTranslate2.default)(PostListClassic);

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postListClassicHeader = __webpack_require__(1531);

var _postListClassicHeader2 = _interopRequireDefault(_postListClassicHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postListClassicHeader2.default;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _postListClassicHeader = __webpack_require__(1532);

var _postListClassicHeader2 = _interopRequireDefault(_postListClassicHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostListClassicHeader = function PostListClassicHeader(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    'thead',
    null,
    _react2.default.createElement(
      'tr',
      { className: _postListClassicHeader2.default.row },
      _react2.default.createElement('th', { className: _postListClassicHeader2.default.avatarHeader }),
      _react2.default.createElement(
        'th',
        { className: (0, _classnames2.default)(_postListClassicHeader2.default.titleHeader, _postListClassicHeader2.default.left, 'forum-text-color') },
        t('post-list-classic.title')
      ),
      _react2.default.createElement(
        'th',
        { className: (0, _classnames2.default)(_postListClassicHeader2.default.iconHeader, _postListClassicHeader2.default.right) },
        _react2.default.createElement(_icons.ViewCountIcon, { className: 'forum-icon-fill', title: t('post-list-classic.views') })
      ),
      _react2.default.createElement(
        'th',
        { className: (0, _classnames2.default)(_postListClassicHeader2.default.iconHeader, _postListClassicHeader2.default.right) },
        _react2.default.createElement(_icons.CommentIcon, { className: 'forum-icon-stroke', title: t('post-list-classic.comments') })
      ),
      _react2.default.createElement(
        'th',
        { className: (0, _classnames2.default)(_postListClassicHeader2.default.iconHeader, _postListClassicHeader2.default.right) },
        _react2.default.createElement(_icons.LikeHollowIcon, { className: 'forum-icon-stroke', title: t('post-list-classic.likes') })
      ),
      _react2.default.createElement(
        'th',
        { className: (0, _classnames2.default)(_postListClassicHeader2.default.timeAgoHeader, _postListClassicHeader2.default.left, 'forum-text-color') },
        t('post-list-classic.recent-activity')
      ),
      _react2.default.createElement('th', { className: _postListClassicHeader2.default.moreButtonHeader })
    )
  );
};

PostListClassicHeader.propTypes = {
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(PostListClassicHeader);

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left":"E6KjL","right":"_27Dq4","row":"_3x5Bv","avatarHeader":"PDkDH","titleHeader":"_3IBpB","iconHeader":"_3QeC7","timeAgoHeader":"_3nZw1","moreButtonHeader":"_2WYlL"};

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postListItemClassic = __webpack_require__(1534);

var _postListItemClassic2 = _interopRequireDefault(_postListItemClassic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postListItemClassic2.default;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostListItemClassic = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(5);

var _icons = __webpack_require__(9);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _postTitle = __webpack_require__(970);

var _postTitle2 = _interopRequireDefault(_postTitle);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _iconTooltip = __webpack_require__(1011);

var _iconTooltip2 = _interopRequireDefault(_iconTooltip);

var _postActions = __webpack_require__(1009);

var _postActions2 = _interopRequireDefault(_postActions);

var _categoriesSelectors = __webpack_require__(35);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withTopCommentColor = __webpack_require__(276);

var _withTopCommentColor2 = _interopRequireDefault(_withTopCommentColor);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _experiments = __webpack_require__(32);

var _postListItemClassic = __webpack_require__(1535);

var _postListItemClassic2 = _interopRequireDefault(_postListItemClassic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostListItemClassic = exports.PostListItemClassic = function PostListItemClassic(_ref) {
  var type = _ref.type,
      category = _ref.category,
      post = _ref.post,
      query = _ref.query,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName,
      _ref$navigation = _ref.navigation,
      ProfileLink = _ref$navigation.ProfileLink,
      Link = _ref$navigation.Link,
      topCommentColor = _ref.topCommentColor,
      isTopCommentExperimentEnabled = _ref.isTopCommentExperimentEnabled,
      t = _ref.t;

  var className = (0, _classnames2.default)(_postListItemClassic2.default.container, 'forum-text-color', 'post-list-item', contentFontClassName);
  var owner = post.owner || {};
  var moreButtonId = 'more-button-' + post._id;
  return _react2.default.createElement(
    'tr',
    { className: className },
    _react2.default.createElement(
      'td',
      { className: _postListItemClassic2.default.avatar },
      _react2.default.createElement(
        ProfileLink,
        { className: _postListItemClassic2.default.avatarLink, user: owner },
        _react2.default.createElement(_userAvatarImage2.default, { user: owner })
      )
    ),
    _react2.default.createElement(
      'td',
      null,
      _react2.default.createElement(
        'div',
        { className: _postListItemClassic2.default.titleWrapper },
        _react2.default.createElement(
          Link,
          { className: (0, _classnames2.default)(titleFontClassName, _postListItemClassic2.default.titleLink), to: '/' + category.slug + '/' + post.slug },
          _react2.default.createElement(_postTitle2.default, {
            className: (0, _classnames2.default)(titleFontClassName, _postListItemClassic2.default.title),
            type: type,
            title: post.title,
            query: query
          })
        ),
        post.isPinned && _react2.default.createElement(_icons.PinIcon, { className: (0, _classnames2.default)(_postListItemClassic2.default.icon, 'icon-secondary-fill'), isPinned: post.isPinned }),
        post.isCommentsDisabled && _react2.default.createElement(_icons.LockIcon, { className: (0, _classnames2.default)(_postListItemClassic2.default.icon, 'icon-secondary-fill'), isLocked: post.isCommentsDisabled }),
        isTopCommentExperimentEnabled && Boolean(post.topCommentId) && _react2.default.createElement(
          _iconTooltip2.default,
          { text: t('comment.top-comment'), className: _postListItemClassic2.default.tooltip },
          _react2.default.createElement(_icons.TopCommentIcon, { color: topCommentColor })
        )
      ),
      _react2.default.createElement(
        ProfileLink,
        { className: (0, _classnames2.default)(_postListItemClassic2.default.name, 'forum-text-color'), user: owner },
        owner.name,
        ',\xA0'
      ),
      _react2.default.createElement(_timeAgo2.default, { className: _postListItemClassic2.default.timeAgo, time: post.createdDate })
    ),
    _react2.default.createElement(
      'td',
      { className: (0, _classnames2.default)(_postListItemClassic2.default.stats, _postListItemClassic2.default.count, _postListItemClassic2.default.right) },
      post.viewCount || 0
    ),
    _react2.default.createElement(
      'td',
      { className: (0, _classnames2.default)(_postListItemClassic2.default.stats, _postListItemClassic2.default.count, _postListItemClassic2.default.right) },
      post.totalComments || 0
    ),
    _react2.default.createElement(
      'td',
      { className: (0, _classnames2.default)(_postListItemClassic2.default.stats, _postListItemClassic2.default.count, _postListItemClassic2.default.right) },
      post.likeCount || 0
    ),
    _react2.default.createElement(
      'td',
      { className: (0, _classnames2.default)(_postListItemClassic2.default.stats, _postListItemClassic2.default.left, _postListItemClassic2.default.recentActivity) },
      _react2.default.createElement(_timeAgo2.default, { time: post.lastActivityDate || post.createdDate })
    ),
    _react2.default.createElement(
      'td',
      { className: (0, _classnames2.default)(_postListItemClassic2.default.more) },
      _react2.default.createElement(
        _moreButton2.default,
        { id: moreButtonId },
        _react2.default.createElement(_postActions2.default, { post: post, focusOnCloseId: moreButtonId })
      )
    )
  );
};

PostListItemClassic.propTypes = {
  t: _propTypes2.default.func,
  category: _propTypes2.default.object,
  post: _propTypes2.default.object.isRequired,
  query: _propTypes2.default.string,
  type: _propTypes2.default.string,
  titleFontClassName: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string,
  navigation: _propTypes2.default.object,
  topCommentColor: _propTypes2.default.string,
  isTopCommentExperimentEnabled: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    category: (0, _categoriesSelectors.getCategory)(state, ownProps.post.categoryId)
  };
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps), (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withFontClassName2.default, _withTopCommentColor2.default, _withTranslate2.default, (0, _withExperiment2.default)({ isTopCommentExperimentEnabled: _experiments.EXPERIMENT_TOP_COMMENT }))(PostListItemClassic);

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_13LQj","left":"_1DAAF","right":"_29sW9","avatarLink":"_1WBtw","avatar":"_25QLr","titleWrapper":"_1o9j_","titleLink":"_3mylH","title":"_1XLep","icon":"_19YSP","timeAgo":"_19YrJ","name":"_3BuB1","stats":"_2RinH","recentActivity":"_1aIzc","count":"_1TBIj","more":"_3kFU_","tooltip":"UnV9D"};

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _createPostHandler = __webpack_require__(1308);

var _createPostHandler2 = _interopRequireDefault(_createPostHandler);

var _ensureAuth = __webpack_require__(411);

var _ensureAuth2 = _interopRequireDefault(_ensureAuth);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonSecure = (0, _ensureAuth2.default)(_button2.default);

var CreatePostButton = function CreatePostButton(_ref) {
  var t = _ref.t,
      categorySlug = _ref.categorySlug;
  return _react2.default.createElement(
    _createPostHandler2.default,
    { categorySlug: categorySlug },
    _react2.default.createElement(
      ButtonSecure,
      null,
      t('create-post-button.create-new-post')
    )
  );
};

CreatePostButton.propTypes = {
  categorySlug: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(CreatePostButton);

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationClassic = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pagination = __webpack_require__(1309);

var _pagination2 = _interopRequireDefault(_pagination);

var _pagination3 = __webpack_require__(1310);

var _pagination4 = _interopRequireDefault(_pagination3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationClassic = exports.PaginationClassic = function PaginationClassic(props) {
  return _react2.default.createElement(_pagination4.default, _extends({
    className: _pagination2.default.large,
    activeClass: 'button-color',
    arrowClass: _pagination2.default.arrow,
    innerClass: _pagination2.default.inner
  }, props));
};

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Qtte","spacing":"_3eEOu","buttonContainer":"_1fm1I","icon":"_8Cbaj","controls":"_1B6lJ","table":"_23YP-","paginationContainer":"_1bf1S","separatorColumn":"_3NJhh"};

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _postListItem = __webpack_require__(524);

var _postListItem2 = _interopRequireDefault(_postListItem);

var _createPostCta = __webpack_require__(1307);

var _createPostCta2 = _interopRequireDefault(_createPostCta);

var _infiniteList = __webpack_require__(1103);

var _infiniteList2 = _interopRequireDefault(_infiniteList);

var _postList = __webpack_require__(1183);

var _postList2 = _interopRequireDefault(_postList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THRESHOLD = 400;

var itemRenderer = function itemRenderer(props) {
  return function (index) {
    // eslint-disable-next-line react/prop-types
    var category = props.category,
        posts = props.posts,
        query = props.query,
        onLikeClick = props.onLikeClick,
        showCreatePostAction = props.showCreatePostAction;


    if (showCreatePostAction && index === 0) {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_postList2.default.listItemMobile), key: 'create-post' },
        _react2.default.createElement(_createPostCta2.default, { categorySlug: category.slug })
      );
    }

    var post = posts[index - (showCreatePostAction ? 1 : 0)];
    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_postList2.default.listItemMobile, 'post-list__post-list-item'), key: post._id, id: post._id },
      _react2.default.createElement(_postListItem2.default, { post: post, query: query, onLikeClick: onLikeClick })
    );
  };
};

var PostListMobile = function PostListMobile(props) {
  return _react2.default.createElement(
    'div',
    { 'data-hook': 'post-list' },
    _react2.default.createElement(_infiniteList2.default, {
      length: props.posts.length + (props.showCreatePostAction ? 1 : 0),
      itemRenderer: itemRenderer(props) // Must pass props here otherwise it does not rerender after post change
      , threshold: THRESHOLD
    })
  );
};

PostListMobile.propTypes = {
  onLikeClick: _propTypes2.default.func.isRequired,
  category: _propTypes2.default.object,
  posts: _propTypes2.default.array,
  location: _propTypes2.default.object,
  query: _propTypes2.default.string,
  showCreatePostAction: _propTypes2.default.bool
};

exports.default = PostListMobile;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactList = __webpack_require__(1541);

var _reactList2 = _interopRequireDefault(_reactList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InfiniteList = function InfiniteList(_ref) {
  var length = _ref.length,
      itemRenderer = _ref.itemRenderer,
      otherProps = _objectWithoutProperties(_ref, ['length', 'itemRenderer']);

  return _react2.default.createElement(_reactList2.default, _extends({}, otherProps, { itemRenderer: itemRenderer, type: 'simple', length: length, useTranslate3d: true }));
};

InfiniteList.propTypes = {
  length: _propTypes2.default.number.isRequired,
  itemRenderer: _propTypes2.default.func.isRequired
};

exports.default = InfiniteList;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(0), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, require('react'), require('react-dom'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, global.React, global.ReactDOM);
    global.ReactList = mod.exports;
  }
})(this, function (_module2, _react, _reactDom) {
  'use strict';

  var _module3 = _interopRequireDefault(_module2);

  var _react2 = _interopRequireDefault(_react);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _class, _temp;

  var findDOMNode = _reactDom2.default.findDOMNode;


  var isEqualSubset = function isEqualSubset(a, b) {
    for (var key in a) {
      if (a[key] !== b[key]) return false;
    }return true;
  };

  var isEqual = function isEqual(a, b) {
    return isEqualSubset(a, b) && isEqualSubset(b, a);
  };

  var CLIENT_SIZE_KEYS = { x: 'clientWidth', y: 'clientHeight' };
  var CLIENT_START_KEYS = { x: 'clientTop', y: 'clientLeft' };
  var INNER_SIZE_KEYS = { x: 'innerWidth', y: 'innerHeight' };
  var OFFSET_SIZE_KEYS = { x: 'offsetWidth', y: 'offsetHeight' };
  var OFFSET_START_KEYS = { x: 'offsetLeft', y: 'offsetTop' };
  var OVERFLOW_KEYS = { x: 'overflowX', y: 'overflowY' };
  var SCROLL_SIZE_KEYS = { x: 'scrollWidth', y: 'scrollHeight' };
  var SCROLL_START_KEYS = { x: 'scrollLeft', y: 'scrollTop' };
  var SIZE_KEYS = { x: 'width', y: 'height' };

  var NOOP = function NOOP() {};

  // If a browser doesn't support the `options` argument to
  // add/removeEventListener, we need to check, otherwise we will
  // accidentally set `capture` with a truthy value.
  var PASSIVE = function () {
    if (typeof window === 'undefined') return false;
    var hasSupport = false;
    try {
      document.createElement('div').addEventListener('test', NOOP, {
        get passive() {
          hasSupport = true;
          return false;
        }
      });
    } catch (e) {}
    return hasSupport;
  }() ? { passive: true } : false;

  _module3.default.exports = (_temp = _class = function (_Component) {
    _inherits(ReactList, _Component);

    function ReactList(props) {
      _classCallCheck(this, ReactList);

      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReactList).call(this, props));

      var _this$props = _this.props;
      var initialIndex = _this$props.initialIndex;
      var pageSize = _this$props.pageSize;

      var itemsPerRow = 1;

      var _this$constrain = _this.constrain(initialIndex, pageSize, itemsPerRow, _this.props);

      var from = _this$constrain.from;
      var size = _this$constrain.size;

      _this.state = { from: from, size: size, itemsPerRow: itemsPerRow };
      _this.cache = {};
      return _this;
    }

    _createClass(ReactList, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(next) {
        var _state = this.state;
        var from = _state.from;
        var size = _state.size;
        var itemsPerRow = _state.itemsPerRow;

        this.setState(this.constrain(from, size, itemsPerRow, next));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.updateFrame = this.updateFrame.bind(this);
        window.addEventListener('resize', this.updateFrame);
        this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(props, state) {
        return !isEqual(props, this.props) || !isEqual(state, this.state);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.updateFrame();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.updateFrame);
        this.scrollParent.removeEventListener('scroll', this.updateFrame, PASSIVE);
        this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
      }
    }, {
      key: 'getOffset',
      value: function getOffset(el) {
        var axis = this.props.axis;

        var offset = el[CLIENT_START_KEYS[axis]] || 0;
        var offsetKey = OFFSET_START_KEYS[axis];
        do {
          offset += el[offsetKey] || 0;
        } while (el = el.offsetParent);
        return offset;
      }
    }, {
      key: 'getScrollParent',
      value: function getScrollParent() {
        var _props = this.props;
        var axis = _props.axis;
        var scrollParentGetter = _props.scrollParentGetter;

        if (scrollParentGetter) return scrollParentGetter();
        var el = findDOMNode(this);
        var overflowKey = OVERFLOW_KEYS[axis];
        while (el = el.parentElement) {
          switch (window.getComputedStyle(el)[overflowKey]) {
            case 'auto':case 'scroll':case 'overlay':
              return el;
          }
        }
        return window;
      }
    }, {
      key: 'getScroll',
      value: function getScroll() {
        var scrollParent = this.scrollParent;
        var axis = this.props.axis;

        var scrollKey = SCROLL_START_KEYS[axis];
        var actual = scrollParent === window ?
        // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
        // always return document.documentElement[scrollKey] as 0, so take
        // whichever has a value.
        document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
        var max = this.getScrollSize() - this.getViewportSize();
        var scroll = Math.max(0, Math.min(actual, max));
        var el = findDOMNode(this);
        return this.getOffset(scrollParent) + scroll - this.getOffset(el);
      }
    }, {
      key: 'setScroll',
      value: function setScroll(offset) {
        var scrollParent = this.scrollParent;
        var axis = this.props.axis;

        offset += this.getOffset(findDOMNode(this));
        if (scrollParent === window) return window.scrollTo(0, offset);

        offset -= this.getOffset(this.scrollParent);
        scrollParent[SCROLL_START_KEYS[axis]] = offset;
      }
    }, {
      key: 'getViewportSize',
      value: function getViewportSize() {
        var scrollParent = this.scrollParent;
        var axis = this.props.axis;

        return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
      }
    }, {
      key: 'getScrollSize',
      value: function getScrollSize() {
        var scrollParent = this.scrollParent;
        var _document = document;
        var body = _document.body;
        var documentElement = _document.documentElement;

        var key = SCROLL_SIZE_KEYS[this.props.axis];
        return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
      }
    }, {
      key: 'hasDeterminateSize',
      value: function hasDeterminateSize() {
        var _props2 = this.props;
        var itemSizeGetter = _props2.itemSizeGetter;
        var type = _props2.type;

        return type === 'uniform' || itemSizeGetter;
      }
    }, {
      key: 'getStartAndEnd',
      value: function getStartAndEnd() {
        var threshold = arguments.length <= 0 || arguments[0] === undefined ? this.props.threshold : arguments[0];

        var scroll = this.getScroll();
        var start = Math.max(0, scroll - threshold);
        var end = scroll + this.getViewportSize() + threshold;
        if (this.hasDeterminateSize()) {
          end = Math.min(end, this.getSpaceBefore(this.props.length));
        }
        return { start: start, end: end };
      }
    }, {
      key: 'getItemSizeAndItemsPerRow',
      value: function getItemSizeAndItemsPerRow() {
        var _props3 = this.props;
        var axis = _props3.axis;
        var useStaticSize = _props3.useStaticSize;
        var _state2 = this.state;
        var itemSize = _state2.itemSize;
        var itemsPerRow = _state2.itemsPerRow;

        if (useStaticSize && itemSize && itemsPerRow) {
          return { itemSize: itemSize, itemsPerRow: itemsPerRow };
        }

        var itemEls = findDOMNode(this.items).children;
        if (!itemEls.length) return {};

        var firstEl = itemEls[0];

        // Firefox has a problem where it will return a *slightly* (less than
        // thousandths of a pixel) different size for the same element between
        // renders. This can cause an infinite render loop, so only change the
        // itemSize when it is significantly different.
        var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
        var delta = Math.abs(firstElSize - itemSize);
        if (isNaN(delta) || delta >= 1) itemSize = firstElSize;

        if (!itemSize) return {};

        var startKey = OFFSET_START_KEYS[axis];
        var firstStart = firstEl[startKey];
        itemsPerRow = 1;
        for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
          ++itemsPerRow;
        }return { itemSize: itemSize, itemsPerRow: itemsPerRow };
      }
    }, {
      key: 'updateFrame',
      value: function updateFrame(cb) {
        this.updateScrollParent();
        if (typeof cb != 'function') cb = NOOP;
        switch (this.props.type) {
          case 'simple':
            return this.updateSimpleFrame(cb);
          case 'variable':
            return this.updateVariableFrame(cb);
          case 'uniform':
            return this.updateUniformFrame(cb);
        }
      }
    }, {
      key: 'updateScrollParent',
      value: function updateScrollParent() {
        var prev = this.scrollParent;
        this.scrollParent = this.getScrollParent();
        if (prev === this.scrollParent) return;
        if (prev) {
          prev.removeEventListener('scroll', this.updateFrame);
          prev.removeEventListener('mousewheel', NOOP);
        }
        this.scrollParent.addEventListener('scroll', this.updateFrame, PASSIVE);
        this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
      }
    }, {
      key: 'updateSimpleFrame',
      value: function updateSimpleFrame(cb) {
        var _getStartAndEnd = this.getStartAndEnd();

        var end = _getStartAndEnd.end;

        var itemEls = findDOMNode(this.items).children;
        var elEnd = 0;

        if (itemEls.length) {
          var axis = this.props.axis;

          var firstItemEl = itemEls[0];
          var lastItemEl = itemEls[itemEls.length - 1];
          elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
        }

        if (elEnd > end) return cb();

        var _props4 = this.props;
        var pageSize = _props4.pageSize;
        var length = _props4.length;

        this.setState({ size: Math.min(this.state.size + pageSize, length) }, cb);
      }
    }, {
      key: 'updateVariableFrame',
      value: function updateVariableFrame(cb) {
        if (!this.props.itemSizeGetter) this.cacheSizes();

        var _getStartAndEnd2 = this.getStartAndEnd();

        var start = _getStartAndEnd2.start;
        var end = _getStartAndEnd2.end;
        var _props5 = this.props;
        var length = _props5.length;
        var pageSize = _props5.pageSize;

        var space = 0;
        var from = 0;
        var size = 0;
        var maxFrom = length - 1;

        while (from < maxFrom) {
          var itemSize = this.getSizeOf(from);
          if (itemSize == null || space + itemSize > start) break;
          space += itemSize;
          ++from;
        }

        var maxSize = length - from;

        while (size < maxSize && space < end) {
          var _itemSize = this.getSizeOf(from + size);
          if (_itemSize == null) {
            size = Math.min(size + pageSize, maxSize);
            break;
          }
          space += _itemSize;
          ++size;
        }

        this.setState({ from: from, size: size }, cb);
      }
    }, {
      key: 'updateUniformFrame',
      value: function updateUniformFrame(cb) {
        var _getItemSizeAndItemsP = this.getItemSizeAndItemsPerRow();

        var itemSize = _getItemSizeAndItemsP.itemSize;
        var itemsPerRow = _getItemSizeAndItemsP.itemsPerRow;


        if (!itemSize || !itemsPerRow) return cb();

        var _getStartAndEnd3 = this.getStartAndEnd();

        var start = _getStartAndEnd3.start;
        var end = _getStartAndEnd3.end;

        var _constrain = this.constrain(Math.floor(start / itemSize) * itemsPerRow, (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow, itemsPerRow, this.props);

        var from = _constrain.from;
        var size = _constrain.size;


        return this.setState({ itemsPerRow: itemsPerRow, from: from, itemSize: itemSize, size: size }, cb);
      }
    }, {
      key: 'getSpaceBefore',
      value: function getSpaceBefore(index) {
        var cache = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        if (cache[index] != null) return cache[index];

        // Try the static itemSize.
        var _state3 = this.state;
        var itemSize = _state3.itemSize;
        var itemsPerRow = _state3.itemsPerRow;

        if (itemSize) {
          return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
        }

        // Find the closest space to index there is a cached value for.
        var from = index;
        while (from > 0 && cache[--from] == null) {}

        // Finally, accumulate sizes of items from - index.
        var space = cache[from] || 0;
        for (var i = from; i < index; ++i) {
          cache[i] = space;
          var _itemSize2 = this.getSizeOf(i);
          if (_itemSize2 == null) break;
          space += _itemSize2;
        }

        return cache[index] = space;
      }
    }, {
      key: 'cacheSizes',
      value: function cacheSizes() {
        var cache = this.cache;
        var from = this.state.from;

        var itemEls = findDOMNode(this.items).children;
        var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
        for (var i = 0, l = itemEls.length; i < l; ++i) {
          cache[from + i] = itemEls[i][sizeKey];
        }
      }
    }, {
      key: 'getSizeOf',
      value: function getSizeOf(index) {
        var cache = this.cache;
        var items = this.items;
        var _props6 = this.props;
        var axis = _props6.axis;
        var itemSizeGetter = _props6.itemSizeGetter;
        var itemSizeEstimator = _props6.itemSizeEstimator;
        var type = _props6.type;
        var _state4 = this.state;
        var from = _state4.from;
        var itemSize = _state4.itemSize;
        var size = _state4.size;


        // Try the static itemSize.
        if (itemSize) return itemSize;

        // Try the itemSizeGetter.
        if (itemSizeGetter) return itemSizeGetter(index);

        // Try the cache.
        if (index in cache) return cache[index];

        // Try the DOM.
        if (type === 'simple' && index >= from && index < from + size && items) {
          var itemEl = findDOMNode(items).children[index - from];
          if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
        }

        // Try the itemSizeEstimator.
        if (itemSizeEstimator) return itemSizeEstimator(index, cache);
      }
    }, {
      key: 'constrain',
      value: function constrain(from, size, itemsPerRow, _ref) {
        var length = _ref.length;
        var pageSize = _ref.pageSize;
        var type = _ref.type;

        size = Math.max(size, pageSize);
        var mod = size % itemsPerRow;
        if (mod) size += itemsPerRow - mod;
        if (size > length) size = length;
        from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);

        if (mod = from % itemsPerRow) {
          from -= mod;
          size += mod;
        }

        return { from: from, size: size };
      }
    }, {
      key: 'scrollTo',
      value: function scrollTo(index) {
        if (index != null) this.setScroll(this.getSpaceBefore(index));
      }
    }, {
      key: 'scrollAround',
      value: function scrollAround(index) {
        var current = this.getScroll();
        var bottom = this.getSpaceBefore(index);
        var top = bottom - this.getViewportSize() + this.getSizeOf(index);
        var min = Math.min(top, bottom);
        var max = Math.max(top, bottom);
        if (current <= min) return this.setScroll(min);
        if (current > max) return this.setScroll(max);
      }
    }, {
      key: 'getVisibleRange',
      value: function getVisibleRange() {
        var _state5 = this.state;
        var from = _state5.from;
        var size = _state5.size;

        var _getStartAndEnd4 = this.getStartAndEnd(0);

        var start = _getStartAndEnd4.start;
        var end = _getStartAndEnd4.end;

        var cache = {};
        var first = void 0,
            last = void 0;
        for (var i = from; i < from + size; ++i) {
          var itemStart = this.getSpaceBefore(i, cache);
          var itemEnd = itemStart + this.getSizeOf(i);
          if (first == null && itemEnd > start) first = i;
          if (first != null && itemStart < end) last = i;
        }
        return [first, last];
      }
    }, {
      key: 'renderItems',
      value: function renderItems() {
        var _this2 = this;

        var _props7 = this.props;
        var itemRenderer = _props7.itemRenderer;
        var itemsRenderer = _props7.itemsRenderer;
        var _state6 = this.state;
        var from = _state6.from;
        var size = _state6.size;

        var items = [];
        for (var i = 0; i < size; ++i) {
          items.push(itemRenderer(from + i, i));
        }return itemsRenderer(items, function (c) {
          return _this2.items = c;
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props8 = this.props;
        var axis = _props8.axis;
        var length = _props8.length;
        var type = _props8.type;
        var useTranslate3d = _props8.useTranslate3d;
        var _state7 = this.state;
        var from = _state7.from;
        var itemsPerRow = _state7.itemsPerRow;


        var items = this.renderItems();
        if (type === 'simple') return items;

        var style = { position: 'relative' };
        var cache = {};
        var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
        var size = this.getSpaceBefore(bottom, cache);
        if (size) {
          style[SIZE_KEYS[axis]] = size;
          if (axis === 'x') style.overflowX = 'hidden';
        }
        var offset = this.getSpaceBefore(from, cache);
        var x = axis === 'x' ? offset : 0;
        var y = axis === 'y' ? offset : 0;
        var transform = useTranslate3d ? 'translate3d(' + x + 'px, ' + y + 'px, 0)' : 'translate(' + x + 'px, ' + y + 'px)';
        var listStyle = {
          msTransform: transform,
          WebkitTransform: transform,
          transform: transform
        };
        return _react2.default.createElement(
          'div',
          { style: style },
          _react2.default.createElement(
            'div',
            { style: listStyle },
            items
          )
        );
      }
    }]);

    return ReactList;
  }(_react.Component), _class.displayName = 'ReactList', _class.propTypes = {
    axis: _react.PropTypes.oneOf(['x', 'y']),
    initialIndex: _react.PropTypes.number,
    itemRenderer: _react.PropTypes.func,
    itemSizeEstimator: _react.PropTypes.func,
    itemSizeGetter: _react.PropTypes.func,
    itemsRenderer: _react.PropTypes.func,
    length: _react.PropTypes.number,
    pageSize: _react.PropTypes.number,
    scrollParentGetter: _react.PropTypes.func,
    threshold: _react.PropTypes.number,
    type: _react.PropTypes.oneOf(['simple', 'variable', 'uniform']),
    useStaticSize: _react.PropTypes.bool,
    useTranslate3d: _react.PropTypes.bool
  }, _class.defaultProps = {
    axis: 'y',
    itemRenderer: function itemRenderer(index, key) {
      return _react2.default.createElement(
        'div',
        { key: key },
        index
      );
    },
    itemsRenderer: function itemsRenderer(items, ref) {
      return _react2.default.createElement(
        'div',
        { ref: ref },
        items
      );
    },
    length: 0,
    pageSize: 10,
    threshold: 100,
    type: 'simple',
    useStaticSize: false,
    useTranslate3d: false
  }, _temp);
});


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _paginationRegular = __webpack_require__(1311);

var _paginationRegular2 = _interopRequireDefault(_paginationRegular);

var _createPostButton = __webpack_require__(1243);

var _createPostButton2 = _interopRequireDefault(_createPostButton);

var _postListItem = __webpack_require__(524);

var _postListItem2 = _interopRequireDefault(_postListItem);

var _changePage = __webpack_require__(1012);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _pagination = __webpack_require__(166);

var _postList = __webpack_require__(1183);

var _postList2 = _interopRequireDefault(_postList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostListLarge = function (_Component) {
  _inherits(PostListLarge, _Component);

  function PostListLarge(props) {
    _classCallCheck(this, PostListLarge);

    var _this = _possibleConstructorReturn(this, (PostListLarge.__proto__ || Object.getPrototypeOf(PostListLarge)).call(this, props));

    _this.handlePageChange = function (_ref) {
      var page = _ref.page,
          buttonType = _ref.buttonType;

      _this.props.onPageChange(page);
      _this.props.changePage({
        page: page,
        meta: {
          bi: {
            buttonType: buttonType
          }
        }
      });
    };

    _this.renderPosts = function () {
      return _this.props.posts.map(function (post) {
        return _react2.default.createElement(
          'div',
          { key: post._id, className: _postList2.default.listItem },
          _react2.default.createElement(_postListItem2.default, { type: _postListItem2.default.LARGE, post: post, onLikeClick: _this.props.onLikeClick })
        );
      });
    };

    _this.handlePageChange = _this.handlePageChange.bind(_this);
    return _this;
  }

  _createClass(PostListLarge, [{
    key: 'renderHeader',
    value: function renderHeader() {
      var _props = this.props,
          category = _props.category,
          showCreatePostAction = _props.showCreatePostAction,
          entityCount = _props.entityCount,
          page = _props.page;


      if (!showCreatePostAction && entityCount <= _pagination.POSTS_PER_PAGE) {
        return _react2.default.createElement('div', { className: _postList2.default.largeHeader });
      }

      return _react2.default.createElement(
        'div',
        { className: _postList2.default.largeHeader },
        _react2.default.createElement(
          'div',
          { className: _postList2.default.left },
          _react2.default.createElement(_paginationRegular2.default, {
            page: page,
            entityCount: entityCount,
            showPerPage: _pagination.POSTS_PER_PAGE,
            onChange: this.handlePageChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: _postList2.default.right },
          showCreatePostAction && _react2.default.createElement(_createPostButton2.default, { categorySlug: category.slug })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isLoading = _props2.isLoading,
          isLoaded = _props2.isLoaded;

      return _react2.default.createElement(
        'div',
        { className: _postList2.default.large },
        isLoaded && this.renderHeader(),
        isLoading ? _react2.default.createElement(_loader2.default, null) : this.renderPosts()
      );
    }
  }]);

  return PostListLarge;
}(_react.Component);

PostListLarge.propTypes = {
  category: _propTypes2.default.object,
  page: _propTypes2.default.number,
  entityCount: _propTypes2.default.number,
  posts: _propTypes2.default.array.isRequired,
  onLikeClick: _propTypes2.default.func,
  showCreatePostAction: _propTypes2.default.bool,
  onPageChange: _propTypes2.default.func.isRequired,
  changePage: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  isLoaded: _propTypes2.default.bool
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    changePage: _changePage.changePage
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(PostListLarge);

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _pagination = __webpack_require__(1244);

var _pagination2 = _interopRequireDefault(_pagination);

var _paginationRegular = __webpack_require__(1544);

var _paginationRegular2 = _interopRequireDefault(_paginationRegular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationRegular = function PaginationRegular(props) {
  return _react2.default.createElement(_pagination2.default, _extends({
    className: _paginationRegular2.default.container,
    arrowClass: _paginationRegular2.default.arrow,
    innerClass: _paginationRegular2.default.page,
    activeClass: (0, _classnames2.default)(_paginationRegular2.default.active, 'button-color')
  }, props));
};

exports.default = PaginationRegular;

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"XvkJi","arrow":"sT67e","page":"_325wI","active":"_1Jknx"};

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollListener = __webpack_require__(323);

var _scrollListener2 = _interopRequireDefault(_scrollListener);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadMore = function (_Component) {
  _inherits(LoadMore, _Component);

  function LoadMore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoadMore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoadMore.__proto__ || Object.getPrototypeOf(LoadMore)).call.apply(_ref, [this].concat(args))), _this), _this.shouldLoadMore = function (position) {
      var end = (0, _scrollParent2.default)().scrollHeight;
      return position > end && _this.props.hasMore && !_this.props.isLoading;
    }, _this.handleScroll = function (scroll) {
      var position = scroll.scrollTop + scroll.documentHeight + _this.props.threshold;
      if (_this.shouldLoadMore(position)) {
        _this.loadMore();
      }
    }, _this.loadMore = function () {
      _this.props.loadMore(_this.page);
      _this.page++;
    }, _this.componentDidMount = function () {
      _this.page = _this.props.pageStart;
    }, _this.render = function () {
      var _this$props = _this.props,
          Element = _this$props.element,
          children = _this$props.children,
          loader = _this$props.loader,
          hasMore = _this$props.hasMore,
          props = _objectWithoutProperties(_this$props, ['element', 'children', 'loader', 'hasMore']);

      var passProps = _lodash2.default.omit(props, ['scroll', 'loadMore', 'isLoading', 'pageStart', 'threshold', 'dispatch']);

      return _react2.default.createElement(
        Element,
        passProps,
        children,
        hasMore && loader,
        _react2.default.createElement(_scrollListener2.default, { onScroll: _this.handleScroll })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LoadMore;
}(_react.Component);

LoadMore.propTypes = {
  element: _propTypes2.default.string,
  children: _propTypes2.default.node,
  loader: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  loadMore: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  pageStart: _propTypes2.default.number,
  threshold: _propTypes2.default.number
};

LoadMore.defaultProps = {
  element: 'div',
  hasMore: false,
  pageStart: 2,
  threshold: 500
};

exports.default = LoadMore;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _restriction = __webpack_require__(1547);

var _restriction2 = _interopRequireDefault(_restriction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _restriction2.default;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _loginButton = __webpack_require__(521);

var _loginButton2 = _interopRequireDefault(_loginButton);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _restriction = __webpack_require__(1548);

var _restriction2 = _interopRequireDefault(_restriction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Restriction = function Restriction(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    _emptyStates2.default,
    {
      className: (0, _classnames2.default)(_restriction2.default.emptyStates, 'restriction'),
      title: t('restriction.title'),
      content: t('restriction.content')
    },
    _react2.default.createElement(_loginButton2.default, null)
  );
};

Restriction.propTypes = {
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(Restriction);

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3X7Ri","emptyStates":"_2Coyi"};

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _restrictionPrivateMember = __webpack_require__(1550);

var _restrictionPrivateMember2 = _interopRequireDefault(_restrictionPrivateMember);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _restrictionPrivateMember2.default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(2);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _restrictionPrivateMember = __webpack_require__(1551);

var _restrictionPrivateMember2 = _interopRequireDefault(_restrictionPrivateMember);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _joinCommunityPopupService = __webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestrictionPrivateMember = function RestrictionPrivateMember(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    _emptyStates2.default,
    {
      className: (0, _classnames2.default)(_restrictionPrivateMember2.default.emptyStates, 'restriction'),
      title: t('restriction-private-member.title'),
      content: t('restriction-private-member.content')
    },
    _react2.default.createElement(
      _button2.default,
      { className: (0, _classnames2.default)('login-button'), onClick: _joinCommunityPopupService.showJoinCommunityPopup },
      t('restriction-private-member.button')
    )
  );
};

RestrictionPrivateMember.propTypes = {
  t: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)(_withTranslate2.default)(RestrictionPrivateMember);

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_5UfNq","emptyStates":"jYMLO"};

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NotFound = function NotFound(_ref) {
  var t = _ref.t,
      props = _objectWithoutProperties(_ref, ['t']);

  return _react2.default.createElement(
    _emptyStates2.default,
    _extends({ title: t('not-found.nothings-showing-up'), content: t('not-found.head-back') }, props),
    _react2.default.createElement(
      _button2.default,
      { component: _internalLink2.default, to: '/' },
      t('not-found.back')
    )
  );
};

NotFound.propTypes = {
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(NotFound);

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _noPosts = __webpack_require__(1554);

var _noPosts2 = _interopRequireDefault(_noPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _noPosts2.default;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _createPostButton = __webpack_require__(1243);

var _createPostButton2 = _interopRequireDefault(_createPostButton);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NoPosts = function NoPosts(_ref) {
  var category = _ref.category,
      showCreatePostAction = _ref.showCreatePostAction,
      t = _ref.t,
      props = _objectWithoutProperties(_ref, ['category', 'showCreatePostAction', 't']);

  return _react2.default.createElement(
    _emptyStates2.default,
    _extends({ title: t('category-page.no-posts-yet'), content: t('category-page.create-new-post') }, props),
    showCreatePostAction && _react2.default.createElement(_createPostButton2.default, { categorySlug: category.slug })
  );
};

NoPosts.propTypes = {
  category: _propTypes2.default.object,
  showCreatePostAction: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var category = _ref2.category,
      canSee = _ref2.canSee;
  return {
    showCreatePostAction: category && (!category.isWriteProtected || canSee('create-post', 'category', category))
  };
};

exports.default = _lodash2.default.flowRight(_withPermissions2.default, (0, _reactRedux.connect)(mapStateToProps), _withTranslate2.default)(NoPosts);

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _newPostMessageRoot = __webpack_require__(1556);

var _newPostMessageRoot2 = _interopRequireDefault(_newPostMessageRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _newPostMessageRoot2.default;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewPostMessageRoot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactTransitionGroup = __webpack_require__(122);

var _newPostMessage = __webpack_require__(1557);

var _newPostMessage2 = _interopRequireDefault(_newPostMessage);

var _hideNewPostMessage = __webpack_require__(1099);

var _currentUserSelectors = __webpack_require__(67);

var _postSelectors = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEBOUNCE_TIME = 4000;
var ANIMATION_TIMEOUT = 200;

var NewPostMessageRoot = exports.NewPostMessageRoot = function (_Component) {
  _inherits(NewPostMessageRoot, _Component);

  function NewPostMessageRoot() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewPostMessageRoot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewPostMessageRoot.__proto__ || Object.getPrototypeOf(NewPostMessageRoot)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isMessageVisible: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewPostMessageRoot, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var postId = _ref2.postId,
          post = _ref2.post;

      if (this.props.postId !== postId && postId) {
        var isMessageVisible = !this.isInViewport(postId) && !this.isOwnPost(post);
        if (isMessageVisible) {
          this.props.hideNewPostMessageDebounced(DEBOUNCE_TIME);
        } else {
          this.props.hideNewPostMessage();
        }

        this.setState({ isMessageVisible: isMessageVisible });
      } else if (!postId) {
        this.setState({
          isMessageVisible: false
        });
      }
    }
  }, {
    key: 'isInViewport',
    value: function isInViewport(postId) {
      var header = this.props.header;

      var postElement = document.getElementById(postId);
      var headerOffset = header.offset + header.height;
      var postRect = postElement.getBoundingClientRect();

      return postRect.top >= headerOffset && postRect.top < window.innerHeight;
    }
  }, {
    key: 'isOwnPost',
    value: function isOwnPost(post) {
      return post.ownerId === this.props.currentUserId;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          postId = _props.postId,
          pathname = _props.pathname,
          hideNewPostMessage = _props.hideNewPostMessage;
      var isMessageVisible = this.state.isMessageVisible;

      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransitionGroup,
        {
          component: 'div',
          transitionName: 'message',
          transitionEnterTimeout: ANIMATION_TIMEOUT,
          transitionLeaveTimeout: ANIMATION_TIMEOUT
        },
        isMessageVisible ? _react2.default.createElement(_newPostMessage2.default, { postId: postId, pathname: pathname, onClick: hideNewPostMessage }) : null
      );
    }
  }]);

  return NewPostMessageRoot;
}(_react.Component);

NewPostMessageRoot.propTypes = {
  postId: _propTypes2.default.string,
  currentUserId: _propTypes2.default.string,
  post: _propTypes2.default.object,
  header: _propTypes2.default.object.isRequired,
  hideNewPostMessage: _propTypes2.default.func.isRequired,
  hideNewPostMessageDebounced: _propTypes2.default.func.isRequired,
  pathname: _propTypes2.default.string.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    header: state.header,
    postId: state.newPostMessage,
    post: (0, _postSelectors.getPost)(state, state.newPostMessage),
    currentUserId: (0, _currentUserSelectors.getCurrentUserId)(state)
  };
};

var mapDispatchToProps = {
  hideNewPostMessage: _hideNewPostMessage.hideNewPostMessage,
  hideNewPostMessageDebounced: _hideNewPostMessage.hideNewPostMessageDebounced
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewPostMessageRoot);

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _newPostMessage = __webpack_require__(1558);

var _newPostMessage2 = _interopRequireDefault(_newPostMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _newPostMessage2.default;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _getColors = __webpack_require__(265);

var _hideNewPostMessage = __webpack_require__(1099);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _newPostMessage = __webpack_require__(1559);

var _newPostMessage2 = _interopRequireDefault(_newPostMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewPostMessage = function (_Component) {
  _inherits(NewPostMessage, _Component);

  function NewPostMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewPostMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewPostMessage.__proto__ || Object.getPrototypeOf(NewPostMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewPostMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          header = _props.header,
          pathname = _props.pathname,
          onClick = _props.onClick,
          t = _props.t;

      var transform = 'translate3d(0, ' + (header.offset + header.height + 10 || 0) + 'px, 0)';
      var style = {
        transform: transform,
        backgroundColor: (0, _getColors.getSecondaryColor)()
      };

      var to = pathname + '#' + this.props.postId;
      return _react2.default.createElement(
        _internalLink2.default,
        { to: to, className: _newPostMessage2.default.container, style: style, onClick: onClick },
        t('new-post-message.new-posts')
      );
    }
  }]);

  return NewPostMessage;
}(_react.Component);

NewPostMessage.propTypes = {
  header: _propTypes2.default.object.isRequired,
  postId: _propTypes2.default.string.isRequired,
  pathname: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    header: state.header
  };
};

var mapDispatchToProps = {
  hideNewPostMessage: _hideNewPostMessage.hideNewPostMessage
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default)(NewPostMessage);

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"wF13a"};

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = outerHeight;
function outerHeight(element) {
  var height = element.offsetHeight;
  var style = getComputedStyle(element);
  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  return height;
}

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _categoryPageHeader = __webpack_require__(1562);

var _categoryPageHeader2 = _interopRequireDefault(_categoryPageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _categoryPageHeader2.default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

var _headerTitle = __webpack_require__(1302);

var _headerTitle2 = _interopRequireDefault(_headerTitle);

var _categoriesSelectors = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryPageHeader = function CategoryPageHeader(_ref) {
  var categories = _ref.categories,
      menu = _ref.menu;

  if (categories.length) {
    return categories.length === 1 ? _react2.default.createElement(_header2.default, null) : _react2.default.createElement(_header2.default, { left: _react2.default.createElement(_headerTitle2.default, { to: '/' }), menu: menu });
  }
};

CategoryPageHeader.propTypes = {
  categories: _propTypes2.default.array,
  menu: _propTypes2.default.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    categories: (0, _categoriesSelectors.getCategories)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CategoryPageHeader);

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentEditPage = __webpack_require__(1564);

var _commentEditPage2 = _interopRequireDefault(_commentEditPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentEditPage2.default;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentEditPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _updateComment = __webpack_require__(446);

var _goBack = __webpack_require__(1184);

var _goBack2 = _interopRequireDefault(_goBack);

var _fetchPostAndRedirect = __webpack_require__(1245);

var _redirectTo = __webpack_require__(1007);

var _fetchComment = __webpack_require__(313);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _postPageLayout = __webpack_require__(1185);

var _postPageLayout2 = _interopRequireDefault(_postPageLayout);

var _commentForm = __webpack_require__(1246);

var _commentForm2 = _interopRequireDefault(_commentForm);

var _commentFormWrapper = __webpack_require__(1247);

var _commentFormWrapper2 = _interopRequireDefault(_commentFormWrapper);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _postSelectors = __webpack_require__(117);

var _commentSelectors = __webpack_require__(1248);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentEditPage = exports.CommentEditPage = function (_Component) {
  _inherits(CommentEditPage, _Component);

  function CommentEditPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentEditPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentEditPage.__proto__ || Object.getPrototypeOf(CommentEditPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var _this$props = _this.props,
          comment = _this$props.comment,
          updateComment = _this$props.updateComment,
          showMessage = _this$props.showMessage,
          goBack = _this$props.goBack;

      updateComment(_extends({}, comment, values)).then(function () {
        return showMessage(_messages2.default[_messages.COMMENT_UPDATE].content(), _messages2.default[_messages.COMMENT_UPDATE].type);
      }).then(goBack);
    }, _this.render = function () {
      var _this$props2 = _this.props,
          comment = _this$props2.comment,
          goBack = _this$props2.goBack;


      return _react2.default.createElement(
        _postPageLayout2.default,
        { className: 'comment-edit-page' },
        _react2.default.createElement(
          _commentFormWrapper2.default,
          null,
          _react2.default.createElement(_commentForm2.default, { initialValues: comment, onSubmit: _this.handleSubmit, onCancel: goBack })
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CommentEditPage;
}(_react.Component);

CommentEditPage.fetchData = function (_ref3) {
  var store = _ref3.store,
      _ref3$params = _ref3.params,
      categorySlug = _ref3$params.categorySlug,
      postSlug = _ref3$params.postSlug,
      commentId = _ref3$params.commentId,
      search = _ref3.search;
  return store.dispatch((0, _fetchPostAndRedirect.fetchPostAndRedirect)(categorySlug, postSlug, search)).then(function (post) {
    return store.dispatch((0, _fetchComment.fetchComment)({
      postId: post._id,
      commentId: commentId
    }));
  }).catch(function (error) {
    if (error.status === 401) {
      return store.dispatch((0, _routerUtils.push)({
        pathname: '/login' + search + '&redirect=/' + categorySlug + '/' + postSlug
      }));
    } else {
      return store.dispatch((0, _redirectTo.redirectTo404)(search));
    }
  });
};

CommentEditPage.propTypes = {
  comment: _propTypes2.default.object.isRequired,
  goBack: _propTypes2.default.func.isRequired,
  showMessage: _propTypes2.default.func.isRequired,
  updateComment: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var _ref2$params = _ref2.params,
      postSlug = _ref2$params.postSlug,
      commentId = _ref2$params.commentId;

  var post = (0, _postSelectors.getPostBySlug)(state, postSlug);
  return {
    comment: (0, _commentSelectors.getComment)(state, commentId, post._id)
  };
};

var mapDispatchToProps = {
  goBack: _goBack2.default,
  updateComment: _updateComment.updateComment
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }))(CommentEditPage);

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

var _postPageLayout = __webpack_require__(1566);

var _postPageLayout2 = _interopRequireDefault(_postPageLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PostPageLayoutMobile = function PostPageLayoutMobile(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    _page2.default,
    _extends({ noSpacing: true }, otherProps),
    children
  );
};

PostPageLayoutMobile.propTypes = {
  children: _propTypes2.default.node
};

var PostPageLayoutDesktop = function PostPageLayoutDesktop(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, ['children', 'className']);

  return _react2.default.createElement(
    _page2.default,
    _extends({ className: (0, _classnames2.default)(_postPageLayout2.default.container, className) }, otherProps),
    children
  );
};

PostPageLayoutDesktop.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.default = (0, _forDevice2.default)(PostPageLayoutMobile, PostPageLayoutDesktop);

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3L3UZ"};

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(34);

var _redux = __webpack_require__(6);

var _reduxForm = __webpack_require__(40);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _mapProps = __webpack_require__(518);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _currentUserAvatar = __webpack_require__(543);

var _currentUserAvatar2 = _interopRequireDefault(_currentUserAvatar);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _styledTextEditor = __webpack_require__(292);

var _currentUserProfileLink = __webpack_require__(546);

var _currentUserProfileLink2 = _interopRequireDefault(_currentUserProfileLink);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _commentFormSettings = __webpack_require__(1314);

var _commentFormSettings2 = _interopRequireDefault(_commentFormSettings);

var _commentForm = __webpack_require__(1568);

var _commentForm2 = _interopRequireDefault(_commentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentForm = exports.CommentForm = function (_Component) {
  _inherits(CommentForm, _Component);

  function CommentForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentForm.__proto__ || Object.getPrototypeOf(CommentForm)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillReceiveProps = function (_ref2) {
      var submitting = _ref2.submitting,
          handleSubmit = _ref2.handleSubmit;

      if (submitting && !_this.props.submitting) {
        handleSubmit();
      }
    }, _this.handleContentChange = function (contentState) {
      _this.props.fields.content.onChange(contentState);

      var blocks = contentState.blocks;
      if (blocks[0].text || blocks.length > 1) {
        _lodash2.default.invoke(_this.props, 'onChange');
      }
    }, _this.renderEditDate = function () {
      var editedDate = _this.props.editedDate;


      if (!editedDate) {
        return null;
      }

      return _react2.default.createElement(
        'p',
        { className: _commentForm2.default.editDate },
        _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'comment-form.edited', timeAgo: _react2.default.createElement(_timeAgo2.default, { time: editedDate }) })
      );
    }, _this.renderButtons = function () {
      var _this$props = _this.props,
          submitting = _this$props.submitting,
          invalid = _this$props.invalid,
          submit = _this$props.submit,
          t = _this$props.t,
          onCancel = _this$props.onCancel,
          shouldDisableButton = _this$props.shouldDisableButton,
          forPublicUser = _this$props.forPublicUser;

      var primaryButtonProps = {
        disabled: shouldDisableButton ? submitting || invalid : false,
        onClick: forPublicUser(submit)
      };
      return _react2.default.createElement(_buttonGroup2.default, {
        primaryButtonText: t('comment-form.publish'),
        primaryButtonProps: primaryButtonProps,
        secondaryButtonText: t('comment-form.cancel'),
        secondaryButtonProps: { onClick: onCancel },
        isSecondaryButtonVisible: Boolean(onCancel)
      });
    }, _this.render = function () {
      var _this$props2 = _this.props,
          content = _this$props2.fields.content,
          autoFocus = _this$props2.autoFocus,
          t = _this$props2.t,
          formName = _this$props2.formName,
          contentFontClassName = _this$props2.contentFontClassName;

      var containerClassName = (0, _classnames2.default)(_commentForm2.default.commentForm, contentFontClassName, 'forum-text-color', 'comment-form');
      return _react2.default.createElement(
        'div',
        { className: containerClassName, 'data-hook': 'comment-form' },
        _react2.default.createElement(
          'div',
          { className: _commentForm2.default.header },
          _react2.default.createElement(
            _currentUserProfileLink2.default,
            null,
            _react2.default.createElement(_currentUserAvatar2.default, { type: _currentUserAvatar2.default.LARGE })
          )
        ),
        _this.renderEditDate(),
        _react2.default.createElement(
          'div',
          { className: _commentForm2.default.content },
          _react2.default.createElement(_styledTextEditor.TextEditor, _extends({
            className: (0, _classnames2.default)(_commentForm2.default.texteditor, 'comment-form__content'),
            identifier: formName,
            type: 'comment',
            placeholder: t('text-editor.comment-placeholder'),
            autoFocus: autoFocus
          }, content, {
            onChange: _this.handleContentChange
          }))
        ),
        _react2.default.createElement(
          'div',
          { className: _commentForm2.default.buttonContainer },
          _react2.default.createElement(
            'div',
            { className: _commentForm2.default.editorControlsWrapper },
            _react2.default.createElement(_styledTextEditor.TextEditorMediaButtons, { identifier: formName })
          ),
          _this.renderButtons()
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CommentForm;
}(_react.Component);

CommentForm.propTypes = {
  onChange: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func.isRequired,
  submit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func,
  fields: _propTypes2.default.object.isRequired,
  submitting: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  invalid: _propTypes2.default.bool,
  contentFontClassName: _propTypes2.default.string.isRequired,
  formName: _propTypes2.default.string.isRequired,
  shouldDisableButton: _propTypes2.default.bool,
  editedDate: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  forPublicUser: _propTypes2.default.func
};

CommentForm.defaultProps = {
  shouldDisableButton: true
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    submit: function submit() {
      return (0, _reduxForm.startSubmit)(ownProps.formName);
    }
  }, dispatch);
};

var mapper = function mapper(props) {
  return _extends({}, props, {
    formName: props.form || 'comment'
  });
};

exports.default = _lodash2.default.flowRight((0, _mapProps2.default)(mapper), // this HOC must go before the reduxForm
(0, _reduxForm.reduxForm)(_commentFormSettings2.default, undefined, mapDispatchToProps), _withTranslate2.default, _withFontClassName2.default, _withAuth2.default)(CommentForm);

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"commentForm":"mvL-i","header":"_1B4Iy","content":"_2s-_j","editDate":"_2Dnkq","buttonContainer":"Ui2vj","editorControlsWrapper":"_1KRCs"};

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _commentFormWrapper = __webpack_require__(1570);

var _commentFormWrapper2 = _interopRequireDefault(_commentFormWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentFormWrapper = function CommentFormWrapper(_ref) {
  var children = _ref.children,
      borderWidth = _ref.borderWidth;

  var containerClassName = (0, _classnames2.default)(_commentFormWrapper2.default.container, 'forum-card-background-color', 'forum-card-border-color');

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: { borderWidth: borderWidth } },
    children
  );
};

CommentFormWrapper.propTypes = {
  children: _propTypes2.default.node,
  borderWidth: _propTypes2.default.number.isRequired
};

exports.default = (0, _withCardBorderWidth2.default)(CommentFormWrapper);

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"QyFVJ"};

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentEditPageHeader = __webpack_require__(1572);

var _commentEditPageHeader2 = _interopRequireDefault(_commentEditPageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentEditPageHeader2.default;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

var _headerBackButton = __webpack_require__(1104);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

var _styledTextEditor = __webpack_require__(292);

var _publishButton = __webpack_require__(1249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentEditPageHeader = function CommentEditPageHeader() {
  return _react2.default.createElement(_header2.default, {
    left: _react2.default.createElement(_headerBackButton2.default, null),
    right: _react2.default.createElement(_publishButton.CommentPublishButton, { text: 'comment-edit-page-header.update', formName: 'comment' }),
    menu: _react2.default.createElement(_styledTextEditor.TextEditorMobileToolbar, { identifier: 'comment' })
  });
};

exports.default = CommentEditPageHeader;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _backButton = __webpack_require__(1315);

var _backButton2 = _interopRequireDefault(_backButton);

var _icons = __webpack_require__(9);

var _headerBackButton = __webpack_require__(1575);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderBackButton = function HeaderBackButton(_ref) {
  var text = _ref.text,
      t = _ref.t;

  return _react2.default.createElement(
    _backButton2.default,
    { className: (0, _classnames2.default)(_headerBackButton2.default.button, 'header-back-button') },
    _react2.default.createElement(
      'span',
      { className: _headerBackButton2.default.wrapper },
      _react2.default.createElement(_icons.ArrowBackIcon, { className: 'button-primary-icon-fill' }),
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_headerBackButton2.default.label, 'button-primary-text-color') },
          text && t(text)
        )
      )
    )
  );
};

HeaderBackButton.propTypes = {
  text: _propTypes2.default.string,
  t: _propTypes2.default.func
};

HeaderBackButton.defaultProps = {
  text: 'header-back-button.back'
};

exports.default = (0, _withTranslate2.default)(HeaderBackButton);

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackButton = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _goBack = __webpack_require__(1184);

var _goBack2 = _interopRequireDefault(_goBack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackButton = exports.BackButton = function BackButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      handleClick = _ref.goBack;
  return _react2.default.createElement(
    'button',
    { className: className, onClick: handleClick },
    children
  );
};

BackButton.propTypes = {
  goBack: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

var mapDispatchToProps = {
  goBack: _goBack2.default
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(BackButton);

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_2K25j","wrapper":"_336sV","label":"_36b0R"};

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentPublishButton = exports.PostPublishButton = exports.PublishButton = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reduxForm = __webpack_require__(40);

var _headerButton = __webpack_require__(1577);

var _headerButton2 = _interopRequireDefault(_headerButton);

var _postFormSettings = __webpack_require__(547);

var _postFormSettings2 = _interopRequireDefault(_postFormSettings);

var _commentFormSettings = __webpack_require__(1314);

var _commentFormSettings2 = _interopRequireDefault(_commentFormSettings);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PublishButton = exports.PublishButton = function (_Component) {
  _inherits(PublishButton, _Component);

  function PublishButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PublishButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PublishButton.__proto__ || Object.getPrototypeOf(PublishButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          submit = _this$props.submit,
          invalid = _this$props.invalid;

      if (!invalid) {
        return submit();
      }

      var _this$props2 = _this.props,
          showMessage = _this$props2.showMessage,
          errors = _this$props2.errors;

      var emptyFields = [];
      _lodash2.default.forOwn(errors, function (error, field) {
        if (error === 'required') {
          emptyFields.push(field);
        }
      });

      if (emptyFields.length) {
        showMessage(_messages2.default[_messages.REQUIRE_POST_FIELDS].content(emptyFields), _messages2.default[_messages.REQUIRE_POST_FIELDS].type);
      }
    }, _this.render = function () {
      var _this$props3 = _this.props,
          text = _this$props3.text,
          errors = _this$props3.errors;

      return _react2.default.createElement(_headerButton2.default, {
        text: text,
        onClick: _this.handleClick,
        isMuted: errors.content === 'uploading',
        'data-role': 'publish'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PublishButton;
}(_react.Component);

PublishButton.propTypes = {
  text: _propTypes2.default.string,
  invalid: _propTypes2.default.bool,
  submit: _propTypes2.default.func.isRequired,
  showMessage: _propTypes2.default.func.isRequired,
  errors: _propTypes2.default.object,
  formName: _propTypes2.default.string
};

PublishButton.defaultProps = {
  text: 'publish-button.publish',
  formName: 'post'
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var formName = _ref2.formName;
  return (0, _redux.bindActionCreators)({
    submit: function submit() {
      return (0, _reduxForm.startSubmit)(formName);
    }
  }, dispatch);
};

var PostPublishButton = exports.PostPublishButton = _lodash2.default.flowRight((0, _reduxForm.reduxForm)(_postFormSettings2.default, undefined, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }))(PublishButton);

var CommentPublishButton = exports.CommentPublishButton = _lodash2.default.flowRight((0, _reduxForm.reduxForm)(_commentFormSettings2.default, undefined, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }))(PublishButton);

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _headerButton = __webpack_require__(1578);

var _headerButton2 = _interopRequireDefault(_headerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _headerButton2.default;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _headerButton = __webpack_require__(1579);

var _headerButton2 = _interopRequireDefault(_headerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HeaderButton = function HeaderButton(_ref) {
  var t = _ref.t,
      text = _ref.text,
      onClick = _ref.onClick,
      isMuted = _ref.isMuted,
      otherProps = _objectWithoutProperties(_ref, ['t', 'text', 'onClick', 'isMuted']);

  return _react2.default.createElement(
    'button',
    _extends({
      className: (0, _classnames2.default)(_headerButton2.default.button, 'button-primary-text-color', 'header-button', _defineProperty({}, _headerButton2.default.isMuted, isMuted)),
      onClick: onClick
    }, otherProps),
    t && t(text)
  );
};

HeaderButton.propTypes = {
  t: _propTypes2.default.func.isRequired,
  text: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  isMuted: _propTypes2.default.bool
};

exports.default = (0, _withTranslate2.default)(HeaderButton);

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"GmFzA","isMuted":"_2XS2B"};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followersMenu = __webpack_require__(1581);

var _followersMenu2 = _interopRequireDefault(_followersMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followersMenu2.default;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowersMenu = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(244);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _menu = __webpack_require__(1316);

var _menu2 = _interopRequireDefault(_menu);

var _menuTab = __webpack_require__(1317);

var _menuTab2 = _interopRequireDefault(_menuTab);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _userSelectors = __webpack_require__(69);

var _counters = __webpack_require__(289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TABS = [{
  type: 'followers',
  className: 'followers-menu__followers-tab',
  title: 'followers-menu.followers',
  getPath: function getPath(userSlug) {
    return '/profiles/' + userSlug + '/followers';
  }
}, {
  type: 'following',
  className: 'followers-menu__following-tab',
  title: 'followers-menu.following',
  getPath: function getPath(userSlug) {
    return '/profiles/' + userSlug + '/following';
  }
}];

var FollowersMenu = exports.FollowersMenu = function (_Component) {
  _inherits(FollowersMenu, _Component);

  function FollowersMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FollowersMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FollowersMenu.__proto__ || Object.getPrototypeOf(FollowersMenu)).call.apply(_ref, [this].concat(args))), _this), _this.navigateTo = function (_ref2) {
      var getPath = _ref2.getPath;
      return function (event) {
        event.preventDefault();

        var _this$props = _this.props,
            push = _this$props.push,
            userSlug = _this$props.params.userSlug;

        push(getPath(userSlug));
      };
    }, _this.render = function () {
      var _this$props2 = _this.props,
          t = _this$props2.t,
          counters = _this$props2.counters,
          router = _this$props2.router,
          userSlug = _this$props2.params.userSlug;

      return _react2.default.createElement(
        _menu2.default,
        null,
        TABS.map(function (tab, key) {
          return _react2.default.createElement(_menuTab2.default, {
            key: key,
            className: tab.className,
            title: t(tab.title),
            count: counters[tab.type],
            onClick: _this.navigateTo(tab),
            isActive: router.isActive(tab.getPath(userSlug))
          });
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return FollowersMenu;
}(_react.Component);

FollowersMenu.propTypes = {
  router: _propTypes2.default.object,
  t: _propTypes2.default.func,
  push: _propTypes2.default.func,
  params: _propTypes2.default.object,
  counters: _propTypes2.default.shape({
    followers: _propTypes2.default.number,
    following: _propTypes2.default.number
  })
};

var mapStateToProps = function mapStateToProps(state, props) {
  var user = (0, _userSelectors.getUserBySlug)(state, props.params.userSlug);
  return {
    counters: {
      followers: (0, _counters.getFollowersCount)(user),
      following: (0, _counters.getFollowingCount)(user)
    }
  };
};

var mapDispatchToProps = {
  push: _routerUtils.push
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _reactRouter.withRouter, _withTranslate2.default)(FollowersMenu);

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _menu = __webpack_require__(1583);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(_ref) {
  var children = _ref.children,
      cardBackgroundColor = _ref.cardBackgroundColor,
      borderWidth = _ref.borderWidth;

  var wrapperStyle = { backgroundColor: cardBackgroundColor, borderWidth: borderWidth };
  return _react2.default.createElement(
    'div',
    { className: _menu2.default.overflow },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)(_menu2.default.wrapper, 'default-forum-card-background-color', 'forum-card-border-color'),
        style: wrapperStyle
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_menu2.default.container, 'menu'), style: { marginBottom: -borderWidth } },
        children
      )
    )
  );
};

Menu.propTypes = {
  children: _propTypes2.default.node,
  cardBackgroundColor: _propTypes2.default.string.isRequired,
  borderWidth: _propTypes2.default.number.isRequired
};

exports.default = _lodash2.default.flowRight(_withCardBorderWidth2.default, _withCardBackgroundColor2.default)(Menu);

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overflow":"_1vlTY","wrapper":"_3JXsE","container":"_2ZFGB"};

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _accessibility = __webpack_require__(49);

var _menuTab = __webpack_require__(1585);

var _menuTab2 = _interopRequireDefault(_menuTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MenuTab = function MenuTab(_ref) {
  var className = _ref.className,
      title = _ref.title,
      count = _ref.count,
      isActive = _ref.isActive,
      borderWidth = _ref.borderWidth,
      contentFontClassName = _ref.contentFontClassName,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['className', 'title', 'count', 'isActive', 'borderWidth', 'contentFontClassName', 'onClick']);

  var containerClassName = (0, _classnames2.default)(_menuTab2.default.link, className, contentFontClassName, _defineProperty({}, _menuTab2.default.linkActive, isActive), 'menu-tab', isActive ? (0, _classnames2.default)('button-color', 'button-border-color') : 'forum-text-color');
  return _react2.default.createElement(
    'a',
    _extends({
      className: containerClassName,
      style: { borderWidth: Math.max(borderWidth, 1) },
      tabIndex: !isActive && '0',
      onClick: onClick,
      onKeyUp: (0, _accessibility.handleEnterKeyUp)(onClick)
    }, props),
    _react2.default.createElement(
      'span',
      { className: _menuTab2.default.wrapper },
      _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)(_menuTab2.default.title, 'menu-tab__title') },
        title
      ),
      _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)(_menuTab2.default.count, _defineProperty({}, _menuTab2.default.zeroCount, count === 0), 'menu-tab__count') },
        count
      )
    )
  );
};

MenuTab.propTypes = {
  borderWidth: _propTypes2.default.number.isRequired,
  contentClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  count: _propTypes2.default.number,
  isActive: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

exports.default = (0, _withCardBorderWidth2.default)((0, _withFontClassName2.default)(MenuTab));

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"_393mT","wrapper":"YKrNr","linkActive":"_19tXH","count":"D3EOz","zeroCount":"bszn-"};

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followersPage = __webpack_require__(1587);

var _followersPage2 = _interopRequireDefault(_followersPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followersPage2.default;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowersPage = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _fetchFollowers = __webpack_require__(195);

var _clearFollowers = __webpack_require__(1170);

var _fetchUserAndRedirect = __webpack_require__(1186);

var _redirectTo = __webpack_require__(1007);

var _defaultDesktopLayout = __webpack_require__(1187);

var _defaultDesktopLayout2 = _interopRequireDefault(_defaultDesktopLayout);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _memberList = __webpack_require__(1188);

var _memberList2 = _interopRequireDefault(_memberList);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _infiniteListLoader = __webpack_require__(528);

var _infiniteListLoader2 = _interopRequireDefault(_infiniteListLoader);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _pagination = __webpack_require__(166);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _currentUserSelectors = __webpack_require__(67);

var _isLoadingSelectors = __webpack_require__(267);

var _followersSelectors = __webpack_require__(1609);

var _userSelectors = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reset = function reset() {
  return { page: 1 };
};
var increment = function increment(state) {
  return { page: state.page + 1 };
};

var FollowersPage = exports.FollowersPage = function (_Component) {
  _inherits(FollowersPage, _Component);

  function FollowersPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FollowersPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FollowersPage.__proto__ || Object.getPrototypeOf(FollowersPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { page: 1 }, _this.componentDidMount = function () {
      return _this.fetchFollowers();
    }, _this.componentWillUnmount = function () {
      return _this.props.clearFollowers();
    }, _this.componentWillReceiveProps = function (_ref2) {
      var userId = _ref2.userId;

      if (_this.props.userId !== userId) {
        _this.props.clearFollowers();
        _this.setState(reset, function () {
          return _this.fetchFollowers(userId);
        });
      }
    }, _this.fetchFollowers = function () {
      var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.userId;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.page;
      return _this.props.fetchFollowers({
        userId: userId,
        page: page,
        pageSize: _pagination.MEMBERS_PER_PAGE
      });
    }, _this.handleLoad = function () {
      return _this.setState(increment, _this.fetchFollowers);
    }, _this.renderEmptyState = function () {
      var _this$props = _this.props,
          isCurrentUser = _this$props.isCurrentUser,
          t = _this$props.t;

      var suffix = isCurrentUser ? '-current-user' : '';
      return _react2.default.createElement(_emptyStates2.default, {
        title: t('followers-page.empty-state-title' + suffix),
        content: t('followers-page.empty-state-content' + suffix)
      });
    }, _this.renderMemberList = function () {
      var _this$props2 = _this.props,
          isLoading = _this$props2.isLoading,
          followers = _this$props2.followers,
          count = _this$props2.count;

      return _react2.default.createElement(
        _defaultDesktopLayout2.default,
        null,
        _react2.default.createElement(_memberList2.default, { members: followers }),
        _react2.default.createElement(_infiniteListLoader2.default, {
          onLoad: _this.handleLoad,
          loader: _react2.default.createElement(_loader2.default, null),
          isLoading: isLoading,
          hasMore: followers.length < count
        })
      );
    }, _this.render = function () {
      var _this$props3 = _this.props,
          isLoading = _this$props3.isLoading,
          followers = _this$props3.followers;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _animatedLoader2.default,
          { isLoading: isLoading && !followers.length },
          followers.length ? _this.renderMemberList() : _this.renderEmptyState()
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return FollowersPage;
}(_react.Component);

FollowersPage.fetchData = function (_ref3) {
  var store = _ref3.store,
      params = _ref3.params,
      search = _ref3.search;
  return store.dispatch((0, _fetchUserAndRedirect.fetchUserAndRedirect)(params.userSlug, search)).then(function (user) {
    return store.dispatch((0, _fetchFollowers.fetchFollowers)({
      userId: user._id,
      page: 1,
      pageSize: _pagination.MEMBERS_PER_PAGE
    }));
  }).catch(function () {
    return store.dispatch((0, _redirectTo.redirectTo404)(search));
  });
};

FollowersPage.propTypes = {
  fetchFollowers: _propTypes2.default.func.isRequired,
  clearFollowers: _propTypes2.default.func.isRequired,
  isCurrentUser: _propTypes2.default.bool.isRequired,
  userId: _propTypes2.default.string.isRequired,
  params: _propTypes2.default.object.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  followers: _propTypes2.default.array,
  t: _propTypes2.default.func.isRequired,
  count: _propTypes2.default.number.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isCurrentUser: (0, _currentUserSelectors.getCurrentUserSlug)(state) === ownProps.params.userSlug,
    userId: (0, _userSelectors.getUserBySlug)(state, ownProps.params.userSlug)._id,
    isLoading: (0, _isLoadingSelectors.getIsFollowersLoading)(state),
    followers: (0, _followersSelectors.getFollowers)(state),
    count: (0, _followersSelectors.getFollowerCount)(state)
  };
};

var mapDispatchToProps = {
  fetchFollowers: _fetchFollowers.fetchFollowers,
  clearFollowers: _clearFollowers.clearFollowers
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default)(FollowersPage);

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultDesktopLayout = __webpack_require__(1589);

var _defaultDesktopLayout2 = _interopRequireDefault(_defaultDesktopLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultDesktopLayout = function DefaultDesktopLayout(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: _defaultDesktopLayout2.default.container },
    _react2.default.createElement(
      'div',
      { className: _defaultDesktopLayout2.default.content },
      children
    )
  );
};

DefaultDesktopLayout.propTypes = {
  children: _propTypes2.default.node
};

exports.default = DefaultDesktopLayout;

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_28J-M","content":"_2xNkw"};

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memberListDesktop = __webpack_require__(1591);

var _memberListDesktop2 = _interopRequireDefault(_memberListDesktop);

var _memberListMobile = __webpack_require__(1600);

var _memberListMobile2 = _interopRequireDefault(_memberListMobile);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _forDevice2.default)(_memberListMobile2.default, _memberListDesktop2.default);

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _memberListItemDesktop = __webpack_require__(1592);

var _memberListItemDesktop2 = _interopRequireDefault(_memberListItemDesktop);

var _memberListDesktop = __webpack_require__(1599);

var _memberListDesktop2 = _interopRequireDefault(_memberListDesktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberListDesktop = function MemberListDesktop(_ref) {
  var members = _ref.members;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: _memberListDesktop2.default.wrapper },
      members.map(function (member) {
        return _react2.default.createElement(
          'div',
          { className: _memberListDesktop2.default.item, key: member._id },
          _react2.default.createElement(_memberListItemDesktop2.default, { member: member })
        );
      })
    )
  );
};

MemberListDesktop.propTypes = {
  members: _propTypes2.default.array.isRequired
};

exports.default = MemberListDesktop;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _followUserButtonSecure = __webpack_require__(1318);

var _followUserButtonSecure2 = _interopRequireDefault(_followUserButtonSecure);

var _publicProfileActions = __webpack_require__(1250);

var _publicProfileActions2 = _interopRequireDefault(_publicProfileActions);

var _profileActionsButton = __webpack_require__(1182);

var _profileActionsButton2 = _interopRequireDefault(_profileActionsButton);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _userBadge = __webpack_require__(272);

var _userBadge2 = _interopRequireDefault(_userBadge);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _separator = __webpack_require__(18);

var _resolveUserImage = __webpack_require__(249);

var _resolveUserImage2 = _interopRequireDefault(_resolveUserImage);

var _counters = __webpack_require__(289);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _memberListItemDesktop = __webpack_require__(1598);

var _memberListItemDesktop2 = _interopRequireDefault(_memberListItemDesktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(src) {
  return {
    backgroundImage: src && 'url(' + src + ')'
  };
};

var UserProfileCover = function UserProfileCover(_ref) {
  var user = _ref.user;
  return _react2.default.createElement('div', { className: _memberListItemDesktop2.default.cover, style: getStyle((0, _resolveUserImage2.default)(user.cover)) });
};

UserProfileCover.propTypes = {
  user: _propTypes2.default.object.isRequired
};

var MemberListItemDesktop = function MemberListItemDesktop(_ref2) {
  var borderWidth = _ref2.borderWidth,
      contentFontClassName = _ref2.contentFontClassName,
      currentUser = _ref2.currentUser,
      member = _ref2.member,
      _ref2$navigation = _ref2.navigation,
      ProfileLink = _ref2$navigation.ProfileLink,
      FollowersLink = _ref2$navigation.FollowersLink,
      t = _ref2.t;

  var className = (0, _classnames2.default)(_memberListItemDesktop2.default.container, contentFontClassName, 'forum-text-color', 'forum-card-background-color', 'forum-card-border-color', 'member-list-item');
  var isCurrentUser = (0, _lodash.get)(currentUser, '_id') === member._id;

  return _react2.default.createElement(
    'div',
    { className: className, style: { borderWidth: borderWidth }, 'data-hook': 'member-list-item' },
    _react2.default.createElement(
      ProfileLink,
      { user: member },
      _react2.default.createElement(UserProfileCover, { user: member })
    ),
    _react2.default.createElement(_userAvatarImage2.default, { className: _memberListItemDesktop2.default.avatar, type: 'member', user: member, component: ProfileLink }),
    _react2.default.createElement(
      'div',
      { className: _memberListItemDesktop2.default.details },
      _react2.default.createElement(
        ProfileLink,
        { className: (0, _classnames2.default)(_memberListItemDesktop2.default.name, 'button-hover-color'), user: member },
        member.name,
        ' ',
        _react2.default.createElement(_userBadge2.default, { user: member })
      ),
      _react2.default.createElement(
        'div',
        { className: _memberListItemDesktop2.default.date },
        t('member-list-item-desktop.date', { date: member.createdDate })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _memberListItemDesktop2.default.stats },
      _react2.default.createElement(
        ProfileLink,
        { className: (0, _classnames2.default)(_memberListItemDesktop2.default.statsGroup, 'button-hover-color'), user: member },
        _react2.default.createElement(
          'div',
          { className: _memberListItemDesktop2.default.statsNumber },
          (0, _counters.getPostsCount)(member)
        ),
        _react2.default.createElement(
          'div',
          { className: _memberListItemDesktop2.default.statsText },
          t('member-list-item-desktop.posts-stats', { count: (0, _counters.getPostsCount)(member) })
        )
      ),
      _react2.default.createElement(_separator.VerticalSeparator, null),
      _react2.default.createElement(
        FollowersLink,
        { className: (0, _classnames2.default)(_memberListItemDesktop2.default.statsGroup, 'button-hover-color'), user: member },
        _react2.default.createElement(
          'div',
          { className: _memberListItemDesktop2.default.statsNumber },
          (0, _counters.getFollowersCount)(member)
        ),
        _react2.default.createElement(
          'div',
          { className: _memberListItemDesktop2.default.statsText },
          t('member-list-item-desktop.followers-stats', { count: (0, _counters.getFollowersCount)(member) })
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _memberListItemDesktop2.default.actions },
      !isCurrentUser && _react2.default.createElement(
        _followUserButtonSecure2.default,
        { user: member },
        _react2.default.createElement(_publicProfileActions2.default, { triggerButton: _profileActionsButton2.default, user: member })
      ),
      isCurrentUser && _react2.default.createElement(
        _button2.default,
        { component: ProfileLink, user: member },
        t('member-list-item-desktop.my-profile')
      )
    )
  );
};

MemberListItemDesktop.propTypes = {
  borderWidth: _propTypes2.default.number,
  contentFontClassName: _propTypes2.default.string,
  currentUser: _propTypes2.default.object,
  member: _propTypes2.default.object.isRequired,
  navigation: _propTypes2.default.object,
  t: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)(_withAuth2.default, _withCardBorderWidth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withFontClassName2.default, _withTranslate2.default)(MemberListItemDesktop);

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _toggleUserSubscribe = __webpack_require__(527);

var _followUserButton = __webpack_require__(1594);

var _followUserButton2 = _interopRequireDefault(_followUserButton);

var _ensureAuth = __webpack_require__(411);

var _ensureAuth2 = _interopRequireDefault(_ensureAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    onClick: function onClick() {
      return (0, _toggleUserSubscribe.toggleUserSubscribe)(ownProps.user._id);
    }
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(undefined, mapDispatchToProps), _ensureAuth2.default)(_followUserButton2.default);

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followUserButton = __webpack_require__(1595);

var _followUserButton2 = _interopRequireDefault(_followUserButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followUserButton2.default;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _followUserButton = __webpack_require__(1596);

var _followUserButton2 = _interopRequireDefault(_followUserButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FollowUserButton = function FollowUserButton(_ref) {
  var user = _ref.user,
      t = _ref.t,
      onClick = _ref.onClick,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['user', 't', 'onClick', 'children']);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    onClick(e);
  };
  return _react2.default.createElement(
    'span',
    { className: _followUserButton2.default.container },
    _react2.default.createElement(
      _button2.default,
      _extends({ onClick: handleClick, isSecondary: user.isSubscribed }, props),
      t(user.isSubscribed ? 'follow-button.unfollow' : 'follow-button.follow')
    ),
    children
  );
};

FollowUserButton.propTypes = {
  user: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
};

exports.default = (0, _withTranslate2.default)(FollowUserButton);

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"VgafU"};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublicProfileActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _permissionsChecker = __webpack_require__(269);

var _openModal = __webpack_require__(36);

var _buttonClicked2 = __webpack_require__(57);

var _icons = __webpack_require__(9);

var _actionButton = __webpack_require__(250);

var _actionButton2 = _interopRequireDefault(_actionButton);

var _modalTypes = __webpack_require__(26);

var _userRole = __webpack_require__(169);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isModerator = function isModerator(user) {
  return (0, _userRole.getUserRole)(user) === _permissionsChecker.ROLE_MODERATOR;
};

var PublicProfileActions = exports.PublicProfileActions = function (_Component) {
  _inherits(PublicProfileActions, _Component);

  function PublicProfileActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PublicProfileActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PublicProfileActions.__proto__ || Object.getPrototypeOf(PublicProfileActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleBlockClick = function () {
      var _this$props = _this.props,
          user = _this$props.user,
          buttonClicked = _this$props.buttonClicked,
          openModal = _this$props.openModal;

      var modal = user.isBlocked ? _modalTypes.MODAL_TYPE_UNBLOCK_MEMBER : _modalTypes.MODAL_TYPE_BLOCK_MEMBER;
      buttonClicked({ action: 'block_user', flag: Number(user.isBlocked) });
      return openModal(modal, { userId: user._id });
    }, _this.handleReportClick = function () {
      var _this$props2 = _this.props,
          user = _this$props2.user,
          buttonClicked = _this$props2.buttonClicked,
          openModal = _this$props2.openModal;

      buttonClicked({ action: _modalTypes.MODAL_TYPE_REPORT_MEMBER });
      return openModal(_modalTypes.MODAL_TYPE_REPORT_MEMBER, { userId: user._id });
    }, _this.handlePromoteClick = function () {
      var _this$props3 = _this.props,
          user = _this$props3.user,
          buttonClicked = _this$props3.buttonClicked,
          openModal = _this$props3.openModal;

      var modal = isModerator(user) ? _modalTypes.MODAL_TYPE_DEMOTE_MODERATOR : _modalTypes.MODAL_TYPE_PROMOTE_MODERATOR;
      buttonClicked({ action: modal });
      return openModal(modal, { userId: user._id });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PublicProfileActions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canRender = _props.canRender,
          user = _props.user,
          TriggerButton = _props.triggerButton,
          emptyNode = _props.emptyNode,
          t = _props.t;

      var reportButton = canRender('report', 'member', user, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'public-profile-actions__report',
            className: 'public-profile-actions__report',
            onClick: _this2.handleReportClick
          },
          _react2.default.createElement(_icons.ReportIcon, { className: 'forum-icon-fill' }),
          t('public-profile-actions.report-member')
        );
      });
      var promoteModeratorButton = canRender('promote-moderator', 'member', user, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'public-profile-actions__promote',
            className: 'public-profile-actions__promote',
            onClick: _this2.handlePromoteClick
          },
          _react2.default.createElement(_icons.ModeratorIcon, { className: 'forum-icon-fill' }),
          t(isModerator(user) ? 'public-profile-actions.demote-moderator' : 'public-profile-actions.promote-moderator')
        );
      });
      var blockButton = canRender('block', 'member', user, function () {
        return _react2.default.createElement(
          _actionButton2.default,
          {
            'data-hook': 'public-profile-actions__block',
            className: 'public-profile-actions__block',
            onClick: _this2.handleBlockClick
          },
          _react2.default.createElement(_icons.BlockIcon, { className: 'forum-icon-fill' }),
          t(user.isBlocked ? 'public-profile-actions.unblock-member' : 'public-profile-actions.block-member')
        );
      });

      if (reportButton || promoteModeratorButton || blockButton) {
        return _react2.default.createElement(
          TriggerButton,
          null,
          _react2.default.createElement(
            'div',
            null,
            reportButton,
            promoteModeratorButton,
            blockButton
          )
        );
      }
      return emptyNode || null;
    }
  }]);

  return PublicProfileActions;
}(_react.Component);

PublicProfileActions.propTypes = {
  triggerButton: _propTypes2.default.any.isRequired,
  emptyNode: _propTypes2.default.node,
  user: _propTypes2.default.object.isRequired,
  buttonClicked: _propTypes2.default.func.isRequired,
  openModal: _propTypes2.default.func.isRequired,
  canRender: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    buttonClicked: function buttonClicked(data) {
      return (0, _buttonClicked2.buttonClicked)(_extends({ name: 'action_click', type: 'profile' }, data));
    },
    openModal: _openModal.openModal
  }, dispatch);
};

// prettier-ignore
exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(undefined, mapDispatchToProps), _withPermissions2.default, _withTranslate2.default)(PublicProfileActions);

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3xV78","cover":"_1MaXL","avatar":"_2w1KF","name":"_3UuFK","date":"_3W86P","stats":"_3kwHv","statsGroup":"_4PC6q","statsNumber":"Ru5-y","statsText":"vucEb","actions":"_2bfuI"};

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_30hNO","item":"_1XYHX"};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _infiniteList = __webpack_require__(1103);

var _infiniteList2 = _interopRequireDefault(_infiniteList);

var _separator = __webpack_require__(18);

var _memberListItem = __webpack_require__(1601);

var _memberListItem2 = _interopRequireDefault(_memberListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THRESHOLD = 400;

var MemberList = function MemberList(_ref) {
  var members = _ref.members;
  return _react2.default.createElement(_infiniteList2.default, {
    length: members.length,
    itemRenderer: function itemRenderer(idx) {
      return _react2.default.createElement(
        'div',
        { className: 'forum-card-background-color', key: members[idx]._id },
        _react2.default.createElement(_memberListItem2.default, { member: members[idx] }),
        _react2.default.createElement(_separator.HorizontalSeparator, null)
      );
    },
    threshold: THRESHOLD
  });
};

MemberList.propTypes = {
  members: _propTypes2.default.array.isRequired
};

exports.default = MemberList;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _memberListItem = __webpack_require__(1602);

var _memberListItem2 = _interopRequireDefault(_memberListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _memberListItem2.default;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _followUserButtonMobileSecure = __webpack_require__(1603);

var _followUserButtonMobileSecure2 = _interopRequireDefault(_followUserButtonMobileSecure);

var _publicProfileActions = __webpack_require__(1250);

var _publicProfileActions2 = _interopRequireDefault(_publicProfileActions);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _userBadge = __webpack_require__(272);

var _userBadge2 = _interopRequireDefault(_userBadge);

var _counters = __webpack_require__(289);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _memberListItem = __webpack_require__(1608);

var _memberListItem2 = _interopRequireDefault(_memberListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoreButtonFix = function MoreButtonFix(props) {
  return _react2.default.createElement(_moreButton2.default, _extends({ className: _memberListItem2.default.moreButton }, props));
};

var MemberListItem = function MemberListItem(_ref) {
  var contentFontClassName = _ref.contentFontClassName,
      currentUser = _ref.currentUser,
      member = _ref.member,
      _ref$navigation = _ref.navigation,
      ProfileLink = _ref$navigation.ProfileLink,
      FollowersLink = _ref$navigation.FollowersLink,
      t = _ref.t;
  return _react2.default.createElement(
    ProfileLink,
    { className: (0, _classnames2.default)(_memberListItem2.default.container, contentFontClassName), user: member },
    _react2.default.createElement(_userAvatarImage2.default, { className: _memberListItem2.default.avatar, type: 'member', user: member }),
    _react2.default.createElement(
      'div',
      { className: _memberListItem2.default.details },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_memberListItem2.default.name, 'forum-text-color') },
        member.name,
        ' ',
        _react2.default.createElement(_userBadge2.default, { user: member })
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_memberListItem2.default.date, 'forum-text-color') },
        t('member-list-item.date', { date: member.createdDate })
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_memberListItem2.default.stats, 'forum-text-color') },
        t('member-list-item.posts-stats', { count: (0, _counters.getPostsCount)(member) }),
        ' | ',
        _react2.default.createElement(
          'object',
          { type: 'communities/link' },
          _react2.default.createElement(
            FollowersLink,
            { className: _memberListItem2.default.link, user: member },
            t('member-list-item.followers-stats', { count: (0, _counters.getFollowersCount)(member) })
          )
        )
      )
    ),
    (0, _lodash.get)(currentUser, '_id') !== member._id && _react2.default.createElement(
      'div',
      { className: _memberListItem2.default.actions },
      _react2.default.createElement(
        _followUserButtonMobileSecure2.default,
        { user: member },
        _react2.default.createElement(_publicProfileActions2.default, {
          triggerButton: MoreButtonFix,
          emptyNode: _react2.default.createElement('div', { className: _memberListItem2.default.spacer }),
          user: member
        })
      )
    )
  );
};

MemberListItem.propTypes = {
  contentFontClassName: _propTypes2.default.string,
  currentUser: _propTypes2.default.object,
  member: _propTypes2.default.object.isRequired,
  navigation: _propTypes2.default.object,
  t: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)(_withAuth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withFontClassName2.default, _withTranslate2.default)(MemberListItem);

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followUserButtonMobileSecure = __webpack_require__(1604);

var _followUserButtonMobileSecure2 = _interopRequireDefault(_followUserButtonMobileSecure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followUserButtonMobileSecure2.default;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modalTypes = __webpack_require__(26);

var _openModal = __webpack_require__(36);

var _toggleUserSubscribe = __webpack_require__(527);

var _followUserButtonMobile = __webpack_require__(1605);

var _followUserButtonMobile2 = _interopRequireDefault(_followUserButtonMobile);

var _ensureAuth = __webpack_require__(411);

var _ensureAuth2 = _interopRequireDefault(_ensureAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    onClick: function onClick() {
      return ownProps.user.isSubscribed ? (0, _openModal.openModal)(_modalTypes.MODAL_TYPE_UNFOLLOW_MEMBER, { userId: ownProps.user._id }) : (0, _toggleUserSubscribe.toggleUserSubscribe)(ownProps.user._id);
    }
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(undefined, mapDispatchToProps), _ensureAuth2.default)(_followUserButtonMobile2.default);

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followUserButtonMobile = __webpack_require__(1606);

var _followUserButtonMobile2 = _interopRequireDefault(_followUserButtonMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followUserButtonMobile2.default;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _icons = __webpack_require__(9);

var _followUserButtonMobile = __webpack_require__(1607);

var _followUserButtonMobile2 = _interopRequireDefault(_followUserButtonMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FollowUserButtonMobile = function FollowUserButtonMobile(_ref) {
  var user = _ref.user,
      onClick = _ref.onClick,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['user', 'onClick', 'children']);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    onClick(e);
  };
  return _react2.default.createElement(
    'div',
    { className: _followUserButtonMobile2.default.container },
    _react2.default.createElement(
      _button2.default,
      _extends({ className: _followUserButtonMobile2.default.button, onClick: handleClick, isSecondary: user.isSubscribed }, props),
      user.isSubscribed ? _react2.default.createElement(_icons.FollowingIcon, { className: 'button-secondary-icon-fill' }) : _react2.default.createElement(_icons.FollowMemberIcon, { className: 'button-primary-icon-fill' })
    ),
    children
  );
};

FollowUserButtonMobile.propTypes = {
  user: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
};

exports.default = FollowUserButtonMobile;

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_97AMi","button":"_2XEkX"};

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1jSPB","avatar":"_2ssUq","details":"_2tyXe","name":"_2K3m7","date":"_1U3kH","stats":"_1Nf9Y","actions":"_3YQpR","moreButton":"_3cxtn","spacer":"K2Bsx","link":"_2uL_p"};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFollowerCount = exports.getFollowers = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(46);

var _userSelectors = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFollowersState = function getFollowersState(state) {
  return state.followers;
};
var getIdList = function getIdList(state) {
  return getFollowersState(state).idList;
};
var getMetadata = function getMetadata(state) {
  return getFollowersState(state).metadata;
};

var getFollowers = exports.getFollowers = (0, _reselect.createSelector)([getIdList, _userSelectors.getUserMap], function (followerIds, users) {
  return _lodash2.default.map(followerIds, function (followerId) {
    return users[followerId];
  });
});

var getFollowerCount = exports.getFollowerCount = function getFollowerCount(state) {
  return _lodash2.default.get(getMetadata(state), 'count', 0);
};

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _followingPage = __webpack_require__(1611);

var _followingPage2 = _interopRequireDefault(_followingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _followingPage2.default;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowingPage = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _fetchFollowing = __webpack_require__(196);

var _clearFollowing = __webpack_require__(1171);

var _fetchUserAndRedirect = __webpack_require__(1186);

var _redirectTo = __webpack_require__(1007);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _defaultDesktopLayout = __webpack_require__(1187);

var _defaultDesktopLayout2 = _interopRequireDefault(_defaultDesktopLayout);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _memberList = __webpack_require__(1188);

var _memberList2 = _interopRequireDefault(_memberList);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _infiniteListLoader = __webpack_require__(528);

var _infiniteListLoader2 = _interopRequireDefault(_infiniteListLoader);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _pagination = __webpack_require__(166);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _currentUserSelectors = __webpack_require__(67);

var _isLoadingSelectors = __webpack_require__(267);

var _followingSelectors = __webpack_require__(1612);

var _userSelectors = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reset = function reset() {
  return { page: 1 };
};
var increment = function increment(state) {
  return { page: state.page + 1 };
};

var FollowingPage = exports.FollowingPage = function (_Component) {
  _inherits(FollowingPage, _Component);

  function FollowingPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FollowingPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FollowingPage.__proto__ || Object.getPrototypeOf(FollowingPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { page: 1 }, _this.componentDidMount = function () {
      return _this.fetchFollowing();
    }, _this.componentWillUnmount = function () {
      return _this.props.clearFollowing();
    }, _this.componentWillReceiveProps = function (_ref2) {
      var userId = _ref2.userId;

      if (_this.props.userId !== userId) {
        _this.props.clearFollowing();
        _this.setState(reset, function () {
          return _this.fetchFollowing(userId);
        });
      }
    }, _this.fetchFollowing = function () {
      var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.userId;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.page;
      return _this.props.fetchFollowing({
        userId: userId,
        page: page,
        pageSize: _pagination.MEMBERS_PER_PAGE
      });
    }, _this.handleLoad = function () {
      return _this.setState(increment, _this.fetchFollowing);
    }, _this.renderEmptyState = function () {
      var _this$props = _this.props,
          isCurrentUser = _this$props.isCurrentUser,
          t = _this$props.t,
          MembersLink = _this$props.navigation.MembersLink;

      var suffix = isCurrentUser ? '-current-user' : '';
      return _react2.default.createElement(
        _emptyStates2.default,
        {
          title: t('following-page.empty-state-title' + suffix),
          content: t('following-page.empty-state-content' + suffix)
        },
        isCurrentUser ? _react2.default.createElement(
          _button2.default,
          { component: MembersLink },
          t('following-page.members-page-link')
        ) : null
      );
    }, _this.renderMemberList = function () {
      var _this$props2 = _this.props,
          isLoading = _this$props2.isLoading,
          following = _this$props2.following,
          count = _this$props2.count;

      return _react2.default.createElement(
        _defaultDesktopLayout2.default,
        null,
        _react2.default.createElement(_memberList2.default, { members: following }),
        _react2.default.createElement(_infiniteListLoader2.default, {
          onLoad: _this.handleLoad,
          loader: _react2.default.createElement(_loader2.default, null),
          isLoading: isLoading,
          hasMore: following.length < count
        })
      );
    }, _this.render = function () {
      var _this$props3 = _this.props,
          isLoading = _this$props3.isLoading,
          following = _this$props3.following;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _animatedLoader2.default,
          { isLoading: isLoading && !following.length },
          following.length ? _this.renderMemberList() : _this.renderEmptyState()
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return FollowingPage;
}(_react.Component);

FollowingPage.fetchData = function (_ref3) {
  var store = _ref3.store,
      params = _ref3.params,
      search = _ref3.search;
  return store.dispatch((0, _fetchUserAndRedirect.fetchUserAndRedirect)(params.userSlug, search)).then(function (user) {
    return store.dispatch((0, _fetchFollowing.fetchFollowing)({
      userId: user._id,
      page: 1,
      pageSize: _pagination.MEMBERS_PER_PAGE
    }));
  }).catch(function () {
    return store.dispatch((0, _redirectTo.redirectTo404)(search));
  });
};

FollowingPage.propTypes = {
  count: _propTypes2.default.number.isRequired,
  fetchFollowing: _propTypes2.default.func.isRequired,
  clearFollowing: _propTypes2.default.func.isRequired,
  isCurrentUser: _propTypes2.default.bool.isRequired,
  userId: _propTypes2.default.string.isRequired,
  params: _propTypes2.default.object.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  following: _propTypes2.default.array,
  navigation: _propTypes2.default.object,
  t: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isCurrentUser: (0, _currentUserSelectors.getCurrentUserSlug)(state) === ownProps.params.userSlug,
    userId: (0, _userSelectors.getUserBySlug)(state, ownProps.params.userSlug)._id,
    isLoading: (0, _isLoadingSelectors.getIsFollowingLoading)(state),
    following: (0, _followingSelectors.getFollowing)(state),
    count: (0, _followingSelectors.getFollowerCount)(state)
  };
};

var mapDispatchToProps = {
  fetchFollowing: _fetchFollowing.fetchFollowing,
  clearFollowing: _clearFollowing.clearFollowing
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withTranslate2.default)(FollowingPage);

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFollowerCount = exports.getFollowing = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(46);

var _userSelectors = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFollowingState = function getFollowingState(state) {
  return state.following;
};
var getIdList = function getIdList(state) {
  return getFollowingState(state).idList;
};
var getMetadata = function getMetadata(state) {
  return getFollowingState(state).metadata;
};

var getFollowing = exports.getFollowing = (0, _reselect.createSelector)([getIdList, _userSelectors.getUserMap], function (followerIds, users) {
  return _lodash2.default.map(followerIds, function (followerId) {
    return users[followerId];
  });
});

var getFollowerCount = exports.getFollowerCount = function getFollowerCount(state) {
  return _lodash2.default.get(getMetadata(state), 'count', 0);
};

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InternalPageDesktopHeader = undefined;

var _internalPageDesktopHeader = __webpack_require__(1614);

var _internalPageDesktopHeader2 = _interopRequireDefault(_internalPageDesktopHeader);

var _internalPageHeader = __webpack_require__(1634);

var _internalPageHeader2 = _interopRequireDefault(_internalPageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.InternalPageDesktopHeader = _internalPageDesktopHeader2.default;
exports.default = _internalPageHeader2.default;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _breadcrumbs = __webpack_require__(1319);

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

var _desktopHeader = __webpack_require__(1320);

var _desktopHeader2 = _interopRequireDefault(_desktopHeader);

var _searchInput = __webpack_require__(1626);

var _searchInput2 = _interopRequireDefault(_searchInput);

var _breadcrumbsWidget = __webpack_require__(1322);

var _breadcrumbsWidget2 = _interopRequireDefault(_breadcrumbsWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderSearchInput = function renderSearchInput() {
  return _react2.default.createElement(_searchInput2.default, {
    inputClassName: 'desktop-header-search-text-color desktop-header-search-font',
    borderClassName: 'desktop-header-search-border-background-color',
    iconClassName: 'desktop-header-search-icon-fill'
  });
};

var InternalPageDesktopHeader = function InternalPageDesktopHeader(_ref) {
  var routes = _ref.routes,
      params = _ref.params,
      props = _objectWithoutProperties(_ref, ['routes', 'params']);

  return _react2.default.createElement(_desktopHeader2.default, _extends({
    left: _react2.default.createElement(_breadcrumbs2.default, { routes: routes, params: params }),
    right: _react2.default.createElement(_breadcrumbsWidget2.default, { searchInput: renderSearchInput() })
  }, props));
};

InternalPageDesktopHeader.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.object.isRequired
};

exports.default = InternalPageDesktopHeader;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(5);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _reactRouterBreadcrumbs = __webpack_require__(1616);

var _reactRouterBreadcrumbs2 = _interopRequireDefault(_reactRouterBreadcrumbs);

var _arrowIcon = __webpack_require__(1622);

var _arrowIcon2 = _interopRequireDefault(_arrowIcon);

var _categoriesSelectors = __webpack_require__(35);

var _userSelectors = __webpack_require__(69);

var _postSelectors = __webpack_require__(117);

var _forumDataSelectors = __webpack_require__(457);

var _locationHistorySelectors = __webpack_require__(162);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _breadcrumbs = __webpack_require__(1623);

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR_MAP = {
  ':categorySlug': function categorySlug(state, text) {
    return ((0, _categoriesSelectors.getCategoryBySlug)(state, text) || {}).label;
  },
  ':userSlug': function userSlug(state, text) {
    return ((0, _userSelectors.getUserBySlug)(state, text) || {}).name;
  },
  ':postSlug': function postSlug(state, text) {
    return ((0, _postSelectors.getPostBySlug)(state, text) || {}).title;
  }
};

var createSeparator = function createSeparator(crumbElement, index) {
  return _react2.default.createElement(
    'span',
    { className: _breadcrumbs2.default.separator, key: 'separator-' + index },
    _react2.default.createElement(_arrowIcon2.default, { className: 'breadcrumbs-icon-fill' })
  );
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var routes = _ref.routes,
      params = _ref.params,
      state = _ref.state,
      t = _ref.t,
      label = _ref.forumData.label;

  SELECTOR_MAP['Wix Forum'] = function () {
    return label;
  };

  var resolver = function resolver(key, text) {
    var fn = SELECTOR_MAP[key];
    return fn ? fn(state, text) : t(key);
  };

  // eslint-disable-next-line max-params
  var createLink = function createLink(link, key, text, index, routes) {
    var categories = (0, _categoriesSelectors.getCategories)(state);
    var hasOneCategory = categories.length === 1;
    var length = _lodash2.default.filter(routes, function (r) {
      return !r.breadcrumbIgnore;
    }).length;
    var isLast = index === length - 1;
    var isFirst = index === 0;
    var is404 = (0, _locationHistorySelectors.getCurrentLocation)(state).pathname === '/404';
    if (isFirst && hasOneCategory) {
      link = '/' + categories[0].slug;
    }

    return isLast && !is404 ? _react2.default.createElement(
      'span',
      { className: 'breadcrumbs-font', key: key, 'data-hook': 'breadcrumbs__current-page' },
      text
    ) : _react2.default.createElement(
      _internalLink2.default,
      { className: 'breadcrumbs-font', to: link, key: key, 'data-hook': 'breadcrumbs__' + index },
      text
    );
  };

  return _react2.default.createElement(_reactRouterBreadcrumbs2.default, {
    className: (0, _classnames2.default)(_breadcrumbs2.default.breadcrumbs, 'breadcrumbs-text-color'),
    routes: routes,
    params: params,
    resolver: resolver,
    createLink: createLink,
    createSeparator: createSeparator
  });
};

Breadcrumbs.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.object.isRequired,
  state: _propTypes2.default.object,
  t: _propTypes2.default.func,
  forumData: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    forumData: (0, _forumDataSelectors.getForumData)(state),
    state: state
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withTranslate2.default)(Breadcrumbs));

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.key = exports.debug = exports.pathname = exports.path = exports.childOf = exports.resolver = exports.textResolver = exports.combineResolvers = undefined;

var _resolverUtils = __webpack_require__(1617);

Object.defineProperty(exports, 'combineResolvers', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.combineResolvers;
    }
});
Object.defineProperty(exports, 'textResolver', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.textResolver;
    }
});
Object.defineProperty(exports, 'resolver', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.resolver;
    }
});
Object.defineProperty(exports, 'childOf', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.childOf;
    }
});
Object.defineProperty(exports, 'path', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.path;
    }
});
Object.defineProperty(exports, 'pathname', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.pathname;
    }
});
Object.defineProperty(exports, 'debug', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.debug;
    }
});
Object.defineProperty(exports, 'key', {
    enumerable: true,
    get: function get() {
        return _resolverUtils.key;
    }
});

var _breadcrumbs = __webpack_require__(1618);

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _breadcrumbs2.default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.combineResolvers = combineResolvers;
exports.textResolver = textResolver;
function combineResolvers() {
    for (var _len = arguments.length, resolvers = Array(_len), _key = 0; _key < _len; _key++) {
        resolvers[_key] = arguments[_key];
    }

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return resolvers.reduce(function (acc, res) {
            if (acc) return acc;
            return res.apply(undefined, args);
        }, undefined);
    };
}

var debug = exports.debug = function debug(fn) {
    return function () {
        debugger; // eslint-disable-line no-debugger, no-restricted-syntax
        return fn.apply(undefined, arguments);
    };
};
var key = exports.key = function key(expected) {
    return function (keyValue) {
        return expected === keyValue;
    };
};
var pathname = exports.pathname = function pathname(expected) {
    return function (keyValue, text, routePath, route) {
        return expected === route.name;
    };
};
var path = exports.path = function path(expected) {
    return function (keyValue, text, routePath, route) {
        return expected === route.path;
    };
};
var childOf = exports.childOf = function childOf() {
    for (var _len3 = arguments.length, predicates = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        predicates[_key3] = arguments[_key3];
    }

    return function (keyValue, text, routePath) {
        return routePath.slice(0, routePath.length - 1).map(function (route) {
            return predicates.reduce(function (acc, predicate) {
                return acc && predicate(keyValue, text, routePath, route);
            }, true);
        }).includes(true);
    };
};

var resolver = exports.resolver = function resolver() {
    for (var _len4 = arguments.length, predicates = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        predicates[_key4] = arguments[_key4];
    }

    return {
        then: function then(cb) {
            return function () {
                for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                    args[_key5] = arguments[_key5];
                }

                var predicateResult = predicates.reduce(function (acc, predicate) {
                    return acc && predicate.apply(undefined, args);
                }, true);
                if (predicateResult) {
                    return cb.apply(undefined, args);
                }
                return undefined;
            };
        }
    };
};

function textResolver(_, text) {
    return text;
}

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderCrumbs = exports.toCrumb = exports.createHref = exports.createText = exports.paramReplace = exports.defaultSeparator = exports.defaultLink = exports.defaultResolver = exports.safeKey = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(244);

var _routerProps = __webpack_require__(1619);

var RouterProps = _interopRequireWildcard(_routerProps);

var _utils = __webpack_require__(1620);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var paramKeys = /:(\w+)/g;

var safeKey = exports.safeKey = function safeKey(key) {
    return key.replace(/\W/g, '');
};
/* eslint-disable no-unused-vars */
var defaultResolver = exports.defaultResolver = function defaultResolver(key, text, routePath, route) {
    return key;
};
var defaultLink = exports.defaultLink = function defaultLink(link, key, text, index, routes) {
    return _react2.default.createElement(
        _reactRouter.Link,
        { to: link, key: key },
        text
    );
};
var defaultSeparator = exports.defaultSeparator = function defaultSeparator(crumb, index, array) {
    return _react2.default.createElement(
        'span',
        { key: 'separator-' + index },
        ' > '
    );
};
/* eslint-enable */

var paramReplace = exports.paramReplace = function paramReplace(text) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return text.replace(paramKeys, function (_, key) {
        return params[key] || key;
    });
};

var createText = exports.createText = function createText(routePath, params, resolver) {
    var route = (0, _utils.lastOf)(routePath);
    var text = route.breadcrumbName || route.name || route.component.name;

    return resolver(text, paramReplace(text, params), routePath, route);
};

var createHref = exports.createHref = function createHref(routePath, params) {
    var link = routePath.map(function (route) {
        return route.breadcrumbLink || route.path || '';
    }).map(function (routeName) {
        return routeName.startsWith('/') ? routeName : '/' + routeName;
    }).join('').replace(/\/\/+/g, '/');

    return paramReplace(link, params);
};

var toCrumb = exports.toCrumb = function toCrumb(_ref) {
    var params = _ref.params,
        createLink = _ref.createLink,
        resolver = _ref.resolver;
    return function (route, index, routes) {
        if (route.breadcrumbIgnore) {
            return route;
        }

        var routePath = routes.slice(0, index + 1);
        var text = createText(routePath, params, resolver);
        var link = createHref(routePath, params);
        var key = safeKey(text + '--' + link);

        return createLink(link, key, text, index, routes);
    };
};

var renderCrumbs = exports.renderCrumbs = function renderCrumbs(_ref2) {
    var routes = _ref2.routes,
        createSeparator = _ref2.createSeparator,
        prefixElements = _ref2.prefixElements,
        suffixElements = _ref2.suffixElements,
        params = _ref2.params,
        createLink = _ref2.createLink,
        resolver = _ref2.resolver;

    var crumbs = (0, _utils.on)(routes).map(toCrumb({ params: params, createLink: createLink, resolver: resolver })).filter((0, _utils.not)((0, _utils.where)((0, _utils.pluck)('breadcrumbIgnore'), (0, _utils.isEqualTo)(true)))).reduce((0, _utils.join)(createSeparator), []);

    return (0, _utils.on)(prefixElements).concat(crumbs).concat((0, _utils.on)(suffixElements));
};

function Breadcrumbs(_ref3) {
    var className = _ref3.className,
        wrappingComponent = _ref3.wrappingComponent,
        props = _objectWithoutProperties(_ref3, ['className', 'wrappingComponent']);

    var crumbs = renderCrumbs(props);

    if (crumbs.length === 0) {
        return null;
    }

    return _react2.default.createElement(wrappingComponent, { className: className }, crumbs);
}

Breadcrumbs.defaultProps = {
    wrappingComponent: 'div',
    className: 'breadcrumbs',
    params: {},
    resolver: defaultResolver,
    createLink: defaultLink,
    createSeparator: defaultSeparator,
    prefixElements: [],
    suffixElements: []
};

Breadcrumbs.propTypes = {
    routes: RouterProps.routes.isRequired,
    params: _react.PropTypes.object, // eslint-disable-line react/forbid-prop-types
    resolver: _react.PropTypes.func,
    createLink: _react.PropTypes.func,
    createSeparator: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
    className: _react.PropTypes.string,
    wrappingComponent: _react.PropTypes.string,
    prefixElements: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.element), _react.PropTypes.element]),
    suffixElements: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.element), _react.PropTypes.element])
};

exports.default = Breadcrumbs;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = exports.route = undefined;

var _react = __webpack_require__(0);

var route = exports.route = _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element]);
var routes = exports.routes = _react.PropTypes.oneOfType([route, _react.PropTypes.arrayOf(route)]);

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lastOf = exports.join = exports.fn = exports.isEqualTo = exports.pluck = exports.where = exports.not = exports.on = undefined;

var _isFunction = __webpack_require__(1621);

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = exports.on = function on(type) {
    return Array.isArray(type) ? type : [type];
};
var not = exports.not = function not(predicate) {
    return function (item) {
        return !predicate(item);
    };
};
var where = exports.where = function where() {
    var transformation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (a) {
        return a;
    };
    var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
    };
    return function (item) {
        return predicate(transformation(item));
    };
};
var pluck = exports.pluck = function pluck(key) {
    return function (item) {
        return item[key];
    };
};
var isEqualTo = exports.isEqualTo = function isEqualTo(expected) {
    return function (value) {
        return value === expected;
    };
};
var fn = exports.fn = function fn(possibleFn) {
    return (0, _isFunction2.default)(possibleFn) ? possibleFn : function () {
        return possibleFn;
    };
};
var join = exports.join = function join(separator) {
    var separatorFn = fn(separator);

    return function (accumulator, element, index, array) {
        accumulator.push(element);
        if (index < array.length - 1) {
            accumulator.push(separatorFn(element, index, array));
        }
        return accumulator;
    };
};
var lastOf = exports.lastOf = function lastOf(input) {
    return on(input).slice(-1)[0];
};

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowIcon = function ArrowIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "6",
      height: "9.969",
      viewBox: "0 0 6 9.969",
      style: { fillRule: 'evenodd' }
    }, props),
    _react2.default.createElement("path", {
      d: "M785.783,854.5l-4.552,4.3a0.771,0.771,0,0,1-1.048,0,0.672,0.672,0,0,1,0-.99L784.21,854l-4.027-3.8a0.672,0.672,0,0,1,0-.99,0.773,0.773,0,0,1,1.048,0l4.552,4.3A0.674,0.674,0,0,1,785.783,854.5Z",
      transform: "translate(-780 -849.031)"
    })
  );
};

exports.default = ArrowIcon;

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"-QFz-","separator":"_2K1hn"};

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _desktopHeader = __webpack_require__(1625);

var _desktopHeader2 = _interopRequireDefault(_desktopHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderMenu = function renderMenu(menu) {
  return menu && _react2.default.createElement(
    'div',
    { className: _desktopHeader2.default.menu },
    menu
  );
};

var DesktopHeader = function DesktopHeader(_ref) {
  var left = _ref.left,
      right = _ref.right,
      menu = _ref.menu;

  var containerClassName = (0, _classnames2.default)(_desktopHeader2.default.container, 'header-background-color');

  var headerClassName = (0, _classnames2.default)(_desktopHeader2.default.header);

  return _react2.default.createElement(
    'div',
    { className: containerClassName, 'data-hook': 'desktop-header' },
    _react2.default.createElement(
      'div',
      { className: headerClassName },
      left,
      right
    ),
    renderMenu(menu)
  );
};

DesktopHeader.propTypes = {
  left: _propTypes2.default.node,
  right: _propTypes2.default.node,
  menu: _propTypes2.default.node
};

exports.default = DesktopHeader;

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_4F5I-","header":"a8gq-","menu":"_1f6eG"};

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchInput = __webpack_require__(1627);

var _searchInput2 = _interopRequireDefault(_searchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchInput2.default;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _searchInput = __webpack_require__(1321);

var _searchInput2 = _interopRequireDefault(_searchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onClick: function onClick(query) {
      return function (dispatch) {
        dispatch((0, _routerUtils.push)({
          pathname: '/search/posts',
          query: { query: query }
        }));
      };
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(_searchInput2.default);

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTransitionGroup = __webpack_require__(122);

var _searchIcon = __webpack_require__(1629);

var _searchIcon2 = _interopRequireDefault(_searchIcon);

var _clearIcon = __webpack_require__(1630);

var _clearIcon2 = _interopRequireDefault(_clearIcon);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _searchInput = __webpack_require__(1631);

var _searchInput2 = _interopRequireDefault(_searchInput);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLEAR_ANIMATION_TIMEOUT = 500;

var SearchInput = exports.SearchInput = function (_Component) {
  _inherits(SearchInput, _Component);

  function SearchInput(props) {
    _classCallCheck(this, SearchInput);

    var _this = _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call(this, props));

    _this.state = {
      value: props.value || '',
      isExpanded: props.isExpanded
    };

    _this.setInput = _this.setInput.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(SearchInput, [{
    key: 'setInput',
    value: function setInput(node) {
      this.input = node;
    }
  }, {
    key: 'isExpandable',
    value: function isExpandable() {
      return !this.props.isExpanded;
    }
  }, {
    key: 'expand',
    value: function expand() {
      this.setState({ isExpanded: true });
    }
  }, {
    key: 'collapse',
    value: function collapse() {
      this.setState({ isExpanded: false });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var value = _ref.value;

      if (value !== this.props.value) {
        this.setValue(value);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.isExpanded && this.state.isExpanded) {
        this.input.focus();
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setValue(e.target.value);
    }
  }, {
    key: 'handleClear',
    value: function handleClear() {
      this.setValue('');
      if (this.isExpandable()) {
        this.collapse();
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.isExpandable() && !this.state.isExpanded) {
        this.expand();
      } else if (this.props.onClick) {
        this.props.onClick(this.state.value);
      }
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      if (this.props.onClick && event.keyCode === 13) {
        this.props.onClick(this.state.value);
      } else if (event.keyCode === 27) {
        event.target.blur();
        this.handleClear();
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      var _this2 = this;

      this.setState({ value: value }, function () {
        var onChange = _this2.props.onChange;

        if (onChange) {
          onChange(_this2.state.value);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          type = _props.type,
          className = _props.className,
          inputClassName = _props.inputClassName,
          iconClassName = _props.iconClassName,
          borderClassName = _props.borderClassName,
          color = _props.color,
          t = _props.t,
          isFullWidth = _props.isFullWidth;
      var _state = this.state,
          isExpanded = _state.isExpanded,
          value = _state.value;

      var showClearButton = this.isExpandable() && isExpanded || !this.isExpandable() && value;
      var containerClassName = (0, _classnames2.default)(_searchInput2.default.container, className, 'search-input', (_classNames = {}, _defineProperty(_classNames, _searchInput2.default[type], type), _defineProperty(_classNames, _searchInput2.default.expanded, isExpanded), _defineProperty(_classNames, _searchInput2.default.isFullWidth, isFullWidth), _classNames));
      return _react2.default.createElement(
        'div',
        {
          className: containerClassName,
          tabIndex: !isExpanded && '0',
          role: 'button',
          'aria-label': t('search-input.placeholder'),
          onKeyUp: (0, _accessibility.handleEnterKeyUp)(this.handleClick)
        },
        _react2.default.createElement(_searchIcon2.default, {
          className: (0, _classnames2.default)(_searchInput2.default.icon, iconClassName),
          onClick: this.handleClick,
          fill: color,
          'data-hook': 'search-icon'
        }),
        _react2.default.createElement('input', {
          ref: this.setInput,
          className: (0, _classnames2.default)(_searchInput2.default.input, inputClassName, 'search-input__input'),
          onChange: this.handleChange,
          value: value,
          type: 'text',
          placeholder: t('search-input.placeholder'),
          onKeyUp: this.handleKeyUp,
          style: { color: color }
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_searchInput2.default.spacer, inputClassName, _searchInput2.default.placeholder) },
          t('search-input.placeholder')
        ),
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_searchInput2.default.border, borderClassName), style: { backgroundColor: color } }),
        _react2.default.createElement(
          _reactTransitionGroup.CSSTransitionGroup,
          {
            transitionName: 'clear',
            transitionEnterTimeout: CLEAR_ANIMATION_TIMEOUT,
            transitionLeaveTimeout: CLEAR_ANIMATION_TIMEOUT
          },
          showClearButton ? _react2.default.createElement(
            'button',
            {
              className: (0, _classnames2.default)(_searchInput2.default.clear, 'search-input__clear-button'),
              onClick: this.handleClear,
              tabIndex: '-1'
            },
            _react2.default.createElement(_clearIcon2.default, { className: (0, _classnames2.default)(_searchInput2.default.clearIcon, iconClassName), fill: color })
          ) : null
        )
      );
    }
  }]);

  return SearchInput;
}(_react.Component);

SearchInput.propTypes = {
  t: _propTypes2.default.func.isRequired,
  type: _propTypes2.default.string,
  isExpanded: _propTypes2.default.bool,
  isFullWidth: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string,
  borderClassName: _propTypes2.default.string,
  inputClassName: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  color: _propTypes2.default.string
};

exports.default = (0, _withTranslate2.default)(SearchInput);

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "15",
      height: "16",
      viewBox: "0 0 15 16",
      style: { fillRule: 'evenodd' }
    }, props),
    _react2.default.createElement("path", {
      d: "M878.766,254.573l-3.7-3.96a6.555,6.555,0,0,0,1.471-4.153,6.274,6.274,0,1,0-6.27,6.46,6.074,6.074,0,0,0,3.592-1.169l3.725,3.99a0.8,0.8,0,0,0,1.156.024A0.862,0.862,0,0,0,878.766,254.573Zm-8.5-12.888a4.777,4.777,0,1,1-4.636,4.775A4.712,4.712,0,0,1,870.27,241.685Z",
      transform: "translate(-864 -240)"
    })
  );
};

exports.default = SearchIcon;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClearIcon = function ClearIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      style: { fillRule: 'evenodd' }
    }, props),
    _react2.default.createElement("path", {
      d: "M3144.99,617.882l-1.11,1.109-3.88-3.882-3.88,3.882-1.11-1.109,3.88-3.882-3.88-3.882,1.11-1.109,3.88,3.882,3.88-3.882,1.11,1.109L3141.11,614Z",
      transform: "translate(-3135 -609)"
    })
  );
};

exports.default = ClearIcon;

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1YA61","expanded":"_2oJrd","isFullWidth":"_2ofor","icon":"_3OsMD","input":"_27Nue","placeholder":"_2t1ih","spacer":"_2Sp96","border":"_3amb6","clear":"_1A6qR","clearIcon":"_3nxMu"};

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbsWidget = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _showBreadrumbsLogin = __webpack_require__(1053);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _wixParams = __webpack_require__(24);

var _requestLogin = __webpack_require__(522);

var _requestLogin2 = _interopRequireDefault(_requestLogin);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _iconButton = __webpack_require__(1181);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _icons = __webpack_require__(9);

var _profileActionsButton = __webpack_require__(1182);

var _profileActionsButton2 = _interopRequireDefault(_profileActionsButton);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _notificationButton = __webpack_require__(1242);

var _notificationButton2 = _interopRequireDefault(_notificationButton);

var _privateProfileActions = __webpack_require__(520);

var _privateProfileActions2 = _interopRequireDefault(_privateProfileActions);

var _preventClickInDemoMode = __webpack_require__(523);

var _preventClickInDemoMode2 = _interopRequireDefault(_preventClickInDemoMode);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _memberAreaSelectors = __webpack_require__(270);

var _breadcrumbsWidget = __webpack_require__(1633);

var _breadcrumbsWidget2 = _interopRequireDefault(_breadcrumbsWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProtectedButton = (0, _preventClickInDemoMode2.default)(_button2.default);

var BreadcrumbsWidget = exports.BreadcrumbsWidget = function (_Component) {
  _inherits(BreadcrumbsWidget, _Component);

  function BreadcrumbsWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BreadcrumbsWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BreadcrumbsWidget.__proto__ || Object.getPrototypeOf(BreadcrumbsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.isLoginWidgetEnabled = function () {
      var _this$props = _this.props,
          isLoginWidgetEnabled = _this$props.isLoginWidgetEnabled,
          isMemberAreaActive = _this$props.isMemberAreaActive;

      return isLoginWidgetEnabled !== undefined ? isLoginWidgetEnabled : !isMemberAreaActive;
    }, _this.renderLogin = function () {
      return _react2.default.createElement(
        'div',
        { className: _breadcrumbsWidget2.default.container },
        _this.renderSearchInput(),
        _this.renderMembersButton(),
        _this.renderLoginButton()
      );
    }, _this.renderMainWidget = function () {
      return _react2.default.createElement(
        'div',
        { className: _breadcrumbsWidget2.default.container },
        _this.renderSearchInput(),
        _this.renderMembersButton(),
        _this.renderNotifications(),
        _this.renderProfile()
      );
    }, _this.renderLoginButton = function () {
      var requestLogin = _this.props.requestLogin;

      if (!_this.isLoginWidgetEnabled()) {
        return null;
      }

      return _react2.default.createElement(
        ProtectedButton,
        { className: _breadcrumbsWidget2.default.loginButton, isSecondary: true, onClick: requestLogin, 'data-hook': 'login-button' },
        _this.props.t('header.sign-up-button')
      );
    }, _this.renderNotifications = function () {
      var NotificationsLink = _this.props.navigation.NotificationsLink;

      return _this.isLoginWidgetEnabled() ? _react2.default.createElement(_notificationButton2.default, {
        className: _breadcrumbsWidget2.default.notificationButton,
        component: NotificationsLink,
        iconClassName: 'breadcrumbs-icon-fill',
        bubbleClassName: (0, _classnames2.default)('forum-header-border-color', 'header-notification-bubble-background-color', 'header-notification-bubble-text-color', _breadcrumbsWidget2.default.notificationBubble),
        'data-hook': 'notification-button'
      }) : null;
    }, _this.renderProfile = function () {
      var currentUser = _this.props.currentUser;


      if (!_this.isLoginWidgetEnabled()) {
        return null;
      }

      var icon = _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)(_breadcrumbsWidget2.default.avatarImage),
          'aria-label': _this.props.t('breadcrumbs.profile'),
          'data-hook': 'avatar-image'
        },
        _react2.default.createElement(_userAvatarImage2.default, { type: 'widget', user: _this.props.currentUser })
      );
      return _react2.default.createElement(
        'div',
        { className: _breadcrumbsWidget2.default.profile },
        _react2.default.createElement(
          _profileActionsButton2.default,
          {
            actionsContainerClassName: _breadcrumbsWidget2.default.profileActions,
            position: _profileActionsButton2.default.POSITION_RIGHT,
            icon: icon
          },
          _react2.default.createElement(_privateProfileActions2.default, { user: currentUser })
        )
      );
    }, _this.renderMembersButton = function () {
      var MembersLink = _this.props.navigation.MembersLink;

      return _this.isLoginWidgetEnabled() && !_this.props.isMemberAreaActive ? _react2.default.createElement(_iconButton2.default, {
        icon: _icons.MemberIcon,
        iconClassName: 'breadcrumbs-icon-fill members-icon-button',
        component: MembersLink,
        'aria-label': _this.props.t('breadcrumbs.members'),
        'data-hook': 'members-button'
      }) : null;
    }, _this.renderSearchInput = function () {
      return _react2.default.createElement(
        'div',
        { className: _breadcrumbsWidget2.default.searchInput, 'data-hook': 'search-input' },
        _this.props.searchInput
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BreadcrumbsWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isAuthenticated = _props.isAuthenticated,
          showLogin = _props.showLogin,
          viewMode = _props.viewMode;


      var isEditor = viewMode && viewMode === 'editor';

      // For app settings toggling
      if (isEditor && showLogin) {
        return this.renderLogin();
      }

      if (!isAuthenticated) {
        return this.renderLogin();
      } else {
        return this.renderMainWidget();
      }
    }
  }]);

  return BreadcrumbsWidget;
}(_react.Component);

BreadcrumbsWidget.propTypes = {
  isAuthenticated: _propTypes2.default.bool.isRequired,
  showLogin: _propTypes2.default.bool.isRequired,
  isOwner: _propTypes2.default.bool.isRequired,
  isLoginWidgetEnabled: _propTypes2.default.bool,
  requestLogin: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  viewMode: _propTypes2.default.string.isRequired,
  showBreadcrumbsLogin: _propTypes2.default.func.isRequired,
  searchInput: _propTypes2.default.node,
  currentUser: _propTypes2.default.object,
  navigation: _propTypes2.default.object,
  isMemberAreaActive: _propTypes2.default.bool
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    requestLogin: _requestLogin2.default,
    showBreadcrumbsLogin: _showBreadrumbsLogin.showBreadcrumbsLogin
  }, dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    showLogin: state.breadcrumbsWidget.showLogin,
    viewMode: state.viewMode,
    isMemberAreaActive: (0, _memberAreaSelectors.isMemberAreaActive)(state)
  };
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withAppSettings2.default)({ isLoginWidgetEnabled: _wixParams.IS_LOGIN_WIDGET_ENABLED_PATH }), _withAuth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withCardBackgroundColor2.default, _withTranslate2.default)(BreadcrumbsWidget);

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3yEWu","profileActions":"TxJU9","profile":"VVy-N","searchInput":"_24e9m","notificationBubble":"_1S8oG","avatarImage":"_1Jx_s","loginButton":"aUCPp","moreButton":"_1HNfq"};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

var _headerBackButton = __webpack_require__(1104);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InternalPageHeader = function InternalPageHeader(props) {
  return _react2.default.createElement(_header2.default, _extends({ left: _react2.default.createElement(_headerBackButton2.default, null) }, props));
};

exports.default = InternalPageHeader;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loginPage = __webpack_require__(1636);

var _loginPage2 = _interopRequireDefault(_loginPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loginPage2.default;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _loginMember = __webpack_require__(264);

var _loginPage = __webpack_require__(1637);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _loginScreen = __webpack_require__(552);

var _loginScreen2 = _interopRequireDefault(_loginScreen);

var _icons = __webpack_require__(9);

var _backButton = __webpack_require__(1315);

var _backButton2 = _interopRequireDefault(_backButton);

var _forMobileOnly = __webpack_require__(1013);

var _forMobileOnly2 = _interopRequireDefault(_forMobileOnly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackButtonMobile = (0, _forMobileOnly2.default)(_backButton2.default);

var LoginPage = function LoginPage(props) {
  return _react2.default.createElement(
    _loginScreen2.default,
    props,
    _react2.default.createElement(
      BackButtonMobile,
      { className: (0, _classnames2.default)(_loginPage2.default.closeButton, 'forum-icon-fill') },
      _react2.default.createElement(_icons.XSmall, null)
    )
  );
};

LoginPage.propTypes = {
  onLogin: _propTypes2.default.func.isRequired,
  onLoginError: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onLogin: function onLogin(member) {
      dispatch((0, _loginMember.loginMember)(member)).then(function () {
        return dispatch((0, _routerUtils.replace)(ownProps.location.query.redirect || '/'));
      });
    },
    onLoginError: function onLoginError() {
      dispatch((0, _routerUtils.replace)('/'));
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(LoginPage);

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"_3A7oo"};

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _membersMenu = __webpack_require__(1639);

var _membersMenu2 = _interopRequireDefault(_membersMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _membersMenu2.default;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _memberHeader = __webpack_require__(1640);

var _memberHeader2 = _interopRequireDefault(_memberHeader);

var _routerUtils = __webpack_require__(55);

var _memberSelectors = __webpack_require__(1326);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MembersMenu = function (_Component) {
  _inherits(MembersMenu, _Component);

  function MembersMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MembersMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MembersMenu.__proto__ || Object.getPrototypeOf(MembersMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleSortChange = function (sort) {
      var name = _this.props.name;

      _this.props.onFilterChange({ sort: sort, name: name });
    }, _this.handleFilterChange = function (name) {
      var sort = _this.props.sort;

      _this.props.onFilterChange({ sort: sort, name: name });
    }, _this.render = function () {
      var _this$props = _this.props,
          sort = _this$props.sort,
          name = _this$props.name,
          membersCount = _this$props.membersCount,
          isBlocked = _this$props.isBlocked;

      if (isBlocked) {
        return null;
      }
      return _react2.default.createElement(_memberHeader2.default, {
        sort: sort,
        onSortChange: _this.handleSortChange,
        filter: name,
        onFilterChange: _this.handleFilterChange,
        membersCount: membersCount
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return MembersMenu;
}(_react.Component);

MembersMenu.propTypes = {
  onFilterChange: _propTypes2.default.func,
  sort: _propTypes2.default.string,
  name: _propTypes2.default.string,
  membersCount: _propTypes2.default.number,
  isBlocked: _propTypes2.default.bool
};

var buildLocation = function buildLocation(location, params) {
  return _extends({}, location, { query: _extends({}, params) });
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var location = _ref2.location;
  return {
    sort: location.query.sort || 'postsCount',
    name: location.query.name || '',
    membersCount: (0, _memberSelectors.getMembersCount)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var location = _ref3.location;
  return (0, _redux.bindActionCreators)({
    onFilterChange: function onFilterChange(params) {
      return (0, _routerUtils.replace)(buildLocation(location, params));
    }
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withAuth2.default)(MembersMenu);

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _memberHeader = __webpack_require__(1641);

var _memberHeader2 = _interopRequireDefault(_memberHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _memberHeader2.default;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memberHeaderMobile = __webpack_require__(1642);

var _memberHeaderMobile2 = _interopRequireDefault(_memberHeaderMobile);

var _memberHeaderDesktop = __webpack_require__(1648);

var _memberHeaderDesktop2 = _interopRequireDefault(_memberHeaderDesktop);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _forDevice2.default)(_memberHeaderMobile2.default, _memberHeaderDesktop2.default);

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _separator = __webpack_require__(18);

var _memberFilter = __webpack_require__(1323);

var _memberFilter2 = _interopRequireDefault(_memberFilter);

var _memberSortField = __webpack_require__(1324);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _memberHeaderMobile = __webpack_require__(1647);

var _memberHeaderMobile2 = _interopRequireDefault(_memberHeaderMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberHeaderMobile = function MemberHeaderMobile(_ref) {
  var sort = _ref.sort,
      onSortChange = _ref.onSortChange,
      filter = _ref.filter,
      onFilterChange = _ref.onFilterChange,
      membersCount = _ref.membersCount,
      cardBackgroundColor = _ref.cardBackgroundColor;
  return _react2.default.createElement(
    'div',
    { className: 'default-forum-card-background-color', style: { backgroundColor: cardBackgroundColor } },
    _react2.default.createElement(
      'div',
      { className: _memberHeaderMobile2.default.content },
      _react2.default.createElement(_memberSortField.MembersSortFieldMobile, { className: _memberHeaderMobile2.default.sort, value: sort, onChange: onSortChange }),
      _react2.default.createElement(_separator.VerticalSeparator, { className: _memberHeaderMobile2.default.vertical }),
      _react2.default.createElement(_memberFilter2.default, { className: _memberHeaderMobile2.default.filter, value: filter, onChange: onFilterChange, count: membersCount })
    ),
    _react2.default.createElement(_separator.HorizontalSeparator, null)
  );
};

MemberHeaderMobile.propTypes = {
  sort: _propTypes2.default.string.isRequired,
  onSortChange: _propTypes2.default.func.isRequired,
  filter: _propTypes2.default.string,
  onFilterChange: _propTypes2.default.func.isRequired,
  membersCount: _propTypes2.default.number,
  cardBackgroundColor: _propTypes2.default.string
};

exports.default = (0, _withCardBackgroundColor2.default)(MemberHeaderMobile);

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_109R7","input":"lJmOr","count":"ru6Jy"};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(1325);

var _icons = __webpack_require__(9);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _memberSortFieldMobile = __webpack_require__(1645);

var _memberSortFieldMobile2 = _interopRequireDefault(_memberSortFieldMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembersSortFieldMobile = function MembersSortFieldMobile(_ref) {
  var className = _ref.className,
      value = _ref.value,
      _onChange = _ref.onChange,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_memberSortFieldMobile2.default.container, className) },
    _react2.default.createElement(_icons.SortIcon, { className: 'forum-icon-fill' }),
    _react2.default.createElement(
      'select',
      { className: _memberSortFieldMobile2.default.select, value: value, onChange: function onChange(e) {
          return _onChange(e.target.value);
        } },
      _lodash2.default.map(_constants.SORT_OPTIONS, function (translation, value) {
        return _react2.default.createElement(
          'option',
          { value: value },
          t(translation)
        );
      })
    )
  );
};

MembersSortFieldMobile.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(MembersSortFieldMobile);

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_22mK-","select":"_3XYHp"};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(1325);

var _select = __webpack_require__(548);

var _select2 = _interopRequireDefault(_select);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getOptions = function getOptions(t) {
  return _lodash2.default.map(_constants.SORT_OPTIONS, function (translation, value) {
    return {
      value: value,
      label: t(translation)
    };
  });
};

var MembersSortFieldDesktop = function MembersSortFieldDesktop(_ref) {
  var value = _ref.value,
      t = _ref.t,
      props = _objectWithoutProperties(_ref, ['value', 't']);

  return _react2.default.createElement(_select2.default, _extends({ defaultValue: value, options: getOptions(t), height: 60, isTransparent: true, isScrollable: false }, props));
};

MembersSortFieldDesktop.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(MembersSortFieldDesktop);

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"_hut_","sort":"_1g0BV","filter":"_14GMH"};

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _memberFilter = __webpack_require__(1323);

var _memberFilter2 = _interopRequireDefault(_memberFilter);

var _memberSortField = __webpack_require__(1324);

var _separator = __webpack_require__(18);

var _memberHeaderDesktop = __webpack_require__(1649);

var _memberHeaderDesktop2 = _interopRequireDefault(_memberHeaderDesktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberHeaderDesktop = function MemberHeaderDesktop(_ref) {
  var sort = _ref.sort,
      onSortChange = _ref.onSortChange,
      filter = _ref.filter,
      onFilterChange = _ref.onFilterChange,
      membersCount = _ref.membersCount;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_memberHeaderDesktop2.default.container, 'forum-card-background-color') },
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_memberHeaderDesktop2.default.borders, 'forum-text-border-color') }),
    _react2.default.createElement(_memberFilter2.default, { className: _memberHeaderDesktop2.default.filter, value: filter, onChange: onFilterChange, count: membersCount }),
    _react2.default.createElement(_separator.VerticalSeparator, null),
    _react2.default.createElement(_memberSortField.MembersSortFieldDesktop, { className: _memberHeaderDesktop2.default.sort, value: sort, onChange: onSortChange }),
    _react2.default.createElement(_separator.VerticalSeparator, null)
  );
};

MemberHeaderDesktop.propTypes = {
  sort: _propTypes2.default.string.isRequired,
  onSortChange: _propTypes2.default.func.isRequired,
  filter: _propTypes2.default.string,
  onFilterChange: _propTypes2.default.func.isRequired,
  membersCount: _propTypes2.default.number
};

exports.default = MemberHeaderDesktop;

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Asj9Q","borders":"_209vg","filter":"_2XSck","sort":"_2q0Tu"};

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _membersPage = __webpack_require__(1651);

var _membersPage2 = _interopRequireDefault(_membersPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _membersPage2.default;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MembersPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _pagination = __webpack_require__(166);

var _viewModes = __webpack_require__(161);

var _clearMembers = __webpack_require__(1085);

var _clearMembers2 = _interopRequireDefault(_clearMembers);

var _fetchMembers = __webpack_require__(199);

var _accountSuspended = __webpack_require__(1179);

var _accountSuspended2 = _interopRequireDefault(_accountSuspended);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _defaultDesktopLayout = __webpack_require__(1187);

var _defaultDesktopLayout2 = _interopRequireDefault(_defaultDesktopLayout);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _infiniteListLoader = __webpack_require__(528);

var _infiniteListLoader2 = _interopRequireDefault(_infiniteListLoader);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _loginButton = __webpack_require__(521);

var _loginButton2 = _interopRequireDefault(_loginButton);

var _memberList = __webpack_require__(1188);

var _memberList2 = _interopRequireDefault(_memberList);

var _membersPlaceholder = __webpack_require__(1652);

var _membersPlaceholder2 = _interopRequireDefault(_membersPlaceholder);

var _noMemberResults = __webpack_require__(1654);

var _noMemberResults2 = _interopRequireDefault(_noMemberResults);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _routerUtils = __webpack_require__(55);

var _isLoadingSelectors = __webpack_require__(267);

var _memberSelectors = __webpack_require__(1326);

var _viewModeSelectors = __webpack_require__(153);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reset = function reset() {
  return { page: 1 };
};
var increment = function increment(state) {
  return { page: state.page + 1 };
};

var MembersPage = exports.MembersPage = function (_Component) {
  _inherits(MembersPage, _Component);

  function MembersPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MembersPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MembersPage.__proto__ || Object.getPrototypeOf(MembersPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      page: 1
    }, _this.componentDidMount = function () {
      if (_this.props.isAuthenticated && !_this.props.isBlocked) {
        _this.fetchMembers();
      }
    }, _this.componentDidUpdate = function (_ref2) {
      var sort = _ref2.sort,
          name = _ref2.name,
          isAuthenticated = _ref2.isAuthenticated;

      if (_this.props.sort !== sort || _this.props.name !== name || _this.props.isAuthenticated && isAuthenticated !== _this.props.isAuthenticated) {
        _this.props.clearMembers();
        _this.setState(reset, _this.fetchMembers);
      }
    }, _this.fetchMembers = function () {
      var page = _this.state.page;
      var _this$props = _this.props,
          sort = _this$props.sort,
          name = _this$props.name,
          fetchMembers = _this$props.fetchMembers;


      fetchMembers({
        sort: sort,
        name: name,
        page: page,
        pageSize: _pagination.MEMBERS_PER_PAGE
      });
    }, _this.handleLoad = function () {
      return _this.setState(increment, _this.fetchMembers);
    }, _this.renderNoResults = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          membersCount = _this$props2.membersCount,
          isLoading = _this$props2.isLoading,
          viewMode = _this$props2.viewMode;


      if (isLoading || membersCount) {
        return null;
      }

      return viewMode !== _viewModes.VIEW_MODE_SITE ? _react2.default.createElement(_membersPlaceholder2.default, null) : _react2.default.createElement(_noMemberResults2.default, { name: name });
    }, _this.renderList = function () {
      var _this$props3 = _this.props,
          isLoading = _this$props3.isLoading,
          members = _this$props3.members,
          membersCount = _this$props3.membersCount;

      return (isLoading || membersCount > 0) && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_memberList2.default, { members: members }),
        _react2.default.createElement(_infiniteListLoader2.default, {
          onLoad: _this.handleLoad,
          loader: _react2.default.createElement(_loader2.default, null),
          isLoading: isLoading,
          hasMore: members.length < membersCount
        })
      );
    }, _this.renderSignUp = function () {
      var t = _this.props.t;

      return _react2.default.createElement(
        _emptyStates2.default,
        { title: t('members-page.sign-up-title'), content: t('members-page.sign-up-content') },
        _react2.default.createElement(_loginButton2.default, null)
      );
    }, _this.render = function () {
      var _this$props4 = _this.props,
          isLoading = _this$props4.isLoading,
          isBlocked = _this$props4.isBlocked,
          members = _this$props4.members,
          isAuthenticated = _this$props4.isAuthenticated;


      if (isBlocked) {
        return _react2.default.createElement(_accountSuspended2.default, null);
      }

      return _react2.default.createElement(
        _page2.default,
        { noSpacing: true },
        _react2.default.createElement(
          _animatedLoader2.default,
          { isLoading: isLoading && !members.length },
          _react2.default.createElement(
            _defaultDesktopLayout2.default,
            null,
            isAuthenticated && _this.renderNoResults(),
            isAuthenticated && _this.renderList(),
            !isAuthenticated && _this.renderSignUp()
          )
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return MembersPage;
}(_react.Component);

MembersPage.fetchData = function (_ref5) {
  var store = _ref5.store,
      query = _ref5.query,
      user = _ref5.user;

  if (!user || user.isBlocked) {
    return;
  }

  return store.dispatch((0, _fetchMembers.fetchMembers)(_extends({
    pageSize: _pagination.MEMBERS_PER_PAGE,
    page: 1
  }, _lodash2.default.pick(query, ['sort', 'name']))));
};

MembersPage.propTypes = {
  clearMembers: _propTypes2.default.func,
  fetchMembers: _propTypes2.default.func,
  onFilterChange: _propTypes2.default.func,
  sort: _propTypes2.default.string,
  name: _propTypes2.default.string,
  members: _propTypes2.default.array,
  membersCount: _propTypes2.default.number,
  isLoading: _propTypes2.default.bool,
  isBlocked: _propTypes2.default.bool,
  isAuthenticated: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  viewMode: _propTypes2.default.string
};

var buildLocation = function buildLocation(location, params) {
  return _extends({}, location, { query: _extends({}, params) });
};

var mapStateToProps = function mapStateToProps(state, _ref3) {
  var location = _ref3.location;
  return {
    sort: location.query.sort || 'postsCount',
    name: location.query.name || '',
    members: (0, _memberSelectors.getMembers)(state),
    membersCount: (0, _memberSelectors.getMembersCount)(state),
    isLoading: (0, _isLoadingSelectors.getIsMembersLoading)(state),
    viewMode: (0, _viewModeSelectors.getViewMode)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref4) {
  var location = _ref4.location;
  return (0, _redux.bindActionCreators)({
    clearMembers: _clearMembers2.default,
    fetchMembers: _fetchMembers.fetchMembersWithFakeLoading,
    onFilterChange: function onFilterChange(params) {
      return (0, _routerUtils.replace)(buildLocation(location, params));
    }
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withAuth2.default, _withTranslate2.default)(MembersPage);

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _membersPlaceholder = __webpack_require__(1653);

var _membersPlaceholder2 = _interopRequireDefault(_membersPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _membersPlaceholder2.default;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembersPlaceholder = function MembersPlaceholder(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(_emptyStates2.default, { title: t('members-placeholder.title'), content: t('members-placeholder.content') });
};

MembersPlaceholder.propTypes = {
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(MembersPlaceholder);

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _noMemberResults = __webpack_require__(1655);

var _noMemberResults2 = _interopRequireDefault(_noMemberResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _noMemberResults2.default;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoMemberResults = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(34);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _noMemberResults = __webpack_require__(1656);

var _noMemberResults2 = _interopRequireDefault(_noMemberResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoMemberResults = exports.NoMemberResults = function NoMemberResults(_ref) {
  var name = _ref.name,
      t = _ref.t;

  var tryAgain = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'no-member-results.no-members-found',
      name: _react2.default.createElement(
        'span',
        { className: _noMemberResults2.default.term },
        name
      )
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'no-member-results.try-again' })
  );
  return _react2.default.createElement(_emptyStates2.default, { className: _noMemberResults2.default.container, title: t('no-member-results.nothings-coming-up'), content: tryAgain });
};

NoMemberResults.propTypes = {
  name: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func
};

exports.default = _lodash2.default.flowRight(_withTranslate2.default)(NoMemberResults);

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Wwj8","term":"_5wDVn"};

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notFoundPage = __webpack_require__(1658);

var _notFoundPage2 = _interopRequireDefault(_notFoundPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notFoundPage2.default;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redirectTo = __webpack_require__(1007);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _layout = __webpack_require__(1237);

var _notFound = __webpack_require__(1313);

var _notFound2 = _interopRequireDefault(_notFound);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layout = (0, _forDevice2.default)(_layout.FullHeightLayout, _layout.SimpleLayout);

var NotFoundPage = exports.NotFoundPage = function (_Component) {
  _inherits(NotFoundPage, _Component);

  function NotFoundPage() {
    _classCallCheck(this, NotFoundPage);

    return _possibleConstructorReturn(this, (NotFoundPage.__proto__ || Object.getPrototypeOf(NotFoundPage)).apply(this, arguments));
  }

  _createClass(NotFoundPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _page2.default,
        null,
        _react2.default.createElement(
          Layout,
          null,
          _react2.default.createElement(_notFound2.default, null)
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }
  }]);

  return NotFoundPage;
}(_react.Component);

NotFoundPage.fetchData = function (_ref) {
  var pathname = _ref.pathname,
      store = _ref.store,
      search = _ref.search;

  return store.dispatch((0, _redirectTo.redirectTo404)(search, pathname));
};

exports.default = NotFoundPage;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notificationsPage = __webpack_require__(1660);

var _notificationsPage2 = _interopRequireDefault(_notificationsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notificationsPage2.default;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _fetchNotifications = __webpack_require__(158);

var _readNotification = __webpack_require__(1174);

var _pageOpened = __webpack_require__(410);

var _buttonClicked = __webpack_require__(57);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _notificationList = __webpack_require__(1661);

var _notificationList2 = _interopRequireDefault(_notificationList);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _notificationSelectors = __webpack_require__(1301);

var _isLoadedSelectors = __webpack_require__(412);

var _isLoadingSelectors = __webpack_require__(267);

var _getColors = __webpack_require__(265);

var _detectRoute = __webpack_require__(266);

var _notificationsPage = __webpack_require__(1667);

var _notificationsPage2 = _interopRequireDefault(_notificationsPage);

var _notificationListItem = __webpack_require__(1327);

var _notificationListItem2 = _interopRequireDefault(_notificationListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderStyles = function renderStyles() {
  return '\n  .' + _notificationListItem2.default.container + ':hover {\n    background-color: rgba(' + (0, _getColors.getSecondaryColorNumbers)() + ', 0.1);\n  }\n';
};

var NotificationsPage = exports.NotificationsPage = function (_Component) {
  _inherits(NotificationsPage, _Component);

  function NotificationsPage(props) {
    _classCallCheck(this, NotificationsPage);

    var _this = _possibleConstructorReturn(this, (NotificationsPage.__proto__ || Object.getPrototypeOf(NotificationsPage)).call(this, props));

    _this.handleNotificationClick = _this.handleNotificationClick.bind(_this);
    return _this;
  }

  _createClass(NotificationsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchNotifications();
      this.props.pageOpened({ page: _detectRoute.NOTIFICATIONS });
    }
  }, {
    key: 'handleNotificationClick',
    value: function handleNotificationClick(_ref) {
      var _id = _ref._id,
          isRead = _ref.isRead;

      this.props.buttonClicked({ name: 'notification', _id: _id });
      if (!isRead) {
        this.props.readNotification(_id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          notifications = _props.notifications,
          t = _props.t,
          isLoading = _props.isLoading,
          isLoaded = _props.isLoaded;

      return _react2.default.createElement(
        _page2.default,
        { className: _notificationsPage2.default.container, noSpacing: true },
        _react2.default.createElement(
          'style',
          null,
          renderStyles()
        ),
        _react2.default.createElement(
          _animatedLoader2.default,
          { isLoading: isLoading && !isLoaded },
          notifications.length ? _react2.default.createElement(_notificationList2.default, { notifications: notifications, onItemClick: this.handleNotificationClick }) : _react2.default.createElement(
            _emptyStates2.default,
            {
              className: _notificationsPage2.default.notifications,
              title: t('notifications-page.no-notifications-title'),
              content: t('notifications-page.no-notifications-content')
            },
            _react2.default.createElement(
              _button2.default,
              { component: _internalLink2.default, to: '/' },
              t('notifications-page.back-to-forum')
            )
          )
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }
  }]);

  return NotificationsPage;
}(_react.Component);

NotificationsPage.fetchData = function (_ref2) {
  var store = _ref2.store;

  return store.dispatch((0, _fetchNotifications.fetchNotifications)());
};

NotificationsPage.propTypes = {
  fetchNotifications: _propTypes2.default.func.isRequired,
  readNotification: _propTypes2.default.func.isRequired,
  pageOpened: _propTypes2.default.func.isRequired,
  notifications: _propTypes2.default.array.isRequired,
  buttonClicked: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  isLoaded: _propTypes2.default.bool.isRequired,
  t: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    notifications: (0, _notificationSelectors.getNotifications)(state),
    isLoading: (0, _isLoadingSelectors.getIsNotificationsLoading)(state),
    isLoaded: (0, _isLoadedSelectors.getIsNotificationsLoaded)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchNotifications: _fetchNotifications.fetchNotifications,
    readNotification: _readNotification.readNotification,
    pageOpened: _pageOpened.pageOpened,
    buttonClicked: _buttonClicked.buttonClicked
  }, dispatch);
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default)(NotificationsPage);

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notificationList = __webpack_require__(1662);

var _notificationList2 = _interopRequireDefault(_notificationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notificationList2.default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _infiniteList = __webpack_require__(1103);

var _infiniteList2 = _interopRequireDefault(_infiniteList);

var _notificationListItem = __webpack_require__(1663);

var _notificationListItem2 = _interopRequireDefault(_notificationListItem);

var _separator = __webpack_require__(18);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _notificationList = __webpack_require__(1666);

var _notificationList2 = _interopRequireDefault(_notificationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THRESHOLD = 400;

var NotificationList = function NotificationList(_ref) {
  var notifications = _ref.notifications,
      onItemClick = _ref.onItemClick,
      borderWidth = _ref.borderWidth;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(_notificationList2.default.container, 'forum-card-background-color', 'forum-card-border-color', 'forum-text-color'),
      style: { borderWidth: borderWidth }
    },
    _react2.default.createElement(_infiniteList2.default, {
      length: notifications.length,
      itemRenderer: itemRenderer(notifications, onItemClick),
      threshold: THRESHOLD
    })
  );
};

function itemRenderer(notifications, onItemClick) {
  return function (index) {
    return _react2.default.createElement(
      'div',
      { className: _notificationList2.default.listItem, key: notifications[index]._id },
      _react2.default.createElement(_notificationListItem2.default, { notification: notifications[index], onClick: onItemClick }),
      _react2.default.createElement(_separator.HorizontalSeparator, null)
    );
  };
}

NotificationList.propTypes = {
  notifications: _propTypes2.default.array.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  onItemClick: _propTypes2.default.func.isRequired
};

exports.default = (0, _withCardBorderWidth2.default)(NotificationList);

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notificationListItem = __webpack_require__(1664);

var _notificationListItem2 = _interopRequireDefault(_notificationListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notificationListItem2.default;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationListItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(34);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _experiments = __webpack_require__(32);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _reportAbuseForm = __webpack_require__(549);

var _isFullUrl = __webpack_require__(1665);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _notificationListItem = __webpack_require__(1327);

var _notificationListItem2 = _interopRequireDefault(_notificationListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buildInternalTo = function buildInternalTo(_ref) {
  var url = _ref.url,
      commentId = _ref.commentId;
  return '' + url + (commentId ? '#' + commentId : '');
};
var buildExternalTo = function buildExternalTo(_ref2) {
  var url = _ref2.url;
  return (0, _isFullUrl.isFullUrl)(url) ? url : (0, _getOuterUrl2.default)(url);
};

var getReportMessage = function getReportMessage(notification) {
  return (0, _lodash.get)(_reportAbuseForm.REASONS.find(function (reason) {
    return reason.value && reason.value.toString() === notification.message;
  }), 'text');
};

var trimPostTitle = function trimPostTitle(title) {
  return title.length <= 20 ? title : title.substring(0, 20) + '...';
};

var getPostTitle = function getPostTitle(notification) {
  return notification.data && notification.data.title && trimPostTitle(notification.data.title) || 'a post';
};

var renderMessage = function renderMessage(notification, t) {
  switch (notification.type) {
    case 'comment':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.comment',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: notification.message })
        )
      });
    case 'post-like':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.post-liked',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: notification.message })
        )
      });
    case 'comment-like':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.comment-liked',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: notification.message })
        )
      });
    case 'post-report':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.post-reported',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        title: t('notification-list-item.title', { title: getPostTitle(notification) }),
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: t(getReportMessage(notification) || '') })
        )
      });
    case 'comment-report':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.comment-reported',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        title: t('notification-list-item.title', { title: getPostTitle(notification) }),
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: t(getReportMessage(notification) || '') })
        )
      });
    case 'user-report':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.user-reported',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        reportedName: notification.data.name,
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: t(getReportMessage(notification) || '') })
        )
      });
    case 'post':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.post',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        ),
        message: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.message', { message: notification.message })
        )
      });
    case 'permissions-moderator-promote':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.permissions-moderator-promoted',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        )
      });
    case 'permissions-moderator-demote':
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'notification-list-item.permissions-moderator-demoted',
        useDangerouslySetInnerHTML: true,
        name: _react2.default.createElement(
          'strong',
          null,
          t('notification-list-item.name', { name: notification.user.name })
        )
      });

    default:
      return _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'notification-list-item.unknown', useDangerouslySetInnerHTML: true });
  }
};

var NotificationListItem = exports.NotificationListItem = function (_Component) {
  _inherits(NotificationListItem, _Component);

  function NotificationListItem() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = NotificationListItem.__proto__ || Object.getPrototypeOf(NotificationListItem)).call.apply(_ref3, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          notification = _this$props.notification;

      onClick(notification);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          notification = _props.notification,
          contentFontClassName = _props.contentFontClassName,
          t = _props.t,
          useInternalRouting = _props.useInternalRouting;

      var linkProps = {
        to: useInternalRouting ? buildInternalTo(notification) : buildExternalTo(notification),
        fullUrl: !useInternalRouting
      };
      return _react2.default.createElement(
        _internalLink2.default,
        _extends({ onClick: this.handleClick }, linkProps),
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_notificationListItem2.default.container, contentFontClassName, 'forum-text-color', 'notification-list-item'),
            'data-hook': 'notification-list-item'
          },
          _react2.default.createElement(
            'div',
            { className: _notificationListItem2.default.column1 },
            _react2.default.createElement(_userAvatarImage2.default, { className: _notificationListItem2.default.avatar, user: notification.user })
          ),
          _react2.default.createElement(
            'div',
            { className: _notificationListItem2.default.column2 },
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)(_notificationListItem2.default.message, 'notification-list-item__message'),
                'data-hook': 'notification-list-item__message'
              },
              renderMessage(notification, t)
            ),
            _react2.default.createElement(_timeAgo2.default, { className: _notificationListItem2.default.timeAgo, time: notification.createdDate })
          ),
          _react2.default.createElement(
            'div',
            { className: _notificationListItem2.default.column3 },
            !notification.isRead ? _react2.default.createElement('span', {
              className: (0, _classnames2.default)(_notificationListItem2.default.dot, 'icon-secondary-background-color', 'notification-list-item__dot')
            }) : null
          )
        )
      );
    }
  }]);

  return NotificationListItem;
}(_react.Component);

NotificationListItem.propTypes = {
  t: _propTypes2.default.func.isRequired,
  notification: _propTypes2.default.object.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  useInternalRouting: _propTypes2.default.bool
};

exports.default = (0, _lodash.flowRight)((0, _withExperiment2.default)({ useInternalRouting: _experiments.EXPERIMENT_SWITCH_NOTIFICATIONS_SERVICE }), _withFontClassName2.default, _withTranslate2.default)(NotificationListItem);

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFullUrl = undefined;

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFullUrl = exports.isFullUrl = function isFullUrl(location) {
  var url = (0, _urijs2.default)(location);
  return url.protocol() && url.hostname();
};

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Aly2"};

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notifications":"_2cp7-"};

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postCreatePage = __webpack_require__(1669);

var _postCreatePage2 = _interopRequireDefault(_postCreatePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postCreatePage2.default;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostCreatePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reduxForm = __webpack_require__(40);

var _currentUserSelectors = __webpack_require__(67);

var _categoriesSelectors = __webpack_require__(35);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _postPageLayout = __webpack_require__(1185);

var _postPageLayout2 = _interopRequireDefault(_postPageLayout);

var _postForm = __webpack_require__(517);

var _postForm2 = _interopRequireDefault(_postForm);

var _createPost = __webpack_require__(200);

var _goBack = __webpack_require__(1184);

var _goBack2 = _interopRequireDefault(_goBack);

var _openModal = __webpack_require__(36);

var _modalTypes = __webpack_require__(26);

var _textEditorUtils = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostCreatePage = exports.PostCreatePage = function (_Component) {
  _inherits(PostCreatePage, _Component);

  function PostCreatePage(props) {
    _classCallCheck(this, PostCreatePage);

    var _this = _possibleConstructorReturn(this, (PostCreatePage.__proto__ || Object.getPrototypeOf(PostCreatePage)).call(this, props));

    _this.handleSubmit = function (post) {
      return _this.props.createPost(post);
    };

    _this.handleCancel = function (isModified) {
      var categorySlug = _this.props.params.categorySlug;

      if (isModified) {
        return _this.props.openModal(_modalTypes.MODAL_TYPE_DISCARD_POST, { categorySlug: categorySlug }, (0, _textEditorUtils.getFocusableContainerId)('post'));
      } else {
        return _this.props.goBack('/' + _this.props.params.categorySlug);
      }
    };

    _this.state = {
      initialValues: { ownerId: props.ownerId, categoryId: props.categoryId }
    };
    return _this;
  }

  _createClass(PostCreatePage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          categoryId = _props.categoryId,
          handleSubmitButtonClick = _props.submit;


      return _react2.default.createElement(
        _postPageLayout2.default,
        { className: 'post-create-page' },
        _react2.default.createElement(_postForm2.default, {
          onSubmit: this.handleSubmit,
          onSubmitButtonClick: handleSubmitButtonClick,
          onCancel: this.handleCancel,
          initialValues: this.state.initialValues,
          categoryId: categoryId
        }),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }
  }]);

  return PostCreatePage;
}(_react.Component);

PostCreatePage.propTypes = {
  createPost: _propTypes2.default.func.isRequired,
  goBack: _propTypes2.default.func.isRequired,
  openModal: _propTypes2.default.func.isRequired,
  submit: _propTypes2.default.func.isRequired,
  ownerId: _propTypes2.default.string.isRequired,
  categoryId: _propTypes2.default.string,
  post: _propTypes2.default.object,
  params: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    ownerId: (0, _currentUserSelectors.getCurrentUserId)(state),
    categoryId: (0, _categoriesSelectors.getCategoryBySlug)(state, ownProps.params.categorySlug)._id
  };
};

var mapDispatchToProps = {
  createPost: _createPost.createPost,
  submit: function submit() {
    return (0, _reduxForm.startSubmit)('post');
  },
  goBack: _goBack2.default,
  openModal: _openModal.openModal
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostCreatePage);

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postCreatePageHeader = __webpack_require__(1671);

var _postCreatePageHeader2 = _interopRequireDefault(_postCreatePageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postCreatePageHeader2.default;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

var _headerBackButton = __webpack_require__(1104);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

var _styledTextEditor = __webpack_require__(292);

var _publishButton = __webpack_require__(1249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostCreatePageHeader = function PostCreatePageHeader() {
  return _react2.default.createElement(_header2.default, {
    left: _react2.default.createElement(_headerBackButton2.default, null),
    right: _react2.default.createElement(_publishButton.PostPublishButton, { formName: 'post' }),
    menu: _react2.default.createElement(_styledTextEditor.TextEditorMobileToolbar, { identifier: 'post' })
  });
};

exports.default = PostCreatePageHeader;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postEditPage = __webpack_require__(1673);

var _postEditPage2 = _interopRequireDefault(_postEditPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postEditPage2.default;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostEditPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _reduxForm = __webpack_require__(40);

var _postSelectors = __webpack_require__(117);

var _categoriesSelectors = __webpack_require__(35);

var _fetchPost2 = __webpack_require__(165);

var _fetchPostAndRedirect = __webpack_require__(1245);

var _updatePost = __webpack_require__(397);

var _goBack = __webpack_require__(1184);

var _goBack2 = _interopRequireDefault(_goBack);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _postPageLayout = __webpack_require__(1185);

var _postPageLayout2 = _interopRequireDefault(_postPageLayout);

var _postForm = __webpack_require__(517);

var _postForm2 = _interopRequireDefault(_postForm);

var _pageOpened = __webpack_require__(410);

var _openModal = __webpack_require__(36);

var _detectRoute = __webpack_require__(266);

var _modalTypes = __webpack_require__(26);

var _textEditorUtils = __webpack_require__(66);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostEditPage = exports.PostEditPage = function (_Component) {
  _inherits(PostEditPage, _Component);

  function PostEditPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostEditPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostEditPage.__proto__ || Object.getPrototypeOf(PostEditPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (post) {
      var _this$props = _this.props,
          updatePost = _this$props.updatePost,
          showMessage = _this$props.showMessage;

      updatePost(_extends({}, _this.props.post, post)).then(function () {
        return showMessage(_messages2.default[_messages.POST_UPDATE].content(), _messages2.default[_messages.POST_UPDATE].type);
      });
    }, _this.handleCancel = function (isModified) {
      var categorySlug = _this.props.category.slug;

      if (isModified) {
        return _this.props.openModal(_modalTypes.MODAL_TYPE_DISCARD_POST, { categorySlug: categorySlug }, (0, _textEditorUtils.getFocusableContainerId)('post'));
      } else {
        return _this.props.goBack('/' + categorySlug);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PostEditPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.pageOpened({ page: _detectRoute.POST_EDIT_PAGE });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchPost();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          post = _props.post,
          handleSubmitButtonClick = _props.submit;

      if (!post) {
        return null;
      }

      return _react2.default.createElement(
        _postPageLayout2.default,
        null,
        _react2.default.createElement(_postForm2.default, {
          initialValues: post,
          onSubmit: this.handleSubmit,
          onSubmitButtonClick: handleSubmitButtonClick,
          onCancel: this.handleCancel,
          postId: post._id
        }),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }
  }]);

  return PostEditPage;
}(_react.Component);

PostEditPage.fetchData = function (_ref3) {
  var store = _ref3.store,
      params = _ref3.params,
      search = _ref3.search;

  return store.dispatch((0, _fetchPostAndRedirect.fetchPostAndRedirect)(params.categorySlug, params.postSlug, search, function (category, post, search) {
    return '/' + category.slug + '/' + post.slug + '/edit' + search;
  }));
};

PostEditPage.propTypes = {
  fetchPost: _propTypes2.default.func.isRequired,
  updatePost: _propTypes2.default.func.isRequired,
  showMessage: _propTypes2.default.func.isRequired,
  submit: _propTypes2.default.func.isRequired,
  goBack: _propTypes2.default.func.isRequired,
  openModal: _propTypes2.default.func.isRequired,
  pageOpened: _propTypes2.default.func.isRequired,
  post: _propTypes2.default.object,
  category: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var post = (0, _postSelectors.getPostBySlug)(state, ownProps.params.postSlug);
  return {
    post: post,
    postForm: state.postForm,
    category: (0, _categoriesSelectors.getCategory)(state, post && post.categoryId)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var postSlug = _ref2.params.postSlug;
  return (0, _redux.bindActionCreators)({
    fetchPost: function fetchPost() {
      return (0, _fetchPost2.fetchPost)(postSlug);
    },
    updatePost: _updatePost.updatePost,
    goBack: _goBack2.default,
    openModal: _openModal.openModal,
    pageOpened: _pageOpened.pageOpened,
    submit: function submit() {
      return (0, _reduxForm.startSubmit)('post');
    }
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }))(PostEditPage);

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postEditPageHeader = __webpack_require__(1675);

var _postEditPageHeader2 = _interopRequireDefault(_postEditPageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postEditPageHeader2.default;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

var _headerBackButton = __webpack_require__(1104);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

var _styledTextEditor = __webpack_require__(292);

var _publishButton = __webpack_require__(1249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostEditPageHeader = function PostEditPageHeader() {
  return _react2.default.createElement(_header2.default, {
    left: _react2.default.createElement(_headerBackButton2.default, null),
    right: _react2.default.createElement(_publishButton.PostPublishButton, { text: 'post-edit-page-header.update', formName: 'post' }),
    menu: _react2.default.createElement(_styledTextEditor.TextEditorMobileToolbar, { identifier: 'post' })
  });
};

exports.default = PostEditPageHeader;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postPage = __webpack_require__(1677);

var _postPage2 = _interopRequireDefault(_postPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postPage2.default;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostPage = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _reduxForm = __webpack_require__(40);

var _pagination = __webpack_require__(166);

var _fetchComments = __webpack_require__(136);

var _fetchPost = __webpack_require__(165);

var _fetchPostAndRedirect = __webpack_require__(1245);

var _incrementCommentLikeCount = __webpack_require__(246);

var _incrementPostViewCount = __webpack_require__(1678);

var _pageOpened = __webpack_require__(410);

var _postSocket = __webpack_require__(591);

var _redirectTo = __webpack_require__(1007);

var _setIsLoaded = __webpack_require__(198);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _accountSuspended = __webpack_require__(1179);

var _accountSuspended2 = _interopRequireDefault(_accountSuspended);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _commentingDisabled = __webpack_require__(1679);

var _commentingDisabled2 = _interopRequireDefault(_commentingDisabled);

var _emptyComment = __webpack_require__(1682);

var _emptyComment2 = _interopRequireDefault(_emptyComment);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _pageMetadata = __webpack_require__(1180);

var _pageMetadata2 = _interopRequireDefault(_pageMetadata);

var _paginationComments = __webpack_require__(1685);

var _paginationComments2 = _interopRequireDefault(_paginationComments);

var _postContent = __webpack_require__(1688);

var _postContent2 = _interopRequireDefault(_postContent);

var _postHeader = __webpack_require__(1008);

var _postHeader2 = _interopRequireDefault(_postHeader);

var _postPageLayout = __webpack_require__(1185);

var _postPageLayout2 = _interopRequireDefault(_postPageLayout);

var _postPageStats = __webpack_require__(1690);

var _postPageStats2 = _interopRequireDefault(_postPageStats);

var _postTitle = __webpack_require__(970);

var _postTitle2 = _interopRequireDefault(_postTitle);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _postCommentList = __webpack_require__(1693);

var _postCommentList2 = _interopRequireDefault(_postCommentList);

var _postMainActions = __webpack_require__(1703);

var _postMainActions2 = _interopRequireDefault(_postMainActions);

var _postPageFooter = __webpack_require__(1715);

var _postPageFooter2 = _interopRequireDefault(_postPageFooter);

var _contentStateToString = __webpack_require__(553);

var _contentStateToString2 = _interopRequireDefault(_contentStateToString);

var _detectRoute = __webpack_require__(266);

var _getPostCover = __webpack_require__(526);

var _getPostCover2 = _interopRequireDefault(_getPostCover);

var _hashLinkHandler = __webpack_require__(1002);

var _hashLinkHandler2 = _interopRequireDefault(_hashLinkHandler);

var _pagination2 = __webpack_require__(45);

var _routerUtils = __webpack_require__(55);

var _scrollTo = __webpack_require__(537);

var _categoriesSelectors = __webpack_require__(35);

var _commentSelectors = __webpack_require__(1248);

var _currentUserSelectors = __webpack_require__(67);

var _isLoadedSelectors = __webpack_require__(412);

var _isLoadingSelectors = __webpack_require__(267);

var _paginationSelectors = __webpack_require__(424);

var _postSelectors = __webpack_require__(117);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _postPage = __webpack_require__(1741);

var _postPage2 = _interopRequireDefault(_postPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostPage = exports.PostPage = function (_Component) {
  _inherits(PostPage, _Component);

  function PostPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostPage.__proto__ || Object.getPrototypeOf(PostPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.componentDidMount = function () {
      var _this$props = _this.props,
          _this$props$params = _this$props.params,
          postSlug = _this$props$params.postSlug,
          categorySlug = _this$props$params.categorySlug,
          isAuthenticated = _this$props.isAuthenticated,
          category = _this$props.category,
          push = _this$props.push,
          replace = _this$props.replace;


      if ((0, _lodash.isEmpty)(category)) {
        return;
      }

      if (!isAuthenticated && category.isPrivate) {
        replace('/login?redirect=/' + categorySlug + '/' + postSlug);
      } else if (isAuthenticated || !category.isPrivate) {
        _this.props.fetchPost(postSlug).then(function (post) {
          _this.fetchComments(post, postSlug);
          _this.props.incrementPostViewCount(post._id);
          _this.props.emitOpenPost(post);
          _this.props.pageOpened({
            page: _detectRoute.POST_PAGE,
            post: post
          });
        }).catch(function (error) {
          if (error.status === 401) {
            push('/' + categorySlug);
          }
        });
      }
    }, _this.componentWillReceiveProps = function (nextProps) {
      var _nextProps$params = nextProps.params,
          postSlug = _nextProps$params.postSlug,
          categorySlug = _nextProps$params.categorySlug,
          isAuthenticated = nextProps.isAuthenticated,
          category = nextProps.category,
          push = nextProps.push,
          replace = nextProps.replace;


      if ((0, _lodash.isEmpty)(category)) {
        return;
      }

      if (!isAuthenticated && category.isPrivate) {
        replace('/login?redirect=/' + categorySlug + '/' + postSlug);
      } else if ((isAuthenticated || !category.isPrivate) && _this.props.params.postSlug !== postSlug) {
        _this.props.fetchPost(postSlug).then(function (post) {
          _this.fetchComments(post, postSlug);
          _this.props.incrementPostViewCount(post._id);
          _this.props.emitOpenPost(post);
          _this.props.pageOpened({
            page: _detectRoute.POST_PAGE,
            post: post
          });
        }).catch(function (error) {
          if (error.status === 401) {
            push('/' + categorySlug);
          }
        });
      }
    }, _this.fetchComments = function (post, postSlug) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props.page;

      return _this.props.fetchComments({
        postId: post._id,
        postSlug: postSlug,
        pageSize: _pagination.COMMENTS_PER_PAGE,
        page: page
      });
    }, _this.componentWillUnmount = function () {
      _this.props.setIsLoaded('comments', _this.props.params.postSlug, false);
      if (!(0, _lodash.isEmpty)(_this.props.category)) {
        _this.props.emitClosePost(_this.props.post);
      }
    }, _this.componentDidUpdate = function () {
      (0, _hashLinkHandler2.default)(_this.props.location);
    }, _this.handleEmptyCommentMouseDown = function () {
      if (document.activeElement.tagName.toLowerCase() === 'textarea') {
        _this.ignoreClick = true;
      }
    }, _this.handleEmptyCommentClick = function () {
      if (!_this.ignoreClick) {
        _this.props.focusCommentForm();
      }
      delete _this.ignoreClick;
    }, _this.renderEmptyComment = function () {
      if (!_this.props.allComments.length && !_this.props.post.isCommentsDisabled) {
        return _react2.default.createElement(_emptyComment2.default, { onClick: _this.handleEmptyCommentClick, onMouseDown: _this.handleEmptyCommentMouseDown });
      }
    }, _this.setFirstCommentBottomPosition = function (firstCommentBottomPosition) {
      _this.setState({ firstCommentBottomPosition: firstCommentBottomPosition });
    }, _this.renderPagination = function () {
      var _this$props2 = _this.props,
          page = _this$props2.page,
          entityCount = _this$props2.entityCount,
          isMobile = _this$props2.isMobile,
          isCommentsLoaded = _this$props2.isCommentsLoaded;

      if (!isMobile && isCommentsLoaded) {
        return _react2.default.createElement(_paginationComments2.default, {
          page: page,
          entityCount: entityCount,
          showPerPage: _pagination.COMMENTS_PER_PAGE,
          onChange: _this.handlePageChange
        });
      }
    }, _this.handleCommentCreate = function () {
      var _this$props3 = _this.props,
          post = _this$props3.post,
          entityCount = _this$props3.entityCount,
          _this$props3$params = _this$props3.params,
          postSlug = _this$props3$params.postSlug,
          categorySlug = _this$props3$params.categorySlug;

      var lastPage = (0, _pagination2.getLastPage)(entityCount, _pagination.COMMENTS_PER_PAGE);
      if (_this.props.page === lastPage) {
        return;
      }

      _this.fetchComments(post, postSlug, lastPage);
      _this.props.push({
        pathname: '/' + categorySlug + '/' + postSlug,
        query: { page: lastPage }
      });
    }, _this.handlePageChange = function (_ref2) {
      var page = _ref2.page;
      var _this$props4 = _this.props,
          post = _this$props4.post,
          _this$props4$params = _this$props4.params,
          postSlug = _this$props4$params.postSlug,
          categorySlug = _this$props4$params.categorySlug;

      _this.fetchComments(post, postSlug, page).then(_scrollTo.scrollToAppTop);
      _this.props.push({
        pathname: '/' + categorySlug + '/' + postSlug,
        query: { page: page }
      });
    }, _this.loadMore = function (page) {
      var _this$props5 = _this.props,
          post = _this$props5.post,
          postSlug = _this$props5.params.postSlug;

      _this.fetchComments(post, postSlug, page);
    }, _this.renderEditDate = function () {
      var _this$props6 = _this.props,
          post = _this$props6.post,
          t = _this$props6.t;


      if (post.editedDate) {
        return _react2.default.createElement(
          'p',
          { className: _postPage2.default.edited },
          t('post-page.edited'),
          '\xA0',
          _react2.default.createElement(
            'span',
            { className: _postPage2.default.editedDate },
            _react2.default.createElement(_timeAgo2.default, { time: post.editedDate })
          )
        );
      }
    }, _this.renderFooter = function () {
      var _this$props7 = _this.props,
          isBlocked = _this$props7.isBlocked,
          post = _this$props7.post,
          t = _this$props7.t,
          allComments = _this$props7.allComments,
          isCommentsLoading = _this$props7.isCommentsLoading,
          isCommentsLoaded = _this$props7.isCommentsLoaded;

      if (isBlocked || post.isCommentsDisabled) {
        return _react2.default.createElement(_commentingDisabled2.default, { message: t(isBlocked ? 'post-page.commenting-blocked' : 'post-page.commenting-disabled') });
      }

      var showFooter = !isCommentsLoading && isCommentsLoaded || !(0, _lodash.isEmpty)(allComments);
      if (!showFooter) {
        return null;
      }

      return _react2.default.createElement(_postPageFooter2.default, {
        onCommentCreate: _this.handleCommentCreate,
        postId: post._id,
        isSticky: Boolean(_this.state.firstCommentBottomPosition && allComments.length),
        stickyThreshold: _this.state.firstCommentBottomPosition
      });
    }, _this.renderPost = function () {
      var _this$props8 = _this.props,
          category = _this$props8.category,
          post = _this$props8.post,
          location = _this$props8.location,
          borderWidth = _this$props8.borderWidth,
          titleFontClassName = _this$props8.titleFontClassName,
          page = _this$props8.page;

      if (page > 1) {
        return null;
      }

      var postContainerClassName = (0, _classnames2.default)(_postPage2.default.postContainer, 'forum-card-background-color', 'forum-card-border-color', 'forum-text-color');

      var isHeaderAnimated = location.state && location.state.isAnimated;
      return _react2.default.createElement(
        'main',
        { className: postContainerClassName, style: { borderWidth: borderWidth } },
        _react2.default.createElement(
          'div',
          { className: _postPage2.default.postContentWrapper, 'data-hook': 'post-page__post' },
          _react2.default.createElement(_postHeader2.default, { type: _postHeader2.default.SINGLE, post: post, isAnimated: isHeaderAnimated }),
          _react2.default.createElement(_postTitle2.default, { className: titleFontClassName, type: _postTitle2.default.SINGLE, title: post.title || '', component: 'h1' }),
          _react2.default.createElement(
            'div',
            { className: _postPage2.default.postStatsContainer },
            _react2.default.createElement(_postPageStats2.default, { viewCount: post.viewCount, commentCount: post.totalComments, isAnimated: isHeaderAnimated }),
            _this.renderEditDate()
          ),
          _react2.default.createElement(
            'div',
            { className: _postPage2.default.postContent },
            _react2.default.createElement(_postContent2.default, { post: post })
          ),
          _react2.default.createElement(_postMainActions2.default, { category: category, post: post })
        )
      );
    }, _this.renderEmpty = function () {
      var t = _this.props.t;

      return _react2.default.createElement(
        _emptyStates2.default,
        {
          className: _postPage2.default.emptyState,
          title: t('post-page.not-found-title'),
          content: t('post-page.not-fount-content')
        },
        _react2.default.createElement(
          _button2.default,
          { component: _internalLink2.default, to: '/' },
          t('post-page.back-to-forum')
        )
      );
    }, _this.render = function () {
      var _this$props9 = _this.props,
          postSlug = _this$props9.params.postSlug,
          isBlocked = _this$props9.isBlocked,
          category = _this$props9.category,
          post = _this$props9.post,
          contentFontClassName = _this$props9.contentFontClassName,
          isLoading = _this$props9.isLoading,
          isLoaded = _this$props9.isLoaded,
          isCommentsLoading = _this$props9.isCommentsLoading,
          isCommentsLoaded = _this$props9.isCommentsLoaded,
          allComments = _this$props9.allComments;


      if ((0, _lodash.isEmpty)(post) && !isLoading) {
        return _this.renderEmpty();
      }

      if (!(0, _lodash.isEmpty)(category) && category.isPrivate && isBlocked) {
        return _react2.default.createElement(_accountSuspended2.default, { className: _postPage2.default.emptyState });
      }

      var showCommentsLoader = isCommentsLoading && !isCommentsLoaded && (0, _lodash.isEmpty)(allComments);

      return _react2.default.createElement(
        _postPageLayout2.default,
        { className: (0, _classnames2.default)(_postPage2.default.postPage, contentFontClassName, 'forum-background-color') },
        _react2.default.createElement(_pageMetadata2.default, {
          title: post.title,
          description: (0, _contentStateToString2.default)(post.content),
          image: (0, _getPostCover2.default)(post.content),
          type: 'article'
        }),
        _react2.default.createElement(
          _animatedLoader2.default,
          { isLoading: isLoading && !isLoaded && (0, _lodash.isEmpty)(post) },
          _this.renderPost(),
          _react2.default.createElement(
            _animatedLoader2.default,
            { isLoading: showCommentsLoader, isAnimated: true },
            _react2.default.createElement(
              'div',
              null,
              _this.renderEmptyComment(),
              _react2.default.createElement(_postCommentList2.default, {
                loadMore: _this.loadMore,
                page: _this.props.page,
                setFirstCommentBottomPosition: _this.setFirstCommentBottomPosition,
                postSlug: postSlug
              }),
              _this.renderFooter(),
              _this.renderPagination()
            )
          )
        ),
        _react2.default.createElement(_appLoaded2.default, { parent: _this, selector: '[data-hook=post-page__post]' })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PostPage;
}(_react.Component);

PostPage.fetchData = function (_ref3) {
  var store = _ref3.store,
      _ref3$params = _ref3.params,
      categorySlug = _ref3$params.categorySlug,
      postSlug = _ref3$params.postSlug,
      query = _ref3.query,
      search = _ref3.search;
  return store.dispatch((0, _fetchPostAndRedirect.fetchPostAndRedirect)(categorySlug, postSlug, search)).then(function (post) {
    return store.dispatch((0, _fetchComments.fetchComments)({
      postId: post._id,
      postSlug: postSlug,
      page: (0, _lodash.toNumber)(query.page) || 1,
      pageSize: _pagination.COMMENTS_PER_PAGE
    }));
  }).catch(function (error) {
    if (error.status === 401) {
      return store.dispatch((0, _routerUtils.push)({
        pathname: '/login' + search + '&redirect=/' + categorySlug + '/' + postSlug
      }));
    } else {
      return store.dispatch((0, _redirectTo.redirectTo404)(search));
    }
  });
};

PostPage.propTypes = {
  fetchPost: _propTypes2.default.func.isRequired,
  fetchComments: _propTypes2.default.func.isRequired,
  incrementPostViewCount: _propTypes2.default.func.isRequired,
  incrementCommentLikeCount: _propTypes2.default.func.isRequired,
  category: _propTypes2.default.object.isRequired,
  post: _propTypes2.default.object.isRequired,
  allComments: _propTypes2.default.array.isRequired,
  focusCommentForm: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.object,
  page: _propTypes2.default.number,
  isMobile: _propTypes2.default.bool,
  emitOpenPost: _propTypes2.default.func.isRequired,
  emitClosePost: _propTypes2.default.func.isRequired,
  pageOpened: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func,
  typing: _propTypes2.default.array,
  ownerId: _propTypes2.default.string,
  entityCount: _propTypes2.default.number,
  isAuthenticated: _propTypes2.default.bool,
  isBlocked: _propTypes2.default.bool,
  params: _propTypes2.default.object,
  borderWidth: _propTypes2.default.number.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  setIsLoaded: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  isLoaded: _propTypes2.default.bool.isRequired,
  isCommentsLoading: _propTypes2.default.bool.isRequired,
  isCommentsLoaded: _propTypes2.default.bool.isRequired,
  push: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var post = (0, _postSelectors.getPostBySlug)(state, ownProps.params.postSlug) || {};
  var page = (0, _lodash.toNumber)((0, _lodash.get)(ownProps, 'location.query.page', 1));
  return {
    category: (0, _categoriesSelectors.getCategoryBySlug)(state, ownProps.params.categorySlug) || {},
    post: post,
    allComments: (0, _commentSelectors.getCommentsByPostId)(state, post._id),
    typing: state.typing,
    ownerId: (0, _currentUserSelectors.getCurrentUserId)(state),
    isLoading: (0, _isLoadingSelectors.getIsPostLoading)(state, ownProps.params.postSlug),
    isLoaded: (0, _isLoadedSelectors.getIsPostLoaded)(state, ownProps.params.postSlug),
    isCommentsLoading: (0, _isLoadingSelectors.getIsCommentsLoading)(state, ownProps.params.postSlug),
    isCommentsLoaded: (0, _isLoadedSelectors.getIsCommentsLoaded)(state, ownProps.params.postSlug),
    entityCount: (0, _paginationSelectors.getEntityCount)(state, 'comments'),
    page: page
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchPost: _fetchPost.fetchPost,
    fetchComments: _fetchComments.fetchComments,
    incrementPostViewCount: _incrementPostViewCount.incrementPostViewCount,
    incrementCommentLikeCount: _incrementCommentLikeCount.incrementCommentLikeCount,
    focusCommentForm: function focusCommentForm() {
      return (0, _reduxForm.focus)('comment', 'content');
    },
    emitOpenPost: _postSocket.emitOpenPost,
    emitClosePost: _postSocket.emitClosePost,
    pageOpened: _pageOpened.pageOpened,
    setIsLoaded: _setIsLoaded.setIsLoaded,
    push: _routerUtils.push,
    replace: _routerUtils.replace
  }, dispatch);
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withDeviceType2.default, _withFontClassName2.default, _withCardBorderWidth2.default, _withAuth2.default, _withTranslate2.default)(PostPage);

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incrementPostViewCount = incrementPostViewCount;
var INCREMENT_POST_VIEW_COUNT_REQUEST = exports.INCREMENT_POST_VIEW_COUNT_REQUEST = 'post/INCREMENT_VIEW_COUNT_REQUEST';

function incrementPostViewCount(postId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: INCREMENT_POST_VIEW_COUNT_REQUEST
    });

    return request.post('/_api/posts/' + postId + '/views');
  };
}

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentingDisabled = __webpack_require__(1680);

var _commentingDisabled2 = _interopRequireDefault(_commentingDisabled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentingDisabled2.default;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _commentingDisabled = __webpack_require__(1681);

var _commentingDisabled2 = _interopRequireDefault(_commentingDisabled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentingDisabled = function CommentingDisabled(_ref) {
  var message = _ref.message,
      contentFontClassName = _ref.contentFontClassName,
      borderWidth = _ref.borderWidth;

  var containerClassName = (0, _classnames2.default)(_commentingDisabled2.default.container, contentFontClassName, 'forum-card-background-color', 'forum-card-border-color', 'forum-text-color');

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: { borderWidth: borderWidth }, 'data-hook': 'disabled-commenting' },
    _react2.default.createElement(
      'span',
      { className: _commentingDisabled2.default.wrapper },
      _react2.default.createElement(_icons.LockIcon, { className: _commentingDisabled2.default.icon }),
      message
    )
  );
};

CommentingDisabled.propTypes = {
  message: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  borderWidth: _propTypes2.default.number.isRequired
};

exports.default = (0, _withFontClassName2.default)((0, _withCardBorderWidth2.default)(CommentingDisabled));

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"YbahY","wrapper":"ptKpa","icon":"_3rKyv"};

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _emptyComment = __webpack_require__(1683);

var _emptyComment2 = _interopRequireDefault(_emptyComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _emptyComment2.default;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _emptyComment = __webpack_require__(1684);

var _emptyComment2 = _interopRequireDefault(_emptyComment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EmptyComment = function EmptyComment(_ref) {
  var t = _ref.t,
      props = _objectWithoutProperties(_ref, ['t']);

  return _react2.default.createElement(
    'article',
    _extends({
      className: (0, _classnames2.default)(_emptyComment2.default.comment, 'forum-card-background-color', 'forum-text-color', 'empty-comment')
    }, props),
    _react2.default.createElement(
      'div',
      { className: _emptyComment2.default.text },
      t('empty-comment.be-te-first')
    )
  );
};

EmptyComment.propTypes = {
  onClick: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(EmptyComment);

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"comment":"_3hvYZ","text":"_1a5RX"};

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _paginationComments = __webpack_require__(1686);

var _paginationComments2 = _interopRequireDefault(_paginationComments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _paginationComments2.default;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _pagination = __webpack_require__(1244);

var _pagination2 = _interopRequireDefault(_pagination);

var _paginationComments = __webpack_require__(1687);

var _paginationComments2 = _interopRequireDefault(_paginationComments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationComments = function PaginationComments(props) {
  return _react2.default.createElement(
    'div',
    { className: _paginationComments2.default.container },
    _react2.default.createElement(_pagination2.default, _extends({
      className: _paginationComments2.default.pagination,
      arrowClass: _paginationComments2.default.arrow,
      innerClass: _paginationComments2.default.page,
      activeClass: (0, _classnames2.default)(_paginationComments2.default.active, 'button-color')
    }, props))
  );
};

exports.default = PaginationComments;

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1DXoI","pagination":"_2qSOj","arrow":"_2k2s_","page":"_32H_N","active":"_3DvJo"};

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postContent = __webpack_require__(1689);

var _postContent2 = _interopRequireDefault(_postContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postContent2.default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.PostContent = PostContent;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledTextEditor = __webpack_require__(292);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PostContent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      post = _ref.post,
      contentFontClassName = _ref.contentFontClassName,
      can = _ref.can;

  var postBody = void 0;

  if (_typeof(post.content) === 'object') {
    postBody = _react2.default.createElement(_styledTextEditor.DraftRenderer, { content: post.content, isPublic: can('share', 'post', post) });
  }

  return _react2.default.createElement(
    'article',
    { className: contentFontClassName },
    _react2.default.createElement(
      'div',
      { className: 'post-content__body', tabIndex: '0' },
      postBody
    )
  );
}

PostContent.propTypes = {
  post: _propTypes2.default.object.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  can: _propTypes2.default.func
};

exports.default = _lodash2.default.flowRight(_withFontClassName2.default, _withPermissions2.default)(PostContent);

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postPageStats = __webpack_require__(1691);

var _postPageStats2 = _interopRequireDefault(_postPageStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postPageStats2.default;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(122);

var _postStats = __webpack_require__(1105);

var _postStats2 = _interopRequireDefault(_postStats);

var _postPageStats = __webpack_require__(1692);

var _postPageStats2 = _interopRequireDefault(_postPageStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_TIMEOUT = 1200;

var PostPageStats = function PostPageStats(_ref) {
  var viewCount = _ref.viewCount,
      commentCount = _ref.commentCount,
      isAnimated = _ref.isAnimated;

  return _react2.default.createElement(
    _reactTransitionGroup.CSSTransitionGroup,
    {
      transitionName: _postPageStats2.default,
      transitionEnterTimeout: ANIMATION_TIMEOUT,
      transitionAppearTimeout: ANIMATION_TIMEOUT,
      transitionLeaveTimeout: 0,
      transitionAppear: isAnimated,
      component: 'div'
    },
    _react2.default.createElement(
      'div',
      { key: 'stats' },
      _react2.default.createElement(
        'div',
        { className: _postPageStats2.default.container },
        _react2.default.createElement(_postStats2.default, { viewCount: viewCount, commentCount: commentCount })
      )
    )
  );
};

PostPageStats.propTypes = {
  viewCount: _propTypes2.default.number,
  commentCount: _propTypes2.default.number,
  isAnimated: _propTypes2.default.bool
};

exports.default = PostPageStats;

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"s93RF","enter":"_1bYzr","appear":"_1XYQj","enterActive":"voVCx","appearActive":"_3mamL"};

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postCommentList = __webpack_require__(1694);

var _postCommentList2 = _interopRequireDefault(_postCommentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postCommentList2.default;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostCommentList = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isLoadingSelectors = __webpack_require__(267);

var _commentSelectors = __webpack_require__(1248);

var _paginationSelectors = __webpack_require__(424);

var _editedCommentIdSelectors = __webpack_require__(1328);

var _incrementCommentLikeCount = __webpack_require__(246);

var _setIsLoaded = __webpack_require__(198);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _postSelectors = __webpack_require__(117);

var _loadMore = __webpack_require__(1312);

var _loadMore2 = _interopRequireDefault(_loadMore);

var _loader = __webpack_require__(185);

var _loader2 = _interopRequireDefault(_loader);

var _commentList = __webpack_require__(1695);

var _commentList2 = _interopRequireDefault(_commentList);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostCommentList = exports.PostCommentList = function (_Component) {
  _inherits(PostCommentList, _Component);

  function PostCommentList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostCommentList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostCommentList.__proto__ || Object.getPrototypeOf(PostCommentList)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillUnmount = function () {
      _this.props.setIsLoaded('comments', _this.props.postId, false);
    }, _this.render = function () {
      var _this$props = _this.props,
          allComments = _this$props.allComments,
          currentPageComments = _this$props.currentPageComments,
          isCommentsLoading = _this$props.isCommentsLoading,
          entityCount = _this$props.entityCount,
          isMobile = _this$props.isMobile;

      if (!allComments.length) {
        return null;
      }

      if (isMobile) {
        return _react2.default.createElement(
          _loadMore2.default,
          {
            loadMore: _this.props.loadMore,
            loader: _react2.default.createElement(_loader2.default, null),
            isLoading: isCommentsLoading,
            hasMore: allComments.length < entityCount
          },
          _this.renderCommentList(allComments)
        );
      }

      if (currentPageComments.length) {
        return _this.renderCommentList(currentPageComments);
      }

      return null;
    }, _this.renderCommentList = function (comments) {
      var _this$props2 = _this.props,
          incrementCommentLikeCount = _this$props2.incrementCommentLikeCount,
          editedCommentId = _this$props2.editedCommentId,
          topCommentId = _this$props2.topCommentId;

      return _react2.default.createElement(_commentList2.default, {
        reportBottomPosition: _this.props.setFirstCommentBottomPosition,
        comments: comments,
        onLikeClick: incrementCommentLikeCount,
        editedCommentId: editedCommentId,
        topCommentId: topCommentId
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PostCommentList;
}(_react.Component);

PostCommentList.propTypes = {
  editedCommentId: _propTypes2.default.string,
  topCommentId: _propTypes2.default.string,
  allComments: _propTypes2.default.array.isRequired,
  currentPageComments: _propTypes2.default.array.isRequired,
  entityCount: _propTypes2.default.number,
  postId: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isCommentsLoading: _propTypes2.default.bool,
  setIsLoaded: _propTypes2.default.func,
  loadMore: _propTypes2.default.func,
  incrementCommentLikeCount: _propTypes2.default.func.isRequired,
  setFirstCommentBottomPosition: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var post = (0, _postSelectors.getPostBySlug)(state, ownProps.postSlug) || {};
  var page = ownProps.page;
  return {
    isCommentsLoading: (0, _isLoadingSelectors.getIsCommentsLoading)(state, ownProps.postSlug),
    currentPageComments: (0, _commentSelectors.getCommentsByPostIdAndPage)(state, post._id, page),
    allComments: (0, _commentSelectors.getCommentsByPostId)(state, post._id),
    entityCount: (0, _paginationSelectors.getEntityCount)(state, 'comments'),
    editedCommentId: (0, _editedCommentIdSelectors.getEditedCommentId)(state),
    topCommentId: post.topCommentId,
    postId: post._id
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    incrementCommentLikeCount: _incrementCommentLikeCount.incrementCommentLikeCount,
    setIsLoaded: _setIsLoaded.setIsLoaded
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withDeviceType2.default)(PostCommentList);

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentList = __webpack_require__(1696);

var _commentList2 = _interopRequireDefault(_commentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentList2.default;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _infiniteList = __webpack_require__(1103);

var _infiniteList2 = _interopRequireDefault(_infiniteList);

var _comment = __webpack_require__(1697);

var _comment2 = _interopRequireDefault(_comment);

var _commentEditForm = __webpack_require__(1700);

var _commentEditForm2 = _interopRequireDefault(_commentEditForm);

var _separator = __webpack_require__(18);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _experiments = __webpack_require__(32);

var _commentList = __webpack_require__(1702);

var _commentList2 = _interopRequireDefault(_commentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THRESHOLD = 400;

var CommentList = function CommentList(_ref) {
  var comments = _ref.comments,
      onLikeClick = _ref.onLikeClick,
      onReplyClick = _ref.onReplyClick,
      reportBottomPosition = _ref.reportBottomPosition,
      isMobile = _ref.isMobile,
      editedCommentId = _ref.editedCommentId,
      topCommentId = _ref.topCommentId,
      isTopCommentExperimentEnabled = _ref.isTopCommentExperimentEnabled;
  return _react2.default.createElement(
    'div',
    { id: 'comments', className: _commentList2.default.commentList },
    _react2.default.createElement(_infiniteList2.default, {
      length: comments.length,
      itemRenderer: itemRenderer({
        comments: comments,
        onLikeClick: onLikeClick,
        onReplyClick: onReplyClick,
        reportBottomPosition: reportBottomPosition,
        isMobile: isMobile,
        editedCommentId: editedCommentId,
        topCommentId: topCommentId,
        isTopCommentExperimentEnabled: isTopCommentExperimentEnabled
      }),
      threshold: THRESHOLD
    })
  );
};

function itemRenderer(_ref2) {
  var comments = _ref2.comments,
      onLikeClick = _ref2.onLikeClick,
      onReplyClick = _ref2.onReplyClick,
      reportBottomPosition = _ref2.reportBottomPosition,
      isMobile = _ref2.isMobile,
      editedCommentId = _ref2.editedCommentId,
      topCommentId = _ref2.topCommentId,
      isTopCommentExperimentEnabled = _ref2.isTopCommentExperimentEnabled;

  return function (index) {
    var isLast = index === comments.length - 1;
    var comment = comments[index];
    var key = comment._id;
    var isTopComment = isTopCommentExperimentEnabled && comment._id === topCommentId;

    var result = [editedCommentId === comment._id ? renderCommentForm({ key: key, comment: comment }) : renderComment({ key: key, index: index, comment: comment, reportBottomPosition: reportBottomPosition, onLikeClick: onLikeClick, onReplyClick: onReplyClick, isTopComment: isTopComment })];
    if (isMobile && !isLast) {
      result.push(_react2.default.createElement(_separator.HorizontalSeparator, { className: _commentList2.default.separator, key: key + '-separator' }));
    }
    return result;
  };
}

/* eslint-disable react/prop-types */
function renderCommentForm(_ref3) {
  var key = _ref3.key,
      comment = _ref3.comment;

  return _react2.default.createElement(_commentEditForm2.default, { key: key, comment: comment });
}
/* eslint-enable react/prop-types */

/* eslint-disable react/prop-types */
function renderComment(_ref4) {
  var key = _ref4.key,
      index = _ref4.index,
      comment = _ref4.comment,
      reportBottomPosition = _ref4.reportBottomPosition,
      onLikeClick = _ref4.onLikeClick,
      onReplyClick = _ref4.onReplyClick,
      isTopComment = _ref4.isTopComment;

  return _react2.default.createElement(_comment2.default, {
    reportBottomPosition: index === 0 ? reportBottomPosition : null,
    key: key,
    comment: comment,
    isTopComment: isTopComment,
    onLikeClick: onLikeClick,
    onReplyClick: onReplyClick
  });
}
/* eslint-enable react/prop-types */

CommentList.propTypes = {
  comments: _propTypes2.default.array.isRequired,
  onLikeClick: _propTypes2.default.func.isRequired,
  onReplyClick: _propTypes2.default.func,
  reportBottomPosition: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  editedCommentId: _propTypes2.default.string,
  topCommentId: _propTypes2.default.string,
  isTopCommentExperimentEnabled: _propTypes2.default.bool
};

exports.default = (0, _lodash.flowRight)(_withDeviceType2.default, (0, _withExperiment2.default)({ isTopCommentExperimentEnabled: _experiments.EXPERIMENT_TOP_COMMENT }))(CommentList);

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _comment = __webpack_require__(1698);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _comment2.default;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(34);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _commentHeader = __webpack_require__(1088);

var _commentHeader2 = _interopRequireDefault(_commentHeader);

var _commentFooter = __webpack_require__(1089);

var _commentFooter2 = _interopRequireDefault(_commentFooter);

var _styledTextEditor = __webpack_require__(292);

var _timeAgo = __webpack_require__(275);

var _timeAgo2 = _interopRequireDefault(_timeAgo);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTopCommentColor = __webpack_require__(276);

var _withTopCommentColor2 = _interopRequireDefault(_withTopCommentColor);

var _getImageUrl = __webpack_require__(183);

var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

var _comment = __webpack_require__(1699);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_PHOTO_HEIGHT = 600;
var PHOTO_QUALITY = 60;

var Comment = function (_Component) {
  _inherits(Comment, _Component);

  function Comment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Comment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Comment.__proto__ || Object.getPrototypeOf(Comment)).call.apply(_ref, [this].concat(args))), _this), _this.setComment = function (ref) {
      _this.ref = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Comment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var reportBottomPosition = this.props.reportBottomPosition;

      if (reportBottomPosition) {
        reportBottomPosition(this.ref.offsetTop + this.ref.offsetHeight);
      }
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var image = this.props.comment.image;


      if (!image) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { className: _comment2.default.image, src: (0, _getImageUrl2.default)(image, undefined, MAX_PHOTO_HEIGHT, PHOTO_QUALITY) })
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var comment = this.props.comment;


      var commentBody = null;
      if (_typeof(comment.content) === 'object') {
        commentBody = _react2.default.createElement(_styledTextEditor.DraftRenderer, { type: 'comment', content: comment.content });
      }
      return commentBody;
    }
  }, {
    key: 'renderEditDate',
    value: function renderEditDate() {
      var comment = this.props.comment;


      if (!comment.editedDate) {
        return null;
      }

      return _react2.default.createElement(
        'p',
        { className: _comment2.default.editDate, 'data-hook': 'edit-date' },
        _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'comment.edited', timeAgo: _react2.default.createElement(_timeAgo2.default, { time: comment.editedDate }) })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          comment = _props.comment,
          borderWidth = _props.borderWidth,
          contentFontClassName = _props.contentFontClassName,
          isTopComment = _props.isTopComment,
          topCommentColor = _props.topCommentColor;

      var commentClass = (0, _classnames2.default)(_comment2.default.comment, contentFontClassName, 'forum-text-color', 'forum-card-background-color', 'forum-card-border-color', 'comment');
      var commentStyle = { borderWidth: borderWidth };

      var markerClass = void 0;
      var markerStyle = void 0;

      if (isTopComment) {
        markerClass = (0, _classnames2.default)('button-background-color', _comment2.default.commentMarker);
        markerStyle = { width: Math.max(borderWidth, 3) };
        if (topCommentColor) {
          markerStyle.backgroundColor = topCommentColor;
        }
      }

      return _react2.default.createElement(
        'div',
        { className: _comment2.default.commentWrapper },
        isTopComment && _react2.default.createElement('div', { className: markerClass, style: markerStyle, 'data-hook': 'marker' }),
        _react2.default.createElement(
          'article',
          { id: comment._id, ref: this.setComment, className: commentClass, style: commentStyle, 'data-hook': 'comment' },
          _react2.default.createElement(
            'div',
            { className: _comment2.default.contentWrapper },
            _react2.default.createElement(
              'div',
              { className: _comment2.default.header },
              _react2.default.createElement(_commentHeader2.default, { comment: comment, showMoreButton: true, showTopComment: isTopComment })
            ),
            this.renderEditDate(),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(_comment2.default.content, 'comment__content') },
              this.renderBody(),
              this.renderImage()
            ),
            _react2.default.createElement(_commentFooter2.default, {
              comment: comment,
              onLikeClick: this.props.onLikeClick,
              onReplyClick: this.props.onReplyClick,
              showReplyLink: true
            })
          )
        )
      );
    }
  }]);

  return Comment;
}(_react.Component);

Comment.propTypes = {
  comment: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func,
  onLikeClick: _propTypes2.default.func.isRequired,
  onReplyClick: _propTypes2.default.func,
  reportBottomPosition: _propTypes2.default.func,
  borderWidth: _propTypes2.default.number.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  isTopComment: _propTypes2.default.bool,
  topCommentColor: _propTypes2.default.string
};

exports.default = (0, _lodash.flowRight)(_withFontClassName2.default, _withTranslate2.default, _withCardBorderWidth2.default, _withTopCommentColor2.default)(Comment);

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"commentWrapper":"X8hfe","commentMarker":"_3I5h8","comment":"_2lpCC","contentWrapper":"_2OpAa","header":"_1d81R","editDate":"_3ywfU","content":"_3vLKi","image":"_3rcX1"};

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentEditForm = __webpack_require__(1701);

var _commentEditForm2 = _interopRequireDefault(_commentEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentEditForm2.default;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentEditForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _updateComment = __webpack_require__(446);

var _stopEditingComment = __webpack_require__(1098);

var _commentFormWrapper = __webpack_require__(1247);

var _commentFormWrapper2 = _interopRequireDefault(_commentFormWrapper);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _commentForm = __webpack_require__(1246);

var _commentForm2 = _interopRequireDefault(_commentForm);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentEditForm = exports.CommentEditForm = function (_Component) {
  _inherits(CommentEditForm, _Component);

  function CommentEditForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentEditForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentEditForm.__proto__ || Object.getPrototypeOf(CommentEditForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var _this$props = _this.props,
          comment = _this$props.comment,
          updateComment = _this$props.updateComment,
          showMessage = _this$props.showMessage;

      updateComment(_extends({}, comment, values)).then(function () {
        return showMessage(_messages2.default[_messages.COMMENT_UPDATE].content(), _messages2.default[_messages.COMMENT_UPDATE].type);
      });
    }, _this.render = function () {
      var _this$props2 = _this.props,
          stopEditingComment = _this$props2.stopEditingComment,
          comment = _this$props2.comment,
          isDesktop = _this$props2.isDesktop;

      return _react2.default.createElement(
        _commentFormWrapper2.default,
        null,
        _react2.default.createElement(_commentForm2.default, {
          initialValues: comment,
          onSubmit: _this.handleSubmit,
          onCancel: function onCancel() {
            return stopEditingComment();
          },
          form: 'comment-' + comment._id,
          editedDate: comment.editedDate,
          autoFocus: isDesktop
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CommentEditForm;
}(_react.Component);

CommentEditForm.propTypes = {
  comment: _propTypes2.default.object.isRequired,
  showMessage: _propTypes2.default.func.isRequired,
  stopEditingComment: _propTypes2.default.func.isRequired,
  updateComment: _propTypes2.default.func.isRequired,
  isDesktop: _propTypes2.default.bool.isRequired
};

var mapDispatchToProps = {
  updateComment: _updateComment.updateComment,
  stopEditingComment: _stopEditingComment.stopEditingComment
};

// prettier-ignore
exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }), _withDeviceType2.default)(CommentEditForm);

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"commentList":"_3iCxm","separator":"_33fbR"};

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postMainActions = __webpack_require__(1704);

var _postMainActions2 = _interopRequireDefault(_postMainActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postMainActions2.default;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _incrementPostLikeCount = __webpack_require__(160);

var _modalTypes = __webpack_require__(26);

var _openModal = __webpack_require__(36);

var _postMainActions = __webpack_require__(1705);

var _postMainActions2 = _interopRequireDefault(_postMainActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    onShareClick: function onShareClick() {
      return (0, _openModal.openModal)(_modalTypes.MODAL_TYPE_SHARE_POST, {
        categoryId: ownProps.category._id,
        categorySlug: ownProps.category.slug,
        postId: ownProps.post._id,
        postSlug: ownProps.post.slug
      });
    },
    onLikeClick: function onLikeClick() {
      return (0, _incrementPostLikeCount.incrementPostLikeCount)(ownProps.post._id);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(_postMainActions2.default);

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postMainActions = __webpack_require__(1706);

var _postMainActions2 = _interopRequireDefault(_postMainActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postMainActions2.default;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _protectedButton = __webpack_require__(274);

var _protectedButton2 = _interopRequireDefault(_protectedButton);

var _likeButton = __webpack_require__(372);

var _likeButton2 = _interopRequireDefault(_likeButton);

var _postSocialActions = __webpack_require__(1707);

var _postSocialActions2 = _interopRequireDefault(_postSocialActions);

var _separator = __webpack_require__(18);

var _showShare = __webpack_require__(1010);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _postMainActions = __webpack_require__(1714);

var _postMainActions2 = _interopRequireDefault(_postMainActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostMainActions = function PostMainActions(_ref) {
  var can = _ref.can,
      category = _ref.category,
      post = _ref.post,
      onShareClick = _ref.onShareClick,
      onLikeClick = _ref.onLikeClick,
      isDesktop = _ref.isDesktop,
      isMobile = _ref.isMobile,
      t = _ref.t,
      forPublicUser = _ref.forPublicUser;

  var canShare = can('share', 'post', post) && (0, _showShare.showShare)();
  var likeCount = post.likeCount || 0;

  return _react2.default.createElement(
    'div',
    { className: _postMainActions2.default.container },
    isMobile && _react2.default.createElement(_separator.HorizontalSeparator, null),
    _react2.default.createElement(
      'div',
      { className: _postMainActions2.default.buttonContainer },
      canShare && isDesktop && _react2.default.createElement(_postSocialActions2.default, { path: '/' + category.slug + '/' + post.slug }),
      canShare && !isDesktop && _react2.default.createElement(
        'button',
        { className: _postMainActions2.default.button, onClick: onShareClick },
        _react2.default.createElement(
          'span',
          { className: _postMainActions2.default.buttonWrapper },
          t('post-main-actions.share')
        )
      ),
      canShare && isMobile && _react2.default.createElement(_separator.VerticalSeparator, null),
      _react2.default.createElement(
        _protectedButton2.default,
        { className: _postMainActions2.default.button, onClick: forPublicUser(onLikeClick), 'aria-live': 'assertive' },
        _react2.default.createElement(
          'span',
          { className: _postMainActions2.default.buttonWrapper },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(_postMainActions2.default.likeCount, 'post-main-actions__like-count'), 'data-hook': 'post-main-actions__like-count' },
            t('post-main-actions.like-count', { count: likeCount })
          ),
          _react2.default.createElement(_likeButton2.default, { isLiked: post.isLiked, likeCount: likeCount, isDisabled: post.isLikeInProgress })
        )
      )
    ),
    isMobile && _react2.default.createElement(_separator.HorizontalSeparator, null)
  );
};

PostMainActions.propTypes = {
  category: _propTypes2.default.object.isRequired,
  post: _propTypes2.default.object.isRequired,
  onShareClick: _propTypes2.default.func.isRequired,
  onLikeClick: _propTypes2.default.func.isRequired,
  isDesktop: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  can: _propTypes2.default.func,
  t: _propTypes2.default.func,
  forPublicUser: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)(_withDeviceType2.default, _withPermissions2.default, _withTranslate2.default, _withAuth2.default)(PostMainActions);

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modalTypes = __webpack_require__(26);

var _openModal = __webpack_require__(36);

var _postSocialActions = __webpack_require__(1708);

var _postSocialActions2 = _interopRequireDefault(_postSocialActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openShareLinkModal: function openShareLinkModal(url, focusOnCloseId) {
      return (0, _openModal.openModal)(_modalTypes.MODAL_TYPE_SHARE_LINK, { url: url }, focusOnCloseId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(_postSocialActions2.default);

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postSocialActions = __webpack_require__(1709);

var _postSocialActions2 = _interopRequireDefault(_postSocialActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postSocialActions2.default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostSocialActions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _postShareButton = __webpack_require__(1710);

var _postShareButton2 = _interopRequireDefault(_postShareButton);

var _share = __webpack_require__(550);

var _share2 = _interopRequireDefault(_share);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _postSocialActions = __webpack_require__(1713);

var _postSocialActions2 = _interopRequireDefault(_postSocialActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var containerId = 'post-social-actions';

var PostSocialActions = exports.PostSocialActions = function (_Component) {
  _inherits(PostSocialActions, _Component);

  function PostSocialActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostSocialActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostSocialActions.__proto__ || Object.getPrototypeOf(PostSocialActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleLinkButtonClick = function () {
      _this.props.openShareLinkModal((0, _getOuterUrl2.default)(_this.props.path), containerId);
    }, _this.handleShare = function (socialNetwork) {
      (0, _share2.default)(socialNetwork, (0, _getOuterUrl2.default)(_this.props.path));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PostSocialActions, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(_postSocialActions2.default.container, 'forum-text-color', this.props.titleFontClassName),
          tabIndex: '-1',
          id: containerId
        },
        _react2.default.createElement(
          'div',
          { className: _postSocialActions2.default.content },
          _react2.default.createElement(
            'span',
            { className: _postSocialActions2.default.button },
            _react2.default.createElement(_postShareButton2.default, { type: 'facebook', title: t('share-button.via-facebook'), onClick: this.handleShare })
          ),
          _react2.default.createElement(
            'span',
            { className: _postSocialActions2.default.button },
            _react2.default.createElement(_postShareButton2.default, { type: 'twitter', title: t('share-button.via-twitter'), onClick: this.handleShare })
          ),
          _react2.default.createElement(
            'span',
            { className: _postSocialActions2.default.button },
            _react2.default.createElement(_postShareButton2.default, { type: 'gPlus', title: t('share-button.via-google-plus'), onClick: this.handleShare })
          ),
          _react2.default.createElement(
            'span',
            { className: _postSocialActions2.default.button },
            _react2.default.createElement(_postShareButton2.default, { type: 'link', title: t('share-button.via-link'), onClick: this.handleLinkButtonClick })
          )
        )
      );
    }
  }]);

  return PostSocialActions;
}(_react.Component);

PostSocialActions.propTypes = {
  path: _propTypes2.default.string.isRequired,
  openShareLinkModal: _propTypes2.default.func.isRequired,
  titleFontClassName: _propTypes2.default.string,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withFontClassName2.default)((0, _withTranslate2.default)(PostSocialActions));

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postShareButton = __webpack_require__(1711);

var _postShareButton2 = _interopRequireDefault(_postShareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postShareButton2.default;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _postShareButton = __webpack_require__(1712);

var _postShareButton2 = _interopRequireDefault(_postShareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICONS = {
  facebook: _icons.FacebookIcon,
  twitter: _icons.TwitterIcon,
  gPlus: _icons.GPlusIcon,
  link: _icons.LinkIcon
};

var PostShareButton = function (_Component) {
  _inherits(PostShareButton, _Component);

  function PostShareButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostShareButton.__proto__ || Object.getPrototypeOf(PostShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          type = _this$props.type;

      onClick(type);
    }, _this.render = function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          title = _this$props2.title;

      var iconClassName = (0, _classnames2.default)(_postShareButton2.default.icon, 'forum-icon-fill', { 'button-hover-fill': type === 'link' });
      var Icon = ICONS[type];

      return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)(_postShareButton2.default.button, _postShareButton2.default[type]), onClick: _this.handleClick, 'aria-label': title },
        _react2.default.createElement(Icon, { className: iconClassName })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PostShareButton;
}(_react.Component);

PostShareButton.propTypes = {
  type: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired
};

exports.default = PostShareButton;

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_1Dbzt","icon":"_18TCf","facebook":"_3gl0x","twitter":"_2G9lv","gPlus":"rhdNG","link":"fx736"};

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"s6v4D"};

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Zi3o","buttonContainer":"_1ZAT1","button":"_1By31","likeCount":"_1g70M","icon":"_2AirV"};

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postPageFooter = __webpack_require__(1716);

var _postPageFooter2 = _interopRequireDefault(_postPageFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postPageFooter2.default;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostPageFooter = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(5);

var _reduxForm = __webpack_require__(40);

var _draftJs = __webpack_require__(10);

var _createComment = __webpack_require__(176);

var _typingSocket = __webpack_require__(1101);

var _upload = __webpack_require__(171);

var _cancelUploads = __webpack_require__(422);

var _updateTextEditor = __webpack_require__(261);

var _stopEditingComment = __webpack_require__(1098);

var _cardOverlay = __webpack_require__(1717);

var _cardOverlay2 = _interopRequireDefault(_cardOverlay);

var _postPageFooterWrapper = __webpack_require__(1720);

var _postPageFooterWrapper2 = _interopRequireDefault(_postPageFooterWrapper);

var _commentBar = __webpack_require__(1725);

var _commentBar2 = _interopRequireDefault(_commentBar);

var _commentForm = __webpack_require__(1246);

var _commentForm2 = _interopRequireDefault(_commentForm);

var _loginToComment = __webpack_require__(1732);

var _loginToComment2 = _interopRequireDefault(_loginToComment);

var _typingList = __webpack_require__(1735);

var _typingList2 = _interopRequireDefault(_typingList);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _typingSelectors = __webpack_require__(1178);

var _editedCommentIdSelectors = __webpack_require__(1328);

var _resizeImage = __webpack_require__(271);

var _resizeImage2 = _interopRequireDefault(_resizeImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostPageFooter = exports.PostPageFooter = function (_Component) {
  _inherits(PostPageFooter, _Component);

  function PostPageFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostPageFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostPageFooter.__proto__ || Object.getPrototypeOf(PostPageFooter)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillUnmount = function () {
      _this.props.clearTypingUsers();
      _this.props.cancelUploads();
    }, _this.handleCommentChange = function () {
      return _this.props.emitTyping(_this.props.currentUser, { _id: _this.props.postId });
    }, _this.handleCommentFormSubmit = function (comment) {
      return _this.props.createComment(_this.props.postId, comment).then(function () {
        _this.props.onCommentCreate();
        return _this.props.updateTextEditor({
          identifier: 'comment',
          editorState: _draftJs.EditorState.createEmpty()
        });
      });
    }, _this.handleCommentImageChange = function (file) {
      return (0, _resizeImage2.default)(file).then(function (_ref2) {
        var dataUrl = _ref2.dataUrl;

        _this.props.change('comment', 'image', dataUrl);
        _this.props.upload(dataUrl, _upload.TYPE_IMAGE, function (file) {
          return (0, _reduxForm.change)('comment', 'image', file);
        });
      });
    }, _this.handleCommentImageDelete = function () {
      _this.props.change('comment', 'image', null);
    }, _this.getInitialFormValues = function () {
      return {
        ownerId: _this.props.currentUser._id
      };
    }, _this.renderCommentBar = function () {
      return _react2.default.createElement(_commentBar2.default, {
        initialValues: _this.getInitialFormValues(),
        onChange: _this.handleCommentChange,
        onSubmit: _this.handleCommentFormSubmit,
        onImageChange: _this.handleCommentImageChange,
        onImageDelete: _this.handleCommentImageDelete
      });
    }, _this.renderCommentForm = function () {
      return _react2.default.createElement(_commentForm2.default, {
        initialValues: _this.getInitialFormValues(),
        onChange: _this.handleCommentChange,
        onSubmit: _this.handleCommentFormSubmit,
        shouldDisableButton: !_this.props.isEditingComment
      });
    }, _this.render = function () {
      var _this$props = _this.props,
          isMobile = _this$props.isMobile,
          isAuthenticated = _this$props.isAuthenticated,
          typingUsers = _this$props.typingUsers,
          isSticky = _this$props.isSticky,
          stickyThreshold = _this$props.stickyThreshold,
          isEditingComment = _this$props.isEditingComment,
          stopEditingComment = _this$props.stopEditingComment;

      var content = void 0;

      if (isAuthenticated) {
        content = isMobile ? _this.renderCommentBar() : _this.renderCommentForm();
      } else {
        content = _react2.default.createElement(_loginToComment2.default, null);
      }

      return _react2.default.createElement(
        _postPageFooterWrapper2.default,
        {
          isMobile: isMobile,
          isSticky: isSticky,
          stickyThreshold: stickyThreshold,
          isTyping: Boolean(typingUsers.length)
        },
        isEditingComment && !isMobile ? _react2.default.createElement(_cardOverlay2.default, { onClick: stopEditingComment }) : null,
        _react2.default.createElement(_typingList2.default, { users: typingUsers }),
        content
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PostPageFooter;
}(_react.Component);

PostPageFooter.propTypes = {
  postId: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool.isRequired,
  currentUser: _propTypes2.default.object,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  isSticky: _propTypes2.default.bool,
  stickyThreshold: _propTypes2.default.number,
  typingUsers: _propTypes2.default.array.isRequired,
  emitTyping: _propTypes2.default.func.isRequired,
  upload: _propTypes2.default.func.isRequired,
  cancelUploads: _propTypes2.default.func.isRequired,
  clearTypingUsers: _propTypes2.default.func.isRequired,
  createComment: _propTypes2.default.func.isRequired,
  change: _propTypes2.default.func.isRequired,
  updateTextEditor: _propTypes2.default.func.isRequired,
  onCommentCreate: _propTypes2.default.func.isRequired,
  stopEditingComment: _propTypes2.default.func.isRequired,
  isEditingComment: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    typingUsers: (0, _typingSelectors.getTypingUsers)(state),
    isEditingComment: (0, _editedCommentIdSelectors.isEditingComment)(state)
  };
};

PostPageFooter.defaultProps = {
  onCommentCreate: function onCommentCreate() {}
};
var mapDispatchToProps = {
  createComment: _createComment.createComment,
  emitTyping: _typingSocket.emitTypingThrottled,
  clearTypingUsers: _typingSocket.clearTypingUsers,
  upload: _upload.upload,
  change: _reduxForm.change,
  cancelUploads: _cancelUploads.cancelUploads,
  updateTextEditor: _updateTextEditor.updateTextEditor,
  stopEditingComment: _stopEditingComment.stopEditingComment
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withAuth2.default, _withDeviceType2.default)(PostPageFooter);

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _cardOverlay = __webpack_require__(1718);

var _cardOverlay2 = _interopRequireDefault(_cardOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _cardOverlay2.default;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _cardOverlay = __webpack_require__(1719);

var _cardOverlay2 = _interopRequireDefault(_cardOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardOverlay = function CardOverlay(_ref) {
  var children = _ref.children,
      backgroundColor = _ref.cardBackgroundColor,
      otherProps = _objectWithoutProperties(_ref, ['children', 'cardBackgroundColor']);

  return _react2.default.createElement(
    'div',
    _extends({}, otherProps, {
      className: (0, _classnames2.default)(_cardOverlay2.default.container, 'default-forum-card-background-color'),
      style: { backgroundColor: backgroundColor }
    }),
    children
  );
};

CardOverlay.propTypes = {
  children: _propTypes2.default.node,
  cardBackgroundColor: _propTypes2.default.string.isRequired
};

exports.default = (0, _withCardBackgroundColor2.default)(CardOverlay);

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"nktaJ"};

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postPageFooterWrapper = __webpack_require__(1721);

var _postPageFooterWrapper2 = _interopRequireDefault(_postPageFooterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postPageFooterWrapper2.default;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostPageFooterWrapper = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _stickyFooter = __webpack_require__(1722);

var _stickyFooter2 = _interopRequireDefault(_stickyFooter);

var _separator = __webpack_require__(18);

var _commentFormWrapper = __webpack_require__(1247);

var _commentFormWrapper2 = _interopRequireDefault(_commentFormWrapper);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _postPageFooterWrapper = __webpack_require__(1724);

var _postPageFooterWrapper2 = _interopRequireDefault(_postPageFooterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostPageFooterWrapper = exports.PostPageFooterWrapper = function PostPageFooterWrapper(_ref) {
  var isMobile = _ref.isMobile,
      isSticky = _ref.isSticky,
      stickyThreshold = _ref.stickyThreshold,
      isTyping = _ref.isTyping,
      children = _ref.children,
      backgroundColor = _ref.cardBackgroundColor;

  if (!isMobile) {
    return _react2.default.createElement(
      'div',
      { className: _postPageFooterWrapper2.default.container },
      _react2.default.createElement(
        _commentFormWrapper2.default,
        null,
        children
      )
    );
  }

  var typingHeight = isTyping ? 20 : 0;
  var contentHeight = 60;
  var containerHeight = contentHeight + typingHeight;
  var className = (0, _classnames2.default)(_postPageFooterWrapper2.default.container, {
    'default-forum-card-background-color': isSticky,
    'forum-card-background-color': !isSticky
  });
  var style = isSticky ? { backgroundColor: backgroundColor } : null;
  var content = _react2.default.createElement(
    'div',
    { className: className, style: style },
    _react2.default.createElement(_separator.HorizontalSeparator, null),
    children
  );

  if (!isSticky) {
    return content;
  }

  return _react2.default.createElement(
    _stickyFooter2.default,
    { containerHeight: containerHeight, contentHeight: contentHeight, showAfter: stickyThreshold },
    content
  );
};

PostPageFooterWrapper.propTypes = {
  children: _propTypes2.default.node,
  isSticky: _propTypes2.default.bool,
  stickyThreshold: _propTypes2.default.number,
  isTyping: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  cardBackgroundColor: _propTypes2.default.string.isRequired
};

exports.default = (0, _withCardBackgroundColor2.default)(PostPageFooterWrapper);

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stickyFooter = __webpack_require__(1723);

var _stickyFooter2 = _interopRequireDefault(_stickyFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _stickyFooter2.default;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyFooter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _reactGateway = __webpack_require__(405);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_FORM_HEIGHT = 60;

var StickyFooter = exports.StickyFooter = function (_Component) {
  _inherits(StickyFooter, _Component);

  function StickyFooter(props) {
    _classCallCheck(this, StickyFooter);

    var _this = _possibleConstructorReturn(this, (StickyFooter.__proto__ || Object.getPrototypeOf(StickyFooter)).call(this, props));

    _this.state = {
      showPixels: 0
    };


    _this.showFooter = _this.showFooter.bind(_this);
    return _this;
  }

  _createClass(StickyFooter, [{
    key: 'showFooter',
    value: function showFooter() {
      if (!this.props.showAfter) {
        return;
      }

      var scrollTop = (0, _scrollParent2.default)().scrollTop;
      var scrollBottom = scrollTop + (0, _scrollParent2.default)().clientHeight;

      var formHeight = scrollBottom - this.props.showAfter;
      var roofFormHeight = formHeight < DEFAULT_FORM_HEIGHT ? formHeight : DEFAULT_FORM_HEIGHT;
      if (scrollBottom + roofFormHeight > this.props.showAfter) {
        this.setState({
          showPixels: roofFormHeight
        });
      } else {
        this.setState({ showPixels: 0 });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _scrollParent2.default)().addEventListener('scroll', this.showFooter);
      this.showFooter();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _scrollParent2.default)().removeEventListener('scroll', this.showFooter);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          containerHeight = _props.containerHeight,
          contentHeight = _props.contentHeight;

      var styles = {
        position: 'fixed',
        bottom: -contentHeight + this.state.showPixels,
        right: 0,
        left: 0
      };
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: containerHeight + 'px' } },
        _react2.default.createElement(
          _reactGateway.Gateway,
          { into: 'footer' },
          _react2.default.createElement(
            'div',
            { style: styles },
            children
          )
        )
      );
    }
  }]);

  return StickyFooter;
}(_react.Component);

StickyFooter.propTypes = {
  showAfter: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node.isRequired,
  containerHeight: _propTypes2.default.number.isRequired,
  contentHeight: _propTypes2.default.number.isRequired
};
exports.default = StickyFooter;

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_25N0l"};

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentBar = __webpack_require__(1726);

var _commentBar2 = _interopRequireDefault(_commentBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentBar2.default;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxForm = __webpack_require__(40);

var _reactTextareaAutosize = __webpack_require__(542);

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _mapProps = __webpack_require__(518);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _icons = __webpack_require__(9);

var _commentFormImage = __webpack_require__(1727);

var _commentFormImage2 = _interopRequireDefault(_commentFormImage);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _getImageUrl = __webpack_require__(183);

var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

var _isDataUrl = __webpack_require__(1251);

var _isDataUrl2 = _interopRequireDefault(_isDataUrl);

var _convertSimpleCommentToContentState = __webpack_require__(1730);

var _convertSimpleCommentToContentState2 = _interopRequireDefault(_convertSimpleCommentToContentState);

var _commentBar = __webpack_require__(1731);

var _commentBar2 = _interopRequireDefault(_commentBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentBar = exports.CommentBar = function (_Component) {
  _inherits(CommentBar, _Component);

  function CommentBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentBar.__proto__ || Object.getPrototypeOf(CommentBar)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillReceiveProps = function (_ref2) {
      var content = _ref2.fields.content;

      if (_this.contentInput && content.active && document.activeElement !== _this.contentInput) {
        _this.contentInput.focus();
      }
    }, _this.handleContentChange = function (event) {
      _this.props.onChange();
      _this.props.fields.content.onChange(event);
    }, _this.handleFileChange = function (event) {
      return _this.props.onImageChange(event.target.files[0]);
    }, _this.setContentInput = function (ref) {
      return _this.contentInput = ref;
    }, _this.render = function () {
      var _this$props = _this.props,
          _this$props$fields = _this$props.fields,
          content = _this$props$fields.content,
          image = _this$props$fields.image,
          submitting = _this$props.submitting,
          invalid = _this$props.invalid,
          handleSubmit = _this$props.handleSubmit,
          t = _this$props.t,
          contentFontClassName = _this$props.contentFontClassName;

      var isButtonVisible = content.active || content.value.length || image.value;
      var buttonClassName = (0, _classnames2.default)(_commentBar2.default.saveButton, 'button-secondary-text-color', 'comment-bar__send-button', _defineProperty({}, _commentBar2.default.hidden, !isButtonVisible));

      return _react2.default.createElement(
        'div',
        { className: contentFontClassName },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_commentBar2.default.container, 'forum-text-color', 'comment-bar') },
          _react2.default.createElement(
            'div',
            { className: _commentBar2.default.content },
            _react2.default.createElement(_reactTextareaAutosize2.default, {
              ref: _this.setContentInput,
              value: content.value,
              className: (0, _classnames2.default)(_commentBar2.default.textArea, 'comment-bar__content'),
              placeholder: t('text-editor.comment-placeholder'),
              onChange: _this.handleContentChange
            }),
            _this.renderImage()
          ),
          _react2.default.createElement(
            'div',
            { className: _commentBar2.default.buttonContainer },
            _this.renderUploadButton(),
            _react2.default.createElement(
              'button',
              { className: buttonClassName, disabled: submitting || invalid, onClick: handleSubmit },
              t('comment-bar.send')
            )
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommentBar, [{
    key: 'renderImage',
    value: function renderImage() {
      var _props = this.props,
          value = _props.fields.image.value,
          handleImageDelete = _props.onImageDelete;


      if (!value) {
        return null;
      }

      var src = value;
      var isLoading = (0, _isDataUrl2.default)(src);

      if (!isLoading) {
        src = (0, _getImageUrl2.default)(value);
      }

      return _react2.default.createElement(_commentFormImage2.default, { src: src, isLoading: isLoading, onDelete: handleImageDelete });
    }
  }, {
    key: 'renderUploadButton',
    value: function renderUploadButton() {
      var image = this.props.fields.image;


      if (image.value) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_commentBar2.default.uploadButton, 'comment-form__camera-icon') },
        _react2.default.createElement(_icons.CameraIcon, { className: 'forum-icon-fill' }),
        _react2.default.createElement('input', { className: _commentBar2.default.fileInput, type: 'file', onChange: this.handleFileChange, accept: 'image/*' })
      );
    }
  }]);

  return CommentBar;
}(_react.Component);

CommentBar.propTypes = {
  onChange: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func,
  onImageChange: _propTypes2.default.func.isRequired,
  onImageDelete: _propTypes2.default.func.isRequired,
  fields: _propTypes2.default.object.isRequired,
  submitting: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  invalid: _propTypes2.default.bool,
  contentFontClassName: _propTypes2.default.string.isRequired
};

var formConfig = {
  form: 'comment',
  fields: ['content', 'ownerId', 'image'],
  validate: function validate(_ref3) {
    var image = _ref3.image,
        content = _ref3.content;

    if (!image && !content) {
      return { content: 'empty' };
    }

    if ((0, _isDataUrl2.default)(image)) {
      return { image: 'loading' };
    }
  }
};

var mapper = function mapper(props) {
  return _extends({}, props, {
    onSubmit: function onSubmit(comment) {
      return props.onSubmit((0, _convertSimpleCommentToContentState2.default)(comment));
    }
  });
};

exports.default = _lodash2.default.flowRight((0, _mapProps2.default)(mapper), // this HOC must go before the reduxForm
(0, _reduxForm.reduxForm)(formConfig), _withTranslate2.default, _withFontClassName2.default)(CommentBar);

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _commentFormImage = __webpack_require__(1728);

var _commentFormImage2 = _interopRequireDefault(_commentFormImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _commentFormImage2.default;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _imageLoader = __webpack_require__(155);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

var _commentFormImage = __webpack_require__(1729);

var _commentFormImage2 = _interopRequireDefault(_commentFormImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderButton = function renderButton(isLoading, handleDelete) {
  if (isLoading) {
    return null;
  }

  return _react2.default.createElement('button', { className: _commentFormImage2.default.button, onClick: handleDelete });
};
var renderOverlay = function renderOverlay(isLoading) {
  if (!isLoading) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: _commentFormImage2.default.overlay },
    _react2.default.createElement(_imageLoader2.default, { type: 'mini' })
  );
};
var CommentFormImage = function CommentFormImage(_ref) {
  var src = _ref.src,
      isLoading = _ref.isLoading,
      onDelete = _ref.onDelete;
  return _react2.default.createElement(
    'div',
    { className: _commentFormImage2.default.container },
    _react2.default.createElement('img', { className: _commentFormImage2.default.image, src: src }),
    renderButton(isLoading, onDelete),
    renderOverlay(isLoading)
  );
};

CommentFormImage.propTypes = {
  src: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  onDelete: _propTypes2.default.func.isRequired
};

exports.default = CommentFormImage;

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1WXdp","image":"_3Uhx7","button":"OOv7n","overlay":"_1kVk_"};

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertSimpleCommentToContentState;

var _draftJs = __webpack_require__(10);

function convertSimpleCommentToContentState(comment) {
  var contentState = _draftJs.ContentState.createFromText(comment.content || '');
  var editorState = _draftJs.EditorState.createWithContent(contentState);

  if (comment.image) {
    var props = {
      src: comment.image,
      isLoading: false
    };

    var entityKey = editorState.getCurrentContent().createEntity('IMAGE', 'IMMUTABLE', props).getLastCreatedEntityKey();
    editorState = _draftJs.EditorState.moveSelectionToEnd(editorState);
    editorState = _draftJs.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
  }

  return {
    ownerId: comment.ownerId,
    content: (0, _draftJs.convertToRaw)(editorState.getCurrentContent())
  };
}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_117Ds","content":"_3fJke","textArea":"_3Y29f","saveButton":"_3mJrc","hidden":"_2ul4R","uploadButton":"_1RRHB","fileInput":"_2qme3","buttonContainer":"_2GHXG"};

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loginToComment = __webpack_require__(1733);

var _loginToComment2 = _interopRequireDefault(_loginToComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loginToComment2.default;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginToComment = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(34);

var _protectedButton = __webpack_require__(274);

var _protectedButton2 = _interopRequireDefault(_protectedButton);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _loginToComment = __webpack_require__(1734);

var _loginToComment2 = _interopRequireDefault(_loginToComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginToComment = exports.LoginToComment = function LoginToComment(_ref) {
  var contentFontClassName = _ref.contentFontClassName,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_loginToComment2.default.container, contentFontClassName) },
    _react2.default.createElement(
      _protectedButton2.default,
      { tagName: 'div', className: (0, _classnames2.default)(_loginToComment2.default.loginLink, 'forum-text-color') },
      _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'login-to-comment.login-to-join',
        login: _react2.default.createElement(
          'span',
          { className: 'button-color' },
          t('login-to-comment.login')
        )
      })
    )
  );
};

LoginToComment.propTypes = {
  contentFontClassName: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)((0, _withFontClassName2.default)(LoginToComment));

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Pmtk"};

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typingList = __webpack_require__(1736);

var _typingList2 = _interopRequireDefault(_typingList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _typingList2.default;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(34);

var _typingListLoader = __webpack_require__(1737);

var _typingListLoader2 = _interopRequireDefault(_typingListLoader);

var _separator = __webpack_require__(18);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _typingList = __webpack_require__(1740);

var _typingList2 = _interopRequireDefault(_typingList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypingList = function TypingList(_ref) {
  var _ref$users = _ref.users,
      users = _ref$users === undefined ? [] : _ref$users;

  if (users.length) {
    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_typingList2.default.typing, 'typing-list', 'forum-card-border-color', 'forum-text-color') },
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_typingList2.default.background, 'forum-card-background-color') }),
      _react2.default.createElement(
        'div',
        { className: _typingList2.default.content },
        _react2.default.createElement(_separator.HorizontalSeparator, { className: _typingList2.default.separator }),
        _react2.default.createElement(
          'div',
          { className: _typingList2.default.wrapper },
          _react2.default.createElement(_typingListLoader2.default, null),
          _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'typing-list.is-typing',
            options: { count: users.length },
            count: users.length,
            member: _react2.default.createElement(
              'span',
              { className: _typingList2.default.member },
              users[0].name
            )
          })
        )
      )
    );
  }
  return null;
};

TypingList.propTypes = {
  users: _propTypes2.default.array,
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(TypingList);

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typingListLoader = __webpack_require__(1738);

var _typingListLoader2 = _interopRequireDefault(_typingListLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _typingListLoader2.default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _typingListLoader = __webpack_require__(1739);

var _typingListLoader2 = _interopRequireDefault(_typingListLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypingListLoader = function TypingListLoader(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(_typingListLoader2.default.loader, 'button-color') },
    t('typing-list-loader.typing')
  );
};

TypingListLoader.propTypes = {
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(TypingListLoader);

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"_1UEtE","load7":"_1kT7H"};

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"typing":"_3ZhAk","background":"_2NGRG","content":"_2lMog","wrapper":"_1Azg0","member":"_1p8il","separator":"QEbrk"};

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"postPage":"_3kIJh","emptyState":"_2MtAe","postContainer":"J6lDs","postContentWrapper":"_2U6Fr","edited":"_38NBw","editedDate":"_2jV7L","editIcon":"_1mWA-","postStatsContainer":"_3F9Jj","postContent":"_3XCeb"};

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profileNotificationsPage = __webpack_require__(1743);

var _profileNotificationsPage2 = _interopRequireDefault(_profileNotificationsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profileNotificationsPage2.default;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileNotificationsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _fetchUserAndRedirect = __webpack_require__(1186);

var _pageOpened = __webpack_require__(410);

var _redirectTo = __webpack_require__(1007);

var _updateUserSettings = __webpack_require__(532);

var _notificationsSettings = __webpack_require__(1744);

var _notificationsSettings2 = _interopRequireDefault(_notificationsSettings);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _detectRoute = __webpack_require__(266);

var _currentUserSelectors = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileNotificationsPage = exports.ProfileNotificationsPage = function (_Component) {
  _inherits(ProfileNotificationsPage, _Component);

  function ProfileNotificationsPage(props) {
    _classCallCheck(this, ProfileNotificationsPage);

    //these values are available only after component did mount
    var _this = _possibleConstructorReturn(this, (ProfileNotificationsPage.__proto__ || Object.getPrototypeOf(ProfileNotificationsPage)).call(this, props));

    _this.handleEmailChange = function (settingKey) {
      var newValue = !_this.isChecked('email', settingKey);
      var currentUser = _this.props.currentUser;

      var activeKeyName = 'email';

      var settings = (0, _lodash.cloneDeep)(_this.props.settings);
      settings[activeKeyName] = settings[activeKeyName] || {};
      settings[activeKeyName][settingKey] = newValue;

      return _this.props.updateUserSettings(currentUser._id, settings);
    };

    _this.handleChange = function (keyName, settingsProp) {
      return function () {
        return _this.changeHandlers[keyName](settingsProp);
      };
    };

    _this.isChecked = function (keyName, settingKey) {
      var settings = _this.props.settings[keyName];
      return (0, _lodash.get)(settings, settingKey, false);
    };

    _this.changeHandlers = {
      email: _this.handleEmailChange
    };
    return _this;
  }

  _createClass(ProfileNotificationsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.pageOpened({ page: _detectRoute.USER_SETTINGS });
    }
  }, {
    key: 'render',
    value: function render() {
      var settings = this.props.settings;

      return _react2.default.createElement(
        _page2.default,
        { noSpacing: true },
        _react2.default.createElement(_notificationsSettings2.default, {
          settings: ProfileNotificationsPage.settingsNotificationsKeys,
          onChange: this.handleChange,
          isChecked: this.isChecked,
          userSettings: settings
        }),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    }
  }]);

  return ProfileNotificationsPage;
}(_react.Component);

ProfileNotificationsPage.fetchData = function (_ref) {
  var store = _ref.store,
      params = _ref.params,
      search = _ref.search;

  return store.dispatch((0, _fetchUserAndRedirect.fetchUserAndRedirect)(params.userSlug, search, function (user, search) {
    return '/profiles/' + user.slug + '/settings' + search;
  })).catch(function () {
    return store.dispatch((0, _redirectTo.redirectTo404)(search));
  });
};

ProfileNotificationsPage.settingsNotificationsKeys = ['likes', 'comments', 'subscriptions', 'general'];


ProfileNotificationsPage.propTypes = {
  updateUserSettings: _propTypes2.default.func,
  pageOpened: _propTypes2.default.func,
  currentUser: _propTypes2.default.object,
  settings: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: (0, _currentUserSelectors.getCurrentUser)(state),
    settings: (0, _currentUserSelectors.getCurrentUserSettings)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    updateUserSettings: _updateUserSettings.updateUserSettings,
    pageOpened: _pageOpened.pageOpened
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProfileNotificationsPage);

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notificationsSettings = __webpack_require__(1745);

var _notificationsSettings2 = _interopRequireDefault(_notificationsSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notificationsSettings2.default;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _inputToggle = __webpack_require__(1746);

var _inputToggle2 = _interopRequireDefault(_inputToggle);

var _separator = __webpack_require__(18);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _notificationsSettings = __webpack_require__(1749);

var _notificationsSettings2 = _interopRequireDefault(_notificationsSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsSettings = function NotificationsSettings(_ref) {
  var _ref$settings = _ref.settings,
      settings = _ref$settings === undefined ? [] : _ref$settings,
      onChange = _ref.onChange,
      isChecked = _ref.isChecked,
      t = _ref.t,
      borderWidth = _ref.borderWidth,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName,
      isMobile = _ref.isMobile;

  var className = (0, _classnames2.default)(_notificationsSettings2.default.container, contentFontClassName, 'forum-card-background-color', 'forum-card-border-color', 'forum-text-color');
  return _react2.default.createElement(
    'div',
    { className: className, style: { borderWidth: borderWidth } },
    _react2.default.createElement(
      'table',
      { className: _notificationsSettings2.default.table },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { className: _notificationsSettings2.default.tdTitle },
            isMobile ? t('notifications-settings.notifications') : null
          ),
          _react2.default.createElement(
            'td',
            { className: _notificationsSettings2.default.tdTitle },
            t(isMobile ? 'notifications-settings.email' : 'notifications-settings.email-notifications')
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { colSpan: '2' },
            _react2.default.createElement(_separator.HorizontalSeparator, null)
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        null,
        settings.map(function (key) {
          return [_react2.default.createElement(
            'tr',
            { key: key, className: _notificationsSettings2.default.tr },
            _react2.default.createElement(
              'td',
              { className: _notificationsSettings2.default.tdInformation },
              _react2.default.createElement(
                'div',
                { className: titleFontClassName },
                _react2.default.createElement(
                  'h3',
                  { className: _notificationsSettings2.default.title },
                  t('notifications-settings.' + key)
                )
              ),
              _react2.default.createElement(
                'p',
                { className: _notificationsSettings2.default.description },
                t('notifications-settings.' + key + '-description')
              )
            ),
            _react2.default.createElement(
              'td',
              { className: _notificationsSettings2.default.tdToggle },
              _react2.default.createElement(_inputToggle2.default, { checked: isChecked('email', key), onChange: onChange('email', key) })
            )
          ), _react2.default.createElement(
            'tr',
            { key: key + '-separator', className: _notificationsSettings2.default.tr },
            _react2.default.createElement(
              'td',
              { colSpan: '2' },
              _react2.default.createElement(_separator.HorizontalSeparator, null)
            )
          )];
        })
      )
    )
  );
};

NotificationsSettings.propTypes = {
  settings: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  isChecked: _propTypes2.default.func.isRequired,
  borderWidth: _propTypes2.default.number,
  titleFontClassName: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string,
  t: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool
};

exports.default = (0, _lodash.flowRight)(_withCardBorderWidth2.default, _withDeviceType2.default, _withFontClassName2.default, _withTranslate2.default)(NotificationsSettings);

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _inputToggle = __webpack_require__(1747);

var _inputToggle2 = _interopRequireDefault(_inputToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _inputToggle2.default;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _inputToggle = __webpack_require__(1748);

var _inputToggle2 = _interopRequireDefault(_inputToggle);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InputToggle = function InputToggle(_ref) {
  var text = _ref.text,
      level = _ref.level,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['text', 'level', 'checked', 'disabled', 'onChange']);

  return _react2.default.createElement(
    'label',
    { className: (0, _classnames2.default)(_inputToggle2.default.label, _defineProperty({}, _inputToggle2.default.level1, level === '1')) },
    text,
    _react2.default.createElement(
      'span',
      {
        className: (0, _classnames2.default)(_inputToggle2.default.switch, _inputToggle2.default.right),
        tabIndex: !disabled && '0',
        onKeyUp: (0, _accessibility.handleEnterKeyUp)(onChange),
        role: 'checkbox',
        'aria-checked': checked,
        'aria-label': text
      },
      _react2.default.createElement('input', _extends({
        className: _inputToggle2.default.switchInput,
        type: 'checkbox',
        tabIndex: '-1',
        disabled: disabled,
        onChange: onChange,
        checked: checked
      }, props)),
      _react2.default.createElement(
        'label',
        { className: (0, _classnames2.default)(_inputToggle2.default.switchLabel, 'button-background-color') },
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_inputToggle2.default.switchI, 'button-border-color') },
          _react2.default.createElement(_icons.CheckMarkIcon, { className: (0, _classnames2.default)(_inputToggle2.default.checkedIcon, 'button-fill') }),
          _react2.default.createElement(_icons.MinusIcon, { className: (0, _classnames2.default)(_inputToggle2.default.uncheckedIcon, 'button-fill') })
        )
      )
    )
  );
};

InputToggle.propTypes = {
  name: _propTypes2.default.string,
  value: _propTypes2.default.any,
  text: _propTypes2.default.node,
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  level: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
};

exports.default = InputToggle;

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"_1V8HS","right":"_3OobU","level1":"o2-vG","switch":"_268nJ","switchInput":"_2Jknx","switchLabel":"_2PL8X","switchI":"_24DTI","checkedIcon":"_1TyCQ","uncheckedIcon":"Z0Gdj"};

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1ZcXB","table":"_3_bxl","tdTitle":"_1pLho","tr":"jXMpI","title":"_1r5Ad","description":"_1Q8PF","tdInformation":"jn4LT","tdToggle":"PnV-l"};

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profilePage = __webpack_require__(1751);

var _profilePage2 = _interopRequireDefault(_profilePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profilePage2.default;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfilePage = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _reduxForm = __webpack_require__(40);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _upload = __webpack_require__(171);

var _cancelUploads = __webpack_require__(422);

var _updateUser = __webpack_require__(70);

var _pageOpened = __webpack_require__(410);

var _buttonClicked = __webpack_require__(57);

var _resizeImage = __webpack_require__(271);

var _resizeImage2 = _interopRequireDefault(_resizeImage);

var _userSelectors = __webpack_require__(69);

var _uploadStarted = __webpack_require__(231);

var _uploadEnded = __webpack_require__(230);

var _messages = __webpack_require__(61);

var _messages2 = _interopRequireDefault(_messages);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _pageMetadata = __webpack_require__(1180);

var _pageMetadata2 = _interopRequireDefault(_pageMetadata);

var _followUserButtonSecure = __webpack_require__(1318);

var _followUserButtonSecure2 = _interopRequireDefault(_followUserButtonSecure);

var _profile = __webpack_require__(1752);

var _profile2 = _interopRequireDefault(_profile);

var _profilePageLayout = __webpack_require__(1768);

var _profilePageLayout2 = _interopRequireDefault(_profilePageLayout);

var _profilePlaceholder = __webpack_require__(1772);

var _profilePlaceholder2 = _interopRequireDefault(_profilePlaceholder);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _publicProfileActions = __webpack_require__(1250);

var _publicProfileActions2 = _interopRequireDefault(_publicProfileActions);

var _profileActionsButton = __webpack_require__(1182);

var _profileActionsButton2 = _interopRequireDefault(_profileActionsButton);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _currentUserSelectors = __webpack_require__(67);

var _detectRoute = __webpack_require__(266);

var _profile3 = __webpack_require__(1329);

var _profile4 = _interopRequireDefault(_profile3);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfilePage = exports.ProfilePage = function (_Component) {
  _inherits(ProfilePage, _Component);

  function ProfilePage(props) {
    _classCallCheck(this, ProfilePage);

    var _this = _possibleConstructorReturn(this, (ProfilePage.__proto__ || Object.getPrototypeOf(ProfilePage)).call(this, props));

    _this.componentDidMount = function () {
      _this.props.pageOpened({ page: _detectRoute.USER_PROFILE });
    };

    _this.componentWillReceiveProps = function (_ref) {
      var user = _ref.user,
          isCurrentUser = _ref.isCurrentUser;

      if (!_this.state.disabledUpdate) {
        _this.setState({ user: user, isCurrentUser: isCurrentUser });
      }
    };

    _this.componentDidUpdate = function (props, state) {
      if (state.view !== _this.state.view) {
        if (_this.state.view === _profile.VIEW_PROFILE_EDIT) {
          _this.props.pageOpened({ page: _detectRoute.USER_EDIT_PROFILE });
        } else {
          _this.props.pageOpened({ page: _detectRoute.USER_PROFILE });
        }
      }
    };

    _this.setForm = function (ref) {
      return _this.form = ref;
    };

    _this.handleEditClick = function () {
      _this.props.buttonClicked({ name: 'edit_profile_click' });
      _this.setState({ view: _profile.VIEW_PROFILE_EDIT });
    };

    _this.upload = function (field, file) {
      (0, _resizeImage2.default)(file).then(function (_ref2) {
        var dataUrl = _ref2.dataUrl;

        _this.props.uploadStarted({ type: _upload.TYPE_IMAGE });
        _this.props.change('profile', field, dataUrl);
        _this.props.upload(dataUrl, _upload.TYPE_IMAGE, function (file) {
          _this.props.uploadEnded({ type: _upload.TYPE_IMAGE });
          return (0, _reduxForm.change)('profile', field, file);
        });
      });
    };

    _this.handleImageChange = function (file) {
      return _this.upload('image', file);
    };

    _this.handleCoverChange = function (file) {
      return _this.upload('cover', file);
    };

    _this.handleCancel = function () {
      _this.setState({ view: _profile.VIEW_PROFILE });
      _this.props.reset('profile');
      _this.props.cancelUploads();
    };

    _this.handleSubmit = function (data) {
      var user = _this.state.user;

      _this.setState({ view: _profile.VIEW_PROFILE, disabledUpdate: true });
      _this.props.updateUser(user._id, data).then(function (user) {
        return _this.props.replace('/profiles/' + user.slug);
      }).then(function () {
        return _this.setState({ disabledUpdate: false });
      }).then(function () {
        return _this.props.showMessage(_messages2.default[_messages.PROFILE_UPDATE].content(), _messages2.default[_messages.PROFILE_UPDATE].type);
      }).catch(function () {
        _this.setState({ disabledUpdate: false, user: _this.props.user });
        _this.props.reset('profile');
        _this.props.showMessage(_messages2.default[_messages.PROFILE_UPDATE_FAILED].content(), _messages2.default[_messages.PROFILE_UPDATE_FAILED].type);
      });
    };

    _this.handleSubmitFail = function (errors) {
      _this.props.showMessage(_messages2.default[_messages.REQUIRE_PROFILE_FIELDS].content(errors), _messages2.default[_messages.REQUIRE_PROFILE_FIELDS].type);
    };

    _this.handleSubmitClick = function () {
      return _this.form.submit();
    };

    _this.renderButton = function () {
      var _this$state = _this.state,
          user = _this$state.user,
          isCurrentUser = _this$state.isCurrentUser,
          view = _this$state.view;
      var t = _this.props.t;


      if (isCurrentUser) {
        return view === _profile.VIEW_PROFILE ? _react2.default.createElement(
          _button2.default,
          {
            className: 'profile-page__edit-button',
            onClick: _this.handleEditClick,
            'data-hook': 'profile-page__edit-button'
          },
          t('profile-page.edit-profile')
        ) : [_react2.default.createElement(
          _button2.default,
          {
            key: 'cancel',
            className: (0, _classnames2.default)(_profile4.default.cancelButton),
            onClick: _this.handleCancel,
            isSecondary: true,
            'data-hook': 'profile-page__cancel-button'
          },
          t('profile.cancel')
        ), _react2.default.createElement(
          _button2.default,
          {
            key: 'confirm',
            className: 'profile-page__submit-button',
            onClick: _this.handleSubmitClick,
            'data-hook': 'profile-page__submit-button'
          },
          t('profile.confirm')
        )];
      }

      return _react2.default.createElement(
        _followUserButtonSecure2.default,
        { user: user },
        _react2.default.createElement(_publicProfileActions2.default, { triggerButton: _profileActionsButton2.default, user: user })
      );
    };

    _this.renderProfile = function () {
      var user = _this.state.user;

      if (user._id) {
        return _react2.default.createElement(
          _profile2.default,
          {
            key: 'profile',
            ref: _this.setForm,
            view: _this.state.view,
            user: user,
            initialValues: user,
            onImageChange: _this.handleImageChange,
            onCoverChange: _this.handleCoverChange,
            onSubmit: _this.handleSubmit,
            onSubmitFail: _this.handleSubmitFail
          },
          _this.renderButton()
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_profilePlaceholder2.default, { key: 'placeholder' })
      );
    };

    _this.render = function () {
      var user = _this.state.user;
      var children = _this.props.children;


      return _react2.default.createElement(
        _page2.default,
        { noSpacing: true },
        _react2.default.createElement(_pageMetadata2.default, { title: user.name, type: 'profile', noIndex: true }),
        _react2.default.createElement(
          _profilePageLayout2.default,
          { profile: _this.renderProfile() },
          children
        ),
        _react2.default.createElement(_appLoaded2.default, null)
      );
    };

    _this.state = {
      view: _profile.VIEW_PROFILE,
      user: props.user,
      isCurrentUser: props.isCurrentUser
    };
    return _this;
  }

  return ProfilePage;
}(_react.Component);

ProfilePage.propTypes = {
  children: _propTypes2.default.node,
  replace: _propTypes2.default.func.isRequired,
  isOwner: _propTypes2.default.bool,
  showMessage: _propTypes2.default.func,
  buttonClicked: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object,
  isCurrentUser: _propTypes2.default.bool,
  params: _propTypes2.default.object.isRequired,
  userSlug: _propTypes2.default.string.isRequired,
  logout: _propTypes2.default.func,
  t: _propTypes2.default.func,
  promotePrivileges: _propTypes2.default.func,
  demotePrivileges: _propTypes2.default.func,
  upload: _propTypes2.default.func,
  cancelUploads: _propTypes2.default.func,
  change: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  updateUser: _propTypes2.default.func,
  pageOpened: _propTypes2.default.func,
  uploadStarted: _propTypes2.default.func.isRequired,
  uploadEnded: _propTypes2.default.func.isRequired
};

ProfilePage.defaultProps = {
  user: {},
  currentPagePosts: [],
  allPosts: []
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var userSlug = ownProps.params.userSlug;
  var currentUserSlug = (0, _currentUserSelectors.getCurrentUserSlug)(state);
  var isCurrentUser = currentUserSlug === userSlug;
  var user = (0, _userSelectors.getUserBySlug)(state, userSlug) || {};

  return {
    user: user,
    isCurrentUser: isCurrentUser,
    userSlug: userSlug,
    isOwner: (0, _currentUserSelectors.isOwner)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    replace: _routerUtils.replace,
    upload: _upload.upload,
    cancelUploads: _cancelUploads.cancelUploads,
    change: _reduxForm.change,
    reset: _reduxForm.reset,
    pageOpened: _pageOpened.pageOpened,
    buttonClicked: _buttonClicked.buttonClicked,
    updateUser: _updateUser.updateUser,
    uploadStarted: _uploadStarted.uploadStarted,
    uploadEnded: _uploadEnded.uploadEnded
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withEnvironment2.default)({ showMessage: 'showMessage' }), _withTranslate2.default)(ProfilePage);

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_PROFILE_EDIT = exports.VIEW_PROFILE = exports.default = undefined;

var _profile = __webpack_require__(1753);

Object.defineProperty(exports, 'VIEW_PROFILE', {
  enumerable: true,
  get: function get() {
    return _profile.VIEW_PROFILE;
  }
});
Object.defineProperty(exports, 'VIEW_PROFILE_EDIT', {
  enumerable: true,
  get: function get() {
    return _profile.VIEW_PROFILE_EDIT;
  }
});

var _profile2 = _interopRequireDefault(_profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profile2.default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_PROFILE_EDIT = exports.VIEW_PROFILE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VIEW_CLASS_NAMES;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactInputAutosize = __webpack_require__(1754);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _reactRedux = __webpack_require__(5);

var _reduxForm = __webpack_require__(40);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonClicked = __webpack_require__(57);

var _profileCover = __webpack_require__(1755);

var _profileCover2 = _interopRequireDefault(_profileCover);

var _profilePhoto = __webpack_require__(1758);

var _profilePhoto2 = _interopRequireDefault(_profilePhoto);

var _profileStats = __webpack_require__(1761);

var _profileStats2 = _interopRequireDefault(_profileStats);

var _uploadImageButton = __webpack_require__(1764);

var _uploadImageButton2 = _interopRequireDefault(_uploadImageButton);

var _userBadge = __webpack_require__(272);

var _userBadge2 = _interopRequireDefault(_userBadge);

var _icons = __webpack_require__(9);

var _profileFormSettings = __webpack_require__(1767);

var _profileFormSettings2 = _interopRequireDefault(_profileFormSettings);

var _resolveUserImage = __webpack_require__(249);

var _resolveUserImage2 = _interopRequireDefault(_resolveUserImage);

var _isDataUrl = __webpack_require__(1251);

var _isDataUrl2 = _interopRequireDefault(_isDataUrl);

var _counters = __webpack_require__(289);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _profile = __webpack_require__(1329);

var _profile2 = _interopRequireDefault(_profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VIEW_PROFILE = exports.VIEW_PROFILE = 'VIEW_PROFILE';
var VIEW_PROFILE_EDIT = exports.VIEW_PROFILE_EDIT = 'VIEW_PROFILE_EDIT';

var VIEW_CLASS_NAMES = (_VIEW_CLASS_NAMES = {}, _defineProperty(_VIEW_CLASS_NAMES, VIEW_PROFILE, _profile2.default.viewProfile), _defineProperty(_VIEW_CLASS_NAMES, VIEW_PROFILE_EDIT, _profile2.default.viewProfileEdit), _VIEW_CLASS_NAMES);

var Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Profile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Profile.__proto__ || Object.getPrototypeOf(Profile)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonClicked = function (name) {
      return function () {
        return _this.props.buttonClicked({ name: name });
      };
    }, _this.renderBadge = function () {
      return _react2.default.createElement(_userBadge2.default, { user: _this.props.user });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Profile, [{
    key: 'isProfile',
    value: function isProfile() {
      return this.props.view === VIEW_PROFILE;
    }
  }, {
    key: 'isProfileEdit',
    value: function isProfileEdit() {
      return this.props.view === VIEW_PROFILE_EDIT;
    }
  }, {
    key: 'renderUploadCoverButton',
    value: function renderUploadCoverButton() {
      return this.isProfileEdit() && _react2.default.createElement(_uploadImageButton2.default, {
        onClick: this.handleButtonClicked('change_cover_photo_click'),
        className: (0, _classnames2.default)(_profile2.default.uploadCoverButton, 'profile__upload-cover-button'),
        onChange: this.props.onCoverChange
      });
    }
  }, {
    key: 'renderUploadPhotoButton',
    value: function renderUploadPhotoButton() {
      return this.isProfileEdit() && _react2.default.createElement(_uploadImageButton2.default, {
        onClick: this.handleButtonClicked('change_avatar_click'),
        className: (0, _classnames2.default)(_profile2.default.uploadPhotoButton, 'profile__upload-photo-button'),
        onChange: this.props.onImageChange
      });
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      var _props$fields$name = this.props.fields.name,
          value = _props$fields$name.value,
          handleChange = _props$fields$name.onChange;


      if (this.isProfileEdit()) {
        return _react2.default.createElement(
          'div',
          { className: _profile2.default.nameFieldWrapper },
          _react2.default.createElement(_icons.SecondaryEditIcon, { className: (0, _classnames2.default)(_profile2.default.editIcon, 'forum-icon-fill') }),
          _react2.default.createElement(_reactInputAutosize2.default, {
            className: _profile2.default.nameField,
            inputClassName: (0, _classnames2.default)(_profile2.default.nameInput, 'forum-text-color', 'profile__name-input'),
            value: value,
            maxLength: _profileFormSettings.NAME_MAX_LENGTH,
            onChange: handleChange,
            'data-hook': 'profile__name-input'
          })
        );
      }

      return value;
    }
  }, {
    key: 'renderJoinDate',
    value: function renderJoinDate() {
      var t = this.props.t;

      return this.isProfile() && _react2.default.createElement(
        'div',
        { className: _profile2.default.date },
        t('profile.joined', { date: this.props.user.createdDate })
      );
    }
  }, {
    key: 'renderStats',
    value: function renderStats() {
      return this.isProfile() && _react2.default.createElement(
        'div',
        { className: _profile2.default.statsContainer },
        _react2.default.createElement(_profileStats2.default, {
          user: this.props.user,
          postCount: (0, _counters.getPostsCount)(this.props.user),
          followerCount: (0, _counters.getFollowersCount)(this.props.user),
          followingCount: (0, _counters.getFollowingCount)(this.props.user)
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          fields = _props.fields,
          children = _props.children,
          contentFontClassName = _props.contentFontClassName,
          borderWidth = _props.borderWidth;
      var image = fields.image,
          cover = fields.cover;

      var coverSrc = (0, _resolveUserImage2.default)(cover.value);
      var imageSrc = (0, _resolveUserImage2.default)(image.value);
      var cardClassName = (0, _classnames2.default)(_profile2.default.card, 'forum-card-background-color', 'forum-text-color', 'forum-card-border-color');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_profile2.default.container, contentFontClassName, VIEW_CLASS_NAMES[this.props.view], 'profile') },
        _react2.default.createElement(
          'div',
          { className: cardClassName, style: { borderWidth: borderWidth } },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_profile2.default.cover, 'profile__cover') },
            _react2.default.createElement(_profileCover2.default, { src: coverSrc, isLoading: (0, _isDataUrl2.default)(coverSrc) }),
            this.renderUploadCoverButton()
          ),
          _react2.default.createElement(
            'div',
            { className: _profile2.default.photo },
            _react2.default.createElement(_profilePhoto2.default, { src: imageSrc, isLoading: (0, _isDataUrl2.default)(imageSrc) }),
            this.renderUploadPhotoButton()
          ),
          _react2.default.createElement(
            'div',
            { className: _profile2.default.flexContainer },
            _react2.default.createElement(
              'div',
              { className: _profile2.default.userInfo },
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_profile2.default.name, 'profile__name') },
                this.renderName(),
                this.renderBadge()
              ),
              this.renderJoinDate()
            ),
            _react2.default.createElement(
              'div',
              { className: _profile2.default.childrenContainer },
              children
            ),
            this.renderStats()
          )
        )
      );
    }
  }]);

  return Profile;
}(_react.Component);

Profile.defaultProps = {
  view: VIEW_PROFILE
};

Profile.propTypes = {
  user: _propTypes2.default.object.isRequired,
  fields: _propTypes2.default.object.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  onCoverChange: _propTypes2.default.func,
  buttonClicked: _propTypes2.default.func,
  onImageChange: _propTypes2.default.func,
  children: _propTypes2.default.node,
  view: _propTypes2.default.string,
  t: _propTypes2.default.func
};

var mapDispatchToProps = {
  buttonClicked: _buttonClicked.buttonClicked
};

exports.default = (0, _lodash.flowRight)((0, _reduxForm.reduxForm)(_profileFormSettings2.default), // reduxForm should be exposed
(0, _reactRedux.connect)(undefined, mapDispatchToProps), _withCardBorderWidth2.default, _withFontClassName2.default, _withTranslate2.default)(Profile);

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var createClass = __webpack_require__(1300);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputRef: PropTypes.func, // ref callback for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
		if (typeof this.props.inputRef === 'function') {
			this.props.inputRef(el);
		}
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (!this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		delete inputProps.inputRef;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('style', { dangerouslySetInnerHTML: {
					__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
				} }),
			React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profileCover = __webpack_require__(1756);

var _profileCover2 = _interopRequireDefault(_profileCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profileCover2.default;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _imageLoader = __webpack_require__(155);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

var _profileCover = __webpack_require__(1757);

var _profileCover2 = _interopRequireDefault(_profileCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(src) {
  return {
    backgroundImage: src && 'url(' + src + ')'
  };
};

var renderOverlay = function renderOverlay(isLoading) {
  if (!isLoading) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: _profileCover2.default.overlay },
    _react2.default.createElement(_imageLoader2.default, { type: 'medium' })
  );
};

var ProfileCover = function ProfileCover(_ref) {
  var src = _ref.src,
      isLoading = _ref.isLoading;
  return _react2.default.createElement(
    'div',
    { className: _profileCover2.default.container, style: getStyle(src) },
    renderOverlay(isLoading)
  );
};

ProfileCover.propTypes = {
  src: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool
};

exports.default = ProfileCover;

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"ElnLk","overlay":"_3b3sX"};

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profilePhoto = __webpack_require__(1759);

var _profilePhoto2 = _interopRequireDefault(_profilePhoto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profilePhoto2.default;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _imageLoader = __webpack_require__(155);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

var _profilePhoto = __webpack_require__(1760);

var _profilePhoto2 = _interopRequireDefault(_profilePhoto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(src) {
  return {
    backgroundImage: src && 'url(' + src + ')'
  };
};

var renderOverlay = function renderOverlay(isLoading) {
  if (!isLoading) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: _profilePhoto2.default.overlay },
    _react2.default.createElement(_imageLoader2.default, { type: 'mini' })
  );
};

var ProfilePhoto = function ProfilePhoto(_ref) {
  var src = _ref.src,
      isLoading = _ref.isLoading;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(_profilePhoto2.default.photo, 'profile-photo-border-color'),
      style: getStyle(src),
      'data-hook': 'profile-photo'
    },
    renderOverlay(isLoading)
  );
};

ProfilePhoto.propTypes = {
  src: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool
};

exports.default = ProfilePhoto;

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"photo":"CAQo4","overlay":"_3tWXH"};

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profileStats = __webpack_require__(1762);

var _profileStats2 = _interopRequireDefault(_profileStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profileStats2.default;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileStatsWithLinks = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _profileStats = __webpack_require__(1763);

var _profileStats2 = _interopRequireDefault(_profileStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileStatsWithLinks = exports.ProfileStatsWithLinks = function ProfileStatsWithLinks(_ref) {
  var className = _ref.className,
      postCount = _ref.postCount,
      followerCount = _ref.followerCount,
      followingCount = _ref.followingCount,
      user = _ref.user,
      _ref$navigation = _ref.navigation,
      FollowersLink = _ref$navigation.FollowersLink,
      FollowingLink = _ref$navigation.FollowingLink,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_profileStats2.default.container, className) },
    _react2.default.createElement(
      'div',
      { className: _profileStats2.default.section },
      _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)(_profileStats2.default.count, 'profile-stats__post-count') },
        t('profile-stats.posts-count', { count: postCount })
      ),
      _react2.default.createElement(
        'p',
        { className: _profileStats2.default.label },
        t('profile-stats.posts-count-label', { count: postCount })
      )
    ),
    _react2.default.createElement(
      FollowersLink,
      {
        className: (0, _classnames2.default)(_profileStats2.default.section, 'button-hover-color', 'profile-stats__followers-link'),
        user: user
      },
      _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)(_profileStats2.default.count, 'profile-stats__follower-count') },
        t('profile-stats.follower-count', { count: followerCount })
      ),
      _react2.default.createElement(
        'p',
        { className: _profileStats2.default.label },
        t('profile-stats.follower-count-label', { count: followerCount })
      )
    ),
    _react2.default.createElement(
      FollowingLink,
      {
        className: (0, _classnames2.default)(_profileStats2.default.section, 'button-hover-color', 'profile-stats__following-link'),
        user: user
      },
      _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)(_profileStats2.default.count, 'profile-stats__following-count') },
        t('profile-stats.following-count', { count: followingCount })
      ),
      _react2.default.createElement(
        'p',
        { className: _profileStats2.default.label },
        t('profile-stats.following-count-label')
      )
    )
  );
};

ProfileStatsWithLinks.propTypes = {
  className: _propTypes2.default.string,
  postCount: _propTypes2.default.number.isRequired,
  followerCount: _propTypes2.default.number.isRequired,
  followingCount: _propTypes2.default.number.isRequired,
  user: _propTypes2.default.object.isRequired,
  navigation: _propTypes2.default.object,
  t: _propTypes2.default.func
};

exports.default = (0, _lodash.flowRight)((0, _withEnvironment2.default)({ navigation: 'navigation' }), _withTranslate2.default)(ProfileStatsWithLinks);

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_14EA8","section":"_1kjfI","count":"_1Pu3u","label":"_1bmix"};

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _uploadImageButton = __webpack_require__(1765);

var _uploadImageButton2 = _interopRequireDefault(_uploadImageButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _uploadImageButton2.default;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _uploadImageButton = __webpack_require__(1766);

var _uploadImageButton2 = _interopRequireDefault(_uploadImageButton);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadImageButton = function (_Component) {
  _inherits(UploadImageButton, _Component);

  function UploadImageButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UploadImageButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadImageButton.__proto__ || Object.getPrototypeOf(UploadImageButton)).call.apply(_ref, [this].concat(args))), _this), _this.triggerInputClick = function () {
      _this.input && _this.input.click();
    }, _this.setInput = function (input) {
      _this.input = input;
    }, _this.handleChange = function (event) {
      if (event.target.files.length) {
        _this.props.onChange(event.target.files[0]);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UploadImageButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          handleClick = _props.onClick;


      return _react2.default.createElement(
        'div',
        {
          onClick: handleClick,
          onKeyUp: (0, _accessibility.handleEnterKeyUp)(this.triggerInputClick),
          tabIndex: '0',
          className: (0, _classnames2.default)(_uploadImageButton2.default.button, className, 'upload-image-button')
        },
        _react2.default.createElement('span', { className: _uploadImageButton2.default.icon }),
        _react2.default.createElement('input', {
          ref: this.setInput,
          className: _uploadImageButton2.default.file,
          type: 'file',
          accept: 'image/*',
          onChange: this.handleChange,
          tabIndex: '-1'
        })
      );
    }
  }]);

  return UploadImageButton;
}(_react.Component);

UploadImageButton.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string
};

exports.default = UploadImageButton;

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"file":"_3vfv9","button":"_13a4x","icon":"J6muc"};

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAME_MAX_LENGTH = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _isDataUrl = __webpack_require__(1251);

var _isDataUrl2 = _interopRequireDefault(_isDataUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME_MAX_LENGTH = exports.NAME_MAX_LENGTH = 25;

exports.default = {
  form: 'profile',
  fields: ['_id', 'name', 'image', 'cover'],
  validate: function validate(values) {
    var errors = {};
    var name = values.name,
        image = values.image,
        cover = values.cover;


    if (!_lodash2.default.trim(name)) {
      errors.name = 'required';
    } else if (name.length > NAME_MAX_LENGTH) {
      errors.name = 'too-long';
    }

    if (image && (0, _isDataUrl2.default)(image)) {
      errors.image = 'uploading';
    }
    if (cover && (0, _isDataUrl2.default)(cover)) {
      errors.cover = 'uploading';
    }

    return errors;
  }
};

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profilePageLayout = __webpack_require__(1769);

var _profilePageLayout2 = _interopRequireDefault(_profilePageLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profilePageLayout2.default;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(122);

var _profilePageLayoutTransition = __webpack_require__(1770);

var _profilePageLayoutTransition2 = _interopRequireDefault(_profilePageLayoutTransition);

var _profilePageLayout = __webpack_require__(1771);

var _profilePageLayout2 = _interopRequireDefault(_profilePageLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_TIMEOUT = 400;

var ProfilePageLayout = function ProfilePageLayout(_ref) {
  var profile = _ref.profile,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        className: _profilePageLayout2.default.profileContainer,
        component: 'div',
        transitionName: _profilePageLayoutTransition2.default,
        transitionEnterTimeout: ANIMATION_TIMEOUT,
        transitionLeaveTimeout: ANIMATION_TIMEOUT
      },
      profile
    ),
    children
  );
};

ProfilePageLayout.propTypes = {
  profile: _propTypes2.default.node,
  children: _propTypes2.default.node
};

exports.default = ProfilePageLayout;

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"enter":"_2RN2D","enterActive":"_36WvQ","leave":"_1REGI"};

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"profileContainer":"_75F1Z"};

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profilePlaceholder = __webpack_require__(1773);

var _profilePlaceholder2 = _interopRequireDefault(_profilePlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profilePlaceholder2.default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _profilePlaceholder = __webpack_require__(1774);

var _profilePlaceholder2 = _interopRequireDefault(_profilePlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfilePlaceholder = function ProfilePlaceholder() {
  return _react2.default.createElement(
    'div',
    { className: _profilePlaceholder2.default.container },
    _react2.default.createElement(
      'div',
      { className: _profilePlaceholder2.default.card },
      _react2.default.createElement('div', { className: _profilePlaceholder2.default.cover }),
      _react2.default.createElement(
        'div',
        { className: _profilePlaceholder2.default.photo },
        _react2.default.createElement('div', { className: _profilePlaceholder2.default.image })
      ),
      _react2.default.createElement(
        'div',
        { className: _profilePlaceholder2.default.flexContainer },
        _react2.default.createElement(
          'div',
          { className: _profilePlaceholder2.default.userInfo },
          _react2.default.createElement('p', { className: _profilePlaceholder2.default.name }),
          _react2.default.createElement('p', { className: _profilePlaceholder2.default.date })
        ),
        _react2.default.createElement('div', { className: _profilePlaceholder2.default.childrenContainer }),
        _react2.default.createElement(
          'div',
          { className: _profilePlaceholder2.default.stats },
          _react2.default.createElement(
            'div',
            { className: _profilePlaceholder2.default.section },
            _react2.default.createElement('p', { className: _profilePlaceholder2.default.smallCount }),
            _react2.default.createElement('p', { className: _profilePlaceholder2.default.smallLabel })
          ),
          _react2.default.createElement(
            'div',
            { className: _profilePlaceholder2.default.section },
            _react2.default.createElement('p', { className: _profilePlaceholder2.default.count }),
            _react2.default.createElement('p', { className: _profilePlaceholder2.default.label })
          ),
          _react2.default.createElement(
            'div',
            { className: _profilePlaceholder2.default.section },
            _react2.default.createElement('p', { className: _profilePlaceholder2.default.count }),
            _react2.default.createElement('p', { className: _profilePlaceholder2.default.label })
          )
        )
      )
    )
  );
};

exports.default = ProfilePlaceholder;

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2NHrc","card":"_2V29l","cover":"_9wQqc","placeHolderShimmer":"_1f8kk","photo":"_3UEaY","image":"_3PhOY","flexContainer":"_3fv7W","userInfo":"_1OQ6I","name":"_2K6a_","date":"_1zceZ","stats":"H_rsW","section":"_1I7lP","smallCount":"_2jGqv","smallLabel":"_3w8J7","count":"_2aSAi","label":"AkqRq"};

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profilePosts = __webpack_require__(1776);

var _profilePosts2 = _interopRequireDefault(_profilePosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profilePosts2.default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfilePosts = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _routerUtils = __webpack_require__(55);

var _fetchUser = __webpack_require__(420);

var _fetchUserAndRedirect = __webpack_require__(1186);

var _fetchPostsByOwnerId = __webpack_require__(130);

var _fetchPostsByOwnerId2 = _interopRequireDefault(_fetchPostsByOwnerId);

var _redirectTo = __webpack_require__(1007);

var _setIsLoaded = __webpack_require__(198);

var _postList = __webpack_require__(1306);

var _postList2 = _interopRequireDefault(_postList);

var _noUserPosts = __webpack_require__(1777);

var _noUserPosts2 = _interopRequireDefault(_noUserPosts);

var _isLoadingSelectors = __webpack_require__(267);

var _isLoadedSelectors = __webpack_require__(412);

var _paginationSelectors = __webpack_require__(424);

var _postSelectors = __webpack_require__(117);

var _userSelectors = __webpack_require__(69);

var _pagination = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfilePosts = exports.ProfilePosts = function (_Component) {
  _inherits(ProfilePosts, _Component);

  function ProfilePosts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfilePosts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfilePosts.__proto__ || Object.getPrototypeOf(ProfilePosts)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      _this.fetchUserData(_this.props.params.userSlug);
    }, _this.componentWillReceiveProps = function (_ref2) {
      var nextParams = _ref2.params;
      var userSlug = _this.props.params.userSlug;


      if (userSlug !== nextParams.userSlug) {
        _this.fetchUserData(nextParams.userSlug);
      }
    }, _this.componentWillUnmount = function () {
      _this.props.setIsLoaded('profile-posts', _this.props.userId, false);
    }, _this.fetchUserData = function (userSlug) {
      return _this.props.fetchUser(userSlug).then(function (_ref3) {
        var _id = _ref3._id;
        return _this.fetchPosts(_id);
      });
    }, _this.fetchPosts = function (ownerId) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.getPage();
      return _this.props.fetchPosts({
        ownerId: ownerId,
        page: page,
        pageSize: _pagination.POSTS_PER_PAGE
      });
    }, _this.getPage = function () {
      return _lodash2.default.toNumber(_this.props.location.query.page) || 1;
    }, _this.changePage = function (page) {
      var userId = _this.props.userId;

      _this.fetchPosts(userId, _lodash2.default.toNumber(page));
      _this.props.push({ pathname: '/profiles/' + _this.props.params.userSlug, query: { page: page } });
    }, _this.loadMore = function (page) {
      return _this.fetchPosts(_this.props.userId, page);
    }, _this.render = function () {
      var _this$props = _this.props,
          entityCount = _this$props.entityCount,
          allPosts = _this$props.allPosts,
          currentPagePosts = _this$props.currentPagePosts,
          incrementPostLikeCount = _this$props.incrementPostLikeCount,
          isProfilePostsLoading = _this$props.isProfilePostsLoading,
          isProfilePostsLoaded = _this$props.isProfilePostsLoaded;


      if (!allPosts.length) {
        return _react2.default.createElement(_noUserPosts2.default, null);
      }

      return _react2.default.createElement(_postList2.default, {
        page: _this.getPage(),
        entityCount: entityCount,
        allPosts: allPosts,
        currentPagePosts: currentPagePosts,
        changePage: _this.changePage,
        loadMore: _this.loadMore,
        isLoading: isProfilePostsLoading,
        isLoaded: isProfilePostsLoaded,
        onLikeClick: incrementPostLikeCount,
        hasSpacing: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ProfilePosts;
}(_react.Component);

ProfilePosts.fetchData = function (_ref5) {
  var store = _ref5.store,
      params = _ref5.params,
      query = _ref5.query,
      search = _ref5.search;
  return store.dispatch((0, _fetchUserAndRedirect.fetchUserAndRedirect)(params.userSlug, search)).then(function (user) {
    return store.dispatch((0, _fetchPostsByOwnerId2.default)({
      ownerId: user._id,
      page: _lodash2.default.toNumber(query.page) || 1,
      pageSize: _pagination.POSTS_PER_PAGE
    }));
  }).catch(function () {
    return store.dispatch((0, _redirectTo.redirectTo404)(search));
  });
};

ProfilePosts.propTypes = {
  fetchUser: _propTypes2.default.func.isRequired,
  fetchPosts: _propTypes2.default.func.isRequired,
  setIsLoaded: _propTypes2.default.func.isRequired,
  push: _propTypes2.default.func.isRequired,
  incrementPostLikeCount: _propTypes2.default.func.isRequired,
  isProfilePostsLoaded: _propTypes2.default.bool.isRequired,
  params: _propTypes2.default.object.isRequired,
  allPosts: _propTypes2.default.array.isRequired,
  currentPagePosts: _propTypes2.default.array.isRequired,
  entityCount: _propTypes2.default.number.isRequired,
  location: _propTypes2.default.object,
  userId: _propTypes2.default.string,
  isProfilePostsLoading: _propTypes2.default.bool.isRequired
};

ProfilePosts.defaultProps = {
  allPosts: [],
  currentPagePosts: [],
  page: 1
};

var mapStateToProps = function mapStateToProps(state, _ref4) {
  var userSlug = _ref4.params.userSlug,
      page = _ref4.location.query.page;

  var user = (0, _userSelectors.getUserBySlug)(state, userSlug) || {};
  return {
    allPosts: (0, _postSelectors.getSortedPostsByOwnerId)(state, user._id),
    currentPagePosts: (0, _postSelectors.getPostsByOwnerIdAndPage)(state, user._id, _lodash2.default.toNumber(page) || 1),
    entityCount: (0, _paginationSelectors.getEntityCount)(state, 'posts'),
    userId: user._id,
    isProfilePostsLoading: (0, _isLoadingSelectors.getIsProfilePostsLoading)(state),
    isProfilePostsLoaded: (0, _isLoadedSelectors.getIsProfilePostsLoaded)(state)
  };
};

var mapDispatchToProps = {
  fetchUser: _fetchUser.fetchUser,
  fetchPosts: _fetchPostsByOwnerId2.default,
  push: _routerUtils.push,
  setIsLoaded: _setIsLoaded.setIsLoaded
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ProfilePosts);

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _noUserPosts = __webpack_require__(1778);

var _noUserPosts2 = _interopRequireDefault(_noUserPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _noUserPosts2.default;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(34);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _noUserPosts = __webpack_require__(1779);

var _noUserPosts2 = _interopRequireDefault(_noUserPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NoUserPosts = function NoUserPosts(_ref) {
  var t = _ref.t,
      props = _objectWithoutProperties(_ref, ['t']);

  return _react2.default.createElement(_emptyStates2.default, _extends({
    className: _noUserPosts2.default.container,
    title: t('no-user-posts.nothing-here-yet'),
    content: _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'no-user-posts.check-back-soon', useDangerouslySetInnerHTML: true })
  }, props));
};

NoUserPosts.propTypes = {
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(NoUserPosts);

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Yzda"};

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _resultsPage = __webpack_require__(1781);

var _resultsPage2 = _interopRequireDefault(_resultsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _resultsPage2.default;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResultCounts = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _experiments = __webpack_require__(32);

var _setIsLoaded = __webpack_require__(198);

var _fetchSearch = __webpack_require__(131);

var _fetchSearch2 = _interopRequireDefault(_fetchSearch);

var _search = __webpack_require__(394);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _animatedLoader = __webpack_require__(273);

var _animatedLoader2 = _interopRequireDefault(_animatedLoader);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _noSearchResults = __webpack_require__(1782);

var _noSearchResults2 = _interopRequireDefault(_noSearchResults);

var _defaultDesktopLayout = __webpack_require__(1187);

var _defaultDesktopLayout2 = _interopRequireDefault(_defaultDesktopLayout);

var _searchResultsList = __webpack_require__(1785);

var _searchResultsList2 = _interopRequireDefault(_searchResultsList);

var _memberList = __webpack_require__(1188);

var _memberList2 = _interopRequireDefault(_memberList);

var _isLoadingSelectors = __webpack_require__(267);

var _isLoadedSelectors = __webpack_require__(412);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPES = ['posts', 'members'];
var getResultCounts = exports.getResultCounts = function getResultCounts(search, excludedType) {
  return (0, _lodash2.default)(TYPES).filter(function (type) {
    return type !== excludedType;
  }).map(function (type) {
    return {
      type: type,
      count: search && search[type].length
    };
  }).filter(function (type) {
    return type.count;
  }).value();
};

var createResultsPage = function createResultsPage(type, alternativeType) {
  var ResultsPage = function ResultsPage(_ref) {
    var search = _ref.search,
        location = _ref.location,
        isLoading = _ref.isLoading,
        isMembersAreaEnabled = _ref.isMembersAreaEnabled;

    var hasResults = Boolean(_lodash2.default.get(search[type], 'length', 0));
    var resultCounts = isMembersAreaEnabled ? [] : getResultCounts(search, type);

    return _react2.default.createElement(
      _page2.default,
      { noSpacing: !hasResults },
      _react2.default.createElement(
        _defaultDesktopLayout2.default,
        null,
        _react2.default.createElement(
          _animatedLoader2.default,
          { isLoading: isLoading, isAnimated: true },
          hasResults ? renderResults(type, search, location.query.query) : _react2.default.createElement(_noSearchResults2.default, {
            type: type,
            alternativeType: alternativeType,
            query: location.query.query,
            resultCounts: resultCounts
          })
        ),
        !isLoading && _react2.default.createElement(_appLoaded2.default, null)
      )
    );
  };

  ResultsPage.fetchData = function (_ref2) {
    var store = _ref2.store,
        query = _ref2.query.query;

    if (query && query.length >= _search.MIN_QUERY_LENGTH) {
      return store.dispatch((0, _fetchSearch2.default)(query));
    }
  };

  ResultsPage.propTypes = {
    search: _propTypes2.default.object.isRequired,
    location: _propTypes2.default.object.isRequired,
    setIsLoaded: _propTypes2.default.func.isRequired,
    isLoading: _propTypes2.default.bool.isRequired,
    isLoaded: _propTypes2.default.bool.isRequired,
    isMembersAreaEnabled: _propTypes2.default.bool
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      search: state.search,
      isLoading: (0, _isLoadingSelectors.getIsSearchLoading)(state),
      isLoaded: (0, _isLoadedSelectors.getIsSearchLoaded)(state)
    };
  };

  var mapDispatchToProps = {
    setIsLoaded: _setIsLoaded.setIsLoaded
  };

  return _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withExperiment2.default)({
    isMembersAreaEnabled: _experiments.EXPERIMENT_MEMBERS_AREA
  }))(ResultsPage);
};

function renderResults(type, search, query) {
  var results = search[type];

  switch (type) {
    case 'posts':
      return _react2.default.createElement(_searchResultsList2.default, { posts: results, query: query });
    case 'members':
      return _react2.default.createElement(_memberList2.default, { members: results });
    default:
      return _react2.default.createElement('div', null);
  }
}

exports.default = createResultsPage;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _noSearchResults = __webpack_require__(1783);

var _noSearchResults2 = _interopRequireDefault(_noSearchResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _noSearchResults2.default;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoSearchResults = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _reactI18next = __webpack_require__(34);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _noSearchResults = __webpack_require__(1784);

var _noSearchResults2 = _interopRequireDefault(_noSearchResults);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLink = function getLink(alternativeType, query, text) {
  var location = {
    pathname: '/search/' + alternativeType,
    query: { query: query }
  };

  return _react2.default.createElement(
    _internalLink2.default,
    { className: _noSearchResults2.default.link, to: location },
    text
  );
};

function renderNoResults(t) {
  return _react2.default.createElement(_emptyStates2.default, {
    className: _noSearchResults2.default.container,
    title: t('no-search-results.no-results-found-title'),
    content: t('no-search-results.try-again')
  });
}

function renderNoTypeFound(query, type, alternativeType, t) {
  var typeName = t('no-search-results.' + type);
  var alternativeTypeName = t('no-search-results.' + alternativeType);
  var tryAgain = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'no-search-results.no-type-found-content.' + type,
      query: _react2.default.createElement(
        'span',
        { className: _noSearchResults2.default.term },
        query
      )
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_reactI18next.Interpolate, {
      i18nKey: 'no-search-results.no-type-found-try-again-content',
      link: getLink(alternativeType, query, alternativeTypeName)
    })
  );
  return _react2.default.createElement(_emptyStates2.default, {
    className: _noSearchResults2.default.container,
    title: t('no-search-results.no-type-found-title', { type: typeName }),
    content: tryAgain
  });
}

var NoSearchResults = exports.NoSearchResults = function NoSearchResults(_ref) {
  var type = _ref.type,
      alternativeType = _ref.alternativeType,
      query = _ref.query,
      t = _ref.t,
      resultCounts = _ref.resultCounts,
      borderWidth = _ref.borderWidth;

  return _react2.default.createElement(
    'div',
    { style: { marginTop: -borderWidth } },
    resultCounts.length > 0 ? renderNoTypeFound(query, type, alternativeType, t) : renderNoResults(t)
  );
};

NoSearchResults.propTypes = {
  query: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  alternativeType: _propTypes2.default.string.isRequired,
  search: _propTypes2.default.object.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  t: _propTypes2.default.func,
  resultCounts: _propTypes2.default.array
};

exports.default = (0, _withTranslate2.default)((0, _withCardBorderWidth2.default)((0, _withFontClassName2.default)(NoSearchResults)));

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3-SrZ","link":"_1uYN2","term":"_3RaHk"};

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchResultsList = __webpack_require__(1786);

var _searchResultsList2 = _interopRequireDefault(_searchResultsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchResultsList2.default;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(5);

var _redux = __webpack_require__(6);

var _incrementPostLikeCount = __webpack_require__(160);

var _incrementCommentLikeCount = __webpack_require__(246);

var _searchResultsList = __webpack_require__(1787);

var _searchResultsList2 = _interopRequireDefault(_searchResultsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onPostLikeClick: _incrementPostLikeCount.incrementPostLikeCount,
    onCommentLikeClick: _incrementCommentLikeCount.incrementCommentLikeCount
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(_searchResultsList2.default);

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchResultsList = __webpack_require__(1788);

var _searchResultsList2 = _interopRequireDefault(_searchResultsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchResultsList2.default;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _searchResultsDesktopList = __webpack_require__(1789);

var _searchResultsDesktopList2 = _interopRequireDefault(_searchResultsDesktopList);

var _searchResultsMobileList = __webpack_require__(1792);

var _searchResultsMobileList2 = _interopRequireDefault(_searchResultsMobileList);

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResultsList = (0, _forDevice2.default)(_searchResultsMobileList2.default, _searchResultsDesktopList2.default);
exports.default = SearchResultsList;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _postListItem = __webpack_require__(524);

var _postListItem2 = _interopRequireDefault(_postListItem);

var _commentSearchListItem = __webpack_require__(1330);

var _commentSearchListItem2 = _interopRequireDefault(_commentSearchListItem);

var _paginationRegular = __webpack_require__(1311);

var _paginationRegular2 = _interopRequireDefault(_paginationRegular);

var _separator = __webpack_require__(18);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _searchResultsList = __webpack_require__(1331);

var _searchResultsList2 = _interopRequireDefault(_searchResultsList);

var _redux = __webpack_require__(6);

var _changePage = __webpack_require__(1012);

var _reactRedux = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POST = 'post';
var COMMENT = 'comment';
var ITEMS_PER_PAGE = 20;

var SearchResultsDesktopList = function (_Component) {
  _inherits(SearchResultsDesktopList, _Component);

  function SearchResultsDesktopList(props) {
    _classCallCheck(this, SearchResultsDesktopList);

    var _this = _possibleConstructorReturn(this, (SearchResultsDesktopList.__proto__ || Object.getPrototypeOf(SearchResultsDesktopList)).call(this, props));

    _this.state = {
      page: 1,
      from: 0,
      to: ITEMS_PER_PAGE
    };


    _this.handlePageChange = _this.handlePageChange.bind(_this);
    return _this;
  }

  _createClass(SearchResultsDesktopList, [{
    key: 'handlePageChange',
    value: function handlePageChange(_ref) {
      var page = _ref.page,
          from = _ref.from,
          to = _ref.to;

      this.setState({ page: page, from: from, to: to });
    }
  }, {
    key: 'renderItem',
    value: function renderItem(post, query, onPostLikeClick, onCommentLikeClick) {
      var separator = _react2.default.createElement(
        'div',
        { className: _searchResultsList2.default.separator },
        _react2.default.createElement(_separator.HorizontalSeparator, { key: post._id + '-separator' })
      );
      switch (post.type) {
        case POST:
          return [_react2.default.createElement(_postListItem2.default, {
            key: post._id,
            type: _postListItem2.default.SEARCH,
            post: post,
            query: query,
            onLikeClick: onPostLikeClick
          }), separator];
        case COMMENT:
          return [_react2.default.createElement(_commentSearchListItem2.default, {
            key: post._id,
            type: _postListItem2.default.SEARCH,
            comment: post,
            query: query,
            onLikeClick: onCommentLikeClick
          }), separator];
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          posts = _props.posts,
          query = _props.query,
          onPostLikeClick = _props.onPostLikeClick,
          onCommentLikeClick = _props.onCommentLikeClick,
          borderWidth = _props.borderWidth;
      var _state = this.state,
          page = _state.page,
          from = _state.from,
          to = _state.to;

      var style = {
        borderWidth: borderWidth,
        marginTop: -borderWidth
      };
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_searchResultsList2.default.container, 'search-results-list') },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_searchResultsList2.default.wrapper, 'forum-card-border-color'), style: style },
          posts.slice(from, to).map(function (post) {
            return _this2.renderItem(post, query, onPostLikeClick, onCommentLikeClick);
          }),
          _react2.default.createElement(_paginationRegular2.default, {
            className: (0, _classnames2.default)(_searchResultsList2.default.pagination, 'forum-card-background-color'),
            page: page,
            entityCount: posts.length,
            showPerPage: ITEMS_PER_PAGE,
            onChange: this.handlePageChange
          })
        )
      );
    }
  }]);

  return SearchResultsDesktopList;
}(_react.Component);

SearchResultsDesktopList.propTypes = {
  posts: _propTypes2.default.array.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  query: _propTypes2.default.string,
  onPostLikeClick: _propTypes2.default.func,
  onCommentLikeClick: _propTypes2.default.func,
  changePage: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    changePage: _changePage.changePage
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withCardBorderWidth2.default)(SearchResultsDesktopList));

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _commentHeader = __webpack_require__(1088);

var _commentHeader2 = _interopRequireDefault(_commentHeader);

var _commentFooter = __webpack_require__(1089);

var _commentFooter2 = _interopRequireDefault(_commentFooter);

var _highlighter = __webpack_require__(370);

var _highlighter2 = _interopRequireDefault(_highlighter);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _categoriesSelectors = __webpack_require__(35);

var _commentSearchListItem = __webpack_require__(1791);

var _commentSearchListItem2 = _interopRequireDefault(_commentSearchListItem);

var _contentExcerpt = __webpack_require__(525);

var _contentExcerpt2 = _interopRequireDefault(_contentExcerpt);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentSearchListItem = function CommentSearchListItem(_ref) {
  var category = _ref.category,
      comment = _ref.comment,
      type = _ref.type,
      query = _ref.query,
      onLikeClick = _ref.onLikeClick,
      borderWidth = _ref.borderWidth,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName;

  var commentLink = '/' + category.slug + '/' + comment.postSlug + '#' + comment._id;
  return _react2.default.createElement(
    _internalLink2.default,
    { to: commentLink, renderInSeo: false },
    _react2.default.createElement(
      'article',
      {
        className: (0, _classnames2.default)(_commentSearchListItem2.default.container, 'forum-card-background-color', 'forum-text-color', 'forum-card-border-color', contentFontClassName),
        style: { borderWidth: borderWidth }
      },
      _react2.default.createElement(
        'div',
        { className: titleFontClassName },
        _react2.default.createElement(
          'h2',
          { className: _commentSearchListItem2.default.postTitle, 'data-hook': 'search-list-item__post-title' },
          _react2.default.createElement(
            'object',
            { type: 'communities/link' },
            _react2.default.createElement(
              _internalLink2.default,
              { to: commentLink, style: { color: 'inherit' } },
              comment.postTitle
            )
          )
        )
      ),
      _react2.default.createElement(_commentHeader2.default, { type: _commentHeader2.default.SEARCH, comment: comment, showMoreButton: true }),
      _react2.default.createElement(
        'div',
        { className: _commentSearchListItem2.default.content },
        _react2.default.createElement(_contentExcerpt2.default, { type: type, content: comment.content, query: query }),
        query ? _react2.default.createElement(_highlighter2.default, { text: comment.content, query: query }) : comment.content
      ),
      _react2.default.createElement(_commentFooter2.default, { type: _commentFooter2.default.SEARCH, comment: comment, onLikeClick: onLikeClick })
    )
  );
};

CommentSearchListItem.propTypes = {
  category: _propTypes2.default.object.isRequired,
  comment: _propTypes2.default.object.isRequired,
  borderWidth: _propTypes2.default.number,
  type: _propTypes2.default.string,
  onLikeClick: _propTypes2.default.func.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  query: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    category: (0, _categoriesSelectors.getCategory)(state, ownProps.comment.categoryId)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withCardBorderWidth2.default)((0, _withFontClassName2.default)(CommentSearchListItem)));

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"G631W","postTitle":"_3QGJf","content":"_2sYXt"};

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _infiniteList = __webpack_require__(1103);

var _infiniteList2 = _interopRequireDefault(_infiniteList);

var _postListItem = __webpack_require__(524);

var _postListItem2 = _interopRequireDefault(_postListItem);

var _commentSearchListItem = __webpack_require__(1330);

var _commentSearchListItem2 = _interopRequireDefault(_commentSearchListItem);

var _searchResultsList = __webpack_require__(1331);

var _searchResultsList2 = _interopRequireDefault(_searchResultsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var THRESHOLD = 400;

var itemRenderer = function itemRenderer(props) {
  return function (index) {
    var _componentProps;

    // eslint-disable-next-line react/prop-types
    var posts = props.posts,
        query = props.query,
        onPostLikeClick = props.onPostLikeClick,
        onCommentLikeClick = props.onCommentLikeClick;

    var post = posts[index];
    var isPost = post.type === 'post';
    var Component = isPost ? _postListItem2.default : _commentSearchListItem2.default;
    var componentProps = (_componentProps = {}, _defineProperty(_componentProps, isPost ? 'post' : 'comment', post), _defineProperty(_componentProps, 'onLikeClick', isPost ? onPostLikeClick : onCommentLikeClick), _defineProperty(_componentProps, 'query', query), _componentProps);

    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_searchResultsList2.default.listItemMobile, 'search-results-list__list-item'), key: post._id, id: post._id },
      _react2.default.createElement(Component, _extends({ type: _postListItem2.default.SEARCH }, componentProps))
    );
  };
};

var SearchResultsMobileList = function SearchResultsMobileList(props) {
  return _react2.default.createElement(_infiniteList2.default, {
    length: props.posts.length,
    itemRenderer: itemRenderer(props) // Must pass props here otherwise it does not rerender after post change
    , threshold: THRESHOLD
  });
};

SearchResultsMobileList.propTypes = {
  onPostLikeClick: _propTypes2.default.func.isRequired,
  onCommentLikeClick: _propTypes2.default.func.isRequired,
  posts: _propTypes2.default.array,
  location: _propTypes2.default.object,
  query: _propTypes2.default.string
};

exports.default = SearchResultsMobileList;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _desktopHeader = __webpack_require__(1320);

var _desktopHeader2 = _interopRequireDefault(_desktopHeader);

var _breadcrumbs = __webpack_require__(1319);

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

var _searchHeader = __webpack_require__(1332);

var _searchHeader2 = _interopRequireDefault(_searchHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SearchDesktopHeader = function SearchDesktopHeader(_ref) {
  var routes = _ref.routes,
      params = _ref.params,
      props = _objectWithoutProperties(_ref, ['routes', 'params']);

  return _react2.default.createElement(_searchHeader2.default, _extends({
    component: _desktopHeader2.default,
    left: _react2.default.createElement(_breadcrumbs2.default, { routes: routes, params: params }),
    inputClassName: 'desktop-header-search-text-color desktop-header-search-font',
    borderClassName: 'desktop-header-search-border-background-color',
    iconClassName: 'desktop-header-search-icon-fill'
  }, props));
};

SearchDesktopHeader.propTypes = {
  routes: _propTypes2.default.array,
  params: _propTypes2.default.object
};

exports.default = SearchDesktopHeader;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _header = __webpack_require__(1063);

var _header2 = _interopRequireDefault(_header);

var _headerBackButton = __webpack_require__(1104);

var _headerBackButton2 = _interopRequireDefault(_headerBackButton);

var _searchHeader = __webpack_require__(1332);

var _searchHeader2 = _interopRequireDefault(_searchHeader);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SearchMobileHeader = function SearchMobileHeader(_ref) {
  var contentFontClassName = _ref.contentFontClassName,
      otherProps = _objectWithoutProperties(_ref, ['contentFontClassName']);

  return _react2.default.createElement(_searchHeader2.default, _extends({
    component: _header2.default,
    left: _react2.default.createElement(_headerBackButton2.default, { text: '' }),
    inputClassName: (0, _classnames2.default)('button-primary-text-color', contentFontClassName),
    borderClassName: 'button-primary-text-background-color',
    iconClassName: 'button-primary-icon-fill',
    showWidget: false
  }, otherProps));
};

SearchMobileHeader.propTypes = {
  contentFontClassName: _propTypes2.default.string.isRequired
};

exports.default = (0, _withFontClassName2.default)(SearchMobileHeader);

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchMenu = __webpack_require__(1796);

var _searchMenu2 = _interopRequireDefault(_searchMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchMenu2.default;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = __webpack_require__(244);

var _routerUtils = __webpack_require__(55);

var _menu = __webpack_require__(1316);

var _menu2 = _interopRequireDefault(_menu);

var _menuTab = __webpack_require__(1317);

var _menuTab2 = _interopRequireDefault(_menuTab);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _buttonClicked = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TABS = [{
  type: 'posts',
  className: 'search-menu__posts-tab',
  title: 'search-menu.posts',
  route: '/search/posts'
}, {
  type: 'members',
  className: 'search-menu__profiles-tab',
  title: 'search-menu.members',
  route: '/search/members'
}];

var buildTo = function buildTo(path, location) {
  return path + '?query=' + (location.query.query || '');
};

var SearchMenu = exports.SearchMenu = function (_Component) {
  _inherits(SearchMenu, _Component);

  function SearchMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchMenu.__proto__ || Object.getPrototypeOf(SearchMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasNavigated: false
    }, _this.componentWillReceiveProps = function (props) {
      if (_this.state.hasNavigated) {
        return;
      }

      var routes = [];
      TABS.forEach(function (tab) {
        if (props[tab.type].length) {
          routes.push(tab.route);
        }
      });

      if (routes.length === 1) {
        _this.navigate(routes[0]);
      }
    }, _this.handleNavigate = function (_ref2) {
      var route = _ref2.route,
          type = _ref2.type;
      return function (event) {
        _this.props.buttonClicked({ name: 'search_tab', type: type });
        event.preventDefault();
        _this.navigate(route);
      };
    }, _this.navigate = function (route) {
      _this.props.replace(buildTo(route, _this.props.location));
      _this.setState({ hasNavigated: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _menu2.default,
        null,
        TABS.map(function (tab, key) {
          return _react2.default.createElement(_menuTab2.default, {
            key: key,
            className: (0, _classnames2.default)(tab.className),
            title: t(tab.title),
            count: _this2.props[tab.type].length,
            isActive: _this2.props.router.isActive(tab.route),
            onClick: _this2.handleNavigate(tab)
          });
        })
      );
    }
  }]);

  return SearchMenu;
}(_react.Component);

SearchMenu.propTypes = {
  posts: _propTypes2.default.array.isRequired,
  members: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  replace: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func.isRequired,
  buttonClicked: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var search = _ref3.search;
  return search;
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    replace: _routerUtils.replace,
    buttonClicked: _buttonClicked.buttonClicked
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)((0, _withTranslate2.default)(SearchMenu)));

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _searchPage = __webpack_require__(1798);

var _searchPage2 = _interopRequireDefault(_searchPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchPage2.default;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emptyStates = __webpack_require__(291);

var _emptyStates2 = _interopRequireDefault(_emptyStates);

var _page = __webpack_require__(458);

var _page2 = _interopRequireDefault(_page);

var _appLoaded = __webpack_require__(262);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _searchPage = __webpack_require__(1799);

var _searchPage2 = _interopRequireDefault(_searchPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchPage = function SearchPage(_ref) {
  var t = _ref.t,
      borderWidth = _ref.borderWidth;

  return _react2.default.createElement(
    _page2.default,
    null,
    _react2.default.createElement(
      'div',
      { style: { marginTop: -borderWidth } },
      _react2.default.createElement(_emptyStates2.default, {
        className: _searchPage2.default.emptyStatesContainer,
        title: t('search-page.no-results-title'),
        content: t('search-page.no-results-content')
      })
    ),
    _react2.default.createElement(_appLoaded2.default, null)
  );
};

SearchPage.propTypes = {
  t: _propTypes2.default.func.isRequired,
  borderWidth: _propTypes2.default.number
};

exports.default = (0, _withTranslate2.default)((0, _withCardBorderWidth2.default)(SearchPage));

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"emptyStatesContainer":"_22ZA5"};

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var forAuthenticatedOnly = function forAuthenticatedOnly(Component) {
  return (0, _withAuth2.default)(function (_ref) {
    var isAuthenticated = _ref.isAuthenticated,
        otherProps = _objectWithoutProperties(_ref, ['isAuthenticated']);

    var props = _lodash2.default.omit(otherProps, ['currentUser', 'isBlocked', 'isOwner', 'dispatch', 'isPrivate', 'forPublicUser']);
    return isAuthenticated ? _react2.default.createElement(Component, props) : null;
  });
};

exports.default = forAuthenticatedOnly;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var forExperiment = function forExperiment(experimentName, ComponentExperimentTrue, ComponentExperimentFalse) {
  var config = _defineProperty({}, experimentName, experimentName);
  return (0, _withExperiment2.default)(config)(function (props) {
    var isExperimentEnabled = props[experimentName];
    var Component = isExperimentEnabled ? ComponentExperimentTrue : ComponentExperimentFalse;
    var newProps = _lodash2.default.omit(props, [experimentName]);

    return Component ? _react2.default.createElement(Component, newProps) : null;
  });
};

exports.default = forExperiment;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxAuthWrapper = __webpack_require__(1333);

var _routerUtils = __webpack_require__(55);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var requireAuth = (0, _reduxAuthWrapper.UserAuthWrapper)({
  authSelector: function authSelector(state) {
    return state.auth;
  },
  predicate: function predicate(auth) {
    return auth.isAuthenticated;
  },
  wrapperDisplayName: 'requireAuth',
  redirectAction: function redirectAction(args) {
    if (args.query.redirect) {
      args.query.redirect = (0, _urijs2.default)(args.query.redirect).search('').toString();
    }
    return (0, _routerUtils.replace)(args);
  }
});
/* eslint-enable */

exports.default = requireAuth;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = factory;

var _reactRedux = __webpack_require__(5);

var _hoistNonReactStatics = __webpack_require__(1804);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _lodash = __webpack_require__(1805);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  LoadingComponent: 'span',
  failureRedirectPath: '/login',
  wrapperDisplayName: 'AuthWrapper',
  predicate: function predicate(x) {
    return !(0, _lodash2.default)(x);
  },
  authenticatingSelector: function authenticatingSelector() {
    return false;
  },
  allowRedirectBack: true
};

function factory(React, empty) {
  var Component = React.Component;
  var PropTypes = React.PropTypes;


  return function (args) {
    var _defaults$args = _extends({}, defaults, args);

    var authSelector = _defaults$args.authSelector;
    var authenticatingSelector = _defaults$args.authenticatingSelector;
    var LoadingComponent = _defaults$args.LoadingComponent;
    var failureRedirectPath = _defaults$args.failureRedirectPath;
    var wrapperDisplayName = _defaults$args.wrapperDisplayName;
    var predicate = _defaults$args.predicate;
    var allowRedirectBack = _defaults$args.allowRedirectBack;
    var redirectAction = _defaults$args.redirectAction;


    var isAuthorized = function isAuthorized(authData) {
      return predicate(authData);
    };

    var createRedirect = function createRedirect(location, redirect) {
      var query = void 0;
      if (allowRedirectBack) {
        query = { redirect: '' + location.pathname + location.search };
      } else {
        query = {};
      }

      redirect({
        pathname: failureRedirectPath,
        query: query
      });
    };

    // Wraps the component that needs the auth enforcement
    function wrapComponent(DecoratedComponent) {
      var _dec, _class, _class2, _temp2;

      var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

      var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        if (redirectAction !== undefined) {
          return { redirect: function redirect(args) {
              return dispatch(redirectAction(args));
            } };
        } else {
          return {};
        }
      };

      var UserAuthWrapper = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          authData: authSelector(state, ownProps, false),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      }, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
        _inherits(UserAuthWrapper, _Component);

        function UserAuthWrapper() {
          var _Object$getPrototypeO;

          var _temp, _this, _ret;

          _classCallCheck(this, UserAuthWrapper);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(UserAuthWrapper)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.getRedirectFunc = function (_ref) {
            var redirect = _ref.redirect;

            if (redirect) {
              return redirect;
            } else {
              if (!_this.context.router.replace) {
                /* istanbul ignore next sanity */
                throw new Error('You must provide a router context (or use React-Router 2.x) if not passing a redirectAction to ' + wrapperDisplayName);
              } else {
                return _this.context.router.replace;
              }
            }
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(UserAuthWrapper, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!this.props.isAuthenticating && !isAuthorized(this.props.authData)) {
              createRedirect(this.props.location, this.getRedirectFunc(this.props));
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var willBeAuthorized = isAuthorized(nextProps.authData);
            var willbeAuthenticating = nextProps.isAuthenticating;
            var wasAuthorized = isAuthorized(this.props.authData);
            var wasAuthenticating = this.props.isAuthenticating;

            if ( // Redirect if:
            // 1. Was authorized, but no longer and not currently authenticating
            wasAuthorized && !willBeAuthorized && !willbeAuthenticating ||
            // 2. Was not authorized and authenticating but no longer authenticating
            wasAuthenticating && !willbeAuthenticating && !willBeAuthorized) {
              createRedirect(nextProps.location, this.getRedirectFunc(nextProps));
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // Allow everything but the replace aciton creator to be passed down
            // Includes route props from React-Router and authData
            var _props = this.props;
            var redirect = _props.redirect;
            var authData = _props.authData;
            var isAuthenticating = _props.isAuthenticating;

            var otherProps = _objectWithoutProperties(_props, ['redirect', 'authData', 'isAuthenticating']); // eslint-disable-line no-unused-vars


            if (isAuthorized(authData)) {
              return React.createElement(DecoratedComponent, _extends({ authData: authData }, otherProps));
            } else if (isAuthenticating) {
              return React.createElement(LoadingComponent, otherProps);
            } else {
              // Don't need to display anything because the user will be redirected
              return React.createElement(empty);
            }
          }
        }]);

        return UserAuthWrapper;
      }(Component), _class2.displayName = wrapperDisplayName + '(' + displayName + ')', _class2.propTypes = {
        location: PropTypes.shape({
          pathname: PropTypes.string.isRequired,
          search: PropTypes.string.isRequired
        }).isRequired,
        redirect: PropTypes.func,
        authData: PropTypes.object
      }, _class2.contextTypes = {
        // Only used if no redirectAction specified
        router: React.PropTypes.object
      }, _temp2)) || _class);


      return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
    }

    wrapComponent.onEnter = function (store, nextState, replace) {
      var authData = authSelector(store.getState(), null, true);
      if (!isAuthorized(authData)) {
        createRedirect(nextState.location, replace);
      }
    };

    return wrapComponent;
  };
}

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);
        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/**
 * lodash 4.2.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var keys = __webpack_require__(1806),
    root = __webpack_require__(1807);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = (freeModule && freeModule.exports === freeExports)
  ? freeExports
  : undefined;

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function getTag(value) {
  return objectToString.call(value);
}

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = !Buffer ? constant(false) : function(value) {
  return value instanceof Buffer;
};

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || isString(value) || isFunction(value.splice) ||
        isArguments(value) || isBuffer(value))) {
    return !value.length;
  }
  if (isObjectLike(value)) {
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) {
      return !value.size;
    }
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return !(nonEnumShadows && keys(value).length);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (!isObject(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var getter = _.constant(object);
 *
 * getter() === object;
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module)))

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

module.exports = root;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module), __webpack_require__(33)))

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxAuthWrapper = __webpack_require__(1333);

var _routerUtils = __webpack_require__(55);

/* eslint-disable */
var requireNotBlocked = (0, _reduxAuthWrapper.UserAuthWrapper)({
  authSelector: function authSelector(state) {
    return state.auth.currentUser;
  },
  predicate: function predicate(user) {
    return !user.isBlocked;
  },
  failureRedirectPath: '/account-suspended',
  wrapperDisplayName: 'requireNotBlocked',
  redirectAction: _routerUtils.replace,
  allowRedirectBack: false
});
/* eslint-enable */

exports.default = requireNotBlocked;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixViewport = exports.getViewportScaleRatio = undefined;

var _wixSdkUtils = __webpack_require__(21);

var _isInWix = __webpack_require__(77);

var getViewportScaleRatio = exports.getViewportScaleRatio = function getViewportScaleRatio() {
  return (0, _wixSdkUtils.isUserAgentMobile)() && (0, _wixSdkUtils.isSite)() && (0, _isInWix.isInWix)() ? 320 / (0, _wixSdkUtils.getScreenWidth)() : 1;
};

var fixViewport = exports.fixViewport = function fixViewport() {
  if ((0, _wixSdkUtils.isSite)() && (0, _wixSdkUtils.isUserAgentMobile)() && (0, _isInWix.isInWix)()) {
    var screenWidth = (0, _wixSdkUtils.getScreenWidth)();
    var viewportAspectRatio = 320 / screenWidth;
    document.body.style.transform = 'scale(' + viewportAspectRatio + ')';
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = screenWidth + 'px';
    document.body.style.height = 100 / viewportAspectRatio + '%';
  }
};

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = listenToHistoryStateChange;

var _lodash = __webpack_require__(2);

var _routerUtils = __webpack_require__(55);

var _sdkQueryParams = __webpack_require__(540);

var _parseGetParam = __webpack_require__(175);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _viewMode = __webpack_require__(423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROUTING_PARAMS = ['sort', 'name', 'query', 'redirect', 'page'];

function listenToHistoryStateChange(history, store) {
  var wasRedirected = (0, _parseGetParam.parseGetParam)('redirected') === 'true';
  // State changes triggered by app should be ignored to prevent an infinite loop
  var isInitialLoad = true;
  var lastState = null;

  var hasChanged = function hasChanged(newState) {
    return lastState !== newState;
  };

  history.listen(function (location) {
    var query = location.query || {};
    if (isInitialLoad) {
      (0, _sdkQueryParams.setQueryParams)((0, _lodash.omit)(query, ROUTING_PARAMS));
    }
    var queryParams = (0, _lodash.map)((0, _lodash.pick)(query, ROUTING_PARAMS), function (value, name) {
      return name + '=' + encodeURIComponent(value);
    }).join('&');
    var search = queryParams ? '?' + queryParams : '';
    var pathname = (0, _lodash.trimStart)(location.pathname, '/') + search || './';
    var isInitialLoadAfterRedirect = !wasRedirected && isInitialLoad;

    if ((0, _viewMode.isInSite)() && hasChanged(pathname) && !isInitialLoadAfterRedirect) {
      _wixSdkPolyfill2.default.replaceSectionState(pathname);
      lastState = pathname;
    }

    isInitialLoad = false;
  });

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.STATE_CHANGED, function (_ref) {
    var newState = _ref.newState;

    if (newState === '') {
      newState = './';
    }

    if ((0, _viewMode.isInEditor)() || !hasChanged(newState)) {
      return;
    }
    lastState = newState;

    var pathname = '/' + newState.replace(/\.\//, '');
    store.dispatch((0, _routerUtils.push)(pathname));
  });

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.EDIT_MODE_CHANGE, function () {
    lastState = null;
  });
}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollOnHistoryChange;

var _scrollTo = __webpack_require__(537);

var _viewMode = __webpack_require__(423);

function scrollOnHistoryChange(history) {
  var lastLocation = {};
  history.listen(function (location) {
    if ((0, _viewMode.isInEditor)()) {
      return;
    }

    if (lastLocation.pathname && lastLocation.pathname !== location.pathname) {
      (0, _scrollTo.scrollToAppTop)();
    }
    lastLocation = location;
  });
}

/***/ }),
/* 1812 */,
/* 1813 */,
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fedops = __webpack_require__(1815);

var _createFedopsLoggerFactory = __webpack_require__(1816);

var _createFedopsLoggerFactory2 = _interopRequireDefault(_createFedopsLoggerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createFedopsLoggerFactory2.default)(_fedops.FEDOPS_APP_NAME).getLogger();

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FEDOPS_APP_NAME = exports.FEDOPS_APP_NAME = 'communities-forum-app';

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fedopsLogger = __webpack_require__(1121);

function fedopsLoggerFactory(appName) {
  var fedopsLogger = void 0;

  var createLogger = function createLogger() {
    return fedopsLogger = (0, _fedopsLogger.create)(appName);
  };
  var getLogger = function getLogger() {
    return fedopsLogger ? fedopsLogger : createLogger();
  };

  return {
    getLogger: getLogger
  };
}

exports.default = fedopsLoggerFactory;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = publishMiddleware;
function publishMiddleware(publish) {
  var actionTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return function () {
    return function (next) {
      return function (action) {
        if (actionTypes.indexOf(action.type) > -1) {
          publish('action', action);
        }
        return next(action);
      };
    };
  };
}

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createPost = __webpack_require__(200);

var _createCategory = __webpack_require__(402);

var _updateCategory = __webpack_require__(403);

var _deletePost = __webpack_require__(132);

var _updatePost = __webpack_require__(397);

var _routerUtils = __webpack_require__(55);

var _locationHistorySelectors = __webpack_require__(162);

var _categoriesSelectors = __webpack_require__(35);

var _postSelectors = __webpack_require__(117);

var handlePostEditRedirect = function handlePostEditRedirect(action, store) {
  var post = action.payload;
  var category = (0, _categoriesSelectors.getCategory)(store.getState(), post.categoryId);

  store.dispatch((0, _routerUtils.replace)({
    pathname: '/' + category.slug + '/' + post.slug,
    state: { isAnimated: true }
  }));
};

var handlePostDeleteRedirect = function handlePostDeleteRedirect(action, store) {
  var state = store.getState();
  var currentLocation = (0, _locationHistorySelectors.getCurrentLocation)(store.getState());
  var post = (0, _postSelectors.getPost)(state, action.payload);
  var category = (0, _categoriesSelectors.getCategory)(state, post.categoryId);
  var isPostPage = currentLocation.pathname.indexOf('/' + category.slug + '/' + post.slug) > -1;
  if (isPostPage) {
    store.dispatch((0, _routerUtils.replace)('/' + category.slug));
  }
};

var redirectMiddleware = function redirectMiddleware(store) {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case _createCategory.CREATE_CATEGORY_SUCCESS:
        case _updateCategory.UPDATE_CATEGORY_SUCCESS:
          store.dispatch((0, _routerUtils.replace)('/'));
          break;
        case _createPost.CREATE_POST_SUCCESS:
          {
            handlePostEditRedirect(action, store);
            break;
          }
        case _updatePost.UPDATE_POST_SUCCESS:
          handlePostEditRedirect(action, store);
          break;
        case _deletePost.DELETE_POST_SUCCESS:
          handlePostDeleteRedirect(action, store);
          break;
        default:
          break;
      }
      return next(action);
    };
  };
};

exports.default = redirectMiddleware;

/***/ })
],[1372]);


// WEBPACK FOOTER //
// app.bundle.min.js